{
  "name": "<root>",
  "type": "Program",
  "children": [
    {
      "type": "Unit",
      "id": "2fae32629d4ef4fc6341f1751b405e45",
      "name": "Security",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-001",
            "text": "The national civil aviation security program shall be established by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-001-A",
                "text": "ECAC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-001-B",
                "text": "Each contracting state",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-001-C",
                "text": "ICAO and other organisations including the contracting state concerned",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-001-D",
                "text": "ICAO",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-002",
            "text": "The obligation of a carrier to transport any person away from the territory of a Contracting state shall terminate from the moment such person has been definitely admitted in other Contracting State of destination.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-002-A",
                "text": "The obligation is for the Contracting State of the operator.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-002-B",
                "text": "The obligation of the operator terminates as soon as the person leaves the aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-002-C",
                "text": "The operator has no obligation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-002-D",
                "text": "The stated above is correct.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-003",
            "text": "Unaccompanied baggage carried by air shall be cleared under the procedure applicable to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-003-A",
                "text": "cargo and is covered by a traffic document",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-003-B",
                "text": "cargo but clearance documents provided by airlines shall be completed by the passenger prior to shipment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-003-C",
                "text": "accompanied baggage or under another simplified customs procedure distinct from that normally applicable to other cargo.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-003-D",
                "text": "cargo but is free from any kind of declaration forms",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-004",
            "text": "When a person is found inadmissible and is returned to the operator for transport away from the territory of the state, the operator:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-004-A",
                "text": "shall not be preclude from recovering from such person any transportation costs arising from his (her) inadmissibility",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-004-B",
                "text": "and the state of the operator are both responsible for the person inadmissible",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-004-C",
                "text": "is not responsible for the person inadmissible for entry in the receiving state",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-004-D",
                "text": "shall not recover from such person any transportation costs arising from his (her) Inadmissibility",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-005",
            "text": "Under ICAO Annex 17, each contracting State shall ensure the establishment of a security programme:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-005-A",
                "text": "for each international airport within the State",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-005-B",
                "text": "for all airports within the State.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-005-C",
                "text": "for every airline operating in the State.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-005-D",
                "text": "only for administrative staff of airport.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-006",
            "text": "The ICAO Annex 17 comprise rules in order to establish security measures for passengers",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-006-A",
                "text": "cabin baggage, checked baggage, cargo and other goods, access control and airport design",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-006-B",
                "text": "checked baggage, cargo and other goods, access control and airport design",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-006-C",
                "text": "and baggage",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-006-D",
                "text": "checked baggage, cargo and other goods",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-007",
            "text": "Member states should introduce specific security measures for the air transport of the following groups of potentially disruptive passengers defined below:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-007-A",
                "text": "Deportees and inadmissible persons only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-007-B",
                "text": "None of the answers is correct",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-007-C",
                "text": "Deportees and persons in lawful custody only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-007-D",
                "text": "Deportees, inadmissible persons and persons in lawful custody",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-008",
            "text": "For the transport of potentially disruptive passengers some supplementary safeguards are to be observed such as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-008-A",
                "text": "boarding after to all other passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-008-B",
                "text": "the boarding will be at the pilot in command discretion",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-008-C",
                "text": "boarding prior to all passengers",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-008-D",
                "text": "the boarding has to be done at the state discretion",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-009",
            "text": "When mixing or contact does take place between passengers subjected to security control and other persons not subjected to such control after the security screening points at airports serving international civil aviation have been passed",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-009-A",
                "text": "only the passengers are to be re screened",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-009-B",
                "text": "only the passengers cabin baggage are to be re screened",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-009-C",
                "text": "the passengers concerned and their cabin baggage shall be re screened before boarding an aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-009-D",
                "text": "the persons not subjected to security control shall be identified",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-010",
            "text": "Assistance to an aircraft following an act of unlawful seizure A State shall provide assistance to an aircraft subjected to an act of unlawful seizure. This assistance includes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-010-A",
                "text": "provision of navigation aids, air traffic services, permission to land and catering for passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-010-B",
                "text": "provision of navigation aids, air traffic services and permission to land",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-010-C",
                "text": "only permission to land",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-010-D",
                "text": "provision of navigation aids, air traffic services, permission to land and refuelling",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-011",
            "text": "A State shall take adequate measures for the safety of passengers and crew of an aircraft which is subjected to an act of unlawful interference,",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-011-A",
                "text": "until their journey can be continued",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-011-B",
                "text": "and arrange for them to return to their country of origin",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-011-C",
                "text": "during a period of investigation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-011-D",
                "text": "if is requested by an individual passenger",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-012",
            "text": "Unlawful interference (Hijacking) in non RVSM airspace An aircraft is being subjected to unlawful interference ('hijacked') in non RVSM airspace. The pilot is forced to divert from the cleared track or cruising level without being able to communicate with ATS. He shall try to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-012-A",
                "text": "fly the emergency triangle and try to establish radiotelephony contact with the interference coordinator of the appropriate ATS unit on 121.5 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-012-B",
                "text": "commence as soon as possible an emergency descent in order to minimise the difference between cabin pressure and outside pressure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-012-C",
                "text": "proceed at a level which differs from the cruising level normally used for IFR flights in the area by 1000 ft above FL 290 or 500 ft below FL 290.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-012-D",
                "text": "slow the speed of the aircraft down to minimum, squawk A7700 and declare emergency on 121.5 MHz",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SEC-013",
            "text": "An active crew member found by the GCAA to be under the influence of psychoactive drugs or alcohol shall;",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-013-A",
                "text": "have action taken against his license.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-013-B",
                "text": "be referred to the Police.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-013-C",
                "text": "submit the medical drug screening.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SEC-013-D",
                "text": "All of the above.",
                "correct": true
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "5a17781bb58a49c7cc754b8d7560978f",
      "name": "SAR (Search and Rescue)",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-001",
            "text": "Urgency signals. The following signal means that an aircraft wishes to give notice of difficulties which compel it to land without requiring immediate assistance:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-001-A",
                "text": "switching on and off of the landing lights in a sequence consisting of the letter group SOS.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-001-B",
                "text": "switching on and off three times the landing lights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-001-C",
                "text": "switching on and off three times the navigation lights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-001-D",
                "text": "the repeated switching on and off of the landing lights.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-002",
            "text": "Search and Rescue Signals, droppable containers .Containers or packages containing survival equipment for dropping should have the general nature of the content indicated by a colour code. The colour of droppable containers and streamers for medical supply and first aid equipment is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-002-A",
                "text": "blue",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-002-B",
                "text": "red",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-002-C",
                "text": "yellow.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-002-D",
                "text": "black.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-003",
            "text": "Search and Rescue Signals, droppable containers. Containers or packages containing survival equipment for dropping should have the general nature of the content indicated by a colour code. The colour for blankets and protective clothing is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-003-A",
                "text": "blue",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-003-B",
                "text": "red",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-003-C",
                "text": "yellow.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-003-D",
                "text": "black.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-004",
            "text": "Search and Rescue Signals, droppable containers. Containers or packages containing survival equipment for dropping should have the general nature of the content indicated by a colour code. The colour of droppable containers and streamers for food and water is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-004-A",
                "text": "blue",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-004-B",
                "text": "red",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-004-C",
                "text": "yellow.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-004-D",
                "text": "black.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-005",
            "text": "Search and Rescue - Organisation The unit responsible for promoting efficient organisation of search and rescue service in each SAR region is the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-005-A",
                "text": "Alerting Centre",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-005-B",
                "text": "Rescue Co-ordination Centre",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-005-C",
                "text": "Area Control Centre",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-005-D",
                "text": "Flight Information Centre",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-006",
            "text": "Search and Rescue signals At night an aircraft observes a luminous signal requesting help. To indicate that he has received these ground signals, the pilot shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-006-A",
                "text": "fly over the group of people in difficulty as low as possible.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-006-B",
                "text": "switch his landing lights on and off twice or, if he is not so equipped, his navigation lights twice",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-006-C",
                "text": "transmit, by luminous Morse signal, a series of the letter \"R\" using his navigational lights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-006-D",
                "text": "make at least one complete turn over the group of people in difficulty.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-007",
            "text": "Search and Rescue signals The ground - air visual signal code for use by survivors on ground in order to indicate \"REQUIRE ASSISTANCE\" is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-007-A",
                "text": "Y",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-007-B",
                "text": "V",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-007-C",
                "text": "N",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-007-D",
                "text": "X",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-008",
            "text": "Search and Rescue signals The ground - air visual signal code for use by survivors on ground in order to indicate \"REQUIRE MEDICAL ASSISTANCE\" is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-008-A",
                "text": "Y",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-008-B",
                "text": "V",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-008-C",
                "text": "N",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-008-D",
                "text": "X",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-009",
            "text": "Search and Rescue signals The ground - air visual signal code for use by survivors on ground to indicate \"NEGATIVE\" is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-009-A",
                "text": "Y",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-009-B",
                "text": "V",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-009-C",
                "text": "N",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-009-D",
                "text": "X",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SAR-010",
            "text": "Search and Rescue signals The ground - air visual signal code for use by survivors on ground to indicate \"AFFIRMATIVE\" is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-010-A",
                "text": "Y",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-010-B",
                "text": "V",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-010-C",
                "text": "N",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SAR-010-D",
                "text": "X",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "d0cd9705630da1a337b6119f7919c1f4",
      "name": "Aerodromes",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-001",
            "text": "Avoidance of collisions An aircraft taxiing on the manoeuvring area of an aerodrome shall give way to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-001-A",
                "text": "aircraft taking off or about to take of",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-001-B",
                "text": "other vehicles or pedestrians.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-001-C",
                "text": "larger (heavier) aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-001-D",
                "text": "all vehicles on the taxiways except the \"follow me\" vehicle.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-002",
            "text": "Signal from a signalman to an aircraft A signalman requests the pilot to engage brakes with the following signal:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-002-A",
                "text": "Raise arm and hand, with fingers extended, horizontally in front of body, then clench fist.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-002-B",
                "text": "Crossing arms extended above his head.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-002-C",
                "text": "Horizontally moving his hands, fingers extended, palms towards ground.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-002-D",
                "text": "Arms down, palms facing inwards, moving arms from extended position inwards.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-003",
            "text": "A separation minimum shall be applied between a light or MEDIUM aircraft and a HEAVY aircraft and between a LIGHT aircraft and a MEDIUM aircraft when the heavier aircraft is making a low or missed approach and the lighter aircraft is landing on the same runway in the opposite direction or on a parallel opposite direction runway separated by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-003-A",
                "text": "Less than 730 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-003-B",
                "text": "Less than 760 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-003-C",
                "text": "730 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-003-D",
                "text": "760 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-004",
            "text": "According to the \"Aerodrome Reference Code\", the \"Code Letter E\" shall identify an aircraft wing span of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-004-A",
                "text": "52 m up to but not including 65 m.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-004-B",
                "text": "24 m up to but not including 36 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-004-C",
                "text": "36 m up to but not including 52 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-004-D",
                "text": "15 m up to but not including 24 m.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-005",
            "text": "In the \"Aerodrome Reference Code\" the code element 2 shall identify:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-005-A",
                "text": "Only the aircraft wing span.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-005-B",
                "text": "The aircraft wing span and the outer main gear wheel span.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-005-C",
                "text": "The length of the aircraft fuselage.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-005-D",
                "text": "The width of the aircraft wing.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-006",
            "text": "Within the Annex to the ICAO convention that specifies dimensions of aerodromes are codes for different runways. Which is the minimum width of a runway with runway code 4?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-006-A",
                "text": "35 metres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-006-B",
                "text": "40 metres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-006-C",
                "text": "45 metres",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-006-D",
                "text": "50 metres",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-007",
            "text": "What is a \"barrette\"?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-007-A",
                "text": "a high obstacle near the runway and/or taxiway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-007-B",
                "text": "a frangible structure on which approach lights are fixed",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-007-C",
                "text": "three or more ground lights closely spaced together to appear as a bar of lights.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-007-D",
                "text": "a CAT II or III holding position.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-008",
            "text": "Definitions - Aerodrome Non-precision approach runways and precision approach runways CAT I,II and III are defined as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-008-A",
                "text": "Parallel Runways.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-008-B",
                "text": "Instrument runways.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-008-C",
                "text": "Non-instrument runways.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-008-D",
                "text": "Movement area.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-009",
            "text": "On the ground, when two aircraft are approaching head on:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-009-A",
                "text": "Both should declare an urgency.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-009-B",
                "text": "Both airplanes must stop or where practicable alter course to the left to keep well clear.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-009-C",
                "text": "Both airplanes must stop or where practicable alter course to the right to keep well clear.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-009-D",
                "text": "Traffic patrol has to be informed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-010",
            "text": "Definitions - Aerodrome A defined rectangular area, selected or prepared as a suitable area over which an aeroplane may make a portion of its initial climb to a specified height is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-010-A",
                "text": "Take-off run available (TORA).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-010-B",
                "text": "Clearway.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-010-C",
                "text": "Stopway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-010-D",
                "text": "Runway end safety area (RESA).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-011",
            "text": "Aerodrome - General A defined rectangular area on the ground at the end of the take-off run available, prepared as a suitable area in which an aircraft can be stopped in the case of an abandoned take-off, is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-011-A",
                "text": "Take-off run available (TORA).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-011-B",
                "text": "Clearway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-011-C",
                "text": "Stopway",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-011-D",
                "text": "Runway end safety area (RESA).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-012",
            "text": "TODA take-o distance available is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-012-A",
                "text": "The length of the take-off run available plus the length of clearway available (if provided).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-012-B",
                "text": "The length of the take-off run available plus the length of the stop way and clearway (if provided).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-012-C",
                "text": "The length of the runway available plus the length of clearway available (if provided).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-012-D",
                "text": "The length of the take-off run available plus the length of the stop way.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-013",
            "text": "ASDA (Acceleration Stop Distance Available) is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-013-A",
                "text": "The length of the take-off run available plus the length of the clearway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-013-B",
                "text": "The length of the runway plus the length of stop way available (if stop way provided).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-013-C",
                "text": "The length of the take-off run available plus the length of stop way and clearway (if provided) .",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-013-D",
                "text": "The length of the take-off run available plus the length of stop way (if stop way provided) .",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-014",
            "text": "Visual ground signals A double white cross displayed horizontally in the signal area indicates that:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-014-A",
                "text": "special precautions must be observed due to the state of the taxiways.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-014-B",
                "text": "the aerodrome is being used by gliders and that glider flights are being performed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-014-C",
                "text": "special precautions is needed while approaching for landing on the runway in use",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-014-D",
                "text": "this area is unfit for the movement of aircraft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-015",
            "text": "Visual ground signals A horizontal white dumb-bell with a black bar placed perpendicular to the shaft across each circular portion placed in the signal area indicates that:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-015-A",
                "text": "aircraft are required to land and take off on runways only, but other manoeuvres need to be confined to runways or taxiways.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-015-B",
                "text": "a parallel runway system is used at this aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-015-C",
                "text": "aircraft are required to land and take off on runways and all other manoeuvres need to be confined to runways or taxiways.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-015-D",
                "text": "the aerodrome is being used by gliders and that glider flights are being performed on a parallel runway.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-016",
            "text": "Visual ground signals A right-hand arrow of conspicuous colour indicates:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-016-A",
                "text": "the position of the Aerodrome Reference Point / ARP.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-016-B",
                "text": "that 180 degree turns on the runway for backtrack have to be made to the right.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-016-C",
                "text": "that turns in the aerodrome circuit have to be made to the left, but gliders have to make the turns to the right.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-016-D",
                "text": "that turns are to be made to the right before landing and after take of",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-017",
            "text": "Visual aids for navigation - Markings On an aerodrome equipped with parallel runways, the designation number of each runway shall be supplemented as follows:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-017-A",
                "text": "In case of three parallel runways by the letter \"L\" and \"R\" for the outer runways and no letter supplement for the central runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-017-B",
                "text": "In case of two parallel runways by adding \"10\" to the left runway designation and by subtracting \"10\" from the right runway designation. In case of three parallel runways by adding \"L\" to the designation of the runway farthest to the left,",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-017-C",
                "text": "adding one \"R\" to the central runway and adding two \"R\" to the designation of the runway farthest to the right.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-017-D",
                "text": "In case of two parallel runways by the letter \"L\" and \"R\" in the sequence from left to right.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-018",
            "text": "How many red lights must a pilot see, whose aircraft, in final approach, is following a normal glide path defined by a PAPI?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-018-A",
                "text": "None.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-018-B",
                "text": "1",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-018-C",
                "text": "2",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-018-D",
                "text": "3",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-019",
            "text": "Taxiway centre line lights other than an exit taxiway shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-019-A",
                "text": "Fixed lights showing green.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-019-B",
                "text": "Fixed lights showing white.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-019-C",
                "text": "Fixed lights showing blue.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-019-D",
                "text": "Fixed lights showing yellow.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-020",
            "text": "The abbreviation PAPI stands for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-020-A",
                "text": "Precision Approach Path Index.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-020-B",
                "text": "Precision Approach Path Indicator",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-020-C",
                "text": "Precision Approach Power Index.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-020-D",
                "text": "Precision Approach Power Indicator.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-021",
            "text": "The \"PAPI\" shall consist of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-021-A",
                "text": "Two wing bars of 6 sharp transition multi-lamp or paired units equally spaced.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-021-B",
                "text": "A wing bar of 2 sharp transition multi-lamp equally spaced.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-021-C",
                "text": "Two wing bars of 4 sharp transition multi-lamp or paired units equally spaced.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-021-D",
                "text": "A wing bar of 4 sharp transition multi-lamp or paired units equally spaced.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-022",
            "text": "Taxiway edge lights shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-022-A",
                "text": "Fixed showing green.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-022-B",
                "text": "Flashing showing blue.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-022-C",
                "text": "Fixed showing blue.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-022-D",
                "text": "Fixed showing yellow.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-023",
            "text": "Aerodrome Identification Beacon The light shown by an Aerodrome Identification Beacon of a land aerodrome shall be flashing, giving the aerodrome identification by Morse Code. The colour of this light is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-023-A",
                "text": "White.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-023-B",
                "text": "Blue.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-023-C",
                "text": "Green.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-023-D",
                "text": "Yellow.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-024",
            "text": "In a precision approach category I, lighting system, the single, two and three light sources on the centre line have a length of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-024-A",
                "text": "150 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-024-B",
                "text": "300 m.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-024-C",
                "text": "250 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-024-D",
                "text": "200 m.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-025",
            "text": "What is the length of an approach lighting system of a precision approach runway CAT II:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-025-A",
                "text": "900m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-025-B",
                "text": "600 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-025-C",
                "text": "150 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-025-D",
                "text": "300 m.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-026",
            "text": "Visual Aids for Navigation Runway-lead-in lighting shall consist:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-026-A",
                "text": "always of a straight row of lights towards the runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-026-B",
                "text": "of groups of at least three white lights, flashing in sequence towards the runway.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-026-C",
                "text": "of a group of at least 5 flashing yellow lights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-026-D",
                "text": "of an arbitrary amount of green lights.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-027",
            "text": "Which of the following alternatives describes the complete CAT 1 ('Calvert') type of approach light system?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-027-A",
                "text": "4 crossbars, centre line with 3 or 2 lamps per light unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-027-B",
                "text": "5 crossbars, centre line with 3, 2 and 1 lamp per light unit.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-027-C",
                "text": "3 crossbars, centre line with 3 or 2 lamps per light unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-027-D",
                "text": "3 crossbars, centre line with 3, 2 or 1 lamp per light unit.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-028",
            "text": "Aeronautical Ground Lights on and in the Vicinity of aerodromes Aeronautical Ground Lights on and in the vicinity of aerodromes may be turned off, provided that they can be brought back into operation before the expected arrival of an aircraft in at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-028-A",
                "text": "30 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-028-B",
                "text": "5 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-028-C",
                "text": "15 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-028-D",
                "text": "one hour.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-029",
            "text": "Visual aids for navigation - Lights - PAPI How does a pilot see the PAPI wing bar lights, when the position of the aircraft is far above the approach slope?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-029-A",
                "text": "The unit nearest to and the unit farthest from the runway are white, the two others are red.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-029-B",
                "text": "The unit nearest to and the unit farthest from the runway are steady white, the two in the centre are flashing white.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-029-C",
                "text": "All the four units are steady white.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-029-D",
                "text": "All the four units are flashing white.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-030",
            "text": "Visual aids for navigation - Approach Lights The centre line and crossbar lights of a precision approach Category I lighting system shall be fixed lights, showing variable intensity of the following colour:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-030-A",
                "text": "yellow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-030-B",
                "text": "White.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-030-C",
                "text": "Green.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-030-D",
                "text": "Blue.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-031",
            "text": "Visual aids for navigation - Runway End Lights The colour of the fixed, unidirectional Runway End Lights shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-031-A",
                "text": "yellow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-031-B",
                "text": "white.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-031-C",
                "text": "green.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-031-D",
                "text": "red.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-032",
            "text": "Visual aids for navigation - Runway threshold Lights The colour of the fixed, unidirectional runway threshold and wing bar lights shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-032-A",
                "text": "yellow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-032-B",
                "text": "white.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-032-C",
                "text": "green.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-032-D",
                "text": "flashing white.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-033",
            "text": "Visual aids for navigation - Lights - Displaced Threshold When a threshold is displaced, what colour shall the lights have in approach direction between the beginning of the runway and the displaced threshold?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-033-A",
                "text": "flashing red, intermittent with flashing white.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-033-B",
                "text": "white.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-033-C",
                "text": "red.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-033-D",
                "text": "blue, this portion of the runway is considered as taxiway",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-034",
            "text": "Visual aids for navigation - Lights Runway threshold identification lights are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-034-A",
                "text": "fixed white lights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-034-B",
                "text": "steady yellow lights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-034-C",
                "text": "flashing green lights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-034-D",
                "text": "flashing white lights.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-035",
            "text": "Visual aids for navigation - Lights Which is the principal composition of a precision approach category I lighting system?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-035-A",
                "text": "A PAPI or T-VASIS-system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-035-B",
                "text": "A row of lights on the extended centre line of the runway, extending over a distance of 420 m from the runway threshold and a crossbar at a distance of 250 m from the runway threshold.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-035-C",
                "text": "A row of lights on the extended centre line of the runway, extending over a distance of 900 m from the runway threshold and a crossbar at a distance of 300 m from the runway threshold.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-035-D",
                "text": "A row of lights on the extended centre line of the runway, extending over a distance of 600 m from the runway threshold and a crossbar at a distance of 450 m from the runway threshold.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-036",
            "text": "Visual aids for navigation - Lights Runway edge lights shall consist of at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-036-A",
                "text": "fixed lights showing variable white.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-036-B",
                "text": "flashing lights showing variable green.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-036-C",
                "text": "fixed lights showing steady green",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-036-D",
                "text": "flashing lights showing variable yellow",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-037",
            "text": "Aerodromes signs should be in the following configuration:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-037-A",
                "text": "mandatory instruction signs ; red background with black inscriptions.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-037-B",
                "text": "mandatory instruction signs; black background with red inscriptions.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-037-C",
                "text": "information signs; yellow or black background with black or yellow inscriptions.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-037-D",
                "text": "information signs; orange background with black inscriptions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-038",
            "text": "High intensity obstacle lights should be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-038-A",
                "text": "Flashing red.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-038-B",
                "text": "Fixed red.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-038-C",
                "text": "Flashing white.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-038-D",
                "text": "Fixed orange.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-039",
            "text": "Visual aids for denoting obstacles Low intensity obstacle lights on vehicles other than those associated with emergency or security shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-039-A",
                "text": "Fixed blue",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-039-B",
                "text": "Fixed red.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-039-C",
                "text": "Flashing blue.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-039-D",
                "text": "Flashing yellow.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-040",
            "text": "The aerodrome category for rescue and fire fighting is based on:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-040-A",
                "text": "The over-all length of the longest aeroplane normally using the aerodrome and its maximum fuselage width.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-040-B",
                "text": "The longest aeroplane maximum width only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-040-C",
                "text": "The over-all length of the longest aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-040-D",
                "text": "The over-all length of the longest aeroplane normally using the aerodrome and its maximum fuselage Weight.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-041",
            "text": "Low intensity obstacle lights on fixed objects shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-041-A",
                "text": "Fixed orange.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-041-B",
                "text": "Fixed red.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-041-C",
                "text": "Flashing yellow.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-041-D",
                "text": "Flashing red.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-042",
            "text": "Definitions The movement area of an airfield, the adjacent terrain and buildings or portions thereof with controlled access are called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-042-A",
                "text": "Security program.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-042-B",
                "text": "Terminal.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-042-C",
                "text": "Manoeuvring area.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-042-D",
                "text": "Airside.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-043",
            "text": "Which of the following is a valid colour scheme for signs on an aerodrome?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-043-A",
                "text": "Black on red",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-043-B",
                "text": "Orange.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-043-C",
                "text": "Yellow on black or black on yellow.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-043-D",
                "text": "Red on white.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ARD-044",
            "text": "When two aircraft are approaching head on, and there is a danger of collision:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-044-A",
                "text": "the smaller aircraft alters heading to port.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-044-B",
                "text": "the larger aircraft alters heading to starboard.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-044-C",
                "text": "both aircraft alter course to the right (starboard side).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ARD-044-D",
                "text": "both aircraft alter heading to port.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "527db8ca28b13b94fb288a96c2988efe",
      "name": "AIS & Publications",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-001",
            "text": "Abbreviations What does the abbreviation OIS mean? (Doc 8168)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-001-A",
                "text": "Obstruction in surface",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-001-B",
                "text": "Obstacle identification surface",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-001-C",
                "text": "Obstacle in surface.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-001-D",
                "text": "Obstacle identification slope.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-002",
            "text": "Abbreviations In Pans-Ops, the abbreviation DER stands for (Doc 8168)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-002-A",
                "text": "Distance error in routing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-002-B",
                "text": "Displaced end of runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-002-C",
                "text": "Direct entry route",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-002-D",
                "text": "Departure end of runway",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-003",
            "text": "An information issued by a meteorological watch office concerning the occurrence or expected occurrence of specified en-route weather phenomena which may affect the safety of low-level aircraft operations and which was not already included in the forecast issued for low level flights in the flight information region concerned or sub- area thereof is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-003-A",
                "text": "A NOTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-003-B",
                "text": "An AIRMET information",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-003-C",
                "text": "An En-Route Meteo Report",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-003-D",
                "text": "A SIGMET information",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-004",
            "text": "When are ATIS broadcasts updated?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-004-A",
                "text": "Only when weather conditions change enough to require a change in the active runway or instrument approach in use",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-004-B",
                "text": "Upon receipt of any official weather, regardless of content change or reported values",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-004-C",
                "text": "Only when the ceiling and/or visibility changes by a reportable value",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-004-D",
                "text": "Every 30 minutes if weather conditions are below those for VFR",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-005",
            "text": "Whenever ATIS is provided, the broadcast information shall be updated",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-005-A",
                "text": "at least every half an hour independently of any significant change",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-005-B",
                "text": "as prescribed by the state",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-005-C",
                "text": "as prescribed by the meteorological office",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-005-D",
                "text": "immediately a significant change occurs",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-006",
            "text": "Whenever ATIS is provided, the broadcast information shall be updated",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-006-A",
                "text": "Shall be transmitted on the voice channel of an ILS, on a discrete VHF frequency or on the voice channel of a VOR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-006-B",
                "text": "shall not be transmitted on the voice channel of an ILS",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-006-C",
                "text": "Shall only be transmitted on a discrete VHF frequency",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-006-D",
                "text": "Shall not be transmitted on the voice of a VOR",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-007",
            "text": "An AIRAC is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-007-A",
                "text": "An Acronym for a system aimed at advance notification based on common effective dates, of circumstances necessitating significant changes in operating procedures. A notice distributed by means of telecommunication containing information concerning the",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-007-B",
                "text": "establishment, condition or change in any aeronautical facility service, procedure or hazard, the timely knowledge of which is essential to personnel concerned with flight operations.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-007-C",
                "text": "A publication issued by or with the authority of a state containing aeronautical information of a lasting character essential to air navigation. A package which consists of the following elements: AIP, supplements to the AIP, NOTAM, AIC, checklists",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-007-D",
                "text": "and summaries.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-008",
            "text": "Each contracting state shall provide an Aeronautical Information Service (AIS) in its territory and for areas in which the state is responsible for the Air Traffic Services outside its territory, and this shall include the preparation and origination of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-008-A",
                "text": "Only NOTAMs and Circulars.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-008-B",
                "text": "Only AIP and NOTAMs.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-008-C",
                "text": "Integrated Aeronautical Information Package.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-008-D",
                "text": "AIP, NOTAMs, Circular and AIRAC.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-009",
            "text": "An integrated aeronautical information package consists of the following elements:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-009-A",
                "text": "AIP, supplements to AIP; NOTAM and PIB; AIC and checklist summaries.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-009-B",
                "text": "AIP, including amendment service; supplements to AIP, NOTAM, AIC and checklist summaries.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-009-C",
                "text": "AIP including amendment service; supplements to AIP; NOTAM, AIC; AIRAC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-009-D",
                "text": "AIP, including amendment service; supplements to AIP; NOTAM and pre-flight information bulletin (PIB); AIC; checklists and summaries.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-010",
            "text": "AIP Which part contains a brief description of areas and/or routes for which meteorological service is provided?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-010-A",
                "text": "METEO",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-010-B",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-010-C",
                "text": "ENR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-010-D",
                "text": "GEN",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-011",
            "text": "AIP Which part of the AIP gives detailed information about refuelling facilities and the fuel grades available?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-011-A",
                "text": "FAL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-011-B",
                "text": "AD",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-011-C",
                "text": "ENR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-011-D",
                "text": "GEN",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-012",
            "text": "AIP Which part of the AIP contains information relating to existing prohibited, restricted and danger areas?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-012-A",
                "text": "The AIP does not contain this information",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-012-B",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-012-C",
                "text": "ENR",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-012-D",
                "text": "GEN",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-013",
            "text": "AIP Which part of the AIP contains a list with \"Location Indicators\"?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-013-A",
                "text": "LOC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-013-B",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-013-C",
                "text": "ENR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-013-D",
                "text": "GEN",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-014",
            "text": "The identification of each prohibited, restricted and danger area shall be composed by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-014-A",
                "text": "The nationality letters for the location indicators assigned to the state, followed by P, R and D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-014-B",
                "text": "The letters P (Prohibited), R (Restricted) and D (Dangerous) for the area concerned and figures",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-014-C",
                "text": "The letters P (Prohibited), R (Restricted) and D (Dangerous) followed by figures",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-014-D",
                "text": "The nationality letters for location indicators assigned to the state or territory, followed the letters P. R and D and figures",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-015",
            "text": "AIP Supplements Temporary changes of \"long duration\" and information of \"short duration\" with extensive text and/or graphics are published as AIP supplements. The period of \"long duration\" is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-015-A",
                "text": "two months or longer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-015-B",
                "text": "one year or longer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-015-C",
                "text": "six months or longer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-015-D",
                "text": "three months or longer.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-016",
            "text": "AIP SIGMET information can be found in which part of the AIP?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-016-A",
                "text": "MET",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-016-B",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-016-C",
                "text": "ENR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-016-D",
                "text": "GEN",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-017",
            "text": "AIP Which part of the AIP contains a brief description of the service(s) responsible for search and rescue?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-017-A",
                "text": "SAR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-017-B",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-017-C",
                "text": "ENR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-017-D",
                "text": "GEN",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-018",
            "text": "AIP Which part of the AIP contains a brief description of the service(s) responsible for search and rescue?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-018-A",
                "text": "SAR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-018-B",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-018-C",
                "text": "ENR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-018-D",
                "text": "GEN",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-019",
            "text": "Information on holding, approach and departure procedures Which part of the AIP contains this information?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-019-A",
                "text": "AD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-019-B",
                "text": "MAP",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-019-C",
                "text": "ENR",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-019-D",
                "text": "GEN",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-020",
            "text": "The temporary, long-term modification ( 3 months or more) and the short-term extensive or graphical information are published as follows:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-020-A",
                "text": "AIP Amendments",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-020-B",
                "text": "Trigger NOTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-020-C",
                "text": "NOTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-020-D",
                "text": "AIP Supplements",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-021",
            "text": "The closure of a runway for a year, because of maintenance, will be published:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-021-A",
                "text": "in NOTAM and AIP, inclusive Supplement",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-021-B",
                "text": "only in NOTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-021-C",
                "text": "only in AIP",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-021-D",
                "text": "NOTAM, AIP and MAL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-022",
            "text": "The ASHTAM provides information on the status of activity of a volcano when a change in its activity is, or is expected to be of operational significance. This information is provided using the volcano level of colour code. When volcanic eruption in progress or volcano dangerous, eruption likely, with ash plume/cloud is reported above FL 250 or is expected to rise above FL 250, the level of alert colour code is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-022-A",
                "text": "YELLOW",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-022-B",
                "text": "GREEN",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-022-C",
                "text": "RED",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-022-D",
                "text": "ORANGE",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-023",
            "text": "Select the acronym corresponding to the following definition: a special NOTAM series notifying, by means of a specific format, an important change for the aircraft operations, due to a volcano activity, a volcano eruption or a volcanic ash cloud.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-023-A",
                "text": "NAVTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-023-B",
                "text": "ASHTAM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-023-C",
                "text": "GVATAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-023-D",
                "text": "VULTAM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-024",
            "text": "A notice providing information on Rules of the Air, Air Traffic Services and Air Navigation Procedures and distributed in advance of its effective date is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-024-A",
                "text": "An AIRAC",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-024-B",
                "text": "An Advisory NOTAM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-024-C",
                "text": "A NOTAM RAC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-024-D",
                "text": "An ATS NOTAM.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-025",
            "text": "Operationally significant changes to the AIP shall be published in accordance with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-025-A",
                "text": "AIP supplements and shall be clearly identified.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-025-B",
                "text": "AIRAC procedures and identified by the acronym AIRAC.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-025-C",
                "text": "NOTAM procedures and identified by acronym NOTAM followed by a number.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-025-D",
                "text": "AIC procedures and identified by the acronym AIC followed by a number.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-026",
            "text": "The system notifying in advance the circumstances requiring important changes in the methods of operation, based on common effective dates, is identified by the acronym:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-026-A",
                "text": "IFPS.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-026-B",
                "text": "NOTAM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-026-C",
                "text": "AIRAC.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-026-D",
                "text": "EATCHIP.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-027",
            "text": "A notice containing information concerning flight safety, air navigation, technical, administration or legislative matters and originated at the AIS of a state is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-027-A",
                "text": "Aeronautical Information Publication (AIP).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-027-B",
                "text": "NOTAM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-027-C",
                "text": "AIRAC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-027-D",
                "text": "Aeronautical Information Circular (AIC).",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-028",
            "text": "A braking action given by ATS of 0.25 and below is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-028-A",
                "text": "Medium.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-028-B",
                "text": "Poor.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-028-C",
                "text": "Medium/poor.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-028-D",
                "text": "Good.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-029",
            "text": "The documents for entry and departure of aircraft:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-029-A",
                "text": "has to be typewritten or produced by electronic data processing techniques.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-029-B",
                "text": "are accepted at the contracting state discretion.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-029-C",
                "text": "has to be typewritten.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-029-D",
                "text": "are accepted in hand-written block lettering in ink.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-030",
            "text": "Where can a pilot find information concerning the airspace limitations of the UAE FIR?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-030-A",
                "text": "In the Civil Aviation Regulations (CAR’s) Part II.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-030-B",
                "text": "In the Aeronautical Information Publication (AIP), Section ENR.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-030-C",
                "text": "In the Civil Aviation Advisory Publications.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-030-D",
                "text": "In the Notice to Airmen (NOTAMS).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-031",
            "text": "Which of the following contains administration, financial and legislative information?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-031-A",
                "text": "AIP",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-031-B",
                "text": "AICs",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-031-C",
                "text": "AIRAC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-031-D",
                "text": "NOTAM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-AIS-032",
            "text": "Which of the following contains administration, financial and legislative information?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-032-A",
                "text": "NOTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-032-B",
                "text": "AICs",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-032-C",
                "text": "AIP",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-AIS-032-D",
                "text": "AIRAC",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "a7a26de06ffdbb451b77682905ae033f",
      "name": "ATC & Air Traffic Management",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-001",
            "text": "Deviation from Flight Plan Pilots of controlled flights are requested to inform the appropriate ATS whenever the average TAS at cruising level between reporting points varies or is expected to vary from the TAS given in the flight plan by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-001-A",
                "text": "2%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-001-B",
                "text": "5%",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-001-C",
                "text": "3%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-001-D",
                "text": "4%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-002",
            "text": "General provisions - handling an ATC-flight plan in case of a delay In the event of a delay of a controlled flight, the submitted flight plan should be amended or cancelled and a new flight plan submitted when the delay is in excess of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-002-A",
                "text": "30 minutes of the estimated time of departure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-002-B",
                "text": "60 minutes of the estimated time off blocks.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-002-C",
                "text": "60 minutes of the estimated time of departure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-002-D",
                "text": "30 minutes of the estimated time off blocks.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-003",
            "text": "General provisions - handling an ATC-flight plan in case of a delay In the event of a delay for an uncontrolled flight for which a flight plan has been submitted, the flight plan should be amended or a new flight plan submitted and the old one cancelled, when the delay is exceeding the original",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-003-A",
                "text": "estimated off-block time by 30 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-003-B",
                "text": "estimated departure time by 30 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-003-C",
                "text": "estimated off-block time by 60 minutes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-003-D",
                "text": "estimated departure time by 60 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-004",
            "text": "Flight Plan For flights in accordance with IFR within advisory airspace a flight plan",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-004-A",
                "text": "shall be submitted. Changes to the flight plan have to be reported.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-004-B",
                "text": "does not have to be submitted.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-004-C",
                "text": "may be submitted at the pilots discretion. In case a flight plan is submitted all changes shall be reported as soon as practicable to the appropriate ATS unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-004-D",
                "text": "shall be submitted. There is no obligation to report changes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-005",
            "text": "Inadvertent changes from a Flight plan The appropriate ATS unit has to be informed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-005-A",
                "text": "if the time estimate for the next reporting point is found to be in error in excess of more than ten minutes from that notified to ATS.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-005-B",
                "text": "about any track deviation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-005-C",
                "text": "if the average TAS at cruising level varies or is expected to vary by +/- 5% from that given in the flight plan.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-005-D",
                "text": "about any deviation in TAS.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-006",
            "text": "SSR - Transponder When the aircraft carries serviceable Mode C transponder, the pilot shall continuously operate this mode",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-006-A",
                "text": "only when the aircraft is flying within controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-006-B",
                "text": "only when directed by ATC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-006-C",
                "text": "regardless of ATC instructions.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-006-D",
                "text": "unless otherwise directed by ATC.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-007",
            "text": "SSR - Transponder When acknowledging mode / code setting instructions, pilots shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-007-A",
                "text": "use the word ROGER.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-007-B",
                "text": "read back the code to be set and SQUAK IDENT.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-007-C",
                "text": "read back the mode and code to be set.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-007-D",
                "text": "use the word WILCO.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-008",
            "text": "The units providing Air Traffic Services are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-008-A",
                "text": "Area Control Centre - Advisory Centre - Flight Information Centre - Approach Control Office and Tower.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-008-B",
                "text": "Area Control Centre - Flight Information Centre - Approach Control Office - Aerodrome Control Tower and Air Traffic Services reporting office.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-008-C",
                "text": "Area Control Centre - Flight Information Region - Approach Control Office and Tower.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-008-D",
                "text": "Area Control Centre - Approach Control Office and Aerodrome Control Tower.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-009",
            "text": "Air traffic control service is provided for the purpose of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-009-A",
                "text": "Preventing collisions between aircraft, between aircraft and obstacles on the manoeuvring area and expediting and maintaining an orderly flow of air traffic.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-009-B",
                "text": "Avoiding collisions between all aircraft and maintaining an orderly flow of air traffic.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-009-C",
                "text": "Applying separation between aircraft and expediting and maintaining an orderly flow of air traffic.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-009-D",
                "text": "Preventing collisions between controlled air traffic and expediting and maintaining an orderly flow of air traffic.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-010",
            "text": "When an aircraft is experiencing difficulties, triggering of the alert phase is the responsibility of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-010-A",
                "text": "control centres only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-010-B",
                "text": "search and rescue co-ordination centres.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-010-C",
                "text": "air traffic control and flight information centres.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-010-D",
                "text": "air traffic co-ordination centres.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-011",
            "text": "Aerodrome traffic is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-011-A",
                "text": "All traffic on the movement area and flying in the vicinity of an aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-011-B",
                "text": "All traffic on the manoeuvring area.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-011-C",
                "text": "All traffic in the aerodrome circuit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-011-D",
                "text": "All traffic on the manoeuvring area and flying in the vicinity of an aerodrome.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-012",
            "text": "Flight Information Region (FIR) is an airspace within which the following services are provided:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-012-A",
                "text": "Flight Information Service, Alerting Service and Advisory Service.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-012-B",
                "text": "Flight Information Service and Alerting Service.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-012-C",
                "text": "Flight Information Service and Advisory Service.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-012-D",
                "text": "Flight Information Service only.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-013",
            "text": "The transfer of an aircraft from one ATC unit to another is done:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-013-A",
                "text": "through a central control unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-013-B",
                "text": "with the pilot's consent.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-013-C",
                "text": "automatically at the control zone boundary.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-013-D",
                "text": "by agreement with the receiving unit",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-014",
            "text": "Regarding Aerodrome Flight Information Service (AFIS):",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-014-A",
                "text": "its purpose is to supply ATC services but it is not a state organisation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-014-B",
                "text": "it can only supply limited services to the users and under no circumstances may it supply ATC services.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-014-C",
                "text": "its only purpose is to relay ATC information to the aircraft in flight or on the ground.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-014-D",
                "text": "it has the same privileges and prerogatives as an ATC organisation but its activity is neither continuous nor regular.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-015",
            "text": "Area Control Centres issue clearances for the purpose of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-015-A",
                "text": "Providing advisory service.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-015-B",
                "text": "Providing flight Information Service.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-015-C",
                "text": "Achieving separation between controlled flights.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-015-D",
                "text": "Achieving separation between IFR flights.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-016",
            "text": "Clearances will be issued by an ATC unit for the purpose of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-016-A",
                "text": "Providing alerting services.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-016-B",
                "text": "Achieving separation between controlled flights.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-016-C",
                "text": "Providing advisory services.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-016-D",
                "text": "Providing flight Information Service.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-017",
            "text": "Flight Information Service shall be provided to aircraft in order to avoid collision hazards when operating in airspace classes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-017-A",
                "text": "F only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-017-B",
                "text": "A, B, C, D, E, F and G",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-017-C",
                "text": "F and G only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-017-D",
                "text": "C, D, E, F, and G",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-018",
            "text": "When it becomes apparent that an aircraft is in difficulty, the decision to initiate the alert phases is the responsibility of the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-018-A",
                "text": "flight information or control organisations.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-018-B",
                "text": "search and rescue co-ordination centres.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-018-C",
                "text": "air traffic co-ordination services.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-018-D",
                "text": "operational air traffic control centres.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-019",
            "text": "The Alerting Service is provided by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-019-A",
                "text": "The Area Control Centres.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-019-B",
                "text": "Only by ATC units.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-019-C",
                "text": "The ATC unit responsible for the aircraft at that moment, when it is provided with 121.5 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-019-D",
                "text": "The ATS unit responsible for the aircraft at that moment.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-020",
            "text": "The phases related to an aircraft in emergency or believed in emergency are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-020-A",
                "text": "uncertainty phase, urgency phase, distress phase.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-020-B",
                "text": "uncertainty phase, distress phase, urgency phase.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-020-C",
                "text": "uncertainty phase, alert phase, distress phase.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-020-D",
                "text": "uncertainty phase, alert phase, distress phase and urgency phase.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-021",
            "text": "A radio communications, \"Distress\" differs from \"Urgency\" because in the first case:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-021-A",
                "text": "The aeroplane or a passenger's safety require the flight immediately interrupted.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-021-B",
                "text": "The aeroplane has suffered damages which impair its fitness to fly.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-021-C",
                "text": "The aeroplane will not be able to reach a suitable aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-021-D",
                "text": "There is a serious and imminent danger requiring immediate assistance.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-022",
            "text": "Alert phase is defined as follows:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-022-A",
                "text": "An emergency event in which an aircraft and its occupants are considered to be threatened by a danger.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-022-B",
                "text": "A situation related to an aircraft and its occupants are considered to be in a state of emergency.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-022-C",
                "text": "A situation where an apprehension exists as to the safety of an aircraft and its occupants.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-022-D",
                "text": "A situation related to an aircraft which reports that the fuel on board is exhausted.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-023",
            "text": "Which of the following statements regarding Alerting service is correct? Aircraft in the vicinity of an aircraft known or believed to be the subject of unlawful interference, shall be",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-023-A",
                "text": "informed about this.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-023-B",
                "text": "The distress phase is established when an aircraft is known or believed to be the subject of unlawful Interference.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-023-C",
                "text": "Alerting Service and Flight Information Service are often provided by the same ATS unit.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-023-D",
                "text": "The Alert phase is established when no communication has been received from an aircraft within a period of thirty minutes after the time a communication should have been received.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-024",
            "text": "Which of the following statements regarding aerodrome control service is correct?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-024-A",
                "text": "ATC permission is required for entering the apron with a vehicle. The aerodrome control service is a service provided for the purpose of preventing collisions between",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-024-B",
                "text": "aircraft on the movement area.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-024-C",
                "text": "An aircraft entering the traffic circuit without permission of ATC, will be cleared to land if this is desirable.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-024-D",
                "text": "Suspension of VFR operations can not be initiated by the aerodrome controller.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-025",
            "text": "Repetitive flight plans (RPLs) shall not be used for flights operated regularly on the same day(s) of consecutive weeks and:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-025-A",
                "text": "On at least 20 days consecutively.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-025-B",
                "text": "On at least ten occasions or every day over a period of at least 20 consecutive days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-025-C",
                "text": "On at least ten occasions or every day over a period of at least ten consecutive days.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-025-D",
                "text": "On at least 20 occasions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-026",
            "text": "The \"estimated total time\" in block 16 of a VFR flight plan is the estimated time:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-026-A",
                "text": "required by the aircraft from brake release at take-off until landing. required by the aircraft from the moment it moves by its own power until it stops at the end of the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-026-B",
                "text": "flight (block time).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-026-C",
                "text": "of endurance at cruising power taking into account pressure and temperature on that day.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-026-D",
                "text": "required by the aircraft from take-off to arrive overhead the destination airport.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-027",
            "text": "The letter \"L\" is written in the wake turbulence box of a flight plan form when the maximum certified take-off weight of an aircraft is less than or equal to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-027-A",
                "text": "20 000 kg",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-027-B",
                "text": "14 000 kg.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-027-C",
                "text": "5 700 kg for aeroplanes and 2 700 kg for helicopters.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-027-D",
                "text": "7 000 kg.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-028",
            "text": "If no ICAO identifier has been attributed to an alternate airport (box 16) of a flight plan form...",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-028-A",
                "text": "write XXXX in box 16 and indicate in box 18 (additional information) ALTN/followed by the name of the airport write ZZZZ in box 16 and indicate in box 18 (additional information) DEGT/followed by the name of the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-028-B",
                "text": "airport.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-028-C",
                "text": "write XXXX in box 16 and indicate in box 18 (additional information) DEGT/followed by the name of the airport.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-028-D",
                "text": "write ZZZZ in box 16 and indicate in box 18 (additional information) ALTN/followed by the name of the airport.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-029",
            "text": "The air traffic control unit has reported ‘'radar contact‘’, what does that mean to the pilot ?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-029-A",
                "text": "Position reports may be omitted.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-029-B",
                "text": "The pilot does not have to follow up the position of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-029-C",
                "text": "The radar identity of the aircraft has been established.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-029-D",
                "text": "The aircraft is subject to positive control.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-030",
            "text": "For an IFR flight to an airport equipped with navaids, the estimated time of arrival is the estimated time at which the aircraft:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-030-A",
                "text": "will leave the initial approach fix to start the final approach.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-030-B",
                "text": "will stop on the parking area.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-030-C",
                "text": "will land.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-030-D",
                "text": "will arrive overhead the initial approach fix.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-031",
            "text": "General provisions - amended clearance If an ATC clearance is not suitable to the pilot-in-command of an aircraft",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-031-A",
                "text": "The PIC may propose another clearance. ATC has to amend the clearance in accordance with the pilots request.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-031-B",
                "text": "The PIC may request and, if practicable, obtain an amended clearance",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-031-C",
                "text": "The PIC may request an amended clearance from the ATC. Amended clearances will only be given when VMC prevails.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-031-D",
                "text": "The PIC has to accept the ATC clearance. The clearance is based on the flight plan filed with ATC.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-032",
            "text": "What is the maximum speed adjustment that a pilot should be requested to make when under radar control and established on intermediate and final approach?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-032-A",
                "text": "± 10KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-032-B",
                "text": "± 20KT",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-032-C",
                "text": "± 15 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-032-D",
                "text": "± 25 KT",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-033",
            "text": "General provisions - change from IFR to VFR A change from instrument flight rules (IFR) to visual flight rules (VFR) is only acceptable, when VFR is permitted in that air space and when",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-033-A",
                "text": "ATC invites the PIC to change from IFR to VFR.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-033-B",
                "text": "the change is initiated by the PIC with a message containing the specific expression \"cancelling my IFR flight\".",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-033-C",
                "text": "the PIC has requested and obtained an ATC CLR for the change and has filed a special VFR flight plan.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-033-D",
                "text": "the position of the change has been noted on the ATC flight plan. The cancellation of the IFR flight will then be made automatically by ATC.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-034",
            "text": "General provisions for ATS - Content of voice position reports (according Doc4444) A complete position report transmitted by radiotelephony shall contain the following elements of information in the order listed.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-034-A",
                "text": "1) Aircraft identification, 2) position, 3) time, 4) flight level or altitude, 5) next position and time over, 6) ensuing significant point.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-034-B",
                "text": "1) Aircraft identification, 2) position, 3) flight level or altitude, 4) time, 5) next position and time over, 6) ensuing significant point.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-034-C",
                "text": "1) Aircraft identification, 2) position, 3) time, 4) true air speed, 5) flight level or altitude, 6) next position and time over.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-034-D",
                "text": "1) Aircraft identification, 2) position, 3) time, 4) flight level or altitude, 5) next position, 6) time over.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-035",
            "text": "A Special Air Report comprises a number of sections. In section I the pilot fills in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-035-A",
                "text": "a position report, including aircraft identification, height, position and time",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-035-B",
                "text": "flight identification and weather noted",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-035-C",
                "text": "urgent messages",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-035-D",
                "text": "weather noted",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-036",
            "text": "Separation methods and minima - ESSENTIAL TRAFFIC INFORMATION Essential traffic is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-036-A",
                "text": "Controlled IFR flights separated from uncontrolled flights within advisory airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-036-B",
                "text": "Uncontrolled IFR flights separated from uncontrolled VFR flights within advisory airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-036-C",
                "text": "Controlled Traffic separated from other controlled traffic with the prescribed separation minima.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-036-D",
                "text": "Controlled Traffic not separated from another controlled traffic with the prescribed separation minima.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-037",
            "text": "Independent Parallel Approaches - Requirement for a No-Transgression Zone Independent parallel approaches may be conducted to parallel runways provided that a No-Transgression Zone/NTZ is established equidistant between the extended runway centre lines. The NTZ shall have a width of at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-037-A",
                "text": "610 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-037-B",
                "text": "500 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-037-C",
                "text": "600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-037-D",
                "text": "710 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-038",
            "text": "When independent parallel approaches are being conducted to parallel runways and vectoring to intercept the ILS localizer course or MLS final approach track, the vector shall be such as to enable the aircraft to be established on the ILS localizer course or MLS final approach track in level flight for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-038-A",
                "text": "at least 2.5 NM prior to intercepting the ILS glide path or specified MLS elevation angle",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-038-B",
                "text": "at least 2.0 NM prior to intercepting the ILS glide path or specified MLS elevation angle",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-038-C",
                "text": "at least 3.0 NM prior to intercepting the ILS glide path or specified MLS elevation angle",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-038-D",
                "text": "at least 1.5 NM prior to intercepting the ILS glide path or specified MLS elevation angle",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-039",
            "text": "Definitions - Visual Approach A so called \"Visual Approach\" can be performed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-039-A",
                "text": "when either part or all of an instrument approach procedure is not completed and the approach is executed in visual reference to terrain.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-039-B",
                "text": "during IFR and VFR approaches in VMC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-039-C",
                "text": "during IFR approaches, if the cloud base is 1000 ft higher than the appropriate DA or MDA for that procedure, and the visibility is at least 5.5 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-039-D",
                "text": "during IFR approaches, if the cloud base is 1000 ft higher than the appropriate DA or MDA for that procedure.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-040",
            "text": "According to international agreements wind direction shall be adjusted to the local variation and given in degrees magnetic:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-040-A",
                "text": "When an aircraft on the request by a meteorological watch office (MWO) or at specified points transmits a PIREP",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-040-B",
                "text": "In upper wind forecast for areas north of Lat 60° north or 60° south.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-040-C",
                "text": "Before landing and take-off",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-040-D",
                "text": "When the local variation exceeds 10° East or 10° West",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-041",
            "text": "General provisions for ATS - obstacle clearance When does Air Traffic Control Services have the responsibility to prevent collisions with terrain?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-041-A",
                "text": "When a flight in accordance with IFR is vectored by radar.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-041-B",
                "text": "ATS only provides prevention when an aircraft is flying IFR in IMC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-041-C",
                "text": "Always when ATS are provided",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-041-D",
                "text": "ATS never prevent collisions with terrain.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-042",
            "text": "One of the functions ensured by a radar control unit for the provision of approach control service is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-042-A",
                "text": "To apply a reduced vertical separation of 500 feet between IFR flights and VFR flights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-042-B",
                "text": "To apply a horizontal separation less than 5 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-042-C",
                "text": "To provide instructions in order to reduce separations minima, if accepted by the pilots.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-042-D",
                "text": "To conduct surveillance radar approaches",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-043",
            "text": "When radar identification of aircraft has been achieved, the radar controller shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-043-A",
                "text": "inform the aircraft only when identification had been achieved by using primary radar.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-043-B",
                "text": "only communicate with the pilot when work load permits.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-043-C",
                "text": "inform the pilot prior to issuing instructions based on the use of radar.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-043-D",
                "text": "request the pilot to squawk ident for identification.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-044",
            "text": "Radar services - Identification without SSR Secondary Surveillance Radar\" (SSR) is not available. For radar identification ATC may request the pilot to execute one or more heading changes of",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-044-A",
                "text": "45°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-044-B",
                "text": "30° or more.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-044-C",
                "text": "20° or more",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-044-D",
                "text": "10°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-045",
            "text": "Use of Radar in the Approach Service - Vectoring to final approach track When an aircraft is vectored by radar to the localizer course, the angle between the interception course and the localizer course is normally 30 degrees. In accordance with DOC 4444 this angle shall not be greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-045-A",
                "text": "45°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-045-B",
                "text": "50°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-045-C",
                "text": "40°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-045-D",
                "text": "35°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-046",
            "text": "Radar Services - Precision Surveillance Radar / PSR identification of departing aircraft When ATC is equipped with and using PSR, at what distance from the end of the runway may a pilot expect that his aircraft can be identified?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-046-A",
                "text": "3NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-046-B",
                "text": "5NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-046-C",
                "text": "1NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-046-D",
                "text": "2NM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-047",
            "text": "During radar-control, a \"radar-controller\" shall issue a missed-approach instruction, in case the \"tower-controller\" has not issued a \"landing clearance\" at the moment the aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-047-A",
                "text": "1 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-047-B",
                "text": "2 NM from touch-down",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-047-C",
                "text": "4 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-047-D",
                "text": "3 NM from touch-down",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-048",
            "text": "When surveillance radar approaches are to be continued to the threshold of the runway transmission should not be interrupted for intervals of more than five seconds while the aircraft is within a distance of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-048-A",
                "text": "4 NM from touch-down",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-048-B",
                "text": "1.5 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-048-C",
                "text": "3 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-048-D",
                "text": "2 NM from touch-down",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-049",
            "text": "Clearance on Final Approach A pilot may expect to receive the clearance to land or any alternative clearance before the aircraft reaches a distance of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-049-A",
                "text": "4 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-049-B",
                "text": "5 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-049-C",
                "text": "3 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-049-D",
                "text": "2 NM from touch-down",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-050",
            "text": "Radar Services - Surveillance Radar Approach - Missed Approach When under radar-control, the Radar-Controller shall issue a missed approach instruction, when the Tower- Controller has not issued the Clearance to land by the time the aircraft reaches a distance of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-050-A",
                "text": "4 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-050-B",
                "text": "5 NM from touch-down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-050-C",
                "text": "2 NM from touch-down",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-050-D",
                "text": "1.5 NM from touch-down",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-051",
            "text": "Procedures related to communication failure - IFR in VMC Which procedure do you follow after having experienced a two way communication failure during a flight in accordance with IFR in VMC?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-051-A",
                "text": "Continue the flight at the assigned level and route, carry out level changes as indicated in the filed ATC flight plan, start the approach to the flight plan destination at the planned ETA.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-051-B",
                "text": "Maintain the assigned level and route and land at the nearest aerodrome where VMC conditions prevail.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-051-C",
                "text": "Continue to fly in VMC and return to the aerodrome of departure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-051-D",
                "text": "Continue to fly in VMC, land at the nearest suitable aerodrome, report the arrival by the most expeditious means to the appropriate Air Traffic Control unit.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-052",
            "text": "Communications Failure - Flight Procedures You are on a flight in accordance with IFR in IMC, exactly on the current flight plan route. At 18:36 UTC you receive and acknowledge the following instruction from the radar controller: \"Turn immediately, fly heading 050ůntil further advised\". At 18:37 UTC you discover a communication failure. Two way radio communication cannot be established again.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-052-A",
                "text": "You continue on Heading 050 for 15 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-052-B",
                "text": "You continue on Heading 050.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-052-C",
                "text": "You continue on Heading 050 for 30 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-052-D",
                "text": "You have to return to your current flight plan route.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-053",
            "text": "A strayed aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-053-A",
                "text": "only that aircraft which has deviated significantly its intended track",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-053-B",
                "text": "An aircraft which has deviated significantly from its intended track or which reports that it is lost",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-053-C",
                "text": "an aircraft in a given area but whose identity has not been established",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-053-D",
                "text": "only that aircraft which reports that it is lost",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-054",
            "text": "An air traffic control unit:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-054-A",
                "text": "may require to change the call sign for safety reasons when there is a risk of confusion between two or more similar call signs providing the aircraft is on a repetitive flight plan.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-054-B",
                "text": "may ask an aircraft to temporarily change its call sign for safety reasons when there is a risk of confusion between two or more similar call signs.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-054-C",
                "text": "must not ask an aircraft to change its call sign.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-054-D",
                "text": "may not ask an aircraft to change its call sign after accepting the flight plan.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-055",
            "text": "During an approach, when can normal separation be reduced?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-055-A",
                "text": "When the controller has both aircraft in sight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-055-B",
                "text": "When the following aircraft has the preceding in sight and can maintain it.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-055-C",
                "text": "When both aircraft are under radar control.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-055-D",
                "text": "When both pilots request it.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-056",
            "text": "Altimeter setting for takeoff and landing",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-056-A",
                "text": "QFE for takeoff and landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-056-B",
                "text": "QFE for takeoff and QNE for landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-056-C",
                "text": "QNH for takeoff and landing.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-056-D",
                "text": "QFE only for landing.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-057",
            "text": "The maximum VFR cruise level within the UAE FIR is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-057-A",
                "text": "12.500 ft AMSL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-057-B",
                "text": "FL160",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-057-C",
                "text": "FL145",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-057-D",
                "text": "FL100",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ATC-058",
            "text": "ATIS provides",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-058-A",
                "text": "Non control information in busy terminal areas",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-058-B",
                "text": "Departure information at uncontrolled aerodromes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-058-C",
                "text": "Weather information for inbound traffic to general aviation airfields.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ATC-058-D",
                "text": "Severe weather conditions only.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "d8493c88969b904c7e28686a0219f52b",
      "name": "Convention and Agreements",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-001",
            "text": "The 'Standards' contained in the Annexes to the Chicago convention are to be considered:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-001-A",
                "text": "binding for all air line companies with international traffic.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-001-B",
                "text": "binding for all member states.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-001-C",
                "text": "advice and guidance for the aviation legislation within the member states.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-001-D",
                "text": "binding for the member states that have not notified ICAO about a national Difference.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-002",
            "text": "Which of the following is obligating for members of ICAO?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-002-A",
                "text": "ICAO must be informed about new flight crew licenses and any suspended validity of such licenses",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-002-B",
                "text": "ICAO must be informed about differences from the standards in any of the Annexes to the convention",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-002-C",
                "text": "ICAO must be informed about changes in the national regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-002-D",
                "text": "ICAO shall approve the pricing of tickets on international airline connections",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-003",
            "text": "Which body of ICAO finalises the Standard and Recommended Practices (SARPS) for submission for adoption?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-003-A",
                "text": "the Assembly",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-003-B",
                "text": "the Regional Air Navigation meeting",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-003-C",
                "text": "the Council",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-003-D",
                "text": "the Air Navigation Commission",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-004",
            "text": "One of the main objectives of ICAO is to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-004-A",
                "text": "develop principles and technique for international aviation",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-004-B",
                "text": "approve new international airlines",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-004-C",
                "text": "approve the ticket prices set by international airline companies",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-004-D",
                "text": "approve new international airlines with jet aircraft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-005",
            "text": "The objectives of ICAO was ratified by the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-005-A",
                "text": "Geneva convention 1948",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-005-B",
                "text": "Chicago convention 1944",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-005-C",
                "text": "Geneva convention 1936",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-005-D",
                "text": "Warsaw convention 1929",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-006",
            "text": "The International Civil Aviation Organisation (ICAO) establishes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-006-A",
                "text": "standards and recommended international practices for contracting member states.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-006-B",
                "text": "proposals for aeronautical regulations in the form of 18 annexes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-006-C",
                "text": "standards and recommended practices applied without exception by all states, signatory to the Chicago convention.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-006-D",
                "text": "aeronautical standards adopted by all states",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-007",
            "text": "Which Freedom of the Air will be exercised by an airline planning a flight that will require a technical stop in a neighbouring State?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-007-A",
                "text": "1st freedom",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-007-B",
                "text": "3rd freedom",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-007-C",
                "text": "4th freedom",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-007-D",
                "text": "2nd freedom",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-008",
            "text": "The second freedom of the air is the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-008-A",
                "text": "right to \"cabotage\" traffic, (trans-border traffic).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-008-B",
                "text": "right to overfly without landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-008-C",
                "text": "right to land for a technical stop.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-008-D",
                "text": "right to operate a commercial passenger flight with passengers on board between two states.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-009",
            "text": "The first freedom of the air is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-009-A",
                "text": "The right to land for a technical stop.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-009-B",
                "text": "The right to overfly without landing.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-009-C",
                "text": "The opportunity to operate a commercial flight with passengers on board between two states.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-009-D",
                "text": "The right to board passengers from the state where the aircraft is registered and to fly to an other state.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-010",
            "text": "Chicago Convention \"Cabotage\" refers to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-010-A",
                "text": "a national air carrier",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-010-B",
                "text": "crop spraying",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-010-C",
                "text": "a flight above territorial waters",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-010-D",
                "text": "domestic air services",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-011",
            "text": "The convention on offences and certain acts committed on board aircraft, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-011-A",
                "text": "the convention of Paris",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-011-B",
                "text": "the convention of Tokyo",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-011-C",
                "text": "the convention of Rome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-011-D",
                "text": "the convention of Chicago",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-012",
            "text": "The convention which deals with offences against penal law, is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-012-A",
                "text": "the convention of Warsaw",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-012-B",
                "text": "the convention of Tokyo",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-012-C",
                "text": "the convention of Rome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-012-D",
                "text": "the convention of Madrid",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-013",
            "text": "The Warsaw convention and later amendments deals with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-013-A",
                "text": "limitation of the operator's liability for damage caused to passengers and goods transported",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-013-B",
                "text": "operators licence for international scheduled aviation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-013-C",
                "text": "the security system at airports",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-013-D",
                "text": "the regulation of transportation of dangerous goods",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-014",
            "text": "The international convention defining rules relative to the responsibilities of international air carriers for the carriage of passengers, baggage and freight is the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-014-A",
                "text": "Montreal Convention.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-014-B",
                "text": "Hague Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-014-C",
                "text": "Tokyo Convention.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-014-D",
                "text": "Warsaw Convention",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-015",
            "text": "The Convention of Rome 1933/1952 for the Unification of certain Rules Relating to Damage caused by Aircraft was established in order to define the liability in case of damage:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-015-A",
                "text": "to third parties on the surface.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-015-B",
                "text": "caused by Dangerous Goods that have been carried by an aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-015-C",
                "text": "to other aircraft in case of a mid-air collision.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-015-D",
                "text": "to other aircraft while operating on ground.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-016",
            "text": "The convention signed by the states and moved by a desire to ensure adequate compensation for persons who suffer damage caused on the surface by foreign aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-016-A",
                "text": "the Tokyo Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-016-B",
                "text": "the Warsaw Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-016-C",
                "text": "the Paris Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-016-D",
                "text": "the Rome Convention",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-017",
            "text": "Any person who suffers damage on the surface shall, upon proof only that damage was caused by an aircraft in flight or by any person or thing falling therefore will be entitled to compensation as provided by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-017-A",
                "text": "the Chicago Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-017-B",
                "text": "the Warsaw Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-017-C",
                "text": "the Montreal Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-017-D",
                "text": "the Rome Convention",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-018",
            "text": "Certain registration marks are prohibited by Annex 7 (Aircraft Nationality and Registration Markings). These include:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-018-A",
                "text": "XXX PAN TTT",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-018-B",
                "text": "OOO MAY DAY",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-018-C",
                "text": "LLL ZZZ YYY",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-018-D",
                "text": "EEE LLL NHQ",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-019",
            "text": "According to Annex 7 (Aircraft Nationality and Registration Markings) certain combinations of letters are not to be used. These include:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-019-A",
                "text": "XXX PAN",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-019-B",
                "text": "TTT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-019-C",
                "text": "QUG",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-019-D",
                "text": "All of the above",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-020",
            "text": "Which of the following registration marks would not be permitted?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-020-A",
                "text": "G-PRAT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-020-B",
                "text": "SY-PAN",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-020-C",
                "text": "3T-SSS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-020-D",
                "text": "YT-LLL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-021",
            "text": "A certificate of registration shall be kept ___ at all times",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-021-A",
                "text": "with the Ministry of the Contracting State",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-021-B",
                "text": "with the aircraft Operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-021-C",
                "text": "with the Ministry of the State of Registry",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-021-D",
                "text": "in the aircraft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-022",
            "text": "When letters are used for registration mark, combinations shall not be used which might be confused with urgent signals for example:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-022-A",
                "text": "LLL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-022-B",
                "text": "FFF",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-022-C",
                "text": "RCC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-022-D",
                "text": "TTT",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-023",
            "text": "The height of the marks on lighter than air aircraft other than unmanned free balloons shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-023-A",
                "text": "at least 60 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-023-B",
                "text": "at least 100 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-023-C",
                "text": "at least 50 centimetres",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-023-D",
                "text": "at least between 40 centimetres and 50 centimetres",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-024",
            "text": "The height of the marks on the fuselage (or equivalent structure) and on the vertical tail surfaces of heavier than air aircraft shall be",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-024-A",
                "text": "at least between 20 centimetres and 40 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-024-B",
                "text": "at least 40 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-024-C",
                "text": "at least 30 centimetres",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-024-D",
                "text": "at least 20 centimetres",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-025",
            "text": "When the first character of the registration mark is a letter:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-025-A",
                "text": "It may not be followed by a number",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-025-B",
                "text": "The registration mark must be completed by the national emblem",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-025-C",
                "text": "It shall be preceded by a hyphen",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-025-D",
                "text": "It shall be followed by a number",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-026",
            "text": "Which of the following is not found on the Certificate of Registration:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-026-A",
                "text": "The name and address of the owner",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-026-B",
                "text": "The nationality or common mark and registration mark",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-026-C",
                "text": "The category of aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-026-D",
                "text": "The aircraft serial number",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-027",
            "text": "Regarding an aircraft Certificate of Registration:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-027-A",
                "text": "Aircraft can be registered in more than one state",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-027-B",
                "text": "Aircraft may only have one owner",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-027-C",
                "text": "Aircraft can only be registered in one country",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-027-D",
                "text": "Aircraft registration cannot be changed from one state to another",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-028",
            "text": "When letters are used for the registration mark, combinations shall not be used which might be confused with urgent or distress signals for example:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-028-A",
                "text": "DDD",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-028-B",
                "text": "RCC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-028-C",
                "text": "XXX",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-028-D",
                "text": "LLL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-029",
            "text": "Which convention deals with the liability of a carrier to passengers and freight consignees where the limit of compensation is limited to 10,000 US dollars 10,000 except in cases of gross negligence?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-029-A",
                "text": "Rome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-029-B",
                "text": "Tokyo",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-029-C",
                "text": "Paris",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-029-D",
                "text": "Warsaw",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-030",
            "text": "Any person who suffers damage on the surface shall, upon proof only that damage was caused by an aircraft in flight or by any person or thing falling therefore will be entitled to compensation as provided by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-030-A",
                "text": "the Chicago Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-030-B",
                "text": "the Warsaw Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-030-C",
                "text": "the Montreal Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-030-D",
                "text": "the Rome Convention",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-CVA-031",
            "text": "The convention signed by the states and moved by a desire to endure adequate compensation for persons who suffer damage caused on the surface by foreign aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-031-A",
                "text": "the Paris Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-031-B",
                "text": "the Rome Convention",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-031-C",
                "text": "the Tokyo Convention",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-CVA-031-D",
                "text": "the Warsaw Convention",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "8aaf174af323381a7070e1bf842cab97",
      "name": "Transport of Dangerous Goods",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-001",
            "text": "Articles and substances are considered to be dangerous goods if defined as such by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-001-A",
                "text": "the ICAO document entitled \"Technical Instructions for the safe transport of dangerous goods by air\".",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-001-B",
                "text": "the IATA document entitled \"Regulations governing the transportation of dangerous goods by air\".",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-001-C",
                "text": "the UNO document entitled \"Dangerous Goods Regulations\".",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-001-D",
                "text": "EASA.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-002",
            "text": "Who initially is responsible for ensuring that cargo for air transportation as dangerous goods is not prohibited?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-002-A",
                "text": "The commander, always using the list of prohibited items.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-002-B",
                "text": "The shipper when completing the shipper's declaration for dangerous goods.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-002-C",
                "text": "It is not specified.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-002-D",
                "text": "The operator.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-003",
            "text": "The dangerous goods transport document shall be drawn up by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-003-A",
                "text": "the operator.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-003-B",
                "text": "the pilot in command.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-003-C",
                "text": "the handling agent.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-003-D",
                "text": "the shipper.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-004",
            "text": "The content of the dangerous goods transport document is specified in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-004-A",
                "text": "Air Transport Permit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-004-B",
                "text": "Flight Manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-004-C",
                "text": "EU-OPS documentation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-004-D",
                "text": "Technical Instructions.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-005",
            "text": "A list of dangerous goods, which may not be transported by air, can be found in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-005-A",
                "text": "Annex 6 to the Chicago Convention.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-005-B",
                "text": "the shipper's declaration for dangerous goods",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-005-C",
                "text": "the Technical Instructions for the Safe Transport of Dangerous Goods by Air.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-005-D",
                "text": "Annex 18 to the Chicago Convention.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-006",
            "text": "The ICAO Annex dealing with the safe transport of dangerous goods by air is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-006-A",
                "text": "Annex 1",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-006-B",
                "text": "Annex 8",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-006-C",
                "text": "Annex 18",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-006-D",
                "text": "Annex 17",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-007",
            "text": "ICAO Annex 18 is a document dealing with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-007-A",
                "text": "the noise pollution of aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-007-B",
                "text": "the safety of the air transport of dangerous goods.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-007-C",
                "text": "the air transport of live animals.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-007-D",
                "text": "the technical operational use of aircraft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-008",
            "text": "The complete information regarding the types of goods which the passengers are forbidden from transporting aboard an aircraft is listed in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-008-A",
                "text": "ICAO document \"Technical Instructions for the Safe Transport of Dangerous Goods by Air“.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-008-B",
                "text": "aircraft's flight manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-008-C",
                "text": "the air transport of live animals.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-008-D",
                "text": "EU-OPS documentation.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-009",
            "text": "In regards to ICAO Annex 18, when offering dangerous goods for transportation by air, who initially is responsible for compliance with the regulations?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-009-A",
                "text": "The aerodrome manager.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-009-B",
                "text": "The pilot in command.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-009-C",
                "text": "The shipper.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-009-D",
                "text": "The station manager",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-010",
            "text": "Assuming that an operator is approved by the Authority to transport dangerous goods, the carriage of dangerous goods is allowed provided that:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-010-A",
                "text": "the operator complies with the Technical Instructions (ICAO DOC 9284).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-010-B",
                "text": "no passengers and dangerous goods are carried on the same flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-010-C",
                "text": "the dangerous goods transport document is approved by the national authority prior to each flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-010-D",
                "text": "the operator has certified the dangerous goods.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-011",
            "text": "As a commander, if you are notified that a package of dangerous goods appears to be damaged, you:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-011-A",
                "text": "mention it on the Notification to Captain.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-011-B",
                "text": "accept it after a visual inspection.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-011-C",
                "text": "mention it on the shipper's declaration.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-011-D",
                "text": "ensure that arrangements are made for its removal.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-012",
            "text": "A crew member is allowed to carry safety matches: Given: 1. on himself 2. in his hand baggage 3. in his checked baggage 4. for his own use The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-012-A",
                "text": "1, 2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-012-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-012-C",
                "text": "1, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-012-D",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-013",
            "text": "In accordance with EU-OPS, where dangerous goods are carried on a flight which takes place wholly or partly outside the territory of a State, which language(s) must be used on the transport document in addition to any other language?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-013-A",
                "text": "French.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-013-B",
                "text": "English, French, Spanish, Russian, Chinese or Arabic",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-013-C",
                "text": "English.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-013-D",
                "text": "Spanish.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-014",
            "text": "Which of the following items, required to be on board an aircraft for operating reasons in accordance with the relevant JARs, are classified as dangerous goods? Given: 1. Fire extinguishers 2. Self-inflating life jackets 3. Portable oxygen supplies 4. First-aid kits The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-014-A",
                "text": "1, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-014-B",
                "text": "1, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-014-C",
                "text": "1, 2, 3, 4",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-014-D",
                "text": "2, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-015",
            "text": "Information, instructions and general guidance on the transport of dangerous goods are included in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-015-A",
                "text": "Operations Manual.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-015-B",
                "text": "Flight Manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-015-C",
                "text": "AIP.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-015-D",
                "text": "Air Operator Certificate.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-DGR-016",
            "text": "The permanent approval for the transport of dangerous goods is specified in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-016-A",
                "text": "air operator certificate.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-016-B",
                "text": "certificate of aircraft registration.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-016-C",
                "text": "airworthiness certificate.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-DGR-016-D",
                "text": "insurance certificate.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "9075825c19d6714cb9d5ffc89cd587ea",
      "name": "Air Navigation",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-001",
            "text": "Definitions (ICAO Doc 8168) What is: A turn executed by the aircraft during the initial approach between the end of the outbound track and the beginning of the intermediate or final approach track. The tracks are not reciprocal.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-001-A",
                "text": "Procedure turn",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-001-B",
                "text": "Reversal procedure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-001-C",
                "text": "Race track",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-001-D",
                "text": "Base turn",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-002",
            "text": "Definitions What is: A manoeuvre in which a turn is made away from a designated track followed by a turn in the opposite direction to permit the aircraft to intercept and proceed along the reciprocal of the designated track:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-002-A",
                "text": "Procedure turn",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-002-B",
                "text": "Reversal procedure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-002-C",
                "text": "Race track",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-002-D",
                "text": "Base turn",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-003",
            "text": "Instrument Departure Procedure - Wind correction Flying an Instrument Departure Procedure pilots are expected to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-003-A",
                "text": "request from ATC an adequate heading to cater for wind direction and strength.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-003-B",
                "text": "correct the track for known wind to remain within the protected airspace.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-003-C",
                "text": "ignore the wind and proceed on a heading equal to the track",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-003-D",
                "text": "request a clearance from ATC with regards to a wind correction to be applied.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-004",
            "text": "Standard Instrument Departure Procedures - Straight Departures A straight departure is one in which the initial departure track does not deviate from the alignment of the extended runway centre line by more than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-004-A",
                "text": "45°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-004-B",
                "text": "30°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-004-C",
                "text": "12.5°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-004-D",
                "text": "15°.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-005",
            "text": "Approach procedures - Instrument Approach Area The primary area of an instrument approach segment is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-005-A",
                "text": "a defined area symmetrically disposed about the nominal flight track in which the Minimum Obstacle clearance is provided.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-005-B",
                "text": "the first part of the segment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-005-C",
                "text": "the most critical part of the segment where the minimum altitude should be kept very carefully.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-005-D",
                "text": "the outside part of the segment where the obstacle clearance increases from zero ft to the appropriate minimum.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-006",
            "text": "OCA An OCA is referenced to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-006-A",
                "text": "Mean Sea Level",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-006-B",
                "text": "an Aerodrome Elevation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-006-C",
                "text": "the Aerodrome Reference Point",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-006-D",
                "text": "the relevant Runway Threshold",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-007",
            "text": "Approach Procedures - Non-precision - straight-in A so-called \"straight-in-approach\" is considered to be acceptable for a non precision approach, if the angle between the final approach track and the runway centreline is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-007-A",
                "text": "20° or less",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-007-B",
                "text": "30° or less",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-007-C",
                "text": "10° or less",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-007-D",
                "text": "40° or less",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-008",
            "text": "Approach procedures - Minimum Sector Altitudes / MSA Minimum Sector Altitudes are established for each aerodrome. The MSA provides an obstacle clearance of at least 300m (984 ft) within a circle, associated with the homing facility for the approach procedure of that aerodrome. How many NM is the radius of this circle?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-008-A",
                "text": "5 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-008-B",
                "text": "10 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-008-C",
                "text": "25 NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-008-D",
                "text": "20 NM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-009",
            "text": "Approach procedures - MDH / OCH For a non-precision or circling approach, the Minimum Descent Height (MDH) cannot be lower than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-009-A",
                "text": "the Obstacle Clearance Height (OCH)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-009-B",
                "text": "350 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-009-C",
                "text": "400 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-009-D",
                "text": "200 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-NAV-010",
            "text": "Arrival and Approach segments - General What are the names of all separate segments that can be part of an instrument approach procedure?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-010-A",
                "text": "Initial, intermediate, final.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-010-B",
                "text": "Arrival, holding, initial, intermediate, final, missed approach.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-010-C",
                "text": "Descend, holding arrival, initial, intermediate, final, missed approach.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-NAV-010-D",
                "text": "Arrival, initial, intermediate, final, missed approach.",
                "correct": true
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "06af8f16dc23b9c6a90adf102f0ce566",
      "name": "Airworthiness",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-EMY-001",
            "text": "The state of design shall ensure that, there exists a continuing structural integrity program to ensure the airworthiness of the aeroplane, which includes specific information concerning corrosion prevention and control, in respect of aeroplanes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-001-A",
                "text": "up to 5.700 kg maximum certificate take-off mass.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-001-B",
                "text": "over 5.700 kg maximum certificate take-off mass.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-001-C",
                "text": "up to 5.700 kg maximum certificate take-off and landing mass.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-001-D",
                "text": "over 5.700 kg maximum certificate take-off and landing mass.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-EMY-002",
            "text": "When an aircraft has sustained damage, the aircraft shall be allowed to resume its flight, if",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-002-A",
                "text": "the state of registry considers that the damage sustained is of a nature such that the aircraft is still airworthy.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-002-B",
                "text": "the state of manufacture informs the state of registry that the damage sustained is of a nature such that the aircraft is still airworthy. the state of design and the state of manufacture inform the state of registry that the aircraft is still",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-002-C",
                "text": "airworthy.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-002-D",
                "text": "the state of registry, the state of design and the state of manufacture consider that the aircraft is still airworthy.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-EMY-003",
            "text": "According to ICAO Annex 8, a certificate of airworthiness shall be renewed or shall remain valid subject to the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-003-A",
                "text": "Laws of the State of registry and operation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-003-B",
                "text": "Laws of the State in which is operated",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-003-C",
                "text": "Requirements laid down by ICAO",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-EMY-003-D",
                "text": "Laws of the State of registry",
                "correct": true
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "9cd0409d9edd69e7d992fc71ac465fe3",
      "name": "Rules of the Air",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-001",
            "text": "The aircraft commander, when he has reasonable grounds to believe that a person has committed or is about to commit, on board the aircraft, an offence against penal law",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-001-A",
                "text": "may require the assistance of passengers to restrain such person",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-001-B",
                "text": "may deliver such person to the competent authorities",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-001-C",
                "text": "may not require or authorise the assistance of other crew members",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-001-D",
                "text": "may request such a person to disembark",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-002",
            "text": "The loading limitations shall include:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-002-A",
                "text": "all limiting mass and centres of gravity",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-002-B",
                "text": "all limiting mass, centres of gravity position, mass distributions and floor loading",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-002-C",
                "text": "all limiting mass, centres of gravity position and floor loading",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-002-D",
                "text": "all limiting mass, mass distributions and centres of gravity",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-003",
            "text": "The height of the marks under the wings of heavier than air aircraft shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-003-A",
                "text": "at least 50 centimetres",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-003-B",
                "text": "at least 60 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-003-C",
                "text": "at least 75 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-003-D",
                "text": "at least between 40 centimetres and 50 centimetres",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-004",
            "text": "The height of the marks on the fuselage (or equivalent structure) and on the vertical tail surfaces of heavier-than- air aircraft shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-004-A",
                "text": "at least between 20 centimetres and 40 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-004-B",
                "text": "at least 40 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-004-C",
                "text": "at least 20 centimetres",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-004-D",
                "text": "at least 30 centimetres",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-005",
            "text": "Flight plan - Inadvertent track changes. In the event that a controlled flight inadvertently deviates from its track given in the current flight plan, action should be taken in order to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-005-A",
                "text": "climb or descent by 500 ft, inform the appropriate ATS unit",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-005-B",
                "text": "maintain VMC, wait for instructions from the appropriate ATS unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-005-C",
                "text": "notify the appropriate ATS unit immediately notifying the new track and to comply with instructions from ATS.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-005-D",
                "text": "adjust the heading of aircraft to regain track as soon as practicable",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-006",
            "text": "According to Annex 7, the registration mark shall be letters, numbers or a combination of letters and numbers and shall be that assigned by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-006-A",
                "text": "the International Civil Aviation Organisation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-006-B",
                "text": "the state of registry or common mark registering authority",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-006-C",
                "text": "the International Telecommunication Union",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-006-D",
                "text": "the state of registry only",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-007",
            "text": "ICAO Annex 2 – Definitions Who is charged with the safe conduct of a flight?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-007-A",
                "text": "The ATC controller whenever the aircraft is flying in controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-007-B",
                "text": "The airline operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-007-C",
                "text": "The aircraft owner.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-007-D",
                "text": "The pilot-in-command.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-008",
            "text": "Authority The final authority as to the disposition of the aircraft has the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-008-A",
                "text": "aircraft owner.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-008-B",
                "text": "Pilot-in-command.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-008-C",
                "text": "ATC controller whenever the aircraft is flying in controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-008-D",
                "text": "Operator.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-009",
            "text": "General provisions - Responsibility for terrain clearance Who is in general responsible for an ATC clearance to be safe in respect to terrain clearance?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-009-A",
                "text": "The ATC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-009-B",
                "text": "The pilot-in-command.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-009-C",
                "text": "The ATS reporting office accepting the flight plan.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-009-D",
                "text": "The aircraft operator.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-010",
            "text": "The pilot in command of an aircraft: Given: 1. must comply immediately to all instructions received from ATC. 2. is responsible only if he is the \"pilot flying\". 3. may deviate from air regulations for safety reasons. 4. may be exempt from air regulations in order to comply to an ATC instruction. 5. may ask for the modification of an unsatisfactory clearance. Which of the following combinations contains all of the correct statements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-010-A",
                "text": "3 - 4 - 5",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-010-B",
                "text": "1 - 4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-010-C",
                "text": "2 - 3 - 5",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-010-D",
                "text": "3 - 5",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-011",
            "text": "Avoidance of collisions The highest priority for landing has:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-011-A",
                "text": "a military aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-011-B",
                "text": "an aircraft on a diplomatic flight (Head of state).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-011-C",
                "text": "an Air Ambulance carrying a very sick person needing immediate medical attention.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-011-D",
                "text": "an aircraft that is compelled to land (Emergency landing)",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-012",
            "text": "Right of way - Converging Two aircraft are approaching each other in a controlled airspace class D in VMC at approximately the same level on converging courses. Aircraft \"A\" is flying under IFR, and Aircraft \"B\" is flying under VFR. Who has the right of way?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-012-A",
                "text": "Aircraft \"A\" regardless of the direction from which \"B\" is approaching.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-012-B",
                "text": "Aircraft \"B\", providing it has \"A\" on its left",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-012-C",
                "text": "Aircraft \"A\", providing it has \"B\" on its right.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-012-D",
                "text": "Aircraft \"B\" regardless of the direction from which \"A\" is approaching.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-013",
            "text": "Light signals A red flare addressed to an aircraft in flight means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-013-A",
                "text": "Return for approach, clearance to land to be expected on final.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-013-B",
                "text": "Aerodrome unsafe, do not land.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-013-C",
                "text": "Slow down speed to minimum, give way to other aircraft in the circuit and continue circling.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-013-D",
                "text": "Notwithstanding any previous instructions, do not land for the time being.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-014",
            "text": "Right of way An overtaking aircraft is an aircraft that approaches another aircraft from the rear on a line forming an angle of less than",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-014-A",
                "text": "70 degrees with the plane of symmetry of the latter.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-014-B",
                "text": "50 degrees with the plane of symmetry of the latter.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-014-C",
                "text": "80 degrees with the plane of symmetry of the latter.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-014-D",
                "text": "60 degrees with the plane of symmetry of the latter.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-015",
            "text": "Anticollision lights Aircraft equipped with red anticollision lights may display them:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-015-A",
                "text": "outside the daylight-period at engine-start. During the daylight period this procedure is not applicable.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-015-B",
                "text": "on the ground when the engines are running.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-015-C",
                "text": "while taxiing, but not when being towed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-015-D",
                "text": "outside the daylight-period in flight, but not on the ground when being towed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-016",
            "text": "Light signals for aerodrome traffic A series of green flashes from aerodrome control directed towards an aircraft in flight means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-016-A",
                "text": "Return for landing.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-016-B",
                "text": "Cleared to land.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-016-C",
                "text": "Continue circling and give way to other aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-016-D",
                "text": "Make a short approach and land as soon as possible.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-017",
            "text": "Light signals for aerodrome traffic: A series of red flashes from aerodrome control directed toward an aircraft on the ground means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-017-A",
                "text": "Slow down taxi speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-017-B",
                "text": "Stop and taxi back, you are on the wrong taxiway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-017-C",
                "text": "Taxi clear of the landing area in use.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-017-D",
                "text": "Give way to other aircraft taxiing.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-018",
            "text": "Light signals for aerodrome traffic A series of green flashes from aerodrome control directed towards an aircraft on the ground means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-018-A",
                "text": "Cleared to taxi.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-018-B",
                "text": "Accelerate taxi speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-018-C",
                "text": "Slow down taxi speed, but continue.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-018-D",
                "text": "Stand by, clearance for take off will be given in short time.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-019",
            "text": "Right of way / Avoidance of collisions When two aircraft are approaching head-on or approximately so and there is a danger of collision, each shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-019-A",
                "text": "alter its heading to the left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-019-B",
                "text": "switch on all available lights in order to warn the other traffic.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-019-C",
                "text": "turn, climb, or descend as appropriate in order to avoid.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-019-D",
                "text": "alter its heading to the right.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-020",
            "text": "Visual signals In flight, the pilot of an aircraft observes a series of projectiles discharged from the ground at intervals of 10 seconds, each showing, on bursting, red and green lights or stars. The meaning of this signal is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-020-A",
                "text": "The aerodrome nearby you have chosen for landing is unsafe, do not attempt to land. Proceed to your alternate.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-020-B",
                "text": "The unauthorized aircraft is flying in or about to enter a restricted, prohibited or danger area and the aircraft is to take such remedial action as may be necessary.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-020-C",
                "text": "Give way to other aircraft and continue circling.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-020-D",
                "text": "Give way to other aircraft and continue circling.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-021",
            "text": "Visual Flight Rules Except when clearance is obtained from an ATC unit, VFR flights shall not take off or land at an aerodrome within a CTR of Airspace Class C or D or enter the aerodrome traffic zone or traffic pattern when the",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-021-A",
                "text": "ceiling is less than 1 000 ft or the ground visibility is less than 5 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-021-B",
                "text": "ceiling is less than 2 000 ft or the ground visibility is less than 5 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-021-C",
                "text": "ceiling is less than 1 500 ft or the ground visibility is less than 5 km",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-021-D",
                "text": "ceiling is less than 1 000 ft or the ground visibility is less than 8 km.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-022",
            "text": "Visual Flight Rules An aircraft operating in accordance with VFR, above the sea at altitudes between 4500 ft and 9000 ft AMSL, outside controlled airspace shall maintain at least",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-022-A",
                "text": "a distance from cloud of 1000 m horizontally and 1000 ft vertically and a flight visibility of 5 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-022-B",
                "text": "a distance from cloud of 1500 m horizontally and 1000 ft vertically and a flight visibility of 8 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-022-C",
                "text": "a distance from cloud of 1500 m horizontally and 1000 ft vertically and a flight visibility of 5 km.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-022-D",
                "text": "a distance from cloud of 600 m horizontally and 1000 ft vertically and a flight visibility of 5 km.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-023",
            "text": "Visual Flight Rules Above an altitude of 10000 ft, flights operating within airspace Class \"G“ in accordance with VFR shall observe the following weather minima:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-023-A",
                "text": "a distance from cloud: 1 Nautical Mile (NM) horizontally, 1000 ft vertically, flight visibility: 5 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-023-B",
                "text": "a distance from cloud: 1500 m horizontally, 1000 ft vertically, flight visibility: 8 km.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-023-C",
                "text": "a distance from cloud: 1 Nautical Mile (NM) horizontally, 1000 ft vertically, flight visibility: 8 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-023-D",
                "text": "a distance from cloud: 1500 m horizontally, 1000 ft vertically, flight visibility: 5 km.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-024",
            "text": "Minimum level IFR When not flying over high terrain or mountainous areas and where no minimum flight altitude has been established, flights in accordance with IFR shall be flown at a level that is at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-024-A",
                "text": "1 000 ft above the highest obstacle located within 8 km of the estimated position of the aircraft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-024-B",
                "text": "2 000 ft above the highest obstacle located within 8 km of the estimated position of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-024-C",
                "text": "2 000 ft above the highest obstacle located within 10 NM of the estimated position of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-024-D",
                "text": "1 000 ft above the highest obstacle located within 10 NM of the estimated position of the aircraft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-025",
            "text": "Communication failure After experiencing a communication failure on a flight in accordance with IFR, the aircraft shall comply with the communication failure procedures. When flying in VMC, the aircraft shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-025-A",
                "text": "continue on to destination, complying with last received and confirmed clearances or with filed flight plan. continue to fly in VMC, land at the nearest suitable aerodrome and report its arrival by most expeditious",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-025-B",
                "text": "means to the appropriate ATS unit. descend to Minimum Safe Altitude / Level, continue to the nearest aerodrome with instrument approach",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-025-C",
                "text": "procedure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-025-D",
                "text": "adopt a VFR flight level and continue according to VFR to the flight plan destination.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-026",
            "text": "Minimum level IFR Over high terrain or mountainous areas, where no minimum flight altitude has been established, flights in accordance with IFR shall be flown at a level that is at least",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-026-A",
                "text": "2 000 ft above the highest obstacle located within 10 NM of the estimated position of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-026-B",
                "text": "1 000 ft above the highest obstacle located within 10 NM of the estimated position of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-026-C",
                "text": "2 000 ft above the highest obstacle located within 5 NM of the estimated position of the aircraft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-026-D",
                "text": "1 000 ft above the highest obstacle located within 5 NM of the estimated position of the aircraft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-027",
            "text": "What is the minimum vertical separation between aircraft flying IFR below flight level 290?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-027-A",
                "text": "2000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-027-B",
                "text": "1000 feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-027-C",
                "text": "1500 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-027-D",
                "text": "500 feet",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-028",
            "text": "Interception An aircraft equipped with SSR transponder which is intercepted by another aircraft shall immediately, unless otherwise instructed by the appropriate air traffic service unit, select Mode A",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-028-A",
                "text": "Code 7000.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-028-B",
                "text": "Code 7600.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-028-C",
                "text": "Code 7500.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-028-D",
                "text": "Code 7700.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-029",
            "text": "Interception An aircraft that is intercepted by another aircraft shall immediately attempt to establish radio-communication with the intercepting aircraft or with the appropriate intercept control unit, by making a general call on the frequency",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-029-A",
                "text": "121.5 MHz If no contact has been established, and if practicable, repeat this call on the frequency 125.5 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-029-B",
                "text": "243 MHz If no contact has been established, and if practicable, repeat this call on the frequency 125 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-029-C",
                "text": "121.5 MHz If no contact has been established, and if practicable, repeat this call on the frequency 282.8 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-029-D",
                "text": "121.5 MHz If no contact has been established, and if practicable, repeat this call on the frequency 243 MHz",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-030",
            "text": "Interception, DAY or NIGHT Which maneuvre will be executed by an intercepting aircraft if the pilot of this aircraft wants to communicate to the intercepted aircraft \"YOU MAY PROCEED\"?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-030-A",
                "text": "121.5 MHz If no contact has been established, and if practicable, repeat this call on the frequency 125.5 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-030-B",
                "text": "243 MHz If no contact has been established, and if practicable, repeat this call on the frequency 125 MHz",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-030-C",
                "text": "121.5 MHz If no contact has been established, and if practicable, repeat this call on the frequency 282.8 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-030-D",
                "text": "121.5 MHz If no contact has been established, and if practicable, repeat this call on the frequency 243 MHz",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-031",
            "text": "Interception If radio contact is established during interception but communication in a common language is not possible, attempts shall be made to convey instructions and essential information by using standard phrases and pronunciations, transmitting each phrase twice. The standard phrase with the meaning \"Descend for landing\" for use by INTERCEPTING aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-031-A",
                "text": "DESCEND FOR LAND DEE-SEND FOR LAAND",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-031-B",
                "text": "YOU LAND YOU-LAAND",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-031-C",
                "text": "DESCEND DEE-SEND",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-031-D",
                "text": "LET DOWN LET-DAUN",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-032",
            "text": "If radio contact with the intercepting aircraft is established but communication in a common language is not possible, which phrase should be pronounced by the intercepted aircraft to communicate that he is unable to comply with the instructions received?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-032-A",
                "text": "CAN NOT COMPLY",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-032-B",
                "text": "UNABLE TO COMPLY",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-032-C",
                "text": "NOT POSSIBLE",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-032-D",
                "text": "CAN NOT",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-033",
            "text": "Interception If any instructions received by radio from any sources conflict with those given by the intercepting aircraft by visual signals, the intercepted aircraft shall: ignore the signals of the intercepting aircraft and continue in accordance with the last clearance received",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-033-A",
                "text": "and confirmed by the appropriate ATS unit. select transponder mode A, squawk 7600 and fly holding patterns until having received instructions from",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-033-B",
                "text": "the appropriate ATS unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-033-C",
                "text": "ignore the signals of the intercepting aircraft and request instructions from the appropriate ATS unit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-033-D",
                "text": "follow the instructions of the intercepting aircraft and request immediate clarification.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-034",
            "text": "An approaching aircraft may descent below the MSA if:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-034-A",
                "text": "the pilot has the field and the underlying terrain in sight and will keep it in sight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-034-B",
                "text": "all mentioned answers are correct",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-034-C",
                "text": "the pilot is following the published approach procedure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-034-D",
                "text": "the aircraft gets radar vectors",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-035",
            "text": "Approach procedures - Final approach segment - precision approach - ILS The ILS obstacle clearance surfaces assume that the pilot does not normally deviate from the centreline more than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-035-A",
                "text": "One and a half of a scale deflection after being established on the track.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-035-B",
                "text": "One full scale deflection after being established on the track.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-035-C",
                "text": "Half a scale deflection after being established on the track.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-035-D",
                "text": "A quarter of a scale deflection after being established on the track.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-036",
            "text": "SSR - Transponder When an aircraft is subjected to unlawful interference, the pilot in command shall indicate the situation by setting the transponder to Mode A, Code",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-036-A",
                "text": "7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-036-B",
                "text": "7600",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-036-C",
                "text": "7500",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-036-D",
                "text": "7000",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-037",
            "text": "SSR - Transponder Pilots shall not SQUAK IDENT unless they:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-037-A",
                "text": "operate a transponder with Mode C",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-037-B",
                "text": "operate within controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-037-C",
                "text": "are requested by ATC.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-037-D",
                "text": "operate outside controlled airspace.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-038",
            "text": "When the transponder appears to be unserviceable prior to departure and restore is impossible, than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-038-A",
                "text": "you must indicate the failure in the fight plan, after which the ATC will endeavour to provide for continuation of the flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-038-B",
                "text": "departure to the nearest suitable airport where repair can be effected is allowed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-038-C",
                "text": "the flight can only continue in the most direct manner.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-038-D",
                "text": "you are not allowed to commence the flight.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-039",
            "text": "Flight information service provided to flights shall include the provision of information concerning collision hazards to aircraft operating in airspace classes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-039-A",
                "text": "A to E (inclusive)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-039-B",
                "text": "A to G (inclusive)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-039-C",
                "text": "F and G",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-039-D",
                "text": "C to G (inclusive)",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-040",
            "text": "You receive an IFR enroute clearance stating: Clearance expires at 0920. What does it mean?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-040-A",
                "text": "If not airborne until 0920, a new clearance has to be issued",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-040-B",
                "text": "Do not take off before 0920",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-040-C",
                "text": "After 0920 return to the ramp and file a new flight plan",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-040-D",
                "text": "The take off clearance is expected at 0920",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-041",
            "text": "Change from IFR to VFR will always take place:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-041-A",
                "text": "on the initiative of the aircraft commander",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-041-B",
                "text": "as instructed by an air traffic control unit",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-041-C",
                "text": "at the clearance limit, irrespective of the weather conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-041-D",
                "text": "when the aircraft is leaving controlled airspace during VMC",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-042",
            "text": "Changing of flight rules from IFR to VFR is possible",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-042-A",
                "text": "If the commander so requests",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-042-B",
                "text": "If instructed by ATC so long as VMC is forecasted during the next 30 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-042-C",
                "text": "If instructed by ATC so long as VMC is forecasted during the next 60 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-042-D",
                "text": "Only when leaving controlled airspace",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-043",
            "text": "Separation Methods and Minima - General What are the controlled traffic separation methods applied by ATC?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-043-A",
                "text": "Vertical and horizontal separation.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-043-B",
                "text": "Time separation and track separation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-043-C",
                "text": "Vertical, horizontal and angular separation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-043-D",
                "text": "Composite separation",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-044",
            "text": "Which of the following Annexes to the Chicago convention contains minimum specifications for the design of aerodromes?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-044-A",
                "text": "Annex 11",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-044-B",
                "text": "Annex 6",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-044-C",
                "text": "Annex 14",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-044-D",
                "text": "Annex 10",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-045",
            "text": "Which annexes to the Chicago Convention deal with the registration and marking of aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-045-A",
                "text": "Annex 11",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-045-B",
                "text": "Annex 6",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-045-C",
                "text": "Annex 14",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-045-D",
                "text": "Annex 7",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ROA-046",
            "text": "Classification of Airspace Above 3050m (10000 ft) AMSL, the VMC minima for VFR flights in all classes of airspace are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-046-A",
                "text": "Visibility: 8 km, Distance from clouds: 1500 m horizontal, 1000 ft vertical.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-046-B",
                "text": "No minima defined, VFR flights are not permitted.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-046-C",
                "text": "Visibility: 5 km, Distance from clouds: 1500 m horizontal, 1000 ft vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ROA-046-D",
                "text": "Visibility: 8 km, clear of clouds.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "3c93cff611364e7f40526b7d8550b405",
      "name": "Accident and Investigation",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-001",
            "text": "Accident, Incident notification, and reporting After landing, while taxiing towards the apron the landing gear sinks into a hole. Nobody gets injured, but the aircraft sustains a structural failure. This obliges the crew to delay the departure. This is an irregularity in the operation. The crew must inform the operator of the aerodrome and establish a",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-001-A",
                "text": "report.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-001-B",
                "text": "This is an accident and the crew must follow the procedure relevant to this case. Since there is no person injured and the flight is terminated, a damage report has to be made out with the",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-001-C",
                "text": "services of the aerodrome in charge of the runway and taxiways for the insurance company.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-001-D",
                "text": "This is an incident and the pilot-in-command must report it to the airport authority within the next 48 hours.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-002",
            "text": "Accident / Incident notification and reporting The aircraft has made a complete stop on the apron. When leaving the aircraft, one of the passengers walks into the trailing edge of the wing and gets seriously injured.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-002-A",
                "text": "This is an accident. The crew must follow the procedure relevant for this case.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-002-B",
                "text": "This is an incident. The pilot-in-command must report it to the airport authority within the next 48 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-002-C",
                "text": "This is a matter of passenger insurance as the flight is terminated and the aeroplane doors are open. The airport operator or the company in charge of the handling shall establish a report for the insurance company.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-002-D",
                "text": "This is an irregularity in the handling. The handling agent must inform his insurance company",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-003",
            "text": "Notification and reporting During the climb-out phase of a flight, the pilot-in-command becomes incapacitated. The co-pilot takes over control of the aircraft and decides that he will return for landing. What action has to be taken after landing?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-003-A",
                "text": "This is an accident. The crew must follow the procedure relevant to an accident.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-003-B",
                "text": "This is an irregularity in the operation. The operator must inform the Authority by writing an Irregularity report.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-003-C",
                "text": "This is an irregularity. The pilot-in-command or the Operator must deposit a report on behalf of the involved airport Authority within the following 48 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-003-D",
                "text": "This is a serious incident. The crew must follow the procedure relevant to an incident.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-004",
            "text": "Accident investigation Who is responsible for the initiation of an accident investigation?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-004-A",
                "text": "The State of design and manufacturer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-004-B",
                "text": "The aircraft manufacturer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-004-C",
                "text": "The Authority of the State in which the accident took place.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-004-D",
                "text": "The Operators of the same aircraft type.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-005",
            "text": "Accident investigation, objective The sole objective of the investigation of an accident or incident shall be the",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-005-A",
                "text": "prevention of accidents or incidents and to establish liability.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-005-B",
                "text": "prevention of accidents or incidents and to provide the manufacturer with investigation data for the improvement of the design.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-005-C",
                "text": "prevention of accidents or incidents and to provide legal evidence for subsequent court cases.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-005-D",
                "text": "prevention of accidents or incidents.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-006",
            "text": "Who is responsible for the investigation of an accident?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-006-A",
                "text": "ICAO.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-006-B",
                "text": "Combination of the State of Occurrence and the State of Registry.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-006-C",
                "text": "State of Registry.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-006-D",
                "text": "State of Occurrence.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-007",
            "text": "During taxi to the runway for take off, the aircraft is accidentally taxied onto the grass and the undercarriage is seriously damaged. Nobody on board or on the ground is hurt. What type of occurrence is this?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-007-A",
                "text": "Incident",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-007-B",
                "text": "Serious incident",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-007-C",
                "text": "Accident",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-007-D",
                "text": "Serious accident",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-008",
            "text": "Which of the following would be considered to be an accident?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-008-A",
                "text": "Engine failure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-008-B",
                "text": "Tyre deflation during an abandoned take off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-008-C",
                "text": "Puncture holes in the aircraft skin.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-008-D",
                "text": "The aircraft is missing or completely inaccessible.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-009",
            "text": "When taxiing from the stand to the runway a person on the ground is injured by the jet blast from the engines. How would this occurrence be described?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-009-A",
                "text": "Incident",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-009-B",
                "text": "Serious incident",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-009-C",
                "text": "Accident",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-009-D",
                "text": "Serious occurrence",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-010",
            "text": "Which of the following defines an incident?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-010-A",
                "text": "Any occurrence involving damage to an aircraft. An occurrence, other than an accident, associated with the operation of an aircraft, which affects or could",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-010-B",
                "text": "have affected the safety of the operation. An occurrence associated with the operation of an aircraft that takes place between the time any person",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-010-C",
                "text": "boards the aircraft with the intention of flight until such time as all persons have disembarked, in which a person is fatally or seriously injured.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-010-D",
                "text": "Any of the above providing the aircraft is seriously damaged at the same time.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-011",
            "text": "The State conducting an accident investigation shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-011-A",
                "text": "Hold a press conference immediately after the termination of the investigation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-011-B",
                "text": "None of the statements are correct",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-011-C",
                "text": "Publish a final report according to ICAO Standards",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-011-D",
                "text": "Publish a final report as requested by the State of the Operator",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-ACI-012",
            "text": "The accident investigation preliminary report shall be submitted to appropriate States and to the ICAO, in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-012-A",
                "text": "English",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-012-B",
                "text": "The language of the investigating State",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-012-C",
                "text": "Any of the world's major languages",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-ACI-012-D",
                "text": "One of the working languages of ICAO",
                "correct": true
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "02c010ef049596720d2eb290adb22d25",
      "name": "Personnel Licensing",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-001",
            "text": "If a licence holder is unable to perform the flight crew functions appropriate to that licence due to illness, the authority must be informed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-001-A",
                "text": "After 21 days of consecutive \"illness“.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-001-B",
                "text": "as soon as possible if the illness is expected to last more than 21days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-001-C",
                "text": "after one calendar month of consecutive illness.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-001-D",
                "text": "if still not fit to fly when his/her current medical certificate expires",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-002",
            "text": "The applicant to exercise the functions of an Instrumental Flight Rating in_____ aeroplanes shall prove, according to Annex I, PERSONNEL LICENSING, his/her capability to pilot such aircraft only by instrumental rules and an engine _________.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-002-A",
                "text": "Land/inactive.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-002-B",
                "text": "Amphibious/inactive or simulated inactive.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-002-C",
                "text": "Single-engine/inactive.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-002-D",
                "text": "Multi-engine / inoperative or simulated inoperative.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-003",
            "text": "In accordance with ICAO Annex 1, when a contracting state renders valid a license issued by another contracting state, the validity of the authorization:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-003-A",
                "text": "Shall not extend beyond the period of validity of the licence.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-003-B",
                "text": "Depends on the regulations of the contracting sate which renders valid the licence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-003-C",
                "text": "Shall not extend beyond one year for ATPL and CPL.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-003-D",
                "text": "Is only considered for PPL.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-004",
            "text": "When a contracting state renders valid a license issued by another contracting state the validity of the authorization",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-004-A",
                "text": "shall not extend more than 15 days from the date of the license.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-004-B",
                "text": "shall not extend beyond the period of validity of the license.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-004-C",
                "text": "shall not extend beyond the period of validity of the license other than for use in private flights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-004-D",
                "text": "the Contracting state rendering a license valid may extend the date of the validity at its own discretion.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-005",
            "text": "According to JAR-FCL, a professional flight crew license issued by a non EASA State may be rendered valid for use on aircraft registered in a EASA Member State",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-005-A",
                "text": "At the discretion of the Authority of that Member State concerned for a period not exceeding one year At the discretion of the Authority of the Member State concerned for a period not exceeding the period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-005-B",
                "text": "validity of the basic license. At the discretion of the Authority of that Member State concerned for a period not exceeding one year,",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-005-C",
                "text": "provided that the basic license remains valid.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-005-D",
                "text": "At the discretion of the Authority of that Member State concerned for a period exceeding one year, provided that the basic license remains valid.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-006",
            "text": "Minimum and maximum age for ATPL holders According to ICAO Annex 1, the minimum/maximum age for the holder of an ATPL is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-006-A",
                "text": "16 and 60 years.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-006-B",
                "text": "17 and 59 years.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-006-C",
                "text": "21 and 59 years.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-006-D",
                "text": "18 and 60 years.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-007",
            "text": "The age of an applicant for a commercial pilot license shall not be less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-007-A",
                "text": "16 years of age",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-007-B",
                "text": "21 years of age",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-007-C",
                "text": "17 years of age",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-007-D",
                "text": "18 years of age",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-008",
            "text": "The privileges of the holder of a commercial pilot licence-aeroplane shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-008-A",
                "text": "to act as pilot-in-command in any aeroplane engaged in operations other than commercial air transportation.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-008-B",
                "text": "to act as pilot in command in any aeroplane certificate for single pilot operation other than in commercial air transportation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-008-C",
                "text": "none of the answers are correct.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-008-D",
                "text": "to act as pilot in command in any aeroplane engaged in commercial air transportation",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-009",
            "text": "An applicant for a commercial pilot licence-aeroplane shall have completed not less than ........ hours of cross- country flight time as pilot in command including a cross-country flight totalling not less than ........ Km (-NM), in the course of which full-stop landings at two different aerodromes shall be made. The hours and distance referred to are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-009-A",
                "text": "10 hours and 270 km (150 NM)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-009-B",
                "text": "20 hours and 540 km (300NM)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-009-C",
                "text": "20 hours and 270 km (150NM)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-009-D",
                "text": "15 hours and 540 km (300NM)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-010",
            "text": "An applicant for a commercial pilot licence aeroplane shall have completed in aeroplanes not less than: 25 hours of cross-country flight time as pilot-in-command including a cross-country flight not less than",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-010-A",
                "text": "540 km (300NM). 10 hours of cross-country flight time as pilot-in-command including a cross-country flight not less than",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-010-B",
                "text": "540 km (300NM). 15 hours of cross-country flight time as pilot-in-command including a cross-country flight not less than",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-010-C",
                "text": "540 km (300NM).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-010-D",
                "text": "20 hours of cross-country flight time as pilot-in-command including a cross-country flight not less than 540 km (300NM).",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-011",
            "text": "An applicant for a commercial pilot licence aeroplane shall have completed in aeroplanes not less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-011-A",
                "text": "200 hours of flight time and 80 hours as pilot in command",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-011-B",
                "text": "200 hours of flight time or 150 hours if completed during a course of approved training as a pilot of aeroplanes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-011-C",
                "text": "150 hours of flight time and 100 hours as pilot in command",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-011-D",
                "text": "200 hours of flight time and 70 hours as pilot in command",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-012",
            "text": "An applicant for a commercial pilot license shall have completed in aeroplanes not less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-012-A",
                "text": "20 hours of instrument instruction time of which not more than 10 hours may be instrument ground time",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-012-B",
                "text": "10 hours of instrument instruction time of which not more than 5 hours may be instrument ground time",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-012-C",
                "text": "20 hours of instrument instruction time of which not more than 5 hours may be instrument ground time.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-012-D",
                "text": "15 hours of instrument time of which not more than 5 hours as pilot in command",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-013",
            "text": "In accordance with JAR-FCL the credit for MPA co-pilot time is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-013-A",
                "text": "50 % of the co-pilot flight time towards the total flight time required for a higher grade of pilot licence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-013-B",
                "text": "100 hours of the flying time required for a higher grade of a pilot licence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-013-C",
                "text": "75 % of the co-pilot flight time towards, the total flight time required for a higher grade of a pilot licence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-013-D",
                "text": "100 % of the co-pilot flight time towards the total flight time required for a higher grade of pilot licence.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-014",
            "text": "An applicant for an Airline Transport Pilot Licence aeroplane shall have completed in aeroplanes not less than ...... hours, either as pilot in command or made up by not less than ...... hours as pilot-in-command and the additional flight time as co-pilot performing, under the supervision of the pilot-in-command the duties and functions of a pilot in command provided that the method of supervision employed is acceptable to the licensing authority. The stated above hours are respectively:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-014-A",
                "text": "250 hours and 100 hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-014-B",
                "text": "200 hours and 100 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-014-C",
                "text": "200 hours and 75 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-014-D",
                "text": "150 hours and 75 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-015",
            "text": "The applicant for an Airline Transport Pilot Licence shall have completed in aeroplanes not less than ...... hours of cross-country flight time, of which not less than ...... hours shall be as pilot-in command or co-pilot performing, under the supervision of the pilot in command, the duties and functions of a pilot in command, provided that the method of supervision employed is acceptable to the licensing authority. The state above hours are respectively:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-015-A",
                "text": "150 hours and 75 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-015-B",
                "text": "250 hours and 10 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-015-C",
                "text": "200 hours and 75 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-015-D",
                "text": "200 hours and 100 hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-016",
            "text": "An applicant for an Airline Transport Pilot Licence shall have completed in aeroplanes not less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-016-A",
                "text": "150 hours of instrument time, of which not more than 75 hours of instrument ground time.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-016-B",
                "text": "75 hours of instrument time, of which not more than 30 hours may be instrument ground time.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-016-C",
                "text": "75 hours of instrument time, of which not more than 20 hours of instrument ground time.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-016-D",
                "text": "100 hours of instrument time, of which not more than 30 hours of instrument ground time.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-017",
            "text": "An applicant for an Airline Transport Pilot Licence shall have completed in aeroplanes not less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-017-A",
                "text": "75 hours of night flight as pilot in command or as co-pilot.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-017-B",
                "text": "100 hours of night flight only as pilot in command.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-017-C",
                "text": "75 hours of night time only as pilot in command.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-017-D",
                "text": "100 hours of night flight as pilot in command or as co-pilot.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-018",
            "text": "The licensing authority shall determine whether experience as a pilot under instruction in a synthetic flight trainer which it has approved, is acceptable as part of the total flight time of 1 500 hours. Credit for such experience shall be limited to a maximum of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-018-A",
                "text": "100 hours of which not more than 15 hours shall have been acquired in a flight procedure trainer or basic instrument flight trainer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-018-B",
                "text": "100 hours, of which not more than 25 hours shall have been acquired in a flight procedure trainer or basic instrument flight trainer.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-018-C",
                "text": "75 hours of which not more than 20 hours shall have been acquired in a flight procedure trainer or basic instrument flight trainer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-018-D",
                "text": "100 hours of which not more than 20 hours shall have been acquired in a basic instrument flight trainer.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-019",
            "text": "The holder of a pilot license when acting as a co-pilot performing under the supervision of the pilot in command the functions and duties of a pilot in command shall be entitled to be credit:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-019-A",
                "text": "the flight time towards the total time required for a higher grade of pilot license in accordance with the requirements of the licensing authority.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-019-B",
                "text": "in full with his flight time towards the total time required for higher grade of pilot licence.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-019-C",
                "text": "in full with his flight but not more than 300 hours towards the total time required for a higher grade of pilot licence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-019-D",
                "text": "50% of his flight time towards the total time required for higher grade of pilot Licence.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-020",
            "text": "According to JAR-FCL, an applicant for ATPL (A) shall have completed as a pilot of aeroplane at least 1.500 hours of flight time, including",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-020-A",
                "text": "500 hours in multi-pilot operations on aeroplanes type certificated in accordance with JAR/FAR 25 or JAR/FAR 23, as pilot-in-command. 500 hours in multi-pilot operations on aeroplanes type certificated in accordance with JAR/FAR 25 or",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-020-B",
                "text": "JAR/FAR 23, of which up to 150 hours may be as flight engineer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-020-C",
                "text": "500 hours in multi-pilot operations on aeroplanes type certificated in accordance with JAR/FAR 25 or JAR/FAR 23. 500 hours in multi-pilot operations on aeroplanes type certificated in accordance with JAR/FAR 25 or",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-020-D",
                "text": "D JAR/FAR 23, including 200 hours of night flight as pilot-in command or as co-pilot.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-021",
            "text": "The validity of the instrument-rating aeroplane - IR(A) is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-021-A",
                "text": "5 years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-021-B",
                "text": "2 years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-021-C",
                "text": "1 year",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-021-D",
                "text": "6 months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-022",
            "text": "An applicant holding a private or commercial pilot license aeroplane for the issue of an instrument rating shall have completed ..... hours of cross-country flight time as pilot-in-command of aircraft in categories acceptable to the licensing Authority, of which not less than ..... Hours shall be in aeroplanes. The said hours are respectively",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-022-A",
                "text": "40 hours and 10 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-022-B",
                "text": "50 hours and 15 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-022-C",
                "text": "40 hours and 15 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-022-D",
                "text": "50 hours and 10 hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-023",
            "text": "Type ratings shall be established",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-023-A",
                "text": "for any type of aircraft whenever considered necessary by the authority",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-023-B",
                "text": "only for aircraft certificated for operation with a minimum crew of at least two pilots and each type of helicopter",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-023-C",
                "text": "all the answers are correct",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-023-D",
                "text": "only aircraft certificated for operation with a minimum crew of at least two pilots",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-024",
            "text": "According to JAR-FCL, an instrument rating is valid for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-024-A",
                "text": "The period of validity of the licence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-024-B",
                "text": "one year.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-024-C",
                "text": "Indefinitely.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-024-D",
                "text": "two years.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-025",
            "text": "According to JAR-FCL, an applicant for an IR(A) shall hold a PPL (A) including a night qualification or CPL(A) and shall have completed at least 50 hours:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-025-A",
                "text": "Instructional flight time as student-pilot-in-command of aeroplanes or helicopters of which at least 10 hours shall be in aeroplanes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-025-B",
                "text": "Cross-country flight time as pilot of aeroplanes or helicopters of which at least 10 hours shall be in aeroplanes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-025-C",
                "text": "Instructional flight time as student-pilot-in-command of aeroplanes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-025-D",
                "text": "Cross-country flight time as pilot-in-command in aeroplanes or helicopters of which at least 10 hours shall be in aeroplanes.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-026",
            "text": "JAR-FCL 1 / Class rating In JAR-FCL1, the Single Engine Piston (A) Class rating is established for Single Pilot Single Engine Aeroplanes not requiring a Type rating. It includes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-026-A",
                "text": "Touring Motor Glider / TMG",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-026-B",
                "text": "All types of single-pilot, single-engine aeroplanes fitted with a turbojet engine.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-026-C",
                "text": "Any other type of aeroplane if considered necessary.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-026-D",
                "text": "Microlights having fixed wings and moveable aerodynamic control surfaces acting in all three dimensions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-027",
            "text": "According to JAR-FCL, the validity of type ratings and multi-engine class ratings will be one year from the date:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-027-A",
                "text": "The application is received by the Authority.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-027-B",
                "text": "Of the skill test",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-027-C",
                "text": "Of issue",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-027-D",
                "text": "Of the last medical certificate",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-028",
            "text": "According to JAR-FCL, single-pilot single-engine class ratings are valid for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-028-A",
                "text": "Two years up to age 40 years then one year thereafter",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-028-B",
                "text": "One year",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-028-C",
                "text": "Five years after licence issue.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-028-D",
                "text": "Two years",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-029",
            "text": "According to JAR-FCL, successful completion of multi-crew cooperation (MCC) training shall be required to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-029-A",
                "text": "Revalidate any rating or license.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-029-B",
                "text": "Obtain the first type rating on multi-pilot aeroplanes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-029-C",
                "text": "Obtain a professional pilot license.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-029-D",
                "text": "Obtain the first-class rating on multi-engine aeroplanes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-030",
            "text": "JAR-FCL3, Information of the Authority in case of illness The holder of a pilot’s license shall inform the Authority of any illness, which involves the incapacity to undertake license-related functions for a certain number of days. The number of days is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-030-A",
                "text": "60",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-030-B",
                "text": "90",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-030-C",
                "text": "21",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-030-D",
                "text": "30",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-031",
            "text": "An applicant for a commercial pilot licence shall hold",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-031-A",
                "text": "a current class III medical assessment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-031-B",
                "text": "a current class I medical assessment",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-031-C",
                "text": "a current class II medical assessment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-031-D",
                "text": "a current class medical assessment as prescribed by the state issuing the licence",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-032",
            "text": "In certain circumstances, a medical examination may be deferred at the discretion of the licensing authority, provided that such deferment shall only be made as an exception and shall not exceed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-032-A",
                "text": "in the case of a private pilot, a single period of 12 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-032-B",
                "text": "A single period of six months in the case of a flight crew member of an aircraft engaged in non commercial operations. A single period of six months in the case of a flight crew member of an aircraft engaged in commercial",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-032-C",
                "text": "operations. Two consecutive periods each of three months in the case of a flight crew member of an aircraft engaged",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-032-D",
                "text": "in non-commercial operations",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-033",
            "text": "The duration of the period of currency of a medical assessment shall begin on the date:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-033-A",
                "text": "the medical assessment is issued",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-033-B",
                "text": "the license is delivered to the pilot",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-033-C",
                "text": "the licence is issued or validated",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-033-D",
                "text": "the licence is issued or renewed",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-034",
            "text": "When the holders of aircraft transport pilot licenses aeroplane and helicopter have passed their 40th birthday the medical examination shall be reduced from:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-034-A",
                "text": "none of the answers are correct",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-034-B",
                "text": "12 months to 6 months",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-034-C",
                "text": "12 months to 3 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-034-D",
                "text": "24 months to 12 months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-035",
            "text": "According to JAR-FCL, license holders do not exercise the privileges of their licenses, related ratings or authorizations at any time when they are aware of any decrease in their medical fitness which might render them unable to safely exercise those privileges. They shall without undue delay seek the advice of the authority or AME when becoming aware of hospital or clinic admissions for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-035-A",
                "text": "More than one week",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-035-B",
                "text": "More than 12 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-035-C",
                "text": "More than 12 hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-035-D",
                "text": "Any period",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-036",
            "text": "According to JAR-FCL, Class 2 medical certificate for private pilots will be valid for",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-036-A",
                "text": "24 months until age of 40, 12 months thereafter",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-036-B",
                "text": "60 months until age of 30, 24 months until age of 50, 12 months until age of 65 and 6 months thereafter",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-036-C",
                "text": "60 months until age of 30, 24 months until age of 40, 12 months thereafter",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-036-D",
                "text": "24 months until age of 40, 12 months until age of 60, and 6 months thereafter",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-037",
            "text": "According to JAR-FCL, Medical certificates classes are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-037-A",
                "text": "class 1 only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-037-B",
                "text": "1, 2 and 3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-037-C",
                "text": "1 and 2",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-037-D",
                "text": "1,2,3 and 4",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-038",
            "text": "What is the situation in respect of a person’s pilot license if the holder has an incapacitating injury or illness lasting twenty days or more?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-038-A",
                "text": "The license is automatically cancelled.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-038-B",
                "text": "The license shall be deemed to be suspended upon the elapse of such period of injury or illness",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-038-C",
                "text": "The medical certificate shall be deemed suspended for the duration of the injury or illness.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-038-D",
                "text": "The medical may be reinstated by an authorized medical doctor.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-039",
            "text": "A letter of validation issued to a foreign pilot license holder, employed in the UAE as a flight crewmember, is valid for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-039-A",
                "text": "two years after issue of the UAE license validation certificate.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-039-B",
                "text": "six month after the issue of the UAE license validation certificate.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-039-C",
                "text": "thirty days, pending the successful writing of an air law exam and the passing of an instrument flight test.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-039-D",
                "text": "90 days, but in any event not longer than the validity date of the foreign license or medical certificate.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-040",
            "text": "The rules, which govern the licensing of all pilots and other flight crew, are to be found in which document?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-040-A",
                "text": "The Aeronautical Information Publication (AIP).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-040-B",
                "text": "The Registry of Civil Law of the UAE.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-040-C",
                "text": "The Civil aviation Regulations (CAR’s).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-040-D",
                "text": "The ICAO Standards and Recommended Practices (SARPS).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-041",
            "text": "An operator shall ensure that recurrent checking is conducted by the following personnel for a type rated commercial pilot, an OPC check can be carried out:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-041-A",
                "text": "Operator proficiency check by a Type rating Examiner (TRE), Class Rating Examiner (CRE) Operator proficiency check - if the check is conducted in a STD or TRE, CRE or a Synthetic Flight Examiner",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-041-B",
                "text": "(SFE)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-041-C",
                "text": "Both above statements are correct",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-041-D",
                "text": "None is correct",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-042",
            "text": "In the case of a pilot engaged in commercial operations, how long may a medical assessment be deferred?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-042-A",
                "text": "2 consecutive periods of 6 months each.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-042-B",
                "text": "2 consecutive periods of 3 months each.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-042-C",
                "text": "Single period of 6 months.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-042-D",
                "text": "Single period of 12 months.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-043",
            "text": "For a type rated commercial pilot, PPC check to be carried out",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-043-A",
                "text": "after 13 months.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-043-B",
                "text": "by a flight instructor.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-043-C",
                "text": "by a GCAA inspector or designated check pilot with GCAA approval.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-043-D",
                "text": "after 2 years.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-044",
            "text": "Medical validity for a commercial pilot over 40 whose Medical Certificate was issued on 25 April 06.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-044-A",
                "text": "31st October 2006",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-044-B",
                "text": "30th April 2007",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-044-C",
                "text": "25th October 2006",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-044-D",
                "text": "1st September 2006",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-045",
            "text": "The requirements for carrying passengers at night are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-045-A",
                "text": "3 take-offs and landings within previous 90 days in that category, class and type of aircraft. 3 take-offs and landings between the hours of sunset and sunrise within the 90 days previous in",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-045-B",
                "text": "category/type/class.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-045-C",
                "text": "3 take-offs and landings between the hours of sunrise and sunset within the previous 90 days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-045-D",
                "text": "There are no requirements at all.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-046",
            "text": "No person may act as pilot-in-command of an aircraft unless in the preceding 12 months, that person has",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-046-A",
                "text": "3 take-offs and landings within the previous 90 days in that category, class, and type of aircraft. 3 take-offs and landings between the hours of sunset and sunrise within the 90 days previous in",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-046-B",
                "text": "category/type/class.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-046-C",
                "text": "3 take-offs and landings between the hours of sunrise and sunset within the previous 90 days.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-046-D",
                "text": "There are no requirements at all.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-047",
            "text": "The minimum age for a PPL(A) shall be at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-047-A",
                "text": "17 years.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-047-B",
                "text": "19 years.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-047-C",
                "text": "15 years.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-047-D",
                "text": "21 years.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-048",
            "text": "Normal residency, for the issue of a license, is the minimum number of days that an applicant must be resident in a state per year. How long is this:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-048-A",
                "text": "185 days.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-048-B",
                "text": "160 days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-048-C",
                "text": "223 days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-048-D",
                "text": "186 days.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-FCL-049",
            "text": "According to JAR-FCL, an applicant for ATPL(A) shall have demonstrated the ability to perform as pilot-in-command, the procedures and manoeuvres of an aeroplane type certificated for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-049-A",
                "text": "the carriage of passengers at night.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-049-B",
                "text": "a minimum crew of two pilots plus a flight engineer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-049-C",
                "text": "a minimum crew of two pilots under IFR.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-FCL-049-D",
                "text": "operations by pilots under training.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "ce5784313d10ee9412daa419e936fc78",
      "name": "General Requirements",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-001",
            "text": "According to Annex 6, what is the definition of Required Navigation Performance (RNP)?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-001-A",
                "text": "A statement of the navigation performance necessary during flight tests for a new aircraft type.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-001-B",
                "text": "A statement of the navigation performance necessary for operation within a defined airspace.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-001-C",
                "text": "A statement of the navigation performance required when installing a new navigation aid on the ground.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-001-D",
                "text": "A statement of the navigation performance required during a pilot skill test.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-002",
            "text": "According to Annex 6, 'RNP type' is defined as a containment value expressed as a distance in ...(i)... from the intended position within which flights would be for at least ...(ii)... of the total flying time.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-002-A",
                "text": "(i) kilometres, (ii) 90%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-002-B",
                "text": "(i) nautical miles, (ii) 95%",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-002-C",
                "text": "(i) kilometres, (ii) 95%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-002-D",
                "text": "(i) nautical miles, (ii) 90%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-003",
            "text": "The regulatory green navigation light is located on the starboard side with a coverage angle of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-003-A",
                "text": "220°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-003-B",
                "text": "140°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-003-C",
                "text": "110°",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-003-D",
                "text": "70°",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-004",
            "text": "The coverage angle of the regulatory white navigation/position lights, located to the rear of the aircraft, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-004-A",
                "text": "110°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-004-B",
                "text": "140°",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-004-C",
                "text": "220°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-004-D",
                "text": "70°",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-005",
            "text": "During a night flight, an observer located in the cockpit, seeing an aircraft coming from front right on approximate opposite parallel track, will first see the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-005-A",
                "text": "red light",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-005-B",
                "text": "red and white flashing light",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-005-C",
                "text": "white light",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-005-D",
                "text": "green light",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-006",
            "text": "During a night flight, an observer located in the cockpit, seeing an aircraft coming from front left on approximate opposite parallel track, will first see the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-006-A",
                "text": "red steady light",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-006-B",
                "text": "white steady light",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-006-C",
                "text": "green and white flashing light",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-006-D",
                "text": "green steady light",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-007",
            "text": "The coverage angle of the red navigation / position light is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-007-A",
                "text": "220°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-007-B",
                "text": "140°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-007-C",
                "text": "110°",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-007-D",
                "text": "70°",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-008",
            "text": "An operator shall ensure that information relevant to the flight is preserved on the ground for the duration of each flight or series of flights. This includes: Given: 1. appropriate meteorological information 2. a copy of the operational flight plan and, if required, the mass and balance documentation 3. copies of the relevant parts of the aircraft technical log 4. route specific NOTAM documentation if specifically edited by the operator 5. special loads notification 6. copies of the day's performances and limitations with completed charts. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-008-A",
                "text": "2, 3, 4, 5.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-008-B",
                "text": "2, 3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-008-C",
                "text": "2, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-008-D",
                "text": "1, 2, 3, 5, 6.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-009",
            "text": "When requested by an Authority to produce the aircraft documentation required to be carried on board, the commander:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-009-A",
                "text": "can request a delay of 48 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-009-B",
                "text": "shall comply within a reasonable period of time.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-009-C",
                "text": "shall only comply if authorised by the operator.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-009-D",
                "text": "can refuse to present them.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-010",
            "text": "In a aeroplane, each crew member shall be properly secured by all safety belts and harnesses provided. Given: 1. during taxying 2. during take-off 3. during landing 4. whenever deemed necessary by the commander in the interest of safety 5. during other phases of the flight while at his station The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-010-A",
                "text": "2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-010-B",
                "text": "1,2, 3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-010-C",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-010-D",
                "text": "2, 3, 4, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-011",
            "text": "Who must finally determine that the load and its distribution is such that the mass and balance limits of the aircraft are not exceeded and confirm their acceptance by countersigning the mass and balance documentation?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-011-A",
                "text": "The airline's dispatcher",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-011-B",
                "text": "The flight engineer.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-011-C",
                "text": "The commander.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-011-D",
                "text": "The operator.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-012",
            "text": "No person may operate an aircraft in acrobatic flight when the flight visibility is less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-012-A",
                "text": "3 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-012-B",
                "text": "8 km",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-012-C",
                "text": "5 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-012-D",
                "text": "10 km",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-013",
            "text": "For two-engined airplanes not approved for ETOPS, the take-off alternate, if required, shall be located (in still air conditions) within:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-013-A",
                "text": "one hour flight time at one engine inoperative cruising speed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-013-B",
                "text": "one hour flight time at cruising speed with all engines operating.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-013-C",
                "text": "two hours flight time at one engine inoperative cruising speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-013-D",
                "text": "two hours flight time at cruising speed with all engines operating.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-014",
            "text": "Information concerning emergency evacuation procedures shall be found in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-014-A",
                "text": "operations manual",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-014-B",
                "text": "operational flight plan.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-014-C",
                "text": "flight manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-014-D",
                "text": "journey logbook.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-015",
            "text": "If no meteorological information is available for the destination, the operator must:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-015-A",
                "text": "select two destination alternates.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-015-B",
                "text": "take extra fuel to fly one hour at holding speed, 1500 ft above the alternate aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-015-C",
                "text": "not take-off until obtaining destination meteorological forecast.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-015-D",
                "text": "take extra fuel to fly two hours at holding speed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-016",
            "text": "Each crew member shall be properly secured by all safety belts AND harnesses provided Given: 1. during taxying 2. during take-off 3. during landing 4. whenever deemed necessary by the commander in the interest of safety 5. during other phases of the flight, while at their station. The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-016-A",
                "text": "2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-016-B",
                "text": "1,2, 3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-016-C",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-016-D",
                "text": "2, 3, 4, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-017",
            "text": "A category I precision approach (CAT I) has:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-017-A",
                "text": "a decision height equal to at least 200 ft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-017-B",
                "text": "no decision height.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-017-C",
                "text": "a decision height equal to at least 50 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-017-D",
                "text": "a decision height equal to at least 100 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-018",
            "text": "The term decision height (DH) is used for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-018-A",
                "text": "an indirect approach.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-018-B",
                "text": "a circling approach only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-018-C",
                "text": "a precision approach.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-018-D",
                "text": "a non-precision approach.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-019",
            "text": "A category II precision approach (CAT II) is an approach with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-019-A",
                "text": "a decision height not lower than 150 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-019-B",
                "text": "no decision height",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-019-C",
                "text": "a decision height not lower than 100 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-019-D",
                "text": "a decision height above 200 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-020",
            "text": "A category I precision approach (CAT I) is an approach which may be carried out with a runway visual range of at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-020-A",
                "text": "350 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-020-B",
                "text": "500 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-020-C",
                "text": "800 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-020-D",
                "text": "550 m",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-021",
            "text": "When establishing an instrument approach procedure, five aeroplane categories are determined according to their speed at the threshold (VAT). This speed is equal to the stalling speed in the landing configuration at the maximum certified landing mass m",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-021-A",
                "text": "1,5",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-021-B",
                "text": "1,45",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-021-C",
                "text": "1,15",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-021-D",
                "text": "1,3",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-022",
            "text": "In accordance with regulations, where no outer marker or equivalent position exists, if the reported RVR/Visibility is less than the applicable minima, the approach shall not be continued beyond:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-022-A",
                "text": "the FAF.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-022-B",
                "text": "the middle marker.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-022-C",
                "text": "the glide slope intersection.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-022-D",
                "text": "1000 ft above the aerodrome / heliport.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-023",
            "text": "If a pilot has coupled the automatic pilot to the directional gyro equipped with a rate correction device set for astronomical precession, the course followed by the aircraft (in still air conditions) is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-023-A",
                "text": "a great circle.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-023-B",
                "text": "a rhumb line.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-023-C",
                "text": "a spherical flight segment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-023-D",
                "text": "an undetermined track.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-024",
            "text": "In the absence of wind and without the astronomic precession effect, an aircraft would, at a constant gyro heading, follow a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-024-A",
                "text": "spherical flight segment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-024-B",
                "text": "a rhumb line.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-024-C",
                "text": "straight map line",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-024-D",
                "text": "great circle line",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-025",
            "text": "During a transoceanic and polar flight, the transport precession is the rotation in degrees of the gyro North with respect to the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-025-A",
                "text": "magnetic North",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-025-B",
                "text": "true North",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-025-C",
                "text": "compass North",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-025-D",
                "text": "grid North",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-026",
            "text": "An operator is permitted to use an aircraft with certain items of equipment out of service if this is permitted in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-026-A",
                "text": "the Maintenance Schedule, in the Approval Specifications Section.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-026-B",
                "text": "the Minimum Equipment List (MEL) or Master Minimum Equipment List (MMEL)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-026-C",
                "text": "regulations Subpart M.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-026-D",
                "text": "the approval conditions for return to service following maintenance.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-027",
            "text": "The operator shall include in the operations manual a Minimum Equipment List which shall be approved by the Authority of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-027-A",
                "text": "the country where the aircraft was manufactured.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-027-B",
                "text": "no approval is required.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-027-C",
                "text": "the country of the operator.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-027-D",
                "text": "the countries where the aircraft is operated.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-028",
            "text": "The M.E.L. (Minimum Equipment List) shall be established by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-028-A",
                "text": "the state of the operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-028-B",
                "text": "the operator",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-028-C",
                "text": "the manufacturer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-028-D",
                "text": "the aircraft state of registry",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-029",
            "text": "The MMEL (Master Minimum Equipment List) is drawn up by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-029-A",
                "text": "the state of the operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-029-B",
                "text": "the operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-029-C",
                "text": "the manufacturer",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-029-D",
                "text": "the aircraft state of registry",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-030",
            "text": "The Master Minimum Equipment List (MMEL) defines the equipment which can be inoperative when undertaking a flight and the conditions under which this allowance can be accepted. This MMEL is drawn up by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-030-A",
                "text": "the operator from a main list drawn up by the manufacturer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-030-B",
                "text": "the operations manual",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-030-C",
                "text": "the manufacturer and approved by the certification authority",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-030-D",
                "text": "the operator and approved by the certification authority",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-031",
            "text": "The Minimum Equipment List (MEL) defines the equipment which can be inoperative when undertaking a flight and the additional procedures under which this allowance can be accepted. The MEL shall be drawn up by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-031-A",
                "text": "the operator and may be more restrictive than the Master Minimum Equipment List (MMEL)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-031-B",
                "text": "the manufacturer and may be less restrictive than the Master Minimum equipment List (MMEL)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-031-C",
                "text": "the operator and may be less restrictive than the Master Minimum equipment List (MMEL)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-031-D",
                "text": "the manufacturer and may be more restrictive than the Master Minimum Equipment List (MMEL)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-032",
            "text": "The Minimum Equipment List (MEL) shall be established by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-032-A",
                "text": "the respective Authority of the operator.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-032-B",
                "text": "the operator and approved by the Authority.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-032-C",
                "text": "the Civil Aviation Authority of all the European States.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-032-D",
                "text": "the manufacturer and approved by the Authority.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-033",
            "text": "The reference document you shall use when a piece of equipment on your aeroplane fails during taxi is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-033-A",
                "text": "the MMEL.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-033-B",
                "text": "the Operations Manual under the heading \"Abnormal and Emergency Procedures\".",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-033-C",
                "text": "the Operations Manual under the heading \"MEL\".",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-033-D",
                "text": "the JAR-OPS.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-034",
            "text": "The Master Minimum Equipment List (MMEL), if this exists, is established by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-034-A",
                "text": "the manufacturer of the aircraft, but need not to be accepted by the authority",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-034-B",
                "text": "the manufacturer of the aircraft, and accepted by the authority",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-034-C",
                "text": "the operator of the aircraft, and accepted by the manufacturer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-034-D",
                "text": "the operator of the aircraft, and accepted by the authority",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-035",
            "text": "The minimum equipment list (MEL) states the equipment which can be inoperative when undertaking a flight and the additional procedures to be observed accordingly. This list shall be established by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-035-A",
                "text": "the operator, and inserted in the operations manual",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-035-B",
                "text": "the operator, and inserted in the flight manual",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-035-C",
                "text": "the manufacturer, and inserted in the flight manual",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-035-D",
                "text": "the manufacturer, and inserted in the operations manual",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-036",
            "text": "Reference shall be made to the Minimum Equipment List (MEL) for equipment found unserviceable at any time:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-036-A",
                "text": "from engine start-up until the aircraft has come to a complete stop at the end of the flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-036-B",
                "text": "prior to the aircraft take-off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-036-C",
                "text": "prior to the flight time stage.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-036-D",
                "text": "during the flight.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-037",
            "text": "An operator, when operating abroad;",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-037-A",
                "text": "shall comply with the laws, regulations and procedures of the UAE at all times. shall at all times comply with all the laws, regulations and procedures of the State in which the aeroplane",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-037-B",
                "text": "is being operated.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-037-C",
                "text": "shall comply only with the limitations of the operator’s Operations Specifications. shall comply with the UAE CARs to the extent that they do not conflict with the laws, regulations and",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-037-D",
                "text": "procedures of those States in which operations are conducted and which are pertinent to the performance of their duties.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-038",
            "text": "An operator and commander shall not operate an aircraft unless:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-038-A",
                "text": "The maximum duty hours for the aircrew is less than 90 hours in any two consecutive weeks and 180 hours in any 4 consecutive weeks.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-038-B",
                "text": "The original Air Operators Certificate is on board.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-038-C",
                "text": "A take-off alternate has been selected and specified in the operational flight plan.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-038-D",
                "text": "The instrument and equipment are in operable condition except as provided by the MEL.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-GEN-039",
            "text": "Meaning of QNH",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-039-A",
                "text": "Standard conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-039-B",
                "text": "29.92 inches/1013.2 millibars",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-039-C",
                "text": "pressure at mean sea level/mean sea level set in altimeter sub scale",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-GEN-039-D",
                "text": "Pressure at aerodrome level",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "e9601563f2ca84650b1e559d6992949a",
      "name": "OPS Regulations",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-001",
            "text": "Regulations applies to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-001-A",
                "text": "aeroplanes used by police, customs and defence departments.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-001-B",
                "text": "the operation by a EASA state member of any civil commercial transport aeroplane.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-001-C",
                "text": "the operation by a EASA state member of any civil aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-001-D",
                "text": "aeroplanes proceeding from European states or flying over them.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-002",
            "text": "Regulations applies In accordance with Regulations, an operator shall ensure that a copy of the operational flight plan is stored in an acceptable form for at least to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-002-A",
                "text": "15 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-002-B",
                "text": "24 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-002-C",
                "text": "12 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-002-D",
                "text": "3 months",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-003",
            "text": "An operator shall ensure that for the duration of each flight or series of flights, relevant information is preserved on the ground. This includes:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-003-A",
                "text": "mass and balance documentation, if required.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-003-B",
                "text": "meteorological information.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-003-C",
                "text": "the calculation of the airborne fuel quantity.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-003-D",
                "text": "a copy of the calculated take-off performance.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-004",
            "text": "Following an accident, the operator of an aircraft equipped with a flight recorder must keep the original recordings for a minimum period of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-004-A",
                "text": "90 days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-004-B",
                "text": "45 days.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-004-C",
                "text": "60 days.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-004-D",
                "text": "30 days.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-005",
            "text": "In accordance with Regulations, the operator must ensure that the mass and balance documentation of a flight is stored for a minimum period of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-005-A",
                "text": "3 months",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-005-B",
                "text": "6 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-005-C",
                "text": "1 month",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-005-D",
                "text": "1 year",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-006",
            "text": "In accordance with Regulations, the operator must ensure that the information contained in the aircraft technical log is stored for a minimum period of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-006-A",
                "text": "3 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-006-B",
                "text": "15 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-006-C",
                "text": "24 months",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-006-D",
                "text": "12 months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-007",
            "text": "According to Regulations, which of the following is the correct definition of \"wet lease\"?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-007-A",
                "text": "The aircraft is operated under the AOC of the lessor.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-007-B",
                "text": "The aircraft is leased from a non-EASA operator.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-007-C",
                "text": "The aircraft is operated overseas.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-007-D",
                "text": "The aircraft is operated under the AOC of the lessee.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-008",
            "text": "According to Annex 6, what is the definition of an Air Operator Certificate?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-008-A",
                "text": "A certificate authorising an operator to carry out specified commercial air transport operations.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-008-B",
                "text": "A certificate automatically authorising an operator to carry out domestic air services in any ICAO contracting State. A certificate needed to carry out specified commercial international air transport operations, but not for",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-008-C",
                "text": "domestic commercial flights. A certificate the crew will present to immigration officers, stating that all passengers on board fulfil the visa",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-008-D",
                "text": "requirements needed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-009",
            "text": "Who is responsible for providing an Operation Manual in accordance with Regulations Subpart P for the use and guidance of the operations personnel?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-009-A",
                "text": "The national authority",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-009-B",
                "text": "The owner of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-009-C",
                "text": "The aircraft operator.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-009-D",
                "text": "The aircraft producer",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-010",
            "text": "According to Regulations, on an IFR flight, a commander shall not commence take-o unless the expected weather conditions at the destination and/or required alternate aerodrome(s) are at or above:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-010-A",
                "text": "the planning minima, at the estimated time of arrival.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-010-B",
                "text": "the planning minima, during a period from 1 hour before to 1 hour after the estimated time of arrival at the aerodrome.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-010-C",
                "text": "the aerodrome operating minima, at the estimated time of arrival, and for a reasonable period before and after such a predicted time.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-010-D",
                "text": "the aerodrome operating minima, during a period from 1 hour before to 1 hour after the estimated time of arrival at the aerodrome.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-011",
            "text": "In accordance with Regulations, refuelling performed while passengers are embarking or disembarking the aircraft:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-011-A",
                "text": "is acceptable provided that all the aircraft doors must be completely opened.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-011-B",
                "text": "is acceptable provided that the ground area beneath the exits intended for emergency evacuation and slide deployment areas must be kept clear.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-011-C",
                "text": "is prohibited.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-011-D",
                "text": "is acceptable provided that all flight crew shall remain at their station.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-012",
            "text": "In accordance with Regulations, if the flight is to be carried out at FL 290, demonstration concerning oxygen equipment must be completed before:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-012-A",
                "text": "the aircraft reaches FL 140.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-012-B",
                "text": "the aircraft reaches FL 250.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-012-C",
                "text": "the aircraft reaches FL 100.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-012-D",
                "text": "take-off.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-013",
            "text": "In accordance with Regulations, the commander of a turbojet engine aeroplane should have a final reserve fuel for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-013-A",
                "text": "45 minutes of flight at holding speed at 1500 ft above aerodrome elevation in standard conditions.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-013-B",
                "text": "45 minutes of flight at cruising speed at FL140.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-013-C",
                "text": "30 minutes of flight at cruising speed at FL140.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-013-D",
                "text": "30 minutes of flight at holding speed at 1500 ft above aerodrome elevation in standard conditions.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-014",
            "text": "In accordance with the fuel policy for isolated aerodromes (Regulations),for aeroplanes with turbine engines, the amount of Additional Fuel should not be less than the fuel to fly after arriving overhead the destination aerodrome for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-014-A",
                "text": "30 minutes at normal cruise consumption, including final reserve fuel.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-014-B",
                "text": "30 minutes at holding consumption at 1 500 ft (450 m) above aerodrome elevation in standard conditions.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-014-C",
                "text": "2 hours at normal cruise consumption, including final reserve fuel.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-014-D",
                "text": "2 hours at holding consumption at 1 500 ft (450 m) above aerodrome elevation in standard conditions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-015",
            "text": "For three- and four-engined aeroplanes, the take-off alternate, if required, shall be located (in still air conditions) within:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-015-A",
                "text": "1 hour flight time at one-engine-inoperative cruising speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-015-B",
                "text": "2 hours flight time at one-engine-inoperative cruising speed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-015-C",
                "text": "2 hours flight time at cruising speed with all engines operating.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-015-D",
                "text": "1 hour flight time at cruising speed with all engines operating.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-016",
            "text": "Without ETOPS Approval, an operator shall not operate a two-engine Class A aeroplane with a maximum approved passenger seating configuration of 20 or more over a route which contains a point further from an adequate aerodrome, at a distance flown:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-016-A",
                "text": "in 30 minutes at the one-engine-inoperative cruise speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-016-B",
                "text": "in 120 minutes at the one-engine-inoperative cruise speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-016-C",
                "text": "in 60 minutes at the one-engine-inoperative cruise speed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-016-D",
                "text": "in 90 minutes at the one-engine-inoperative cruise speed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-017",
            "text": "In accordance with Regulations, a commander shall ensure that the amount of usable fuel remaining in flight is not less than the fuel required to proceed to an aerodrome where a safe landing can be made with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-017-A",
                "text": "final reserve fuel remaining.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-017-B",
                "text": "fuel to hold 30 minutes at 1500 ft above the aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-017-C",
                "text": "fuel to fly 20 minutes at best range speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-017-D",
                "text": "15 minutes of remaining fuel.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-018",
            "text": "According to Regulations, an operator must select two destination alternates when the appropriate weather reports or forecasts for the destination, or any combination thereof, indicate that during a period commencing ...(i)... hour(s) before and ending ..",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-018-A",
                "text": "(i) two, (ii) two, (iii) time of arrival",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-018-B",
                "text": "(i) one, (ii) one, (iii) time of arrival",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-018-C",
                "text": "(i) two, (ii) two, (iii) time of departure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-018-D",
                "text": "(i) one, (ii) one, (iii) time of departure",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-019",
            "text": "According to Regulations, planning minima for a destination aerodrome with an applicable precision approach procedure is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-019-A",
                "text": "RVR / visibility and ceiling at or above DH specified in accordance with JAR-OPS, Aerodrome Operating. Minima",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-019-B",
                "text": "RVR / visibility specified in accordance with JAR-OPS, Aerodrome Operating Minima.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-019-C",
                "text": "Non-precision minima plus 200 ft /1000 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-019-D",
                "text": "Non-precision minima.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-020",
            "text": "According to Regulations, what is the planning minima for a destination alternate with a CAT II approach available?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-020-A",
                "text": "RVR according to Cat I.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-020-B",
                "text": "Circling minima.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-020-C",
                "text": "Non-precision minima plus 200 ft/1000 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-020-D",
                "text": "Non-precision minima.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-021",
            "text": "According to Regulations, what is the planning minima for a destination alternate with a CAT I approach available?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-021-A",
                "text": "Non-precision minima (RVR and the ceiling at or above MDH).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-021-B",
                "text": "RVR according to Cat I.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-021-C",
                "text": "Non-precision minima plus 200 ft/1000 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-021-D",
                "text": "Circling minima",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-022",
            "text": "According to Regulations, what is the planning minima for a destination alternate with a non-precision approach available?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-022-A",
                "text": "Non-precision minima (RVR and the ceiling at or above MDH).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-022-B",
                "text": "RVR according to Cat I.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-022-C",
                "text": "Non-precision minima (RVR and the ceiling at or above MDH) plus 200 ft/1000 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-022-D",
                "text": "Circling minima",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-023",
            "text": "According to Regulations, what is the planning minima for a destination aerodrome, if it is equipped with a non- precision approach only?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-023-A",
                "text": "RVR / visibility specified in accordance with JAR-OPS, and the ceiling at or above MDH.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-023-B",
                "text": "RVR / visibility specified in accordance with JAR-OPS.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-023-C",
                "text": "Non-precision minima (RVR and the ceiling at or above MDH) plus 200 ft/1000 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-023-D",
                "text": "Circling minima.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-024",
            "text": "According to Regulations, a category III B precision approach (CAT III B) is an approach which may be carried out with a runway visual range of at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-024-A",
                "text": "75 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-024-B",
                "text": "250 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-024-C",
                "text": "200 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-024-D",
                "text": "150 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-025",
            "text": "According to regulations, in establishing the aerodrome operating minima which will apply to any particular operation, an operator must take full account of: Given: 1. equipment available on the aircraft 2. dimensions and characteristics of the runways 3. composition of the flight crew 4. obstacles in the approach and missed approach areas 5. means to determine and report the meteorological conditions The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-025-A",
                "text": "2, 3, 5",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-025-B",
                "text": "2, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-025-C",
                "text": "1, 2, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-025-D",
                "text": "1, 2, 3, 4, 5.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-026",
            "text": "According to Regulations, the lowest minima to be used by an operator for circling with a category D aeroplane is a meteorological visibility of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-026-A",
                "text": "1600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-026-B",
                "text": "2400 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-026-C",
                "text": "3600 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-026-D",
                "text": "1500 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-027",
            "text": "According to Regulations, the lowest minima to be used by an operator for circling with a category C aeroplane is a meteorological visibility of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-027-A",
                "text": "1600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-027-B",
                "text": "2400 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-027-C",
                "text": "3600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-027-D",
                "text": "1500 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-028",
            "text": "According to Regulations, the lowest minima to be used by an operator for circling with a category B aeroplane is a meteorological visibility of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-028-A",
                "text": "1600 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-028-B",
                "text": "2400 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-028-C",
                "text": "3600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-028-D",
                "text": "1500 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-029",
            "text": "According to Regulations, the lowest minima to be used by an operator for circling with a category A aeroplane is a meteorological visibility of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-029-A",
                "text": "1600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-029-B",
                "text": "2400 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-029-C",
                "text": "3600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-029-D",
                "text": "1500 m",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-030",
            "text": "In accordance with regulations (Aerodrome Operating Minima), the lowest minima to be used by an operator in a category B aeroplane for circling are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-030-A",
                "text": "MDH=400 ft and visibility=1500 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-030-B",
                "text": "MDH=700 ft and visibility=2600 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-030-C",
                "text": "MDH=500 ft and visibility=1600 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-030-D",
                "text": "MDH=600 ft and visibility=2400 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-031",
            "text": "In accordance with Regulations, the operator shall ensure that:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-031-A",
                "text": "for VFR flights conducted in class B airspace, horizontal distance from clouds is at least 1000m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-031-B",
                "text": "for VFR flights conducted in class E airspace, flight visibility at and above 3050m (10000ft) is at least 5 km (clear of cloud).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-031-C",
                "text": "for VFR flights conducted in class F airspace, vertical distance from clouds is at least 250m .",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-031-D",
                "text": "special VFR flights are not commenced when visibility is less than 3 km.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-032",
            "text": "In accordance with Regulations (Aerodrome Operating Minima), for a Category III A approach, the RVR shall not be less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-032-A",
                "text": "230 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-032-B",
                "text": "200 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-032-C",
                "text": "300 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-032-D",
                "text": "250 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-033",
            "text": "In accordance with Regulations an operator must ensure that the lowest MDH for a NDB approach is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-033-A",
                "text": "250 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-033-B",
                "text": "200 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-033-C",
                "text": "350 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-033-D",
                "text": "300 ft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-034",
            "text": "In accordance with Regulations (Aerodrome Operating Minima), for a Category III B approach, the RVR shall not be less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-034-A",
                "text": "100 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-034-B",
                "text": "50 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-034-C",
                "text": "75 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-034-D",
                "text": "150 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-035",
            "text": "According to regulations and assuming the following circumstances: Given: 1. for a Category A aeroplane 2. an aerodrome equipped with runway edge lighting and centre line lighting and multiple RVR information 3. an acceptable alternate aerodrome is available, the minimum RVR / Visibility required for take-off is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-035-A",
                "text": "250 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-035-B",
                "text": "300 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-035-C",
                "text": "200 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-035-D",
                "text": "150 m.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-036",
            "text": "In accordance with regulations, which of the following are included in the Aerodrome Operating Minima for a non- precision approach? Given: 1. the required RVR 2. the ceiling 3. the minimum descent height (MDH) 4. the decision height (DH)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-036-A",
                "text": "1, 2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-036-B",
                "text": "1, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-036-C",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-036-D",
                "text": "1, 3",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-037",
            "text": "During an ILS procedure, if the reported RVR/visibility is less than the applicable minima, the approach shall not be continued beyond:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-037-A",
                "text": "the outer marker or equivalent, or 1000 ft above the aerodrome / heliport if there is no outer marker or equivalent.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-037-B",
                "text": "the glide slope intersection.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-037-C",
                "text": "the middle marker, or 500 ft above the aerodrome / heliport if there is no middle marker.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-037-D",
                "text": "the FAF, or 1500 ft above the aerodrome / heliport if there is no FAF.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-038",
            "text": "The aerodrome operating minima for a VOR/DME approach are: MDH = 360 ft Given: 1. Required RVR = 1500 metres. 2. Reported RVR is 1800 metres, According to Regulations, the pilot may continue the final approach:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-038-A",
                "text": "if the ceiling reported is higher than 360 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-038-B",
                "text": "if the ceiling reported is higher than 240 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-038-C",
                "text": "regardless of the ceiling reported.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-038-D",
                "text": "if the ceiling reported is higher than 240 ft during the day and 360 ft at night.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-039",
            "text": "Regarding all weather operations, if VAT is from 141 kt to165 kt, the aeroplane is in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-039-A",
                "text": "Category B.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-039-B",
                "text": "Category D",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-039-C",
                "text": "Category E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-039-D",
                "text": "Category C.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-040",
            "text": "To conduct a special VFR flight, the minimum visibility required by Regulations is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-040-A",
                "text": "2500 meters",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-040-B",
                "text": "1500 meters",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-040-C",
                "text": "3000 meters",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-040-D",
                "text": "5000 meters",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-041",
            "text": "The minimum visibility required by Regulations to commence a special VFR flight is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-041-A",
                "text": "3 km",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-041-B",
                "text": "5 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-041-C",
                "text": "2.5 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-041-D",
                "text": "1.5 km",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-042",
            "text": "In accordance with Regulations, an operator must ensure that the MDH for an ILS approach without the glidepath (LLZ only) is not lower than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-042-A",
                "text": "250 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-042-B",
                "text": "350 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-042-C",
                "text": "300 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-042-D",
                "text": "200 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-043",
            "text": "In accordance with Regulations, an operator must ensure that the MDH for a VOR approach is not lower than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-043-A",
                "text": "250 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-043-B",
                "text": "350 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-043-C",
                "text": "300 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-043-D",
                "text": "200 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-044",
            "text": "In accordance with Regulations, an operator must ensure that the MDH for a VOR/DME approach is not lower than",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-044-A",
                "text": "250 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-044-B",
                "text": "350 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-044-C",
                "text": "300 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-044-D",
                "text": "200 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-045",
            "text": "In accordance with Regulations, during a VOR procedure, if the reported RVR/visibility is less than the applicable minima, the approach shall not be continued beyond:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-045-A",
                "text": "the final path intersection.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-045-B",
                "text": "the FAF, or 1500 ft above the aerodrome / heliport if there is no FAF.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-045-C",
                "text": "the middle marker, or 500 ft above the aerodrome / heliport if there is no middle marker.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-045-D",
                "text": "1000 ft above the aerodrome / heliport on the final approach segment.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-046",
            "text": "In accordance with Regulations, during a VOR procedure, if the reported RVR/visibility is less than the applicable minima, the approach shall not be continued beyond:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-046-A",
                "text": "the final path intersection.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-046-B",
                "text": "the FAF, or 1500 ft above the aerodrome / heliport if there is no FAF.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-046-C",
                "text": "the middle marker, or 500 ft above the aerodrome / heliport if there is no middle marker.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-046-D",
                "text": "1000 ft above the aerodrome / heliport on the final approach segment.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-047",
            "text": "Regarding all weather operations, if VAT is from 121 kt to140 kt, the aeroplane is in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-047-A",
                "text": "Category B.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-047-B",
                "text": "Category D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-047-C",
                "text": "Category E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-047-D",
                "text": "Category C.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-048",
            "text": "Regarding all weather operations, if VAT is from 91 kt to120 kt, the aeroplane is in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-048-A",
                "text": "Category B.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-048-B",
                "text": "Category D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-048-C",
                "text": "Category E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-048-D",
                "text": "Category C.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-049",
            "text": "According to Regulations, a Category I operation is a precision instrument approach and landing with a decision height (DH) not lower than ...(i)... and with a runway visual range (RVR) not less than .... (ii).....",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-049-A",
                "text": "(i) 200 ft, (ii) 550 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-049-B",
                "text": "(i) 100 ft, (ii) 550 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-049-C",
                "text": "(i) 100 ft, (ii) 350 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-049-D",
                "text": "(i) 200 ft, (ii) 350 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-50",
            "text": "According to Regulations, who is responsible for establishing Aerodrome Operating Minima for each aerodrome planned to be used for commercial purposes?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-50-A",
                "text": "The Commander",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-50-B",
                "text": "The Operator",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-50-C",
                "text": "The designated local aerodrome authority",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-50-D",
                "text": "The State Authority",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-51",
            "text": "An aeroplane which has a maximum certificated take-off mass over 5700 kg, shall be equipped with a cockpit voice recorder capable of retaining information recorded during at least the last:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-51-A",
                "text": "30 minutes or 2 hours of its operation, depending upon the date of the first issue of its individual Certificate of Airworthiness.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-51-B",
                "text": "30 minutes or 1 hour of its operation, depending upon the date of the first issue of its individual Certificate of Airworthiness.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-51-C",
                "text": "25 hours of its operation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-51-D",
                "text": "20 hours of its operation.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-52",
            "text": "An aeroplane is intended to be operated at FL370. In accordance with regulations, the number of cabin oxygen masks (dispensing units) required is at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-52-A",
                "text": "100% of the seating capacity plus one additional mask per seat row.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-52-B",
                "text": "110% of the seating capacity.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-52-C",
                "text": "100% of the seating capacity plus one additional mask per seat block.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-52-D",
                "text": "150% of the seating capacity.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-53",
            "text": "For a pressurised aircraft, the first-aid oxygen is designed to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-53-A",
                "text": "protect all the occupants against the effects of accidental depressurisation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-53-B",
                "text": "provide undiluted oxygen for passengers who, for physiological reasons, might require oxygen following a cabin depressurisation.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-53-C",
                "text": "protect the flight crew and cabin attendants against fumes and noxious gases.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-53-D",
                "text": "provide oxygen to 10% of passengers at a cabin altitude exceeding 13000 ft after 30 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-54",
            "text": "An aeroplane is intended to be operated at FL 390. Given that: Given: 1. Maximum approved passenger seating configuration = 230 2. Number of seats on board = 200 3. Scheduled number of passengers on board = 180 According to Regulations, the minimum required number of cabin oxygen masks (dispensing units) shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-54-A",
                "text": "220.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-54-B",
                "text": "230.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-54-C",
                "text": "200.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-54-D",
                "text": "180.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-55",
            "text": "According to Regulations, oxygen masks for use by flight crew members shall be a quick donning type of mask, in pressurised aeroplanes operating at pressure altitudes above:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-55-A",
                "text": "41000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-55-B",
                "text": "39000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-55-C",
                "text": "10000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-55-D",
                "text": "25000 ft.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-56",
            "text": "According to Regulations, an operator shall not operate across areas in which search and rescue would be especially difficult unless it is equipped with: Given: 1. signalling equipment 2. at least one ELT 3. at least 2 ELTs 4. additional survival equipment for the route to be flown. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-56-A",
                "text": "1, 2, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-56-B",
                "text": "1, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-56-C",
                "text": "1, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-56-D",
                "text": "2, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-57",
            "text": "In accordance with Regulations, for aeroplanes intended to be operated at pressure altitude of 39000 ft, the total number of oxygen dispensing units and outlets shall exceed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-57-A",
                "text": "the number of passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-57-B",
                "text": "the number of seats by at least 10%.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-57-C",
                "text": "the number of seats.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-57-D",
                "text": "the number of passengers by at least 10%.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-58",
            "text": "In accordance with Regulations, regarding the first aid oxygen, the supply of undiluted oxygen carried on board a pressurised aeroplane with 8 passengers operated at pressure altitude 27000 ft, shall be sufficient for at least: 2 passengers for the remainder of the flight after cabin depressurisation when the cabin altitude exceeds",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-58-A",
                "text": "8000 ft. 1 passenger for the remainder of the flight after cabin depressurisation when the cabin altitude exceeds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-58-B",
                "text": "8000 ft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-58-C",
                "text": "1 passenger for the remainder of the flight after cabin depressurisation when the cabin altitude only exceeds 14000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-58-D",
                "text": "2 passengers for the remainder of the flight after cabin depressurisation when the cabin altitude only exceeds 14000 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-59",
            "text": "According to Regulations, a life jacket is mandatory for each person on board a land aeroplane, when flying over water at a distance from the shore of more than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-59-A",
                "text": "200 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-59-B",
                "text": "400 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-59-C",
                "text": "100 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-59-D",
                "text": "50 NM",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-60",
            "text": "Unless sufficient life-rafts to carry all persons on board are carried, on overwater flights, an operator shall not operate an aeroplane at a distance away from land, which is suitable for making an emergency landing, greater than that corresponding to ...(i)...minutes at cruising speed or ....(ii)... nautical miles, whichever is the lesser, for aeroplanes capable of continuing the flight to an aerodrome with the critical power unit(s) becoming inoperative at any point along the route or planned diversions.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-60-A",
                "text": "(i) 30 minutes (ii) 100 nautical miles",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-60-B",
                "text": "(i) 45 minutes (ii) 200 nautical miles",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-60-C",
                "text": "(i) 90 minutes (ii) 300 nautical miles",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-60-D",
                "text": "(i) 120 minutes (ii) 400 nautical miles",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-61",
            "text": "The number of hand fire extinguishers which have to be installed in the passenger cabin according to Regulations depends on the approved number of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-61-A",
                "text": "seat rows in the cabin.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-61-B",
                "text": "seats in the cabin.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-61-C",
                "text": "emergency exits in the cabin",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-61-D",
                "text": "passengers in the cabin.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-62",
            "text": "According to Regulations, for aeroplanes with a maximum certificated take- off mass over 5700 kg, flight data recorders shall be capable of retaining the data recorded during at least the last:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-62-A",
                "text": "30 hours of operation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-62-B",
                "text": "10 flights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-62-C",
                "text": "25 flights.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-62-D",
                "text": "25 hours of operation.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-63",
            "text": "In accordance with Regulations, for aeroplanes certified before the 1 April 1998, cockpit voice recorder (CVR), when required, must keep the conversations and sound alarms recorded during the last:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-63-A",
                "text": "25 hours of operation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-63-B",
                "text": "48 hours of operation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-63-C",
                "text": "flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-63-D",
                "text": "30 minutes of operation.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-64",
            "text": "In accordance with Regulations, on board a non-pressurised aircraft, the crew and all the passengers must be fed with oxygen throughout the flight period during which the pressure altitude is greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-64-A",
                "text": "13 000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-64-B",
                "text": "11 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-64-C",
                "text": "10 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-64-D",
                "text": "12 000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-65",
            "text": "In accordance with Regulations, on board a non-pressurised aircraft, 10% of the passengers shall be supplied with oxygen throughout the entire flight time, after 30 minutes at pressure altitude greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-65-A",
                "text": "10 000 ft but not exceeding 12 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-65-B",
                "text": "10 000 ft but not exceeding 13 000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-65-C",
                "text": "11 000 ft but not exceeding 12 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-65-D",
                "text": "11 000 ft but not exceeding 13 000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-66",
            "text": "In accordance with Regulations, for the flight crew members, quick donning type of oxygen masks are compulsory on board any pressurised aeroplane operating at a pressure altitude above:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-66-A",
                "text": "25 000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-66-B",
                "text": "10 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-66-C",
                "text": "29 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-66-D",
                "text": "13 000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-67",
            "text": "An operator shall not operate an aeroplane first issued with an individual certificate of Airworthiness on or after 1 April 1998, which has a maximum certificated take-off mass over 5700 kg, unless it is equipped with a cockpit voice recorder which records: Given: 1. Voice communications transmitted from or received on the flight deck by radio 2. The aural environment of the flight deck 3. The cabin attendants communications in the cabin using the aeroplane's interphone system 4. Voice communications of flight crew members on the flight deck using the aeroplane's interphone system 5. Voice or audio signals identifying navigation or approach aids introduced into a headset or speaker 6. Voice communications of flight crew members on the flight deck using the public address system, if installed The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-67-A",
                "text": "2, 4, 5, 6.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-67-B",
                "text": "1, 2, 3, 5, 6.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-67-C",
                "text": "2, 3, 4, 6.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-67-D",
                "text": "1, 2, 4, 5, 6.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-68",
            "text": "In accordance with Regulations, the cockpit voice recorder, when required, must start to record automatically:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-68-A",
                "text": "prior to the aeroplane moving under its own power until the termination of flight when the parking brake is set.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-68-B",
                "text": "prior to the aeroplane moving under its own power until the termination of the flight when the aeroplane is no longer capable of moving under its own power.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-68-C",
                "text": "when the parking brake is released until the termination of flight when the parking brake is set.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-68-D",
                "text": "when full thrust is applied until the termination of the flight when the aeroplane is no longer capable of moving under its own power.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-69",
            "text": "In accordance with the Regulations, a single deck aeroplane, equipped with an approved seating capacity of 61 seats and carrying passengers, must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-69-A",
                "text": "2 megaphones.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-69-B",
                "text": "1 megaphone.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-69-C",
                "text": "2 megaphones if there are more than 31 passengers on board.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-69-D",
                "text": "3 megaphones.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-70",
            "text": "In accordance with the Regulations and with the exception of amphibians and seaplanes, the carriage of a life jacket for each person on board is compulsory when the aeroplane is: Given: 1. cruising at such a distance from the shore that it would not be able to return in the case of an engine failure. 2. is flying over water at a distance from the shore of more than 50 NM. 3. is using departure and arrival paths over water and when a ditching probability exists. 4. is flying over a stretch of water at more than 40 NM off shore. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-70-A",
                "text": "1, 2.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-70-B",
                "text": "2, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-70-C",
                "text": "3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-70-D",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-71",
            "text": "According to Regulations, the minimum number of hand fire extinguishers to be located in the passenger compartment of an aircraft with a maximum approved passenger seating configuration of 31 is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-71-A",
                "text": "0",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-71-B",
                "text": "3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-71-C",
                "text": "2",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-71-D",
                "text": "1",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-72",
            "text": "According to Regulations, the minimum number of crash axes or crowbars on board an aeroplane, whose maximum approved passenger seating configuration is more than 200, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-72-A",
                "text": "4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-72-B",
                "text": "3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-72-C",
                "text": "2",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-72-D",
                "text": "1",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-73",
            "text": "In accordance with Regulations, the purpose of the first aid oxygen is to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-73-A",
                "text": "provide the cabin attendants with respiratory protection.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-73-B",
                "text": "provide undiluted oxygen to passengers for physiological reasons following a cabin depressurisation.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-73-C",
                "text": "provide the flight crew with respiratory assistance after depressurisation.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-73-D",
                "text": "supply all the passengers in case of depressurisation.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-74",
            "text": "In accordance with Regulations, for a pressurised aircraft, the definition of supplemental oxygen is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-74-A",
                "text": "oxygen supplied to a passenger who needs oxygen for physiological reasons",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-74-B",
                "text": "oxygen used for protection against smoke and carbon dioxide.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-74-C",
                "text": "oxygen specifically carried for therapeutic purposes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-74-D",
                "text": "oxygen supplied to the airplane occupants in the case of cabin pressurization failure.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-75",
            "text": "According to Regulations, an aeroplane whose maximum approved passenger seating configuration is 10 seats must be equipped with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-75-A",
                "text": "two hand fire-extinguishers on the flight deck and two hand fire-extinguishers in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-75-B",
                "text": "one hand fire-extinguisher on the flight deck and one hand fire-extinguisher in the passenger compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-75-C",
                "text": "one hand fire-extinguisher on the flight deck and two hand fire-extinguishers in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-75-D",
                "text": "three hand fire-extinguishers in the passenger compartment",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-76",
            "text": "According to Regulations, an aeroplane whose maximum approved passenger seating configuration is 200 must be equipped with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-76-A",
                "text": "3 hand fire extinguishers in the passenger compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-76-B",
                "text": "4 hand fire extinguishers in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-76-C",
                "text": "5 hand fire extinguishers in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-76-D",
                "text": "7 hand fire extinguishers in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-77",
            "text": "According to Regulations, when a flight data recorder is required, it must start automatically to record the data:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-77-A",
                "text": "when the landing gear is retracted.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-77-B",
                "text": "when taking-off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-77-C",
                "text": "when lining up.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-77-D",
                "text": "prior to the aircraft being capable of moving under its own power.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-78",
            "text": "In accordance with Regulations, when the flight data recorder is required, it must stop automatically to record the data:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-78-A",
                "text": "when the aircraft clears the runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-78-B",
                "text": "when the main gear shock strut compresses when touching the runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-78-C",
                "text": "after the aircraft is unable to move by its own power.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-78-D",
                "text": "when the landing gear is extended and locked.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-79",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 7 to 30 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-79-A",
                "text": "1 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-79-B",
                "text": "4 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-79-C",
                "text": "3 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-79-D",
                "text": "2 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-80",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 31 to 60 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-80-A",
                "text": "5 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-80-B",
                "text": "4 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-80-C",
                "text": "3 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-80-D",
                "text": "2 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-81",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 61 to 200 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-81-A",
                "text": "5 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-81-B",
                "text": "4 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-81-C",
                "text": "3 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-81-D",
                "text": "2 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-82",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 201 to 300 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-82-A",
                "text": "5 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-82-B",
                "text": "4 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-82-C",
                "text": "3 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-82-D",
                "text": "2 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-83",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 301 to 400 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-83-A",
                "text": "5 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-83-B",
                "text": "4 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-83-C",
                "text": "3 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-83-D",
                "text": "6 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-84",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 301 to 400 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-84-A",
                "text": "5 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-84-B",
                "text": "7 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-84-C",
                "text": "8 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-84-D",
                "text": "6 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-85",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is 501 to 600 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-85-A",
                "text": "5 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-85-B",
                "text": "7 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-85-C",
                "text": "8 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-85-D",
                "text": "6 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-86",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is greater than 600 seats must be equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-86-A",
                "text": "9 hand fire-extinguisher conveniently located in the passenger compartment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-86-B",
                "text": "7 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-86-C",
                "text": "8 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-86-D",
                "text": "6 hand fire-extinguishers conveniently located in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-87",
            "text": "In accordance with Regulations, an aeroplane whose maximum approved passenger seating configuration is greater than 60 seats must be equipped (including flight deck) with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-87-A",
                "text": "3 HALON 1211 fire-extinguishers or equivalent.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-87-B",
                "text": "2 HALON 1211 fire-extinguishers or equivalent.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-87-C",
                "text": "1 HALON 1211 fire-extinguisher or equivalent.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-87-D",
                "text": "4 HALON 1211 fire-extinguishers or equivalent.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-88",
            "text": "In accordance with Regulations, an aeroplane whose maximum take-off mass exceeds 5 700 kg or whose maximum approved passenger seating configuration is greater than 9 seats and less than 200 seats must be equipped with a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-88-A",
                "text": "crash axe on the flight deck and a crow-bar in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-88-B",
                "text": "crash axe and a crow-bar in the passenger compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-88-C",
                "text": "crash axe or a crow-bar on the flight deck.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-88-D",
                "text": "crow-bar on the flight deck and a crash axe in the passenger compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-89",
            "text": "In accordance with Regulations, for a pressurised aeroplane, during and following an emergency descent, all occupants of flight deck seats on flight deck duty shall be supplied with a minimum supplemental oxygen quantity: Given: 1. In order to maintain a supply throughout the entire flight time where the cabin altitude pressure is greater than 13000 ft. 2. In order to maintain a supply throughout the entire flight time where the cabin altitude pressure is greater than 10000 ft and smaller than 13000 ft minus 30 minutes. 3. In no case less than 30 minutes for aeroplanes certificated to fly up to 25000 ft. 4. In no case less than 2 hours for aeroplanes certificated to fly over 25000 ft. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-89-A",
                "text": "1, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-89-B",
                "text": "1, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-89-C",
                "text": "1, 2.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-89-D",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-90",
            "text": "In accordance with Regulations and if required, the number of life rafts to be carried on board an aeroplane must allow the transportation of the entire aeroplane occupants:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-90-A",
                "text": "plus 20 %.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-90-B",
                "text": "in the case of a loss of one raft of the largest rated capacity.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-90-C",
                "text": "plus 30 %.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-90-D",
                "text": "plus 10 %.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-91",
            "text": "In accordance with Regulations, all occupants of flight deck seats on flight deck duty in a non-pressurised aircraft shall be supplied with supplemental oxygen for the entire flight time at pressure altitudes above:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-91-A",
                "text": "15000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-91-B",
                "text": "10000 ft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-91-C",
                "text": "13000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-91-D",
                "text": "14000 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-92",
            "text": "In accordance with Regulations, 100 % of the passengers in a non-pressurised aircraft shall be supplied with supplemental oxygen for the entire flight time at pressure altitudes above:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-92-A",
                "text": "15000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-92-B",
                "text": "10000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-92-C",
                "text": "13000 ft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-92-D",
                "text": "14000 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-93",
            "text": "In accordance with Regulations, 10 % of the passengers in a non-pressurised aircraft shall be supplied with supplemental oxygen for the entire flight time after 30 minutes at pressure altitudes greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-93-A",
                "text": "14000 ft but not exceeding 15000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-93-B",
                "text": "10000 ft but not exceeding 14000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-93-C",
                "text": "10000 ft but not exceeding 13000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-93-D",
                "text": "10000 ft but not exceeding 15000 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-94",
            "text": "In accordance with Regulations, on aeroplanes intended to be operated at pressure altitude above 25000 ft, the total number of oxygen dispensing units shall exceed the number of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-94-A",
                "text": "passengers by 10 %",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-94-B",
                "text": "seats by 2 %.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-94-C",
                "text": "passengers by 2 %.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-94-D",
                "text": "seats by 10 %.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-95",
            "text": "According to Regulations Subpart K, in an aeroplane with a maximum configuration of more than 19 passengers, the door between the passenger compartment and the flight deck compartment shall have locking means",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-95-A",
                "text": "to prevent passengers from opening it without permission of a member of the flight crew.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-95-B",
                "text": "capable of being locked only from outside the flight deck compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-95-C",
                "text": "capable of being remotely locked from either inside or outside the flight deck compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-95-D",
                "text": "capable of being remotely locked by cabin crew from outside the flight deck compartment.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-96",
            "text": "In accordance with Regulations, an aeroplane with a maximum approved passenger seating configuration of more than 61 seats, must have in its passenger compartment(s), at least 3 hand fire-extinguishers including:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-96-A",
                "text": "3 Halon fire-extinguishers or equivalent.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-96-B",
                "text": "no Halon fire-extinguisher.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-96-C",
                "text": "2 Halon fire-extinguishers or equivalent.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-96-D",
                "text": "1 Halon fire-extinguisher or equivalent.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-97",
            "text": "On a pressurised aeroplane, supplemental oxygen is used to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-97-A",
                "text": "provide selected passengers with oxygen",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-97-B",
                "text": "protect the aircrew fighting fires",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-97-C",
                "text": "assist a passenger with breathing disorders",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-97-D",
                "text": "provide passengers on board with oxygen following a cabin depressurisation",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-98",
            "text": "According to Regulations, a public address system is required to operate an aeroplane with a maximum approved passenger seating configuration of more than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-98-A",
                "text": "30",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-98-B",
                "text": "9",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-98-C",
                "text": "61",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-98-D",
                "text": "19",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-99",
            "text": "According to Regulations, a windshield wiper or equivalent means to maintain a clear portion of the windshield during precipitation is required at each pilot station to operate an aeroplane with a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-99-A",
                "text": "maximum certificated take-off mass of more than 15000 kg",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-99-B",
                "text": "maximum approved passenger configuration of more than 6 seats",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-99-C",
                "text": "maximum certificated take-off mass of more than 5700 kg",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-99-D",
                "text": "maximum approved passenger configuration of more than 9 seats",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-100",
            "text": "According to Regulations, the public address system must be audible and intelligible at: Given: 1. all passenger seats 2. toilets 3. cabin crew seats 4. work stations The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-100-A",
                "text": "1.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-100-B",
                "text": "1, 2, 3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-100-C",
                "text": "1, 2.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-100-D",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-101",
            "text": "According to Regulations, in order to be operated IFR or at night in areas with potentially hazardous weather conditions, an aeroplane must be equipped with an airborne weather radar when the aeroplane is: Given: 1. pressurised 2. non-pressurised with a maximum take-off mass of more than 5700 kg 3. non-pressurised with a maximum approved seating configuration of more than 9 seats 4. non-pressurised regardless of weight or seating configuration The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-101-A",
                "text": "4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-101-B",
                "text": "1, 2, 3",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-101-C",
                "text": "1, 2.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-101-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-102",
            "text": "According to Regulations, for a non pressurized aircraft, the supplemental oxygen is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-102-A",
                "text": "required to operate at pressure altitudes above 10 000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-102-B",
                "text": "used for protection against smoke and carbon dioxide",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-102-C",
                "text": "therapeutical oxygen specially carried for certain passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-102-D",
                "text": "available for supply to passengers for physiological reasons",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-103",
            "text": "In accordance with Regulations, for a non pressurized aircraft, all occupants of flight deck seats on flight deck duty shall be supplied with supplemental oxygen during:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-103-A",
                "text": "the entire flight time at pressure altitudes above 10000 ft the entire flight time at pressure altitudes above 13000 ft and for any period exceeding 30 minutes at",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-103-B",
                "text": "pressure altitudes above 10000 ft but not exceeding 13000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-103-C",
                "text": "the entire flight time after 30 minutes at pressure altitudes greater than 10000 ft but not exceeding 13000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-103-D",
                "text": "the entire flight time at pressure altitudes above 13000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-104",
            "text": "According to Regulations, for a non pressurized aircraft, all required cabin crew members shall be supplied with supplemental oxygen during:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-104-A",
                "text": "the entire flight time at pressure altitudes above 13000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-104-B",
                "text": "the entire flight time after 30 minutes at pressure altitudes greater than 10000 ft but not exceeding 13000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-104-C",
                "text": "the entire flight time at pressure altitudes above 13000 ft and for any period exceeding 30 minutes at pressure altitudes above 10000 ft but not exceeding 13000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-104-D",
                "text": "the entire flight time at pressure altitudes above 10000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-105",
            "text": "According to Regulations, for a non pressurised aircraft, 100% of passengers shall be supplied with supplemental oxygen during: the entire flight time at pressure altitudes above 13000 ft and for any period exceeding 30 minutes at",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-105-A",
                "text": "pressure altitudes above 10000 ft but not exceeding 13000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-105-B",
                "text": "the entire flight time at pressure altitudes above 10000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-105-C",
                "text": "the entire flight time at pressure altitudes above 13000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-105-D",
                "text": "the entire flight time after 30 minutes at pressure altitudes greater than 10000 ft but not exceeding 13000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-106",
            "text": "In accordance with Regulations, for a pressurized aeroplane, certificated to fly at altitudes more than 25000 ft, all occupants of flight deck seats on flight deck duty shall be supplied with supplemental oxygen during a period in no case less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-106-A",
                "text": "30 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-106-B",
                "text": "2 hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-106-C",
                "text": "10 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-106-D",
                "text": "1 hour",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-107",
            "text": "Assuming 60 passengers on board a land aeroplane. The intended track will overfly water for a distance of 80 NM from the shore. According to Regulations, the minimum number of passenger life jackets to be on board is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-107-A",
                "text": "None if equipped with life rafts",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-107-B",
                "text": "0",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-107-C",
                "text": "60",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-107-D",
                "text": "66",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-108",
            "text": "According to Regulations, an aircraft must be equipped with an audio selector panel accessible to each required flight crew member:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-108-A",
                "text": "at all times when carrying passengers.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-108-B",
                "text": "when operating under IFR, or under VFR over routes not navigated by reference to visual landmarks.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-108-C",
                "text": "when operating in controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-108-D",
                "text": "when operating under IFR.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-109",
            "text": "According to Regulations, what minimum navigation equipment is required for operations under IFR, or under VFR over routes not navigated by reference to visual landmarks?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-109-A",
                "text": "One VOR receiving system, one ADF system, two DMEs.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-109-B",
                "text": "One VOR receiving system, one DME.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-109-C",
                "text": "One VOR receiving system, one ADF system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-109-D",
                "text": "One VOR receiving system, one ADF system, one DME.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-110",
            "text": "Which JAR prescribes requirements for approved maintenance organisations?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-110-A",
                "text": "JAR-66",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-110-B",
                "text": "JAR-25",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-110-C",
                "text": "JAR-AMO",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-110-D",
                "text": "JAR-145",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-111",
            "text": "According to Regulations, 'pre-flight inspection' is the inspection carried out:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-111-A",
                "text": "by the caterer to ensure that the aircraft is prepared with meals and beverages necessary for the flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-111-B",
                "text": "before flight to ensure that the aircraft is fit for the intended flight. It does not include defect rectification.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-111-C",
                "text": "before flight to ensure that the aircraft is fit for the intended flight including defect rectification.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-111-D",
                "text": "by the fuel company to ensure that the aircraft is prepared for refuelling.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-112",
            "text": "Under what circumstances may an operator introduce alternative procedures to those prescribed in Regulations Subpart M (maintenance)?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-112-A",
                "text": "Never. Subpart M is mandatory and may not be modified. When needed and when an equivalent safety case has first been approved by the Authority and supported",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-112-B",
                "text": "by EASA Member Authorities. When needed and when an equivalent safety case has been established. No prior approval is needed from",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-112-C",
                "text": "the Authority.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-112-D",
                "text": "When needed to expedite maintenance procedures.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-113",
            "text": "According to Regulations, the recent experience conditions of a commander assigned to a flight on an aeroplane by an operator must not be less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-113-A",
                "text": "3 take-offs and 3 landings on this type of aeroplane during the last 6 months 6 take-offs and 6 landings as pilot flying on the same type of aeroplane or approved simulator, of the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-113-B",
                "text": "aeroplane type to be used",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-113-C",
                "text": "6 take-offs and 6 landings during the last 6 months 3 take-offs and 3 landings as pilot flying on the same type of aeroplane or approved simulator, of the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-113-D",
                "text": "aeroplane type to be used, in the preceding 90 days",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-114",
            "text": "In accordance with Regulations, an operator shall ensure that a pilot does not operate an aeroplane as commander unless:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-114-A",
                "text": "he has carried out at least 3 take-offs and 3 landings as pilot flying in an aeroplane or an approved flight simulator of the type to be used, in the preceding 30 days he has carried out at least 3 flights as commander in an aeroplane or an approved flight simulator of the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-114-B",
                "text": "type to be used, in the preceding 90 days he has carried out at least 3 take-offs and 3 landings as pilot flying in an aeroplane of the same type/class",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-114-C",
                "text": "or in a flight simulator of the aeroplane type to be used, in the preceding 90 days he has carried out at least 3 take-offs and 3 landings as pilot flying in any type of aeroplane or an approved",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-114-D",
                "text": "simulator, under the supervision of an examiner, in the preceding 60 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-115",
            "text": "Regulations requires that a co-pilot does not serve at the flight controls during take-o and landing unless:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-115-A",
                "text": "he has operated the controls as a pilot for three take-offs and landings in an aeroplane in the preceding 60 days. he has operated the controls as a pilot for three take-offs and landings in an aeroplane of the same",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-115-B",
                "text": "type/class or in a flight simulator of the aeroplane type to be used in the preceding 90 days. he has operated the controls as a pilot for three take-offs and landings in an aeroplane in the preceding 90",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-115-C",
                "text": "days. he has operated the controls as a pilot for three take-offs and landings in an aeroplane of the same",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-115-D",
                "text": "type/class or in a flight simulator of the aeroplane type to be used in the preceding 60 days.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-116",
            "text": "In accordance with Regulations, the minimum required recent experience for a pilot engaged in a single-pilot operation under IFR or at night shall be",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-116-A",
                "text": "5 IFR flights, including 3 take-off and 3 landings carried out during the preceding 90 days on the type or class of aeroplane in the single-pilot role. 3 IFR flights, including 3 instrument approaches, carried out during the preceding 90 days on the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-116-B",
                "text": "B type/class of aeroplane in the single-pilot role. 5 IFR flights, including 3 instrument approaches, carried out during the preceding 90 days on the",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-116-C",
                "text": "type/class of aeroplane in the single-pilot role.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-116-D",
                "text": "5 IFR flights, including 3 take-off and 3 landings carried out during the preceding 30 days on the type or D class of aeroplane in the single-pilot role.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-117",
            "text": "According to Regulations, an operator shall ensure that each cabin crew member is at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-117-A",
                "text": "20 years of age.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-117-B",
                "text": "17 years of age.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-117-C",
                "text": "21 years of age.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-117-D",
                "text": "18 years of age.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-118",
            "text": "According to Regulations, an operator shall not operate an aeroplane with a maximum approved passenger seating configuration of more than ...(i)...., and when carrying ...(ii)... or more passengers, unless at least one cabin crew is included.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-118-A",
                "text": "(i) 9, (ii) five",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-118-B",
                "text": "(i) 15, (ii) five",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-118-C",
                "text": "(i) 19, (ii) one",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-118-D",
                "text": "(i) 9, (ii) one",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-119",
            "text": "According to Regulations, an operator must select a take-off alternate:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-119-A",
                "text": "when the flight duration exceeds 6 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-119-B",
                "text": "for an IFR flight with a single-engine aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-119-C",
                "text": "when conducting a flight over water of more than 2 hours or 400 NM, whichever is the lesser if it would not be possible to return to the aerodrome of departure for meteorological or performance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-119-D",
                "text": "reasons.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-120",
            "text": "According to Regulations, the selection of a destination alternate is NOT required when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-120-A",
                "text": "the destination is isolated and no adequate destination alternate exists.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-120-B",
                "text": "the duration of the planned flight does not exceed 8 hours and the weather forecast calls for VMC conditions at the destination aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-120-C",
                "text": "the destination aerodrome has an ILS approach for each runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-120-D",
                "text": "you have an adequate take-off alternate.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-121",
            "text": "According to Regulations, for two-engined aeroplanes in Performance class B or C without an ETOPS approval, the maximum distance from an adequate aerodrome is the distance flown in ....(i)... minutes at the one engine inoperative cruise speed, or ...(ii)... nautical miles, whichever is less.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-121-A",
                "text": "(i) 60, (ii) 300",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-121-B",
                "text": "(i) 120, (ii) 300",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-121-C",
                "text": "(i) 120, (ii) 200",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-121-D",
                "text": "(i) 60, (ii) 200",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-122",
            "text": "According to Regulations, without an ETOPS approval, the maximum distance from an adequate aerodrome for two-engined aeroplanes in Performance Class A , with a maximum approved passenger seating configuration of 20 or more, is the distance flown in .......... minutes at the one-engine-inoperative cruise speed.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-122-A",
                "text": "30",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-122-B",
                "text": "90",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-122-C",
                "text": "120",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-122-D",
                "text": "60",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-123",
            "text": "According to Regulations, without an ETOPS approval, the maximum distance from an adequate aerodrome for two-engined aeroplanes in Performance Class A , with a maximum take-off mass of 45360 kg or more, is the distance flown in .......... minutes at the one-engine inoperative cruise speed.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-123-A",
                "text": "30",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-123-B",
                "text": "90",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-123-C",
                "text": "120",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-123-D",
                "text": "60",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-124",
            "text": "According to Regulations, if a piece of equipment on your aircraft becomes inoperative while you are still parked, before making the decision to proceed the reference document used is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-124-A",
                "text": "the Authorities Regulations Manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-124-B",
                "text": "the flight manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-124-C",
                "text": "the Operations Manual under the heading \"Abnormal and Emergency procedures\".",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-124-D",
                "text": "the Operations Manual under the heading \"MEL\".",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-125",
            "text": "According to Regulations, the Minimum Equipment List of an aircraft is found in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-125-A",
                "text": "operations manual.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-125-B",
                "text": "flight record.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-125-C",
                "text": "flight manual.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-125-D",
                "text": "Ops Regulations.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-126",
            "text": "According to Regulations, an operator shall not operate an aircraft in expected or actual icing conditions unless:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-126-A",
                "text": "the aircraft is sprayed with de-icing fluid before flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-126-B",
                "text": "the aircraft is certificated and equipped to operate in icing conditions.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-126-C",
                "text": "the flight is planned so that a change of cruising level can be initiated rapidly.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-126-D",
                "text": "the aircraft is sprayed with anti-icing fluid before flight.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-127",
            "text": "According to Regulations, the commander shall not commence take-off:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-127-A",
                "text": "even if the ice contamination does not exceed the mass and balance limits.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-127-B",
                "text": "unless the external surfaces are free from any ice contamination greater than 5 mm. unless the external surfaces are still covered with anti-icing fluid and the aircraft is not to be operated in",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-127-C",
                "text": "forecasted icing conditions greater than moderate icing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-127-D",
                "text": "unless the external surfaces are clear of any deposit, except as permitted by Aircraft Flight Manual.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-128",
            "text": "According to Regulations, for operations under IFR or at night the minimum flight crew is 2 pilots for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-128-A",
                "text": "all turbo-propeller aeroplanes with a maximum approved passenger seating configuration of more than 9 and for all turbo-jet aeroplanes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-128-B",
                "text": "all turbo-propeller aeroplanes and for all turbo-jet aeroplanes. all turbo-propeller aeroplanes with a maximum approved passenger seating configuration of more than 19",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-128-C",
                "text": "and for all turbo-jet aeroplanes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-128-D",
                "text": "all turbo-propeller aeroplanes and for all turbo-jet aeroplanes with a maximum approved passenger seating configuration of more than 9.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-129",
            "text": "In accordance with Regulations, the take-off climb procedures for noise abatement to be specified by the operator should be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-129-A",
                "text": "for all aeroplane types, the same for a specific aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-129-B",
                "text": "for all aeroplane types, the same for all aerodromes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-129-C",
                "text": "for any one aeroplane type, the same for all aerodromes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-129-D",
                "text": "different according to aerodromes and aeroplane types.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-130",
            "text": "According with the \"noise abatement take-off and climb procedure B\", as established in ICAO PANS OPS 8168 - Ops Volume 1, part V, aircraft must climb at V2 + 10 to 20 kt, until reaching:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-130-A",
                "text": "1 000 ft AGL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-130-B",
                "text": "3 000 ft AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-130-C",
                "text": "500 ft AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-130-D",
                "text": "1 500 ft AGL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-131",
            "text": "In accordance with ICAO PANS OPS 8168, noise preferential routes are established to ensure that departing and arriving aeroplanes avoid overflying noise-sensitive areas in the vicinity of the aerodrome as far as practicable. In establishing noise preferential routes: turns during take-off and climb should not be required unless the bank angle for turns is limited to 20°",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-131-A",
                "text": "climbing at V2 + 10 to 20 Kt) no turns should be required coincident with a reduction of power associated with a noise abatement",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-131-B",
                "text": "procedure turns during take-off and climb should not be required unless the bank angle for turns is limited to 28°",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-131-C",
                "text": "(climbing at V2 + 10 to 20 Kt) turns during take-off and climb should not be required unless the aeroplane has reached and can maintain",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-131-D",
                "text": "throughout the turn a height of no less than 100 m above terrain and the highest obstacle.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-132",
            "text": "According to ICAO noise abatement procedures during landing:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-132-A",
                "text": "apply in case of instrument approaches only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-132-B",
                "text": "apply in case of visual approaches only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-132-C",
                "text": "prohibit the use of reverse thrust .",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-132-D",
                "text": "shall not prohibit the use of reverse thrust.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-133",
            "text": "According to ICAO Doc 8168, a noise abatement departure procedure is NOT to be initiated at less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-133-A",
                "text": "1 000 ft above aerodrome elevation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-133-B",
                "text": "800 ft above aerodrome elevation",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-133-C",
                "text": "2 000 ft above aerodrome elevation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-133-D",
                "text": "1 500 ft above aerodrome elevation",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-134",
            "text": "According to the recommended \"noise abatement take-off and climb procedure\" NADP2, established in ICAO Doc 8168, acceleration and flaps/slats retraction is initiated:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-134-A",
                "text": "not below 1 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-134-B",
                "text": "at 3 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-134-C",
                "text": "at 1 500 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-134-D",
                "text": "not below 800 ft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-135",
            "text": "According to Regulations, at least one of the following hand fire extinguishers must be conveniently located on the flight deck:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-135-A",
                "text": "a water fire-extinguisher.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-135-B",
                "text": "a foam fire-extinguisher.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-135-C",
                "text": "a halon fire-extinguisher or equivalent.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-135-D",
                "text": "a powder fire-extinguisher.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-136",
            "text": "According to Regulations, following a decompression, the maximum pressure altitude at which each member of the flight crew on flight deck duty are able to fly with no supplemental oxygen with no flight time limitation is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-136-A",
                "text": "13000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-136-B",
                "text": "15000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-136-C",
                "text": "8000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-136-D",
                "text": "10000 ft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-137",
            "text": "According to Regulations, when a commercial transport passenger aircraft is equipped with a door in the flight crew compartment area, this door must include:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-137-A",
                "text": "a locking system to prevent any unauthorised access.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-137-B",
                "text": "a device preventing the flight crew from being locked in the cockpit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-137-C",
                "text": "a sealing system which, in case of depressurisation in the compartment area allows the maintenance of the pressure in the cockpit for as long as possible.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-137-D",
                "text": "distinctive red or yellow coloured markings indicating the access area (in case of a blocked door)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-138",
            "text": "In the Regulations, a runway is considered wet when: Given: 1. it is covered with a quantity of water or loose or slushy snow less than or equal to the equivalent of 3 mm of water. 2. the amount of surface moisture is sufficient to modify its colour but does not give it a shiny appearance. 3. the amount of surface moisture is sufficient to make it reflective, but does not create large stagnant sheets of water. 4. it bears stagnant sheets of water. The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-138-A",
                "text": "4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-138-B",
                "text": "1, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-138-C",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-138-D",
                "text": "1, 2.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-139",
            "text": "In the Regulations, a runway is considered damp when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-139-A",
                "text": "it is covered with a film of water of less than 1 mm.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-139-B",
                "text": "surface moisture gives it a shiny appearance.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-139-C",
                "text": "its surface is not dry, and when surface moisture does not give it a shiny appearance",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-139-D",
                "text": "it is covered with a film of water of less than 3 mm.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-140",
            "text": "In the Regulations, a runway is referred to as contaminated when more than 25 % of the required runway surface is covered with the one of the following elements: Given: 1. a water film sufficiently thick to give a shiny appearance to the runway. 2. a water film or loose or slushy snow equivalent to more than 3 mm of water. 3. compacted snow (a solid mass which may not be compacted further). 4. ice, including wet ice. 5. moist grass. The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-140-A",
                "text": "1, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-140-B",
                "text": "2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-140-C",
                "text": "1, 3, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-140-D",
                "text": "1, 2, 3, 4",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-141",
            "text": "According to Regulations terminology, a runway is considered damp when the runway surface is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-141-A",
                "text": "not dry, and the surface appears reflective.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-141-B",
                "text": "covered with water up to 1 mm deep.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-141-C",
                "text": "covered with water up to 3 mm deep.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-141-D",
                "text": "not dry, but when the moisture on it does not give it a shiny appearance.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-142",
            "text": "For isolated aerodrome procedure, when no suitable alternate aerodrome is available, the amount of fuel at departure should be include: taxi fuel, trip fuel, contingency fuel, additional fuel if required, but not less than - for airplanes with turbine",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-142-A",
                "text": "engines, fuel to fly for two hours at normal cruise consumption after arriving overhead the destination aerodrome including final reserve fuel and extra fuel if required by the commander.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-142-B",
                "text": "taxi fuel, trip fuel, fuel to execute an approach and a missed approach, then hold for 30 minutes at holding speed at 1500 feet above the aerodrome.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-142-C",
                "text": "taxi fuel, tip fuel, fuel to hold for 60 minutes at normal cruise speed and to have contingency fuel. to a nominated equal time point; hold for 2 hours at normal cruise speed, contingency fuel and extra fuel if",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-142-D",
                "text": "required by the commander.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-143",
            "text": "Where persons with reduced mobility are carried, for safety and health reasons they will be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-143-A",
                "text": "Embarked at the captains discretion",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-143-B",
                "text": "Embarked after all other passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-143-C",
                "text": "Embarked before all other passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-143-D",
                "text": "Embarked at the Operators discretion",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-144",
            "text": "An operator shall ensure that the take-off mass of an aeroplane does not exceed the maximum take-off mass specified in the Aeroplane Flight Manual for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-144-A",
                "text": "the density altitude at the destination aerodrome at which the landing is to be made.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-144-B",
                "text": "the pressure altitude and the ambient temperature at the aerodrome at which the take-off is to be made",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-144-C",
                "text": "The ISA deviation as forecast within the proceeding 24 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-144-D",
                "text": "Temperatures above 40 degrees and below - 10 degrees",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-145",
            "text": "A Pilot shall not accept dangerous goods for transport on any GCAA registered aircraft unless he has received training in accordance with the UAE Civil Aviation Regulation (CAR) Part:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-145-A",
                "text": "VI Aviation Safety Regulations",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-145-B",
                "text": "III General Regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-145-C",
                "text": "II Licensing Regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-145-D",
                "text": "He can always accept dangerous goods",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-146",
            "text": "In accordance with Regulations, in an aeroplane in which fuses are used, the number of spare fuses available for use in flight must be at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-146-A",
                "text": "10 % of the number of fuses of each rating or 3 of each rating, whichever is the greater",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-146-B",
                "text": "10 % of the number of fuses of each rating or 3 of each rating, whichever is the greater",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-146-C",
                "text": "20 % of the number of fuses of each rating or 2 of each rating, whichever is the greater",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-146-D",
                "text": "5 % of the number fuses of each rating or 1 of each rating, whichever is the greater",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-REG-147",
            "text": "Assuming a multi-engine land aeroplane with 60 persons on board. The cruising speed is 180 kt. The aeroplane is capable of continuing the flight with the critical power-unit becoming inoperative. The track will overfly water for a distance of 380 NM from land which is suitable for making an emergency landing. According to regulations, the minimum number of life rafts shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-147-A",
                "text": "1 life raft of 30-seat capacity and 2 life rafts of 20-seat capacity.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-147-B",
                "text": "3 life rafts of 30-seat capacity.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-147-C",
                "text": "2 life rafts of 30-seat capacity.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-REG-147-D",
                "text": "none, distance being less than 400 NM.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "0d73b8bc0d1c5e9c1459077d45748f71",
      "name": "Long Range Flights",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-001",
            "text": "Minimum time route is a route calculated for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-001-A",
                "text": "a period of 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-001-B",
                "text": "aircraft flying in MNPS airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-001-C",
                "text": "a given flight from departure to destination",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-001-D",
                "text": "a period of 12 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-002",
            "text": "A minimum time track is a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-002-A",
                "text": "great circle track",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-002-B",
                "text": "track determined according to wind conditions",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-002-C",
                "text": "spherical capable flight segment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-002-D",
                "text": "rhumb line",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-003",
            "text": "An aircraft leaves point P (60°N 030°W) on a true heading equal to 090° while the directional gyro without an hourly rate correction device, indicates 000°. The aircraft arrives at point Q (62°N 010°W) on a true heading equal to 095°. During the flight from P to Q the directional gyro remains in free gyro mode. If the flight lasted 1 hour 30 minutes, the gyro heading at Q will be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-003-A",
                "text": "334°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-003-B",
                "text": "345°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-003-C",
                "text": "003°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-003-D",
                "text": "328°",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-004",
            "text": "A pilot is using a polar stereographic chart whose grid is parallel to the zero meridian, with Grid North in the direction of the North geographic pole. In polar regions, the pilot stops navigation in free-gyro mode after leaving the 6 microteslas zone, and the grid heading controlled by information from the inertial navigation system (INS) is 045°. After switching to \"magnetic mode\", the compass heading is 220°. The INS position at this moment is 76°N 180°W. The magnetic variation on the chart is 10°E. The compass deviation at this heading is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-004-A",
                "text": "+15°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-004-B",
                "text": "+5°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-004-C",
                "text": "-15°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-004-D",
                "text": "-5°",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-005",
            "text": "On the diagram where: TN = True North, MN = Magnetic North, GN = Grid North. If the magnetic variation is equal to 65°W and if the grid variation is equal to 4°E, the correct arrangement of the different north is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-005-A",
                "text": "3",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-005-B",
                "text": "1",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-005-C",
                "text": "2",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-005-D",
                "text": "4",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-006",
            "text": "You plan to fly from point A (60°N 010°E) to point B (60°N 020°E). The North of the directional gyro with no rate correction device, is aligned with the true North of point A. The constant gyro heading to be followed when starting from point A, given that the flight time scheduled is 1h30 min with a zero wind, is equal to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-006-A",
                "text": "080°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-006-B",
                "text": "066°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-006-C",
                "text": "076°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-006-D",
                "text": "085°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-007",
            "text": "A polar stereographic chart has a grid printed over it which is parallel to the meridian 054°W, with Grid North in the direction of the North geographic pole. An aircraft is following a true course of 330°. At position 80°N 140°E, what is the grid heading:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-007-A",
                "text": "164°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-007-B",
                "text": "136°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-007-C",
                "text": "316°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-007-D",
                "text": "276°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-008",
            "text": "On a polar stereographic chart whose grid is parallel with the Greenwich meridian in the direction of the true North pole, the true track of the great circle linking point 62°N 010°E to point 66°N 050°W is 305°. The grid route at the starting point of this great circle is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-008-A",
                "text": "295°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-008-B",
                "text": "298°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-008-C",
                "text": "292°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-008-D",
                "text": "301°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-009",
            "text": "The chart is a South polar stereographic projection of the Antarctic regions. A grid, printed over it, is aligned with meridian 180°, the grid North is pointing in the direction of the geographic North (non standard grid). The grid course followed by the aircraft is 280°, the position is 80°S 100°E. The true course followed at this moment is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-009-A",
                "text": "100°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-009-B",
                "text": "080°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-009-C",
                "text": "260°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-009-D",
                "text": "360°.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-010",
            "text": "The chart type is polar stereographic with the grid parallel to the zero meridian, and Grid North in the direction of the North geographic pole .The gyro is not fitted with a rate correction device. The gyro-magnetic compass of an aircraft standing at an aerodrome located at 59°57’N 010°30'E is switched to free gyro mode at 14.00 UTC, with gyro North being aligned with Grid North and the gyro heading reading 120°. A technical problem delays take off until 16.30 UTC. The gyro was not reset prior to take off. The error (E) at the time of alignment on this runway will be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-010-A",
                "text": "+32.5°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-010-B",
                "text": "-32.5°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-010-C",
                "text": "+73.5°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-010-D",
                "text": "+13°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-011",
            "text": "The pilot uses a South polar stereographic chart with grid parallel with the zero meridian and Grid North in the direction of geographic North along this meridian. The aircraft position is 80°S 130°E, its true route is 110°, the grid route at this moment is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-011-A",
                "text": "060°",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-011-B",
                "text": "340°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-011-C",
                "text": "240°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-011-D",
                "text": "110°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-012",
            "text": "The Control Display Unit (CDU) of an Inertial Navigation System (INS), indicates the following information: Given: 1. Desired track (DTK) = 100° 2. Track (TK) = 120° Based on this information the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-012-A",
                "text": "Track Error Angle (TKE) is left (L)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-012-B",
                "text": "Aircraft is diverging from its ideal course",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-012-C",
                "text": "Aircraft is converging towards its ideal course",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-012-D",
                "text": "Track Error Angle (TKE) is right (R)",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-013",
            "text": "During a transoceanic and polar flight, the chart precession is a rotation in degrees, for a moving aircraft, of the gyro North with respect to the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-013-A",
                "text": "true North for any chart",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-013-B",
                "text": "grid North for a given chart",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-013-C",
                "text": "true North for a given chart",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-013-D",
                "text": "grid North for any chart",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-014",
            "text": "Astronomic precession is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-014-A",
                "text": "independent of the latitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-014-B",
                "text": "depending on the chart used",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-014-C",
                "text": "zero when the aircraft is on the ground",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-014-D",
                "text": "existing whether the aircraft is on the ground or flying",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-015",
            "text": "Astronomic precession:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-015-A",
                "text": "is zero at the North pole",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-015-B",
                "text": "causes an apparent wander on the axis of the directional gyro to the right in the southern hemisphere",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-015-C",
                "text": "causes an apparent wander on the axis of the directional gyro to the left in the southern hemisphere",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-015-D",
                "text": "is zero at the South pole",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-016",
            "text": "Astronomic precession:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-016-A",
                "text": "causes the gyro axis to spin to the right in the Northern hemisphere",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-016-B",
                "text": "is zero at the South pole",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-016-C",
                "text": "causes the gyro axis to spin to the left in the Northern hemisphere",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-016-D",
                "text": "is zero at the North pole",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-017",
            "text": "A polar track is a part of a track which is included in an area where the horizontal component of the earth magnetic field is less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-017-A",
                "text": "6 micro-tesla",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-017-B",
                "text": "38 micro tesla",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-017-C",
                "text": "10 micro-tesla",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-017-D",
                "text": "17 micro-tesla",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-018",
            "text": "When leaving the MNPS oceanic control area for a domestic controlled area, the pilot has to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-018-A",
                "text": "take the Mach number specified in his initial flight plan",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-018-B",
                "text": "maintain the Mach number previously assigned up to the last position shown in the oceanic clearance.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-018-C",
                "text": "take the Mach number provided for this type of flight by his airline.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-018-D",
                "text": "take any Mach number.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-019",
            "text": "MNPS is the abbreviation for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-019-A",
                "text": "Maximum North-Atlantic Precision System",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-019-B",
                "text": "Minimum Navigation Performance Specification.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-019-C",
                "text": "Minimum Navigation Positioning System.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-019-D",
                "text": "Military Network Performance Structure",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-020",
            "text": "In MNPS airspace, the speed reference for turbo-jet aircraft is the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-020-A",
                "text": "true airspeed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-020-B",
                "text": "ground speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-020-C",
                "text": "indicated airspeed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-020-D",
                "text": "Mach number.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-021",
            "text": "Flight in a twin-engine aircraft from PARIS to WASHINGTON Given: 1. ETOPS authorisation: 105 minutes at 420 kt 2. TRACK A: Flight time 08h03 3. TRACK B: Flight time 08h10 4. TRACK C: Flight time 08h15 5. TRACK D: Flight time 08h20 6. Only three alternates are available: SHANNON, SANTA MARIA, ST JOHN TORBAY. The track to be chosen will be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-021-A",
                "text": "Track C",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-021-B",
                "text": "Track A",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-021-C",
                "text": "Track B",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-021-D",
                "text": "Track D",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-022",
            "text": "In the MNPS airspace, a pilot should first of all take the following action in the event of a failure of the last inertial navigation system:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-022-A",
                "text": "request authorisation from Control to track another aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-022-B",
                "text": "notify Air Traffic Control and wait for instructions within a reasonable period.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-022-C",
                "text": "immediately climb or descend 1 000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-022-D",
                "text": "set a different heading approximately 45° from the previous one.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-023",
            "text": "A flight via the SHANNON-GANDER great circle with no MNPS certification can be planned:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-023-A",
                "text": "at FL 290",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-023-B",
                "text": "outside OTS validity hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-023-C",
                "text": "at FL 280 or less.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-023-D",
                "text": "at a Mach number of 0.70 or less.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-024",
            "text": "Aircraft may operate in MNPS airspace along a number of special routes, if the aircraft is equipped with at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-024-A",
                "text": "three Inertial Navigation System (INS).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-024-B",
                "text": "one Long Range Navigation System (LNRS).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-024-C",
                "text": "two Inertial Navigation Systems (INS).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-024-D",
                "text": "two independent Long Range Navigation Systems (LRNS).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-025",
            "text": "The MNPS airspace extends from:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-025-A",
                "text": "27° North to 90° North.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-025-B",
                "text": "27° North to 70° North.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-025-C",
                "text": "30° North to 70° North.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-025-D",
                "text": "30° North to 90° North.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-026",
            "text": "The MNPS airspace extends vertically between flight levels:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-026-A",
                "text": "280 and 400.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-026-B",
                "text": "280 and 390.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-026-C",
                "text": "275 and 400.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-026-D",
                "text": "285 and 420.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-027",
            "text": "In the event of an en-route HF communication failure in an MNPS airspace, the appropriate VHF frequency for air to air communications is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-027-A",
                "text": "123.45 MHz",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-027-B",
                "text": "121.800 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-027-C",
                "text": "118.800 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-027-D",
                "text": "128.800 MHz",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-028",
            "text": "In the event of communication failure in an MNPS airspace, the pilot must:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-028-A",
                "text": "return to the flight plan route if it is different from the last oceanic clearance received and acknowledged.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-028-B",
                "text": "continue the flight in compliance with the last oceanic clearance received and acknowledged.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-028-C",
                "text": "join one of the so-called \"special\" routes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-028-D",
                "text": "change the flight level in accordance with predetermined instructions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-029",
            "text": "The validity period of a night-time organised track system in MNPS airspace is normally at 30°W, between:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-029-A",
                "text": "1030 UTC to 1900 UTC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-029-B",
                "text": "0000 UTC to 0800 UTC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-029-C",
                "text": "1130 UTC to 1800 UTC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-029-D",
                "text": "0100 UTC to 0800 UTC",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-030",
            "text": "The validity period of a day-time OTS in the MNPS airspace is normally, at 30°W, between:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-030-A",
                "text": "1130 UTC to 1900 UTC",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-030-B",
                "text": "0000 UTC to 0800 UTC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-030-C",
                "text": "1030 UTC to 1900 UTC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-030-D",
                "text": "0100 UTC to 0800 UTC",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-031",
            "text": "During a flight to Europe, planned in MNPS airspace, you expect to cross the 30°W meridian at 11H00 UTC ; you will then normally be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-031-A",
                "text": "within the organised night-time flight track system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-031-B",
                "text": "within the organised daytime flight track system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-031-C",
                "text": "within the polar track system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-031-D",
                "text": "outside of the validity period of the organised track system.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-032",
            "text": "During a flight to Europe, planned in MNPS airspace, you expect to cross the 30°W meridian at 00H30 UTC ; you will then normally be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-032-A",
                "text": "within the organised night-time track system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-032-B",
                "text": "beyond the validity period of the organized flight track system",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-032-C",
                "text": "within the polar track system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-032-D",
                "text": "within the organised daytime track system",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-033",
            "text": "The minimum navigation equipment required for an aircraft flying without restriction in MNPS airspace can be at the very least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-033-A",
                "text": "Two inertial navigation systems.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-033-B",
                "text": "One inertial navigation system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-033-C",
                "text": "One Global Navigation Satellite System",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-033-D",
                "text": "Three inertial navigation systems.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-034",
            "text": "The minimum longitudinal separation of two aircraft flying in MNPS airspace at the same Flight Level, on the same track and with the same Mach number is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-034-A",
                "text": "10 minutes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-034-B",
                "text": "5 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-034-C",
                "text": "15 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-034-D",
                "text": "20 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-035",
            "text": "The minimum lateral separation to be maintained between aircraft flying in MNPS airspace is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-035-A",
                "text": "90 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-035-B",
                "text": "120 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-035-C",
                "text": "30 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-035-D",
                "text": "60 NM.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-036",
            "text": "During the flight of two aircraft in MNPS airspace with a leading aircraft flying at higher speed, the longitudinal separation must not be below:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-036-A",
                "text": "10 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-036-B",
                "text": "5 minutes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-036-C",
                "text": "15 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-036-D",
                "text": "20 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-037",
            "text": "If all long range navigation systems of an aircraft become unserviceable during a flight in MNPS airspace, and if no instructions are received from the air traffic control, you must consider:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-037-A",
                "text": "land at the nearest airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-037-B",
                "text": "climbing or descending 500 feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-037-C",
                "text": "return to departure airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-037-D",
                "text": "descend below the MNPS space",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-038",
            "text": "During a flight to Europe, scheduled in MNPS airspace, you expect to cross the 30°W meridian at 0300 UTC; you will normally be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-038-A",
                "text": "outside the validity period of the organised track system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-038-B",
                "text": "within the polar track system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-038-C",
                "text": "in a day-time organised track system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-038-D",
                "text": "in a night-time organised track system.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-039",
            "text": "During a flight from Europe, scheduled in MNPS airspace, you expect to cross the 30°W meridian at 1330 UTC; you will normally be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-039-A",
                "text": "outside the validity period of the organised track system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-039-B",
                "text": "in a polar track system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-039-C",
                "text": "in a day-time organised track system.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-039-D",
                "text": "in a night-time organised track system.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-040",
            "text": "The abbreviation MNPS means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-040-A",
                "text": "Maximum Navigation Performance Specification",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-040-B",
                "text": "Main Navigation Performance Specification",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-040-C",
                "text": "Minimum Navigation Performance Specification",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-040-D",
                "text": "Magnetic Navigation Performance Specification",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-041",
            "text": "The frequency designated for VHF air to air communications when out of range of VHF ground stations in NAT region is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-041-A",
                "text": "121.5 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-041-B",
                "text": "118.5 MHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-041-C",
                "text": "123.45 MHz",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-041-D",
                "text": "243 MHz",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-042",
            "text": "A check on the operation of the SELCAL equipment during a transatlantic flight using the OTS (Organised Track System) must be done:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-042-A",
                "text": "A Within 15 minutes after crossing the oceanic airspace boundary.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-042-B",
                "text": "On ATC request only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-042-C",
                "text": "At or prior entering the oceanic airspace.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-042-D",
                "text": "As soon as possible after entering the NAT region.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-043",
            "text": "If a flight is planned to operate along the whole length of one of the organised tracks in the MNPS airspace, the intended organised track should be defined in items of the flight plan by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-043-A",
                "text": "the abbreviation \"NAT\" followed by the code letter assigned to the track",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-043-B",
                "text": "inserting coordinates defining significant points with intervals of 10° of longitude.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-043-C",
                "text": "using the abbreviation \"OTS\" followed by the code letter assigned to the track.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-043-D",
                "text": "inserting coordinates as detailed in the NAT track message.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-044",
            "text": "In the event of a contingency which required an en-route diversion to an alternate aerodrome across the direction of the prevailing \"NAT\" traffic flow and if prior ATC clearance cannot be obtained, an aircraft not able to maintain its assigned flight level should:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-044-A",
                "text": "immediately descend below FL280 and then acquire a 15 NM offset track.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-044-B",
                "text": "minimise its rate of descent while acquiring a 15 NM offset track.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-044-C",
                "text": "minimise its rate of descent while acquiring a 60 NM offset track.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-044-D",
                "text": "immediately descend below FL280 and then acquire a 60 NM offset track.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-045",
            "text": "Air traffic services may require an aircraft to report position when flying east-west, south of 70°N between 5°W and 65°W, every:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-045-A",
                "text": "15° of longitude.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-045-B",
                "text": "20° of longitude.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-045-C",
                "text": "5° of longitude.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-045-D",
                "text": "10° of longitude.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-046",
            "text": "Air traffic services may require an aircraft to report position when flying east-west, north of 70°N between 10°W and 50°W, every:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-046-A",
                "text": "15° of longitude.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-046-B",
                "text": "20° of longitude.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-046-C",
                "text": "5° of longitude.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-046-D",
                "text": "10° of longitude.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-047",
            "text": "In NAT region, a revised estimate should be transmitted to the ATS when the estimated time for the next position has changed by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-047-A",
                "text": "5 minutes or more.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-047-B",
                "text": "3 minutes or more",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-047-C",
                "text": "2 minutes or more.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-047-D",
                "text": "10 minutes or more.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-048",
            "text": "The minimum lateral separation in the NAT region is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-048-A",
                "text": "90 NM between all aircraft flying in the NAT region.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-048-B",
                "text": "60 NM between aircraft meeting minimum navigation performance specifications.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-048-C",
                "text": "60 NM between all aircraft operating below MNPS airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-048-D",
                "text": "90 NM between aircraft flying above FL285.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-049",
            "text": "Which separation will be provided if RVSM is used when operating in MNPS airspace?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-049-A",
                "text": "60 NM lateral and 500 ft vertical.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-049-B",
                "text": "90 NM lateral and 500 ft vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-049-C",
                "text": "60 NM lateral and 1000 ft vertical.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-049-D",
                "text": "90 NM lateral and 1000 ft vertical.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-050",
            "text": "In case of total loss of communications, if an aircraft operating in MNPS airspace is unable to continue its flight in accordance with its ATC clearance, it must offset from the assigned route by 15 NM and climb by 1000 ft or descend by 500 ft to a level which differs from those normally used if flying:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-050-A",
                "text": "below FL410",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-050-B",
                "text": "at FL430",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-050-C",
                "text": "at FL410",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-050-D",
                "text": "above FL410",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-051",
            "text": "At which levels may Reduced Vertical Separation Minimum (RVSM) be used within the NAT region?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-051-A",
                "text": "Between FL275 and FL400 inclusive.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-051-B",
                "text": "Between FL245 and FL410 inclusive",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-051-C",
                "text": "Between FL290 and FL410 inclusive.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-051-D",
                "text": "Below FL290.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-052",
            "text": "Flights within NAT region shall be conducted in accordance with IFR when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-052-A",
                "text": "Operating more than 100 NM seaward from the shoreline within uncontrolled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-052-B",
                "text": "Operating more than 100 NM seaward from the shoreline within controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-052-C",
                "text": "Operating at or above FL 60 or 2000 ft above ground whichever is the higher.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-052-D",
                "text": "Flying above 3000 ft above ground.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-053",
            "text": "The climb or descent through MNPS airspace of a non MNPS certified aircraft:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-053-A",
                "text": "is forbidden in all circumstances",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-053-B",
                "text": "can be authorised only if the pilot is in communication with the conflicting aircraft pilot",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-053-C",
                "text": "can be authorised when the aircraft has two long range navigation systems",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-053-D",
                "text": "can be authorised under radar control if the pilot is in VHF contact with the controller",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-054",
            "text": "Arriving at the entry point of MNPS airspace (except Shanwick Oceanic) and not having yet received the oceanic clearance, the crew:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-054-A",
                "text": "keeps flying deviating its course by 30 nautical miles from that of the current flight plan",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-054-B",
                "text": "keeps flying in accordance with the current flight plan",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-054-C",
                "text": "returns to base immediately",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-054-D",
                "text": "carries out a holding pattern",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-055",
            "text": "MNPS airspace in the applicable areas of the North Atlantic is defined between the following flight levels:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-055-A",
                "text": "FL 270 and FL 400",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-055-B",
                "text": "FL 285 and FL 420",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-055-C",
                "text": "FL 280 and FL 475",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-055-D",
                "text": "sea level and FL660",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-056",
            "text": "Penetration into the NAT MNPS airspace is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-056-A",
                "text": "not subject to a clearance, since the flight is already controlled",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-056-B",
                "text": "subject to a mandatory clearance",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-056-C",
                "text": "subject to an optional clearance depending on the type of flight (scheduled or not)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-056-D",
                "text": "subject to a clearance only if the flight route is changed",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-057",
            "text": "The North Atlantic airspace is regulated, among other, according to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-057-A",
                "text": "Canadian rules, because this country has the greatest surface area of territorial waters in this airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-057-B",
                "text": "rules common to the bordering States, grouped in document 7050 (North Atlantic Ocean Airspace)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-057-C",
                "text": "rules issued by the bordering States (Document 6530)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-057-D",
                "text": "the ICAO document 7030 (additional regional procedures)",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-058",
            "text": "In airspace where MNPS is applicable, the minimum vertical separation between FL 290 and FL 410 is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-058-A",
                "text": "1 000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-058-B",
                "text": "2000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-058-C",
                "text": "500ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-058-D",
                "text": "1500ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-059",
            "text": "An aircraft flying at FL 370 in MNPS airspace is unable to continue flight in accordance with its air traffic control clearance but is able to maintain FL 370. Due to a total loss of communications capability, it is unable obtain a revised clearance from ATC. The aircraft should offset from the assigned route by 15 NM and:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-059-A",
                "text": "climb or descent 1 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-059-B",
                "text": "climb or descent 1 000 ft or descend 500 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-059-C",
                "text": "climb 500 ft or descend 1 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-059-D",
                "text": "climb or descend 500 ft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-060",
            "text": "An aircraft flying above FL 410 in North Atlantic (NAT) Airspace is unable to continue flight in accordance with its air traffic control clearance, but is able to maintain its assigned level, and due to a total loss of communications capability, cannot obtain a revised clearance from ATC. The aircraft should leave its assigned route or track by turning 90° (90 degrees) to the right of left whenever this is possible, and turn to acquire and maintain in either direction track laterally separated by 30 NM from its assigned route and:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-060-A",
                "text": "climb or descent 1 000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-060-B",
                "text": "climb or descent 1 000 ft or descend 500 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-060-C",
                "text": "climb 500 ft or descend 1 000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-060-D",
                "text": "climb or descend 500 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-061",
            "text": "An aircraft operating within MNPS Airspace is unable to continue flight in accordance with its air traffic control clearance, but is able to maintain its assigned level, and due to a total loss of communications capability, cannot obtain a revised clearance from ATC. The aircraft should offset from the assigned route by 15 NM and climb or descent 500 ft, if:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-061-A",
                "text": "below FL410",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-061-B",
                "text": "at FL410",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-061-C",
                "text": "at FL410",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-061-D",
                "text": "above FL410",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-XLR-062",
            "text": "According to North Atlantic MNPSA Operations Manual, what is the transponder code to be selected continuously 30 min after entry into NAT airspace?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-062-A",
                "text": "Code 2000",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-062-B",
                "text": "Code 7000",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-062-C",
                "text": "The last assigned code prior to entry into NAT airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-XLR-062-D",
                "text": "Code 7500",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "f75fcb38673b90d528a3bb2846f489a5",
      "name": "Special Operational Procedures and Hazards",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-001",
            "text": "During the winter an aircraft is parked overnight prior to an early morning departure. The crew notice a slight glistening ice deposit on top of the wings or blades which appears translucent. Under these conditions:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-001-A",
                "text": "there is no risk of further ice accretion.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-001-B",
                "text": "a longer starting procedure will be necessary to warm up the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-001-C",
                "text": "the aircraft should be sprayed with de-icing fluid of the correct type.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-001-D",
                "text": "the take off performance of the aircraft will not be affected.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-002",
            "text": "The application of a type II anti-icing fluid on an aeroplane on the ground will provide a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-002-A",
                "text": "limited time of protection, dependent on the outside temperature, precipitations and fluid mixture.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-002-B",
                "text": "protection time up to 24 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-002-C",
                "text": "protection against icing for the duration of the flight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-002-D",
                "text": "limited time of protection independent of the outside temperature.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-003",
            "text": "An aircraft having undertaken an anti-icing procedure and having exceeded the holdover time of the anti-icing fluid:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-003-A",
                "text": "does not require a new anti-icing procedure before take-off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-003-B",
                "text": "must only undertake a de-icing procedure before take-off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-003-C",
                "text": "must only undertake a new anti-icing procedure before take-off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-003-D",
                "text": "must undertake a de-icing procedure before a new application of anti-icing fluid before take-off.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-004",
            "text": "During a de-icing / anti-icing procedure carried out in two steps, the holdover time starts:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-004-A",
                "text": "at the beginning of the first step (de-icing step).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-004-B",
                "text": "a the end of the first step (de-icing step).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-004-C",
                "text": "at the end of the second step (anti-icing step).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-004-D",
                "text": "at the beginning of the second step (anti-icing step).",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-005",
            "text": "The actual protection time of an anti-icing fluid depends on: Given: 1. the type and intensity of the showers 2. the ambient temperature 3. the relative humidity 4. the direction and speed of the wind 5. the temperature of the aircraft skin 6. the type of fluid, its concentration and temperature The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-005-A",
                "text": "1, 3, 5, 6.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-005-B",
                "text": "1, 2, 4, 6.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-005-C",
                "text": "2, 3, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-005-D",
                "text": "1, 2, 3, 4, 5, 6.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-006",
            "text": "The anti-icing fluid protecting film can wear o and reduce the holdover time considerably:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-006-A",
                "text": "when the outside temperature is close to 0°C.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-006-B",
                "text": "when the aeroplane is parked facing into wind.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-006-C",
                "text": "during strong winds or as a result of other aircraft engines jet blast / propeller blast.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-006-D",
                "text": "when the temperature of the aeroplane skin is close to 0°C.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-007",
            "text": "A 1211 halon fire-extinguisher can be used for: Given: 1. a paper fire 2. a fabric fire 3. an electric fire 4. a wood fire 5. a hydrocarbon fire The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-007-A",
                "text": "1, 2, 3, 4, 5.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-007-B",
                "text": "1, 3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-007-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-007-D",
                "text": "2, 4, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-008",
            "text": "In icing conditions and after the application of an anti-icing fluid on an aeroplane, the commander should: Given: 1. avoid positioning the aeroplane in the engine jet blast of the preceding aeroplane 2. avoid positioning the aeroplane in the turbo-prop wash of the preceding aeroplane 3. position the aeroplane in the engine jet blast of the preceding aeroplane 4. position the aeroplane in the turbo-prop wash of the preceding aeroplane The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-008-A",
                "text": "1, 4..",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-008-B",
                "text": "1, 2.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-008-C",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-008-D",
                "text": "3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-009",
            "text": "In icing conditions, if you have exceeded the holdover time, the correct procedure is to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-009-A",
                "text": "operate the aircraft de-icing/anti-icing systems.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-009-B",
                "text": "de-ice the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-009-C",
                "text": "de-ice the aircraft again, then apply anti-icing fluid.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-009-D",
                "text": "apply directly anti-icing fluid without conducting previous de-icing procedures.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-010",
            "text": "The holdover time of an anti-icing procedure, for a given ambient temperature, will be longest in weather conditions of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-010-A",
                "text": "freezing fog",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-010-B",
                "text": "steady snow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-010-C",
                "text": "frost",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-010-D",
                "text": "rain on a cold soaked wing",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-011",
            "text": "After anti-icing has been completed, a pre-departure inspection reveals presence of frost, ice or snow. The correct action is to: complete departure provided that the recommended anti-icing holdover (protection) time for the prevailing",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-011-A",
                "text": "conditions and type of fluid used has not been exceeded",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-011-B",
                "text": "carry out a new de-icing/anti-icing procedure",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-011-C",
                "text": "switch on all the aircraft anti-icing and de-icing systems until clear of icing conditions when airborne",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-011-D",
                "text": "complete departure as soon as possible to reduce the possibility of further contamination",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-012",
            "text": "For a given ambient temperature and type of anti-icing fluid, in which of the following conditions will the holdover (protection) time be the shortest?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-012-A",
                "text": "Steady snow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-012-B",
                "text": "Frost",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-012-C",
                "text": "Freezing fog",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-012-D",
                "text": "Freezing rain",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-013",
            "text": "The accumulation of frost, snow or ice on an aeroplane in flight induces, amongst other serious consequences, an increase in the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-013-A",
                "text": "value of the stall angle of attack",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-013-B",
                "text": "stalling speed",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-013-C",
                "text": "roll rate",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-013-D",
                "text": "tuck under",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-014",
            "text": "When taking-off, in winter conditions, the wing contamination by ice, snow or frost will cause the following effects: Given: 1. an increase in the take-off distance 2. a decrease of the take-off run 3. an increase in the stalling speed 4. a decrease of the stalling speed 5. a decrease of the best climb gradient The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-014-A",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-014-B",
                "text": "1, 3, 5.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-014-C",
                "text": "2, 3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-014-D",
                "text": "2, 4, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-015",
            "text": "In regard to the warning of bird strike hazards, pilots may obtain information by means of: Given: 1. ATIS. 2. NOTAMs. 3. BIRDTAMs. 4. Weather radar. 5. The report by another crew. The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-015-A",
                "text": "1, 2, 3, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-015-B",
                "text": "1, 3, 4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-015-C",
                "text": "2, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-015-D",
                "text": "1, 2, 5.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-016",
            "text": "The highest risk of bird strikes occurs:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-016-A",
                "text": "between 3500 and 5000 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-016-B",
                "text": "between 2500 and 3500 ft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-016-C",
                "text": "under 2500 ft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-016-D",
                "text": "above 5000 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-017",
            "text": "Whenever a potential bird hazard is observed, the commander shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-017-A",
                "text": "immediately inform the local ATS unit",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-017-B",
                "text": "inform immediately the bird control unit (BCU) directly by radio.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-017-C",
                "text": "submit a written hazard bird strike report upon arrival and within 48 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-017-D",
                "text": "inform other aircraft in the vicinity by radio.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-018",
            "text": "The ICAO procedure designed to collect and disseminate information on bird strikes to aircraft is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-018-A",
                "text": "IBHA (ICAO Bird Hazard Annex).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-018-B",
                "text": "IBSA (ICAO Bird Safety Alert).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-018-C",
                "text": "IBIS (ICAO Bird Strike Information System).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-018-D",
                "text": "IBSR (ICAO Bird Strike Report).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-019",
            "text": "According to the recommended noise abatement procedures contained in the ICAO PANS OPS 8168 Volume I part V, data available indicates that the procedure which results in the biggest noise relief during the part of the procedure close to the airport:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-019-A",
                "text": "is either procedure A or B, because there is no difference in noise distribution",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-019-B",
                "text": "is procedure A",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-019-C",
                "text": "is procedure B",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-019-D",
                "text": "depends on the wind component",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-020",
            "text": "Who has the responsibility for establishing operating procedures for noise abatement purposes during instrument flight in compliance with ICAO PANS OPS 8168 the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-020-A",
                "text": "commander",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-020-B",
                "text": "operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-020-C",
                "text": "state of the operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-020-D",
                "text": "state in which the aeroplane is operating",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-021",
            "text": "Noise attenuation shall not be the determining factor in the designation of a runway, under the following circumstances: Given: 1. when cross wind component, including gust, exceeds 15 knots. 2. when the tail wind component, including gust, exceeds 5 knots. 3. when the runway is not clear or dry. The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-021-A",
                "text": "1, 2.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-021-B",
                "text": "1, 2, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-021-C",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-021-D",
                "text": "1, 3.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-022",
            "text": "In VMC, a runway should not be chosen as preferential for noise abatement procedures when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-022-A",
                "text": "It has no ILS or visual approach slope guidance",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-022-B",
                "text": "Cross-wind component, including gusts, is 10 kt or less",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-022-C",
                "text": "It has a tail wind regardless its magnitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-022-D",
                "text": "Tail wind component, including gusts, is less than 4 kt",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-023",
            "text": "On most of the large modern aeroplanes, an engine fire warning system will switch on the relevant fire shut off- handle. The fire shut-off handle will be switched off when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-023-A",
                "text": "the fire is no longer detected.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-023-B",
                "text": "the fire-extinguisher has been triggered.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-023-C",
                "text": "the fire shut-o handle has been pulled.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-023-D",
                "text": "all the fire-extinguishers connected to this engine have been triggered.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-024",
            "text": "In case of an engine exhaust pipe fire while on the ground, you should abort the starting procedure and:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-024-A",
                "text": "carry out a dry cranking.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-024-B",
                "text": "carry out a damp cranking.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-024-C",
                "text": "pull the fire shut o handle and trigger the engines fire-extinguishers.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-024-D",
                "text": "fight the fire with a water fire-extinguisher.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-025",
            "text": "Halon or equivalent fire extinguishers can be used in case of fire fighting in an aeroplane:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-025-A",
                "text": "in the cockpit and cargo holds.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-025-B",
                "text": "in the fuel tanks and in the cargo holds.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-025-C",
                "text": "in the avionics bay and the wheel bays.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-025-D",
                "text": "in the wheel bays and lavatories.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-026",
            "text": "In case of a cargo compartment fire, the system which should be switched off, is generally the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-026-A",
                "text": "total air-conditioning",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-026-B",
                "text": "trim air",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-026-C",
                "text": "pressurisation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-026-D",
                "text": "ventilation of the cargo compartment",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-027",
            "text": "According to ICAO Doc 4444, a wake turbulence non-radar separation minima of 2 minutes shall be applied to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-027-A",
                "text": "LIGHT aircraft landing behind a MEDIUM aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-027-B",
                "text": "LIGHT aircraft taking-off behind a MEDIUM aircraft from an intermediate part of the same runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-027-C",
                "text": "MEDIUM aircraft taking-off behind a HEAVY aircraft from an intermediate part of a parallel runway separated by less than 760 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-027-D",
                "text": "MEDIUM aircraft landing behind a HEAVY aircraft.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-028",
            "text": "If smoke appears in the air conditioning, the initial action to be taken by the flight deck crew is to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-028-A",
                "text": "determine the origin of the smoke",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-028-B",
                "text": "cut off all air conditioning units",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-028-C",
                "text": "put on the oxygen mask and goggles.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-028-D",
                "text": "start an emergency descent.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-029",
            "text": "The safety precautions to be taken when using 100% medical oxygen are: Given: 1. refrain from smoking 2. avoid sparks 3. avoid operation of radio communication equipment 4. operate oxygen system shut off valves slowly The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-029-A",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-029-B",
                "text": "1, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-029-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-029-D",
                "text": "1, 2, 4.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-030",
            "text": "Following a landing with overweight and overspeed conditions, the tyres and brakes are extremely hot. For safety reasons, the landing gear wheels should be approached:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-030-A",
                "text": "from left or right side.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-030-B",
                "text": "from any side.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-030-C",
                "text": "under no circumstances.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-030-D",
                "text": "from front or rear side.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-031",
            "text": "Due to a risk of tyre explosions when the brakes are very hot, the landing gear should be approached:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-031-A",
                "text": "from any direction.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-031-B",
                "text": "from the inboard side.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-031-C",
                "text": "from the outboard side.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-031-D",
                "text": "either from the front or the rear.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-032",
            "text": "In the case of overheating of the brakes following the landing, the appropriate action at the parking position is: Given: 1. set parking brake on 2. set parking brake o, with chocks in position 3. spray water on the brakes 4. ventilate the brakes The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-032-A",
                "text": "2, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-032-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-032-C",
                "text": "1, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-032-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-033",
            "text": "A fire occurs in a wheel and immediate action is required to extinguish it. The safest extinguishant to use is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-033-A",
                "text": "CO2 (carbon dioxide)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-033-B",
                "text": "water",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-033-C",
                "text": "dry powder",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-033-D",
                "text": "foam",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-034",
            "text": "Following a heavy mass landing on a short runway, you should pay attention to the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-034-A",
                "text": "temperature of the brakes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-034-B",
                "text": "pressure of the hydraulic fluid.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-034-C",
                "text": "pressure of the pneumatic system.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-034-D",
                "text": "temperature of the hydraulic fluid.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-035",
            "text": "The correct statement concerning extinguishing agents onboard aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-035-A",
                "text": "Water may only be used for minor fires.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-035-B",
                "text": "Halon is an effective extinguishing agent for use in aircraft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-035-C",
                "text": "Carbon dioxide is only used in the cargo hold.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-035-D",
                "text": "A powder extinguisher is suitable for extinguishing a cockpit fire.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-036",
            "text": "A hand water fire-extinguisher should be used on a fire of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-036-A",
                "text": "paper, fabric, carpet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-036-B",
                "text": "metals",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-036-C",
                "text": "flammable gases",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-036-D",
                "text": "flammable liquids",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-037",
            "text": "A halon fire-extinguisher should be used on a fire of: Given: 1. paper, fabric, plastic 2. flammable liquids 3. flammable gases 4. metals The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-037-A",
                "text": "1, 2, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-037-B",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-037-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-037-D",
                "text": "1, 2, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-038",
            "text": "A CO2 fire extinguisher can be used for: Given: 1. a paper fire 2. a hydrocarbon fire 3. a fabric fire 4. an electrical fire 5. a wood fire The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-038-A",
                "text": "1, 3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-038-B",
                "text": "1, 2, 3, 4, 5.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-038-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-038-D",
                "text": "2, 4, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-039",
            "text": "A water fire extinguisher can be used without restriction for: Given: 1. a paper fire 2. a hydrocarbon fire 3. a fabric fire 4. an electrical fire 5. a wood fire The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-039-A",
                "text": "1, 3, 5.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-039-B",
                "text": "1, 2, 3, 4, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-039-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-039-D",
                "text": "2, 4, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-040",
            "text": "You could use a CO2 fire-extinguisher for: Given: 1. a paper fire 2. a plastic fire 3. a hydrocarbon fire 4. an electrical fire The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-040-A",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-040-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-040-C",
                "text": "3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-040-D",
                "text": "1, 2, 3.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-041",
            "text": "You will use a powder fire-extinguisher for: Given: 1. a paper fire 2. a plastic fire 3. a hydrocarbon fire 4. an electrical fire The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-041-A",
                "text": "1, 2, 3,.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-041-B",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-041-C",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-041-D",
                "text": "1, 2, 3.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-042",
            "text": "A dry-chemical type fire extinguisher could be used to fight the fire of: Given: 1. paper, fabric, carpet 2. flammable liquids 3. electrical equipment 4. metals, flammable gases, chemicals The combination of regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-042-A",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-042-B",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-042-C",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-042-D",
                "text": "3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-043",
            "text": "The fire extinguisher types which may be used to fight fire on carbonaceous materials are: Given: 1. H2O 2. CO2 3. dry-chemical 4. halon Which of the following combinations contains all of the correct statements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-043-A",
                "text": "1",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-043-B",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-043-C",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-043-D",
                "text": "3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-044",
            "text": "The fire extinguisher types which may be used to fight fire on flammable liquids are: Given: 1. H2O 2. CO2 3. dry-chemical 4. halon Which of the following combinations contains all of the correct statements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-044-A",
                "text": "2",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-044-B",
                "text": "2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-044-C",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-044-D",
                "text": "3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-045",
            "text": "H2O extinguishers are fit to fight fires on:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-045-A",
                "text": "carbonaceous materials",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-045-B",
                "text": "electrical equipment",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-045-C",
                "text": "metals, flammable gases, chemical products",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-045-D",
                "text": "flammable liquids",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-046",
            "text": "CO2 type extinguishers are suitable to fight fire on: Given: 1. carbonaceous materials 2. flammable liquids 3. electrical equipment 4. metals Which of the following combinations contains all of the correct statements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-046-A",
                "text": "1, 2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-046-B",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-046-C",
                "text": "1, 2, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-046-D",
                "text": "1, 3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-047",
            "text": "Malfunctioning of the automatic pressurization system is indicated by: Given: 1. a change in environmental sounds. 2. the cabin altitude gauge indicates an abnormal rate of climb. 3. the differential pressure between the exterior and the interior of the aircraft decreases Which of the following combinations contains all of the correct statements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-047-A",
                "text": "1, 2, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-047-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-047-C",
                "text": "1, 2.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-047-D",
                "text": "1, 3.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-048",
            "text": "A slow decompression may be caused by: Given: 1. a leak in a door seal during normal pressurised flight 2. loss of a cabin window 3. malfunction of all pressurised systems 4. loss of a door Which of the following combinations contains all of the correct statements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-048-A",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-048-B",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-048-C",
                "text": "1, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-048-D",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-049",
            "text": "When flying in straight and level flight at FL 290 for some considerable time a small leak develops in the cabin which causes a slow depressurisation, this can be seen on the cabin rate of climb indicator which will indicate:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-049-A",
                "text": "a rate of descent dependent upon the cabin differential pressure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-049-B",
                "text": "a rate of descent of approximately 300 fpm.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-049-C",
                "text": "a rate of climb.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-049-D",
                "text": "zero.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-050",
            "text": "During an explosive decompression at flight level 370 (FL 370), your first action will be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-050-A",
                "text": "to put on the oxygen mask",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-050-B",
                "text": "to comfort your passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-050-C",
                "text": "to set the transponder to 7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-050-D",
                "text": "to warn the ATC",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-051",
            "text": "The time of useful consciousness in case of an explosive decompression at an altitude of 40 000 ft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-051-A",
                "text": "1 minute.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-051-B",
                "text": "30 seconds.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-051-C",
                "text": "12 seconds.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-051-D",
                "text": "5 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-052",
            "text": "Mist in the cabin, pressure and temperature drop characterise:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-052-A",
                "text": "a rapid depressurization.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-052-B",
                "text": "a plastic fire.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-052-C",
                "text": "an electrical fire.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-052-D",
                "text": "a slow depressurization.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-053",
            "text": "A fast decompression is recognizable by the following elements: Given: 1. mist in the cabin 2. air streaming out of the aircraft 3. expansion of body gases 4. blast of air released violently from the lungs The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-053-A",
                "text": "1, 2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-053-B",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-053-C",
                "text": "1, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-053-D",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-054",
            "text": "A warning device alerts the crew in case of an excessive cabin altitude. This warning must be triggered on reaching the following altitude:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-054-A",
                "text": "10000 ft (approx. 3000 m)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-054-B",
                "text": "14000 ft (approx. 4200 m)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-054-C",
                "text": "8000 ft (approx. 2400 m)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-054-D",
                "text": "12000 ft (approx. 3600 m)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-055",
            "text": "An aeroplane suffers an explosive decompression at an altitude of 31000 ft. What is the initial action by the operating crew?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-055-A",
                "text": "to put on oxygen masks",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-055-B",
                "text": "place the seat belts sign to ON",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-055-C",
                "text": "transmit a MAYDAY message",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-055-D",
                "text": "disconnect the autopilot",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-056",
            "text": "If cabin altitude increases during level flight, the differential pressure:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-056-A",
                "text": "increases",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-056-B",
                "text": "remains constant",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-056-C",
                "text": "attains its maximum permitted operating limit",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-056-D",
                "text": "decreases",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-057",
            "text": "Due to a cabin pressurisation defect the maximum differential pressure is limited to 3 psi. Assuming the oxygen masks will be deployed at 14000 feet, the maximum achievable flight altitude is approximately:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-057-A",
                "text": "22500 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-057-B",
                "text": "29000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-057-C",
                "text": "27000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-057-D",
                "text": "24500 ft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-058",
            "text": "Due to a cabin pressurisation defect the maximum differential pressure is limited to 2 psi. Assuming you don't want the cabin altitude being greater than 10000 feet, the maximum achievable flight altitude is approximately:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-058-A",
                "text": "5000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-058-B",
                "text": "15000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-058-C",
                "text": "15100 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-058-D",
                "text": "12000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-059",
            "text": "Following an explosive decompression, if you are using an oxygen diluter demand system, the regulator controls the amount of air that is mixed with pure oxygen when the supply selector is at the \"normal\" position. At what approximate altitude will the regulator supply to the mask become pure oxygen only?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-059-A",
                "text": "14000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-059-B",
                "text": "8000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-059-C",
                "text": "25000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-059-D",
                "text": "32000 ft",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-060",
            "text": "The minimum requirements for Supplemental Oxygen to be supplied in pressurised aeroplanes during and following an emergency descent are that for pilots it shall be available for the entire flight time that the cabin pressure altitude exceeds a minimum of X feet. That minimum of X feet is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-060-A",
                "text": "15000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-060-B",
                "text": "13000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-060-C",
                "text": "25000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-060-D",
                "text": "14000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-061",
            "text": "During a manual approach, the aeroplane is subjected to windshear with a decreasing head wind. In the absence of a pilot action, the aeroplane: Given: 1. flies above the intended approach path 2. flies below the intended approach path 3. has an increasing true airspeed 4. has a decreasing true airspeed The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-061-A",
                "text": "1, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-061-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-061-C",
                "text": "2, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-061-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-062",
            "text": "During a manual approach, the aeroplane is subjected to windshear with an increasing head wind. In the absence of a pilot action, the aeroplane: Given: 1. flies above the intended approach path 2. flies below the intended approach path 3. has an increasing true airspeed 4. has a decreasing true airspeed The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-062-A",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-062-B",
                "text": "1, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-062-C",
                "text": "1, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-062-D",
                "text": "2, 3.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-063",
            "text": "During a manual approach, the aeroplane is subjected to windshear with a decreasing tail wind. In the absence of a pilot action, the aeroplane: Given: 1. flies above the intended approach path 2. flies below the intended approach path 3. has an increasing true airspeed 4. has a decreasing true airspeed The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-063-A",
                "text": "1, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-063-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-063-C",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-063-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-064",
            "text": "After take-off, an aeroplane is subjected to windshear with a decreasing head wind. In the absence of a pilot action, the aeroplane: Given: 1. flies above the climb-out path 2. flies below the climb-out path 3. has an increasing true airspeed 4. has a decreasing true airspeed The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-064-A",
                "text": "1, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-064-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-064-C",
                "text": "2, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-064-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-065",
            "text": "When an aircraft flies into a horizontal tail wind gust the aircraft tends:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-065-A",
                "text": "not to change its trajectory",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-065-B",
                "text": "to climb",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-065-C",
                "text": "to climb or descend, depending on the gust strength",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-065-D",
                "text": "to descend",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-066",
            "text": "One of the main characteristics of windshear is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-066-A",
                "text": "it occurs only at a low altitude (2000 ft) and never in the horizontal plane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-066-B",
                "text": "it can occur at any altitude in both the vertical and horizontal planes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-066-C",
                "text": "it occurs only at a low altitude (2000 ft) and never in the vertical plane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-066-D",
                "text": "it can occur at any altitude and only in the horizontal plane.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-067",
            "text": "Which parameter will change first, when penetrating a horizontal windshear?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-067-A",
                "text": "Indicated airspeed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-067-B",
                "text": "Pitch angle.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-067-C",
                "text": "Ground speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-067-D",
                "text": "Vertical speed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-068",
            "text": "Just after take-off an aircraft encounters a \"microburst\" situated directly ahead. The initial indications will be: Given: 1. an increase in head wind 2. an increase in tail wind 3. better climb performance 4. a decrease in climb gradient The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-068-A",
                "text": "1, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-068-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-068-C",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-068-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-069",
            "text": "In a microburst combined with a violent storm the winds at: low altitude diverge from the centre of the phenomenon and the atmospheric pressure increases by a few",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-069-A",
                "text": "hectopascals",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-069-B",
                "text": "low altitude diverge from the centre of the phenomenon and the atmospheric pressure decreases by a few hectopascals.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-069-C",
                "text": "low altitude converge on the centre of the phenomenon and the atmospheric pressure decreases by a few hectopascals.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-069-D",
                "text": "high altitude converge on the centre of the phenomenon and the atmospheric pressure increases by a few hectopascals.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-070",
            "text": "An aircraft which experiences a headwind of 40 kt while making its way towards the centre of a microburst may expect, when crossing the microburst, to face a windshear of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-070-A",
                "text": "40 kt.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-070-B",
                "text": "20 kt.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-070-C",
                "text": "80 kt.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-070-D",
                "text": "60 kt.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-071",
            "text": "A flight is to depart from an airport with runways 09 and 27. Surface wind is 270/05; an inversion is reported at 300 feet with turbulence and windshear. The wind just above the inversion is 090/30. What is the safest departure procedure?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-071-A",
                "text": "Depart runway 27 with maximum throttle during the passage through the inversion.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-071-B",
                "text": "Depart runway 27 with as steep an ascent as possible.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-071-C",
                "text": "Depart runway 09 with a tailwind.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-071-D",
                "text": "Take-off is not possible under these conditions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-072",
            "text": "In final approach, you encounter a strong rear wind gust or strong down wind which forces you to go around. You Given: 1. maintain the same aircraft configuration (gear and flaps) 2. reduce the drags (gear and flaps) 3. gradually increase the attitude up to triggering of stick shaker 4. avoid excessive attitude change The combination of correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-072-A",
                "text": "1, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-072-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-072-C",
                "text": "2, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-072-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-073",
            "text": "While approaching a mountainous airfield, the captain of a transport aircraft notices a fast and high increase in the indicated airspeed without any change in the pre-selected engine and attitude parameters. The preceding crews had reported the occurrence of windshear in final phase. You must:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-073-A",
                "text": "reduce rapidly the selected thrust, maintain on the glide path.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-073-B",
                "text": "take a level flight attitude to reduce speed, then come back to glide path from above.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-073-C",
                "text": "maintain the aircraft on the glide path, accept a positive speed deviation, monitor the speed evolution.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-073-D",
                "text": "reduce rapidly the selected thrust in order to reach 1.2 Vs and try a precision landing.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-074",
            "text": "While approaching the outer-marker, the tower informs you about the presence of a \"microburst\". You will expect to encounter:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-074-A",
                "text": "wake turbulence",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-074-B",
                "text": "convection motion of air mass",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-074-C",
                "text": "supercooled water.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-074-D",
                "text": "windshears (vertical and horizontal).",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-075",
            "text": "In case of an unexpected encounter with windshear, you will: Given: 1. set the maximum take-off thrust 2. increase the pitch-up attitude up to the limit actuating the stick shaker 3. retract gear and flaps, if they are extended 4. keep gear, flaps and slats in current configuration and retract the speed brakes 5. try to reach the maximum lift-to-drag ratio The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-075-A",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-075-B",
                "text": "3, 5.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-075-C",
                "text": "1, 2, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-075-D",
                "text": "1, 3, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-076",
            "text": "Windshear may be described as a change in wind direction and/or speed in space, including updraughts and downdraughts. To counter the effects of windshear the amount of control action that is required is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-076-A",
                "text": "small",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-076-B",
                "text": "substantial",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-076-C",
                "text": "null",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-076-D",
                "text": "medium",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-077",
            "text": "In the \"worst case\" scenario of recovery from the effects of a microburst, having increased to full go-around power, in co-ordinating power and pitch it may be necessary to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-077-A",
                "text": "increase the pitch angle until the stick shaker is felt and hold at slightly below this angle",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-077-B",
                "text": "slowly increase speed whilst maintaining a positive rate of climb",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-077-C",
                "text": "reduce speed to V2 and hold",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-077-D",
                "text": "climb away at Vat + 20 kt",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-078",
            "text": "Aeroplane wake turbulence during take o starts when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-078-A",
                "text": "slats and flaps are extended only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-078-B",
                "text": "the take off roll commences.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-078-C",
                "text": "out of ground effect.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-078-D",
                "text": "the nose wheel lifts off the runway.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-079",
            "text": "The wake turbulence caused by an aircraft is mainly the result of: Given: 1. An aerodynamic effect (wing tip vortices). 2. The engines action (propellers rotation or engine gas exhausts). 3. The importance of the drag devices (size of the landing gear, of the flaps, etc.). The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-079-A",
                "text": "1, 2 and 3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-079-B",
                "text": "3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-079-C",
                "text": "1.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-079-D",
                "text": "2 and 3.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-080",
            "text": "The time needed for the dissipation of a turbulent wake created by a wide- body aircraft during take-off is about:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-080-A",
                "text": "3 minutes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-080-B",
                "text": "1 minute.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-080-C",
                "text": "30 seconds.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-080-D",
                "text": "10 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-081",
            "text": "In calm wind conditions, an aircraft at take-off creates tip vortices that:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-081-A",
                "text": "stagnate on the runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-081-B",
                "text": "separate outwards on each side of the runway.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-081-C",
                "text": "separate outwards to the left side only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-081-D",
                "text": "separate outwards to the right side only.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-082",
            "text": "The wake turbulence:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-082-A",
                "text": "starts at rotation and stops as soon as the aeroplane's wheels touch the ground.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-082-B",
                "text": "starts as soon as the aeroplane commences rolling and stops as soon as it has come to a stop at landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-082-C",
                "text": "starts when the aeroplane reaches a height of 35 ft above the ground and stops when it crosses this height before landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-082-D",
                "text": "starts when pulling out the drag devices and stops when retracting the drag devices.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-083",
            "text": "The tip vortices circulate about each wing tip:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-083-A",
                "text": "clockwise.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-083-B",
                "text": "counter clockwise.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-083-C",
                "text": "from the upper side of the wing toward the underwing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-083-D",
                "text": "from the underwing toward the upper side of the wing.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-084",
            "text": "In a light crosswind (approximately 5 kt) from the right behind an aeroplane taking off:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-084-A",
                "text": "The runway will be clear of any wake turbulence.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-084-B",
                "text": "The right and left wake vortices remain approximately on the runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-084-C",
                "text": "The right wake vortex remains approximately on the runway.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-084-D",
                "text": "The left wake vortex remains approximately on the runway.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-085",
            "text": "The wake turbulence is the most severe when the generating aeroplane is: Given: 1. flying slowly 2. heavy 3. in a clean configuration 4. flying with high thrust The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-085-A",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-085-B",
                "text": "1, 2, 3.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-085-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-085-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-086",
            "text": "The greatest wake turbulence occurs when the generating aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-086-A",
                "text": "Small, light, at maximum speed in full flaps configuration",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-086-B",
                "text": "Large, heavy, at low speed in clean configuration",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-086-C",
                "text": "Large, heavy, at maximum speed in full flaps configuration",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-086-D",
                "text": "Small, light, at low speed in clean configuration",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-087",
            "text": "At a given configuration, the wake turbulence of an aeroplane is greater when the aeroplane is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-087-A",
                "text": "heavy at low airspeed.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-087-B",
                "text": "light at high airspeed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-087-C",
                "text": "light at low airspeed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-087-D",
                "text": "heavy at high airspeed.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-088",
            "text": "To avoid wake turbulence, when flying behind and close to a large aeroplane, the pilot should manoeuvre whenever possible:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-088-A",
                "text": "above and downwind from the large aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-088-B",
                "text": "below and downwind from the large aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-088-C",
                "text": "below and upwind from the large aeroplane.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-088-D",
                "text": "above and upwind from the large aeroplane.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-089",
            "text": "When taking-off behind a heavy aircraft, with the wind coming from the right side, you adopt, whenever possible:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-089-A",
                "text": "a different flight path from the preceding aircraft, by remaining to the right of and above its path.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-089-B",
                "text": "a different flight path from the preceding aircraft, by remaining to the left of and under its path.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-089-C",
                "text": "a different flight path from the preceding aircraft, by remaining behind it and under its path.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-089-D",
                "text": "an identical flight path to the one of the preceding aircraft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-090",
            "text": "To fight a fire in an air-conditioned class E cargo hold, the correct initial action is to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-090-A",
                "text": "shut off the ventilating airflow within the affected compartment.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-090-B",
                "text": "evacuate the smoke.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-090-C",
                "text": "discharge the fire extinguishers in the affected compartment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-090-D",
                "text": "confirm visually the fire.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-091",
            "text": "When taking-off behind a heavy aircraft, with the wind coming from the left side, you adopt, whenever possible:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-091-A",
                "text": "a different flight path form the preceding aircraft, by remaining behind it and under its path.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-091-B",
                "text": "a different flight path from the preceding aircraft, by remaining to the right of and under its path.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-091-C",
                "text": "a different flight path from the preceding aircraft, by remaining to the left of and above its path.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-091-D",
                "text": "an identical flight path to the one of the preceding aircraft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-092",
            "text": "When taking-off after a widebody aircraft which has just landed, you should take-off:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-092-A",
                "text": "beyond the point where the aircraft's wheels have touched down.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-092-B",
                "text": "at the point where the aircraft's wheels have touched the ground and on the underwind side of the runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-092-C",
                "text": "at the point where the aircraft's wheels have touched down and on the wind side of the runway .",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-092-D",
                "text": "in front of the point where the aircraft's wheels have touched down.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-093",
            "text": "For the purpose of wake turbulence separation, what is the ICAO minimum radar separation distance if a HEAVY aeroplane is following directly behind another HEAVY aeroplane on the approach to the same runway?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-093-A",
                "text": "9.3 km (5 NM)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-093-B",
                "text": "11.1 km (6 NM)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-093-C",
                "text": "3.7 km (2 NM)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-093-D",
                "text": "7.4 km (4 NM)",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-094",
            "text": "Regarding wake turbulence, what are the ICAO minimum radar separation distance and the minimum non-radar separation time for a MEDIUM aircraft behind a HEAVY aeroplane on approach to the same runway?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-094-A",
                "text": "9.3 km (5 NM) and 2 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-094-B",
                "text": "11.1 km (6 NM) and 3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-094-C",
                "text": "9.3 km (5 NM) and 3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-094-D",
                "text": "7.4 km (4 NM) and 2 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-095",
            "text": "Regarding wake turbulence, what is the ICAO minimum non-radar separation time for a LIGHT aircraft behind a MEDIUM or HEAVY aeroplane on approach to the same runway?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-095-A",
                "text": "4 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-095-B",
                "text": "5 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-095-C",
                "text": "3 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-095-D",
                "text": "2 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-096",
            "text": "In accordance with ICAO and PANS-ATM procedures, which letter should be entered into a flight plan to denote an aeroplane which has a weight of less than 136000 kg but greater than 7000 kg:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-096-A",
                "text": "L",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-096-B",
                "text": "M",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-096-C",
                "text": "S",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-096-D",
                "text": "H",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-097",
            "text": "Regarding wake turbulence, what is the ICAO minimum separation time for a LIGHT aircraft taking off behind a MEDIUM or HEAVY aeroplane from an intermediate part of the same runway?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-097-A",
                "text": "4 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-097-B",
                "text": "5 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-097-C",
                "text": "3 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-097-D",
                "text": "2 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-098",
            "text": "Wake turbulence should be taken into account when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-098-A",
                "text": "when just before the landing a much lighter aeroplane has landed with a strong crosswind on a long runway. a much heavier aeroplane has landed just previously on the same runway, a light crosswind condition exist",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-098-B",
                "text": "and all high-lift devices are being used.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-098-C",
                "text": "a preceding aeroplane has performed low altitude high roll rate rolling manoeuvres over the runway.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-098-D",
                "text": "during cruise the vertical separation is reduced to 1000 ft.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-099",
            "text": "According to ICAO Doc 4444 , a wake turbulence non-radar separation minima of 3 minutes shall be applied: to a departing MEDIUM aircraft following a HEAVY aircraft arrival when operating on a runway with a",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-099-A",
                "text": "displaced landing threshold.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-099-B",
                "text": "between a LIGHT aircraft and a MEDIUM aircraft making a missed approach and the LIGHT aircraft utilising an opposite-direction runway for take-off.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-099-C",
                "text": "to LIGHT aircraft taking-off behind a MEDIUM aircraft from an intermediate part of a parallel runway separated by less than 760 m.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-099-D",
                "text": "to an arriving LIGHT aircraft following a MEDIUM aircraft departure when operating on a runway with a displaced landing threshold, if the projected flight paths are expected to cross.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-100",
            "text": "In accordance with ICAO Doc 4444, when a MEDIUM aircraft precedes a LIGHT aircraft using the same runway, or parallel runways separated by less than 760 m, the wake turbulence radar separation minima on the approach or departure phases of flight shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-100-A",
                "text": "3 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-100-B",
                "text": "4 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-100-C",
                "text": "5 NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-100-D",
                "text": "2 NM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-101",
            "text": "According to ICAO Doc 4444, a wake turbulence non-radar separation minima of 3 minutes shall be applied to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-101-A",
                "text": "MEDIUM aircraft landing behind a HEAVY aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-101-B",
                "text": "LIGHT aircraft taking -off behind a MEDIUM aircraft when aircraft are using the same runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-101-C",
                "text": "LIGHT aircraft landing behind a MEDIUM aircraft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-101-D",
                "text": "LIGHT aircraft taking-off behind a MEDIUM aircraft from a parallel runway separated by less than 760 m. (using whole runway).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-102",
            "text": "Wake turbulence category HEAVY refers to aircraft which have a maximum certificated take-off mass of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-102-A",
                "text": "136 000 kg or more.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-102-B",
                "text": "186 000 kg or more.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-102-C",
                "text": "146 000 kg or more.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-102-D",
                "text": "between 136 000 kg and 186 000 kg.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-103",
            "text": "In addition to informing each State, whose citizens are known to be on board an aircraft, the State of the country in which an aircraft has landed after an act of unlawful interference must immediately notify the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-103-A",
                "text": "State of Registry of the aircraft, the State of the operator and ICAO",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-103-B",
                "text": "State of Registry of the aircraft and the State of the operator only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-103-C",
                "text": "State of the operator, the EASA and ICAO.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-103-D",
                "text": "State of Registry of the aircraft and the EASA.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-104",
            "text": "Following an act of unlawful interference on board an aircraft, the commander shall submit a report to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-104-A",
                "text": "the designated local authority only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-104-B",
                "text": "the Authority in the State within which the aircraft was operating at the time of the unlawful interference.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-104-C",
                "text": "the Authority in the State of the operator only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-104-D",
                "text": "both the designated local authority and the Authority in the State of the operator.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-105",
            "text": "According to ICAO Annex 17, following an unlawful interference, who shall take adequate measures for the safety of passengers and crew of an aircraft, until their journey can be continued?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-105-A",
                "text": "The contracting State where the aircraft is located.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-105-B",
                "text": "The commander of the aircraft.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-105-C",
                "text": "The aircraft's operator.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-105-D",
                "text": "EASA.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-106",
            "text": "What is the transponder code to be used by the commander of an aircraft that is subject to unlawful interference?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-106-A",
                "text": "A 7500",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-106-B",
                "text": "A 7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-106-C",
                "text": "A 7800",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-106-D",
                "text": "A 7600",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-107",
            "text": "Whenever practicable, what transponder code shall be used to provide recognition of an aircraft which is being subjected to unlawful interference:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-107-A",
                "text": "A 7500",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-107-B",
                "text": "A 7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-107-C",
                "text": "A 7800",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-107-D",
                "text": "A 7600",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-108",
            "text": "In case of a serious threat based on the presence of a bomb on board a pressurized aircraft and disregarding any fuel considerations:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-108-A",
                "text": "you carry out an emergency descent to reach the safety altitude. you descend to the flight level corresponding to the indicated cabin altitude or the safety altitude if higher",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-108-B",
                "text": "and take preventive steps by putting yourself in a landing approach configuration.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-108-C",
                "text": "you climb to the maximum flight level which does not need the use of pressurization. you go down to the level corresponding to the indicated cabin altitude and keep the aircraft in a clean",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-108-D",
                "text": "configuration until the final approach.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-109",
            "text": "The correct definition of a safe forced landing is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-109-A",
                "text": "a landing on land or sea from which it is guaranteed no injuries will result to the occupants",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-109-B",
                "text": "a voluntary landing on land or sea carried out by the crew in order to protect the aircraft and its occupants.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-109-C",
                "text": "an unavoidable landing or ditching with a reasonable expectancy of no injuries to persons in the aircraft or on the surface.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-109-D",
                "text": "an inevitable landing on land or sea from which one may reasonably expect no injuries on board.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-110",
            "text": "According to ICAO Doc 4444, a wake turbulence radar separation minima of 9.3 km (5.0 NM) shall be applied when a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-110-A",
                "text": "HEAVY aircraft is crossing behind a HEAVY aircraft, at the same altitude or less than 300m (1 000 ft)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-110-B",
                "text": "LIGHT aircraft is crossing behind a MEDIUM aircraft, at the same altitude or less than 300m (1 000 ft)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-110-C",
                "text": "LIGHT aircraft is crossing behind a HEAVY aircraft, at the same altitude or less than 300m (1 000 ft)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-110-D",
                "text": "MEDIUM aircraft is crossing behind a MEDIUM aircraft, at the same altitude or less than 300m (1 000 ft)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-111",
            "text": "During the passenger briefing for a flight requiring life jackets, the passengers shall be instructed to inflate their life jackets:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-111-A",
                "text": "immediately on the opening of the exits",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-111-B",
                "text": "when outside the aircraft.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-111-C",
                "text": "as soon as ditching is prepared.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-111-D",
                "text": "immediately on ditching.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-112",
            "text": "In case of a ditching, the cabin attendants should: Given: 1. evacuate women and children first. 2. have the passengers embark directly in the life rafts. 3. prevent passenger movements which may impede the aircraft's flotation ability. 4. ensure the complete evacuation of the aircraft. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-112-A",
                "text": "1, 2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-112-B",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-112-C",
                "text": "2, 3, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-112-D",
                "text": "1, 4.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-113",
            "text": "If obliged to jettison part of the fuel in flight, it would be better to do so:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-113-A",
                "text": "in a holding stack, after control clearance.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-113-B",
                "text": "under flight level 50 (FL50).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-113-C",
                "text": "during final phase of approach.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-113-D",
                "text": "in a straight line and at a relatively high flight level.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-114",
            "text": "In what period of time must a fuel jettisoning system be capable of jettisoning sufficient fuel to meet the specified approach and landing climb performance requirements:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-114-A",
                "text": "15 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-114-B",
                "text": "60 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-114-C",
                "text": "30 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-114-D",
                "text": "90 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-115",
            "text": "During the certification flight tests regarding fuel jettisoning it must be shown that: Given: 1. Fuel jettisoning system and its operation are free from fire hazard 2. The fuel discharges clear of any part of the aeroplane 3. Fuel fumes do not enter any part of the aeroplane 4. The jettisoning operation does not adversely affect the controllability of the aeroplane. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-115-A",
                "text": "2, 3.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-115-B",
                "text": "1, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-115-C",
                "text": "1, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-115-D",
                "text": "1, 2, 3, 4.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-116",
            "text": "According to JAR 25, if a fuel jettisoning system is required, it must be capable of jettisoning enough fuel within:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-116-A",
                "text": "30 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-116-B",
                "text": "15 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-116-C",
                "text": "60 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-116-D",
                "text": "45 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-117",
            "text": "A runway covered with 4 mm thick water, is said to be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-117-A",
                "text": "contaminated.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-117-B",
                "text": "wet.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-117-C",
                "text": "damp",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-117-D",
                "text": "flooded.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-118",
            "text": "A runway is considered to be contaminated when its surface is covered more than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-118-A",
                "text": "25 % with compacted snow",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-118-B",
                "text": "20 % with melted snow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-118-C",
                "text": "15 % with melted snow",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-118-D",
                "text": "10 % with ice",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-119",
            "text": "A braking action of 0.25 and below reported on a SNOWTAM is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-119-A",
                "text": "good",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-119-B",
                "text": "unreliable",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-119-C",
                "text": "poor",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-119-D",
                "text": "medium",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-120",
            "text": "One of the primary factors causing dynamic hydroplaning is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-120-A",
                "text": "the aircraft's weight.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-120-B",
                "text": "the depth of the standing water on the runway.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-120-C",
                "text": "the strength of the crosswind.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-120-D",
                "text": "the strength of the headwind.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-121",
            "text": "Viscous hydroplaning occurs primarily if the runway is covered with a thin film of water and:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-121-A",
                "text": "the tyre treads show minor cuts.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-121-B",
                "text": "the runway has a rough surface.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-121-C",
                "text": "the runway is very smooth and dirty",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-121-D",
                "text": "the runway is very smooth and clean.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-122",
            "text": "The type of hydroplaning that is most likely to occur at the touch down area located at both ends of the runway is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-122-A",
                "text": "viscous.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-122-B",
                "text": "dynamic.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-122-C",
                "text": "rubber reversion.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-122-D",
                "text": "rubber steaming.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-123",
            "text": "When there is a risk of hydroplaning an aeroplane the pilot :",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-123-A",
                "text": "should use normal landing-,braking- and reverse technique",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-123-B",
                "text": "should use maximum reverse thrust, however should start braking below the hydroplaning speed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-123-C",
                "text": "should make a positive landing and apply maximum reverse thrust and brakes as quickly as possible.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-123-D",
                "text": "must wait for landing until the risk for hydroplaning is no longer existing.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-124",
            "text": "For an airplane with a tire pressure of 14 bars, there is a risk of dynamic hydroplaning as soon as the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-124-A",
                "text": "Speed is greater than 129 kt.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-124-B",
                "text": "Tail wind is greater than 10 kt.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-124-C",
                "text": "Water depth is equal to the half of the depth of the tyre grooves.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-124-D",
                "text": "Speed is greater than 95 kt.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-125",
            "text": "For an aeroplane with a tyre pressure of 12 bars, there is a risk of dynamic hydroplaning as soon as the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-125-A",
                "text": "Speed is greater than 119 kt.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-125-B",
                "text": "Cross wind is greater than 10 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-125-C",
                "text": "Speed is greater than 83 kt.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-125-D",
                "text": "Water depth is equal to the half of the depth of the tyre grooves.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-126",
            "text": "For an aeroplane with a tyre pressure of 10 bars, there is a risk of dynamic hydroplaning as soon as the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-126-A",
                "text": "Runway temperature is greater than 40°C.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-126-B",
                "text": "Water depth is equal to the half of the depth of the tyre grooves",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-126-C",
                "text": "Speed is greater than 108 kt.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-126-D",
                "text": "Speed is greater than 96 kt.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-127",
            "text": "For an aeroplane with a tyre pressure of 8 bars, there is a risk of dynamic hydroplaning as soon as the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-127-A",
                "text": "Water depth is equal to the half of the depth of tyre grooves.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-127-B",
                "text": "Speed is greater than 127 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-127-C",
                "text": "Speed is greater than 98 kt",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-127-D",
                "text": "Cross wind is greater than 20 kt.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-128",
            "text": "For an aeroplane with a tyre pressure of 16 bars, there is a risk of dynamic hydroplaning as soon as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-128-A",
                "text": "Water depth is equal to the depth of the tyre grooves.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-128-B",
                "text": "Cross wind is greater than 15 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-128-C",
                "text": "Speed is greater than 138 kt.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-128-D",
                "text": "Speed is greater than 117 kt.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-129",
            "text": "Assuming contaminated runway conditions, if an aeroplane's main wheel tyre pressure is 206 psi., the approximate speed above which dynamic hydroplaning may occur is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-129-A",
                "text": "80 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-129-B",
                "text": "100 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-129-C",
                "text": "114 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-129-D",
                "text": "129 kt",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-130",
            "text": "The tyre pressure of an aeroplane main landing gear is 10,8 bars. There is a risk of hydroplaning as soon as the speed reaches:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-130-A",
                "text": "56 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-130-B",
                "text": "145 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-130-C",
                "text": "113 kt",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-130-D",
                "text": "87 kt",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-131",
            "text": "In case of a cargo compartment fire, the system which should be switched off, is generally the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-131-A",
                "text": "total air-conditioning",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-131-B",
                "text": "trim air",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-131-C",
                "text": "pressurisation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-131-D",
                "text": "ventilation of the cargo compartment",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-132",
            "text": "Which of the following statements is correct concerning a take off from a contaminated runway? As the amount of contamination increases at constant take off weight, V1 should decrease to compensate",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-132-A",
                "text": "for decreasing friction.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-132-B",
                "text": "The take off from a contaminated runway is forbidden. In general the performance data for take off has been determined by means of calculation and has not",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-132-C",
                "text": "been verified by flight tests. The performance corrections for contamination should be applied with any kind of measurable",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-132-D",
                "text": "contamination.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-133",
            "text": "In case of landing on a flooded runway and in heavy rain: Given: 1. you increase your approach speed, 2. you land firmly in order to obtain a firm contact of the wheels with the runway and immediately land your nose gear, 3. you decrease your approach speed, 4. you use systematically all the lift dumper devices, 5. you land as smoothly as possible, 6. you brake energically. The combination regrouping all the correct statements is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-133-A",
                "text": "1, 2, 4.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-133-B",
                "text": "1, 4, 5, 6.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-133-C",
                "text": "2, 3, 4.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-133-D",
                "text": "3, 5.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-134",
            "text": "Your flight manual does not include specific supplementary information on landing distances on wet runways and the service bulletins or weather reports indicate that the runway may be wet at the estimated time of arrival. The required landing distance on a dry runway must be increased by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-134-A",
                "text": "15%",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-134-B",
                "text": "20%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-134-C",
                "text": "18%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-134-D",
                "text": "17.60%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-135",
            "text": "The maximum validity of a SNOWTAM is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-135-A",
                "text": "6 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-135-B",
                "text": "3 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-135-C",
                "text": "12 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-135-D",
                "text": "24 hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-136",
            "text": "How is the uncleared part of a contaminated runway reported in a SNOWTAM?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-136-A",
                "text": "In plain language at item T (the final paragraph) of a SNOWTAM.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-136-B",
                "text": "It is not reported.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-136-C",
                "text": "As a percentage of the total length of the runway available as the final item of a SNOWTAM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-136-D",
                "text": "By a four figure group added to item D, which gives the length in metres.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-SOH-137",
            "text": "Wind shear is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-137-A",
                "text": "a variation only in horizontal wind velocity over a short distance.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-137-B",
                "text": "a variation only in vertical wind velocity over a short distance.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-137-C",
                "text": "a large variation in vertical or horizontal wind velocity and / or wind direction over a short distance.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-SOH-137-D",
                "text": "a variation in vertical or horizontal wind velocity and / or wind direction over a large distance.",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "dcb384cf2475b70104bc15fc9895ccf2",
      "name": "OPS Regulation: GCAA specific",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-001",
            "text": "No person may act as a flight crew member of an aeroplane without:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-001-A",
                "text": "License",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-001-B",
                "text": "Medical Certificate",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-001-C",
                "text": "Logbook",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-001-D",
                "text": "Recency",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-002",
            "text": "The holder of a pilot license when acting as a co-pilot of an aircraft required to be operated with a co-pilot shall be credited with no more than __________ % of the co-pilot flight time to be credited towards the award of a higher grade of license:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-002-A",
                "text": "25",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-002-B",
                "text": "30",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-002-C",
                "text": "100",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-002-D",
                "text": "50",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-003",
            "text": "The holder of a pilot license when acting as a co-pilot under the supervision of the PIC, the functions an duties of a PIC, shall be entitled to be credited ________ of this flight time towards the total flight time required for a higher grade of license:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-003-A",
                "text": "Some",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-003-B",
                "text": "All",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-003-C",
                "text": "Half",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-003-D",
                "text": "None",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-004",
            "text": "A student Pilot shall be entitled to claim ______ of his solo time towards the total flight time required for the initial issue of a Pilot licence:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-004-A",
                "text": "100%",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-004-B",
                "text": "75%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-004-C",
                "text": "None",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-004-D",
                "text": "50%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-005",
            "text": "Which best describes the flight conditions under which flight crew members are specially required to keep their seat belts and shoulder harness fastened?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-005-A",
                "text": "Seatbelts during takeoff and landing, shoulder harnesses during takeoff and landing and while enroute.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-005-B",
                "text": "Seatbelts during takeoff and landing, and while descent; shoulder harness during takeoff and landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-005-C",
                "text": "Seatbelts during takeoff and landing, shoulder harnesses during takeoff and landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-005-D",
                "text": "Seatbelts during takeoff and landing, and while enroute; shoulder harness during takeoff and landing",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-006",
            "text": "A pilot radio license is valid for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-006-A",
                "text": "5 years",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-006-B",
                "text": "4 years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-006-C",
                "text": "8 years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-006-D",
                "text": "10 years",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-007",
            "text": "Recency for a Pilot who does not hold a valid instrument rating:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-007-A",
                "text": "Must carry out at least one landing at night in an Aeroplane or simulator of the same type or class in the preceding 45 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-007-B",
                "text": "Must carry out at least one takeoff and landing at night",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-007-C",
                "text": "Must carry out at least one landing at night in an Aeroplane or simulator of the same type or class in the preceding 90 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-007-D",
                "text": "Must carry out at least one take off and landing",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-008",
            "text": "For which category is the licence issued?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-008-A",
                "text": "aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-008-B",
                "text": "Helicopters only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-008-C",
                "text": "Single and multiengine land aeroplane",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-008-D",
                "text": "Aeroplane & helicopters",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-009",
            "text": "Type rating applicable for which types",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-009-A",
                "text": "Jets",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-009-B",
                "text": "Those requiring two pilots",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-009-C",
                "text": "Those determined by the GCAA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-009-D",
                "text": "All of the above",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-010",
            "text": "An air operator shall not utilize a second in command of an aeroplane unless the pilot has:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-010-A",
                "text": "A valid license for the type of aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-010-B",
                "text": "A valid ATPL license",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-010-C",
                "text": "Completed license requirements",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-010-D",
                "text": "A valid license and medical",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-011",
            "text": "As PPL Holder are you allowed to carry passengers for compensation / hire?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-011-A",
                "text": "With permission of the ICAO",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-011-B",
                "text": "With special permission if the money goes to charity",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-011-C",
                "text": "No",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-011-D",
                "text": "Yes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-012",
            "text": "A Foreign operator is allowed to operate within UAE for a period of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-012-A",
                "text": "30 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-012-B",
                "text": "60 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-012-C",
                "text": "25 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-012-D",
                "text": "90 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-013",
            "text": "The minimum rest period which must be provided before undertaking a flying duty period shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-013-A",
                "text": "24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-013-B",
                "text": "8 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-013-C",
                "text": "At least as long as the preceding duty period, or",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-013-D",
                "text": "12 hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-014",
            "text": "Commercial pilot maximum continuous duty time allowed in any one period.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-014-A",
                "text": "14 hours after 12 hours of rest",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-014-B",
                "text": "12 hours after 12 hours of rest",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-014-C",
                "text": "12 hours within 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-014-D",
                "text": "14 hours within 24 hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-015",
            "text": "Commercial pilot maximum flying time allowed.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-015-A",
                "text": "100 hours within 28 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-015-B",
                "text": "100 hours within 30 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-015-C",
                "text": "30 hours within one week",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-015-D",
                "text": "90 hours per month/300 hours in a 3 month period",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-016",
            "text": "No flight crew member may accept any assignment in excess of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-016-A",
                "text": "14 hours maximum duty time in any 96 hours consecutive hour period.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-016-B",
                "text": "14 hours maximum duty time in any 24 consecutive hour period.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-016-C",
                "text": "12 hours maximum duty time in any 24 consecutive hour period.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-016-D",
                "text": "14 hours maximum duty time in any 48 hours consecutive hour period.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-017",
            "text": "Flight time as a member of a one-or-two pilot crew if that crew members total time in all commercial flying should not exceed.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-017-A",
                "text": "100 hours in any period of 28 consecutive days or 1000 hours in any 12 month period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-017-B",
                "text": "90 hours in any period of 28 consecutive days or 1000 hours in any 12 month period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-017-C",
                "text": "100 hours in any period of 28 consecutive days or 900 hours in any 12 month period",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-017-D",
                "text": "90 hours in any period of 28 consecutive days or 900 hours in any 12 month period",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-018",
            "text": "A Minimum rest period before FLIGHT DUTY shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-018-A",
                "text": "At least as long as the preceding duty period or 12 hours, whichever is greater",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-018-B",
                "text": "At least as long as the preceding duty period or 14 hours, whichever is greater",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-018-C",
                "text": "At least as long as the preceding duty period or 10 hours, whichever is greater",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-018-D",
                "text": "At least as long as the preceding duty period or 8 hours, whichever is greater",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-019",
            "text": "The validity of a medical for a 41-year-old ATP licensed Pilot engaged in single pilot operations is?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-019-A",
                "text": "6 months",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-019-B",
                "text": "30 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-019-C",
                "text": "12 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-019-D",
                "text": "24 months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-020",
            "text": "In the case of a pilot engaged in commercial operations, how long may a medical assessment be deferred?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-020-A",
                "text": "2 consecutive periods of 6 months each",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-020-B",
                "text": "Single period of 6 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-020-C",
                "text": "2 consecutive periods of 3 months each",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-020-D",
                "text": "Single period of 12 months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-021",
            "text": "For a type rated commercial pilot, OPC checks to be carried out,",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-021-A",
                "text": "After 14 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-021-B",
                "text": "By flight instructor",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-021-C",
                "text": "By a GCAA approved examiner",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-021-D",
                "text": "After 13 months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-022",
            "text": "An operator shall not assign a pilot to act as commander of an aeroplane unless he conducts:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-022-A",
                "text": "6 takeoffs and landings within previous 90 days in that category, class and type of aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-022-B",
                "text": "3 takeoffs and landings within previous 90 days in that category, class and type of aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-022-C",
                "text": "5 takeoffs and landings within previous 90 days in that category, class and type of aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-022-D",
                "text": "6 takeoffs and landings within previous 60 days in that category, class and type of aircraft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-023",
            "text": "In the preceding 90 days as PIC",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-023-A",
                "text": "Must carry out at least one landing at night in an Aeroplane or simulator of the same type or class in the preceding 90 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-023-B",
                "text": "Must carry out at least one landing at night in an Aeroplane or simulator of the same type or class in the preceding 120 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-023-C",
                "text": "Must carry out at least three landings at night in an Aeroplane or simulator of the same type or class in the preceding 90 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-023-D",
                "text": "Must carry out at least one landing at night in an Aeroplane or simulator of the same type or class in the preceding 30 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-024",
            "text": "What is the status of a license, if the holder has an incapacitating injury or illness for 20 days or more?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-024-A",
                "text": "Licence instatement after medical board",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-024-B",
                "text": "Licence revoked",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-024-C",
                "text": "Licence extended",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-024-D",
                "text": "License suspended",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-025",
            "text": "A letter of Licence Validation in the UAE is valid for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-025-A",
                "text": "120 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-025-B",
                "text": "30 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-025-C",
                "text": "90 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-025-D",
                "text": "60 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-026",
            "text": "How much alcohol permitted in bloodstream?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-026-A",
                "text": "0.2 promille",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-026-B",
                "text": "2 promille",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-026-C",
                "text": "0.08%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-026-D",
                "text": "1 promille",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-027",
            "text": "Active flight crew members whose blood or urine sample is found to contain traces of psychoactive substances will.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-027-A",
                "text": "Have action taken against their licence",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-027-B",
                "text": "Be reported to the police",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-027-C",
                "text": "Have any evidence gathered by the GCAA made available to the authorities",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-027-D",
                "text": "All of the above",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-028",
            "text": "Accident reports (written) within?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-028-A",
                "text": "7 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-028-B",
                "text": "10 working days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-028-C",
                "text": "10 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-028-D",
                "text": "24 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-029",
            "text": "A pilot who deviated from any rule under the CARs shall submit a written report to the GCAA",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-029-A",
                "text": "Within 10 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-029-B",
                "text": "Within 24 hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-029-C",
                "text": "Within 12 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-029-D",
                "text": "immediately",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-030",
            "text": "What action, if any is appropriate if the pilot deviates from an ATC instruction during and emergency and is given priority.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-030-A",
                "text": "File a report to the GCAA administrator within 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-030-B",
                "text": "Take a special action since you are pilot in command",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-030-C",
                "text": "File a report to the GCAA administrator within 12 hours.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-030-D",
                "text": "File a detailed report within 48 hours to the chief of the appropriate ATC facility, if required",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-031",
            "text": "Following an accident or incident, an operator shall retain flight recorder data for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-031-A",
                "text": "12 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-031-B",
                "text": "28 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-031-C",
                "text": "30 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-031-D",
                "text": "60 days",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-032",
            "text": "Which incident requires an immediate notification to be made to GCAA?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-032-A",
                "text": "An overdue aircraft that is to be involved in an accident",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-032-B",
                "text": "Landing gear damage, due to hard landing.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-032-C",
                "text": "An in-flight generator or alternator failure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-032-D",
                "text": "An in-flight radio communications failure",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-033",
            "text": "Which incident requires an immediate notification to the Flight Operations department?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-033-A",
                "text": "An in-flight radio communications failure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-033-B",
                "text": "An in flight loss of VOR receiver capability",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-033-C",
                "text": "Landing gear damage, due to hard landing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-033-D",
                "text": "Flight control system malfunction or failure",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-034",
            "text": "Which incident would necessitate an immediate notification to the GCAA flight operations department.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-034-A",
                "text": "An in-flight radio communications failure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-034-B",
                "text": "An in-flight fire.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-034-C",
                "text": "An in flight loss of VOR receiver capability",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-034-D",
                "text": "An in-flight radio communications failure",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-035",
            "text": "The operator of an aircraft that has been involved in an accident shall notify the GCAA:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-035-A",
                "text": "Within 48 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-035-B",
                "text": "By the quickest means of communication available",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-035-C",
                "text": "Within 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-035-D",
                "text": "Within 36 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-036",
            "text": "For unrestricted operation in MNPS airspace an aeroplane must be equipped with:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-036-A",
                "text": "2 Flight Management System (FMS)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-036-B",
                "text": "2 Long Range Navigation System (LNRS)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-036-C",
                "text": "2 Inertial Navigation System (INS)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-036-D",
                "text": "Global Positioning System (GPS)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-037",
            "text": "Windshear warnings are only issued when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-037-A",
                "text": "Windshear is reported by aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-037-B",
                "text": "The forecast indicates a possibility of stratus clouds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-037-C",
                "text": "The forecast indicates a possibility of cumulonimbus clouds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-037-D",
                "text": "Low level inversion is expected",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-038",
            "text": "How many hand held fire extinguishers are required to be carried on an aircraft with 250 passengers?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-038-A",
                "text": "Four",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-038-B",
                "text": "One",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-038-C",
                "text": "Five",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-038-D",
                "text": "Three",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-039",
            "text": "On over water flights, for multiengine aeroplane, life-rafts and survival ELTs are required to be carried on board, when the aeroplane operates greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-039-A",
                "text": "120 minutes at cruising speed or 100 nautical miles to an aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-039-B",
                "text": "30 minutes at cruising speed or 100 nautical miles to an aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-039-C",
                "text": "120 minutes at cruising speed or 400 nautical miles to an aerodrome",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-039-D",
                "text": "30 minutes at cruising speed or 400 nautical miles to an aerodrome",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-040",
            "text": "Minimum equipment list for multi-engine aircraft.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-040-A",
                "text": "Minimum Equipment List (MEL)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-040-B",
                "text": "States Regulation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-040-C",
                "text": "Master MEL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-040-D",
                "text": "Manufacturers MEL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-041",
            "text": "Minimum equipment required for operations under VFR",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-041-A",
                "text": "ELT and VHF communication (two way)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-041-B",
                "text": "ELT, radio communication and navigation and SSR transponder",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-041-C",
                "text": "VHF communication",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-041-D",
                "text": "ELT",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-042",
            "text": "Minimum equipment for VFR",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-042-A",
                "text": "VHF communication",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-042-B",
                "text": "ELT, radio communication and navigation and SSR transponder",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-042-C",
                "text": "ELT and VHF communication (two way)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-042-D",
                "text": "ELT",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-043",
            "text": "With certain exceptions, when must each occupant of an aircraft wear an approved parachute?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-043-A",
                "text": "When intentionally pitching the nose of the aircraft up or down 30 deg. or more",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-043-B",
                "text": "When a window is removed from the aircraft to facilitate parachute jumpers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-043-C",
                "text": "When a door is removed from the aircraft to facilitate parachute jumpers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-043-D",
                "text": "Never",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-044",
            "text": "A chair-type parachute must have been packed by a certified and appropriately rated parachute rigger within the preceding",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-044-A",
                "text": "90 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-044-B",
                "text": "60 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-044-C",
                "text": "120 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-044-D",
                "text": "30 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-045",
            "text": "With the respect to passengers, what obligation, if any does the pilot in command have concerning the use of seatbelts?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-045-A",
                "text": "The pilot in command must brief the passengers on the use of seatbelts and notify to fasten them during takeoff and landing",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-045-B",
                "text": "The pilot in command must instruct the passengers to keep seatbelts fastened for the entire flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-045-C",
                "text": "The pilot in command must brief the passengers on the use of seatbelts and notify to fasten them during takeoff.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-045-D",
                "text": "The pilot in command has no obligation in regard to passengers use of seatbelts",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-046",
            "text": "Check for IFR flights (pre flight check) use of radio nav equipment",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-046-A",
                "text": "Ground check against VOR to be within 4 deg",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-046-B",
                "text": "Checked within the proceeding 30 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-046-C",
                "text": "Flight check against VOR to be within 4 deg",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-046-D",
                "text": "Check against second radio nav equipment to be within 6 deg",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-047",
            "text": "What is the specific fuel requirement for flight under VFR at night in a piston engine aeroplane.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-047-A",
                "text": "Enough to fly to the first point of intended landing and to fly after that for 30 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-047-B",
                "text": "Enough to complete the flight at normal cruising speed with adverse wind conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-047-C",
                "text": "Enough to fly to the first point of intended landing and to fly after that 60 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-047-D",
                "text": "Enough to fly to the first point of intended landing and to fly after that for 45 minutes",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-048",
            "text": "For isolated aerodrome procedure, when no suitable alternate aerodrome is available, the amount of fuel at departure should be for additional",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-048-A",
                "text": "1 hour",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-048-B",
                "text": "3 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-048-C",
                "text": "5 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-048-D",
                "text": "2 hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-049",
            "text": "Using readability scale, readability 2 means",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-049-A",
                "text": "Not readable",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-049-B",
                "text": "I heard you twice",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-049-C",
                "text": "Readable now and then",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-049-D",
                "text": "Readable but with difficulty",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-050",
            "text": "Call sign A6-EFT, the correct abbreviation is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-050-A",
                "text": "Foxtrot Tango",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-050-B",
                "text": "Alpha Foxtrot Tango",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-050-C",
                "text": "Six Tango",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-050-D",
                "text": "Echo Foxtrot Tango",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-051",
            "text": "Radio frequency in an emergency or distress",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-051-A",
                "text": "121.3 kHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-051-B",
                "text": "121.9 kHz",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-051-C",
                "text": "121.5 MHz",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-051-D",
                "text": "121.6 MHz",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-052",
            "text": "Whilst under radar control, aircraft experiencing a radio failure shall:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-052-A",
                "text": "Squawk ident then select mode A code 7500",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-052-B",
                "text": "Maintain last assigned heading and level for a period of five minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-052-C",
                "text": "Select Mode A code 7600",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-052-D",
                "text": "Squawk ident then select mode A code 7700",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-053",
            "text": "Unless otherwise requested by ATC, position reports may be omitted:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-053-A",
                "text": "When departing a controlled airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-053-B",
                "text": "When operating as a controlled flight within the UAE FIR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-053-C",
                "text": "When departing an uncontrolled airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-053-D",
                "text": "When receiving radar service",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-054",
            "text": "Transponder code and flight action if radio fails:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-054-A",
                "text": "7700 and continue same heading for 3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-054-B",
                "text": "Advise ATC of radio failure and request course of action to be taken",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-054-C",
                "text": "Continue with flight as planned",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-054-D",
                "text": "7600 and continue same heading for 3 minutes",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-055",
            "text": "An aeroplane and a helicopter are converging while approaching an aerodrome for the purpose of landing.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-055-A",
                "text": "The aeroplane must yield the right of way regardless of his position",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-055-B",
                "text": "The helicopter must yield the right of way regardless of his position",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-055-C",
                "text": "Aircraft to the others right has the right of way",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-055-D",
                "text": "Aircraft to the others left has the right of way",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-056",
            "text": "Unless otherwise notified when operating in the circuit pattern of an aerodrome the pilot shall make all turns to the",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-056-A",
                "text": "Right in helicopter, left in aeroplane",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-056-B",
                "text": "Right",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-056-C",
                "text": "Left in helicopter, right in aeroplane",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-056-D",
                "text": "Left",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-057",
            "text": "What line colours denote taxiways, manoeuvring areas, and runways?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-057-A",
                "text": "White centrelines",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-057-B",
                "text": "Yellow and white lines",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-057-C",
                "text": "Green centreline for taxiways and manoeuvring area and white centreline for runways",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-057-D",
                "text": "Blue Lines",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-058",
            "text": "When on ground you see a flashing green, it indicates",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-058-A",
                "text": "Stop at holding point",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-058-B",
                "text": "Clear to taxi",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-058-C",
                "text": "Clear to start engine",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-058-D",
                "text": "Clear to takeoff",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-059",
            "text": "Which side of the navigation light coloured red?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-059-A",
                "text": "Port",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-059-B",
                "text": "Tail",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-059-C",
                "text": "Left and Port",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-059-D",
                "text": "Left",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-060",
            "text": "If on ground you see a steady white light it means?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-060-A",
                "text": "Cleared for takeoff",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-060-B",
                "text": "Clear the active area and return to bay",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-060-C",
                "text": "Clear the active area stop the engines",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-060-D",
                "text": "Nothing",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-061",
            "text": "If you have communication failure and you see a steady green light from the air it means?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-061-A",
                "text": "Give away to the other traffic",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-061-B",
                "text": "Enter holding",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-061-C",
                "text": "Continue approach and look out for signal for landing clearance.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-061-D",
                "text": "Continue approach and clear to land",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-062",
            "text": "Alternating flashing white and green lights within an airport area indicates:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-062-A",
                "text": "The location of the Helipad area on the airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-062-B",
                "text": "That the airport is safe for landing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-062-C",
                "text": "An international airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-062-D",
                "text": "A civil airport",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-063",
            "text": "Which side of the navigation light coloured red?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-063-A",
                "text": "Left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-063-B",
                "text": "Left and Port",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-063-C",
                "text": "Tail",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-063-D",
                "text": "Port",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-064",
            "text": "If you have a communication failure and you see a steady green light from the air it means?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-064-A",
                "text": "Continue approach and look out for a signal for landing clearance.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-064-B",
                "text": "Give away to other traffic",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-064-C",
                "text": "Abort landing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-064-D",
                "text": "Continue approach and clear to land",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-065",
            "text": "When on ground you see a flashing green, it indicates",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-065-A",
                "text": "Hold your position",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-065-B",
                "text": "Clear to takeoff",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-065-C",
                "text": "Clear to taxi",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-065-D",
                "text": "Clear to start engine",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-066",
            "text": "If on ground you see a steady white light it means?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-066-A",
                "text": "Return to gate",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-066-B",
                "text": "Clear the active area and return to bay",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-066-C",
                "text": "Nothing",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-066-D",
                "text": "Clear the active area stop the engines",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-067",
            "text": "An altitude alerting system is required for operation of what type of aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-067-A",
                "text": ">5700 kg aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-067-B",
                "text": "<5700 kg aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-067-C",
                "text": ">2250 kg aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-067-D",
                "text": "All aircraft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-068",
            "text": "While en-route at night, you observed a single flashing white light on the ground. This could indicate:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-068-A",
                "text": "A military airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-068-B",
                "text": "A sea port",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-068-C",
                "text": "A hazard",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-068-D",
                "text": "Nothing",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-069",
            "text": "Supplemental oxygen is required if the flight is conducted above 10.000 ft. cabin pressure for the duration of flight in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-069-A",
                "text": "Pressurised aircrafts",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-069-B",
                "text": "Unpressurised aircrafts",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-069-C",
                "text": "Not required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-069-D",
                "text": "Both type of aircrafts",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-070",
            "text": "What is the cabin altitude above which all flight crewmembers are required to use supplemental oxygen (O2) continuously?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-070-A",
                "text": "12.000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-070-B",
                "text": "10.000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-070-C",
                "text": "13.000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-070-D",
                "text": "15.000 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-071",
            "text": "What quantity of First Aid O2 is required to be on board a pressurised aeroplane above 25000ft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-071-A",
                "text": "Enough for 2% of passengers carried, but in no case for less than 1 person at cabin altitudes between 8000ft and 15000 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-071-B",
                "text": "Enough for 5% of passengers carried, but in no case for less than 1 person at cabin altitudes between 8000ft and 15000 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-071-C",
                "text": "Entire flight time when the cabin altitude exceeds 14000ft but does not exceed 15000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-071-D",
                "text": "Enough for 10% of passengers when cabin altitude is between 10000ft and 13000ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-072",
            "text": "Oxygen requirements for non-pressurised aircraft",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-072-A",
                "text": "10000ft for more than 30 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-072-B",
                "text": "Above 8000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-072-C",
                "text": "Above 12000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-072-D",
                "text": "Above 10000ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-073",
            "text": "An operator shall not operate a non-pressurized aeroplane at altitudes above 10000ft unless supplemental oxygen equipment supply for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-073-A",
                "text": "All passengers for entire flight time at pressure altitude above 10000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-073-B",
                "text": "All flight deck crew for entire flight time at pressure altitude above 13000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-073-C",
                "text": "10% of passengers for entire flight time after 30 minutes at pressure altitude between 10000ft and 13000ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-073-D",
                "text": "50% of passengers for entire flight time after 30 minutes at pressure altitude between 10000ft and 13000ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-074",
            "text": "Oxygen requirements for non-pressurized aircraft",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-074-A",
                "text": "Above 12000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-074-B",
                "text": "Above 10000ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-074-C",
                "text": "10000ft for more than 30 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-074-D",
                "text": "Above 8000ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-075",
            "text": "Pressurized aircraft on flights over 25000 feet MSL must carry:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-075-A",
                "text": "Oxygen dispensing unit which shall exceed the number of seats by at least 50% immediately available to each occupant and crew",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-075-B",
                "text": "Oxygen masks for flight crew members",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-075-C",
                "text": "Oxygen dispensing unit for flight and cabin crew members",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-075-D",
                "text": "Oxygen dispensing unit which shall exceed the number of seats by at least 10% immediately available to each occupant and crew",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-076",
            "text": "With respect to minimum altitudes for IFR operations, which statement is correct?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-076-A",
                "text": "Elsewhere; above at least 10000ft above the highest obstacle located within 5nm of estimated position of aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-076-B",
                "text": "Over mountainous area at least 2000ft above highest obstacle within 5 nm of the estimated position of aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-076-C",
                "text": "The aircraft cannot operate lower than the published MOCA and in accordance to the KSS formula",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-076-D",
                "text": "Over mountainous area at least 1000ft above highest obstacle within 5 nm of the estimated position of aircraft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-077",
            "text": "Do you require an ATC clearance to enter a danger area?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-077-A",
                "text": "No",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-077-B",
                "text": "A pilot can enter at his own discretion",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-077-C",
                "text": "Yes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-077-D",
                "text": "Yes, only when danger area is active",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-078",
            "text": "Restricted areas _ When can you fly them?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-078-A",
                "text": "Anytime",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-078-B",
                "text": "Never",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-078-C",
                "text": "After checking NOTAMS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-078-D",
                "text": "Normally prohibited but sometimes permitted with ATC clearance",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-079",
            "text": "Restricted areas _ When can you fly them?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-079-A",
                "text": "Always",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-079-B",
                "text": "Anytime",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-079-C",
                "text": "When the pilot has ensured the safety of the aircraft etc.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-079-D",
                "text": "Never",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-080",
            "text": "The symbol OMR60 on aeronautical chart indicates",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-080-A",
                "text": "A danger are which is restricted to military use",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-080-B",
                "text": "An Omni Directional Range station",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-080-C",
                "text": "A prohibited area which is restricted to military use",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-080-D",
                "text": "An area requiring an ATC clearance to penetrate",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-081",
            "text": "On a sectional chart, the letters OMD1 indicate:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-081-A",
                "text": "A danger area",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-081-B",
                "text": "An Omni Directional Range Station",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-081-C",
                "text": "The first UAE aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-081-D",
                "text": "A restricted areas",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-082",
            "text": "Operation of civil aircraft within Danger Area in UAE airspace is allowed",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-082-A",
                "text": "Normally prohibited but sometimes permitted with ATC clearance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-082-B",
                "text": "After checking NOTAMS",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-082-C",
                "text": "Anytime",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-082-D",
                "text": "Never",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-083",
            "text": "No person may operate an aircraft in acrobatic flight when the flight visibility is less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-083-A",
                "text": "5 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-083-B",
                "text": "3 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-083-C",
                "text": "10 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-083-D",
                "text": "8 km",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-084",
            "text": "What is the lowest altitude permitted for aerobatic flight?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-084-A",
                "text": "3,000 feet AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-084-B",
                "text": "1,000 feet AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-084-C",
                "text": "1,500 feet AGL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-084-D",
                "text": "2,000 feet AGL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-085",
            "text": "No person may operate an aircraft in acrobatic flight when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-085-A",
                "text": "Less than 4,500 feet AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-085-B",
                "text": "Less than 2,500 feet AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-085-C",
                "text": "Over any congested area of a city, town, or settlement",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-085-D",
                "text": "Flight visibility is less that 5 miles",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-086",
            "text": "VFR ceiling and visibility requirement in class C,D, E airspace below 10,000 feet are",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-086-A",
                "text": "5 km, visibility 1500m horizontally and 300m vertically from cloud",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-086-B",
                "text": "5 km, visibility 1000m horizontally and 300m vertically from cloud",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-086-C",
                "text": "8 km, visibility 1500m horizontally and 300m vertically from cloud",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-086-D",
                "text": "8 km, visibility 1000m horizontally and 300m vertically from cloud",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-087",
            "text": "Flight visibility minimal in class G airspace VFR below 900 meters",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-087-A",
                "text": "5 km., clear of clouds and in sight of ground or water",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-087-B",
                "text": "5 km., 1500 meters horizontal, 300 meters vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-087-C",
                "text": "8 km., 1000 meters horizontal, 300 meters vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-087-D",
                "text": "8 km., 1500 meters horizontal, 300 meters vertical",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-088",
            "text": "Visibility minima class G below 900 Meters",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-088-A",
                "text": "5 km, clear of clouds",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-088-B",
                "text": "5 km, 1500 meters horizontal, 300 meters vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-088-C",
                "text": "8 km, 1500 meters horizontal, 300 meters vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-088-D",
                "text": "8 km, 1000 meters horizontal, 300 meters vertical",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-089",
            "text": "Visibility minima below 10000 ft",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-089-A",
                "text": "5 km, 1000 meters horizontal, 300 meters vertical from cloud",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-089-B",
                "text": "8 km, 1500 meters horizontal, 300 meters vertical from cloud",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-089-C",
                "text": "5 km, 1500 meters horizontal, 300 meters vertical from cloud",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-089-D",
                "text": "8 km, 1000 meters horizontal, 300 meters vertical from cloud",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-090",
            "text": "Visibility requirements for SVFR",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-090-A",
                "text": "1500 meters ground visibility",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-090-B",
                "text": "1500 meters flight visibility",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-090-C",
                "text": "2500 meters ground and flight visibility",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-090-D",
                "text": "1500 meters ground and flight visibility",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-091",
            "text": "VFR flight position report in class E airspace ( SAME CLASS G)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-091-A",
                "text": "Half hourly",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-091-B",
                "text": "Hourly",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-091-C",
                "text": "Never",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-091-D",
                "text": "Every 10 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-092",
            "text": "ATIS provides",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-092-A",
                "text": "Notam",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-092-B",
                "text": "Non control information in busy areas",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-092-C",
                "text": "Airmet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-092-D",
                "text": "Clearance",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-093",
            "text": "Position reporting in class E airspace- Frequency",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-093-A",
                "text": "Never",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-093-B",
                "text": "Every 1 hour",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-093-C",
                "text": "Every 30 mins.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-093-D",
                "text": "Every 15 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-094",
            "text": "In UAE FIR, IFR rules are applied at all times to aeroplane operating at or above:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-094-A",
                "text": "FL120",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-094-B",
                "text": "FL160",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-094-C",
                "text": "FL100",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-094-D",
                "text": "FL145",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-095",
            "text": "For the entire UAE FIR, the transition altitude and level are fixed at:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-095-A",
                "text": "12 500’ and FL 180 respectively",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-095-B",
                "text": "13 000’ and FL 180 respectively",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-095-C",
                "text": "12 000’ and FL 180 respectively",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-095-D",
                "text": "FL 150 and 13 000’ respectively",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-096",
            "text": "Transition altitude in UAE FIR",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-096-A",
                "text": "14,500 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-096-B",
                "text": "13,000 feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-096-C",
                "text": "10,000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-096-D",
                "text": "15,000 feet",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-097",
            "text": "IFR & VFR flights in Class G airspace _______ services available",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-097-A",
                "text": "Full advisory service for IFR and none for VFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-097-B",
                "text": "Flight information services",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-097-C",
                "text": "None for IFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-097-D",
                "text": "Flight information service for VFR and advisory service for IFR",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-098",
            "text": "The service provided for VFR flights in Class G airspace is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-098-A",
                "text": "Traffic information as far as practicable",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-098-B",
                "text": "ATIS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-098-C",
                "text": "Flight Information Service",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-098-D",
                "text": "Both (a) and (b) are correct",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-099",
            "text": "What is the maximum permissible airspeed below 10 000 feet for a VFR flight in class B airspace",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-099-A",
                "text": "250 kt TAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-099-B",
                "text": "250 kt",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-099-C",
                "text": "Not applicable",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-099-D",
                "text": "250 mph",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-100",
            "text": "(Refer to figure 010-17): The following signal, seen in an airfield signals square indicates: FIGURE 010-17",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-100-A",
                "text": "Light aircraft on the grass",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-100-B",
                "text": "Both runways are in use",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-100-C",
                "text": "Glider flying is in progress",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-100-D",
                "text": "The direction of the take-off and landing are not the same",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-101",
            "text": "(Refer to figure 010-16): What is the meaning of the following visual ground signal?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-101-A",
                "text": "Light aircraft are permitted to take-off and land either on a runway or on area designated",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-101-B",
                "text": "Aircraft movement is confirmed to paved, metaled or similar hardened surfaces FIGURE 010-16",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-101-C",
                "text": "Only for light aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-101-D",
                "text": "A right hand circuit is in force",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-102",
            "text": "(Refer to figure 010-17): What is the meaning of the sign attached here seen in an airfield signal square?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-102-A",
                "text": "Movement confined to paved area FIGURE 010-17",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-102-B",
                "text": "Parallel runways in use",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-102-C",
                "text": "Light aircraft landing area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-102-D",
                "text": "Glider flying in progress",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-103",
            "text": "(Refer to figure 010-14): What is the meaning of the following visual ground signal? FIGURE 010-14",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-103-A",
                "text": "Only for light aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-103-B",
                "text": "Take-offs and landings are to be on a runway, but movement on the ground is not confined to pavements",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-103-C",
                "text": "Aircraft movement is confined to paved, metaled or similar hardened surfaces",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-103-D",
                "text": "Light aircraft are permitted to take-off and land either on a runway or on the area designated",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-104",
            "text": "(Refer to figure 010-15): What is the meaning of the following visual ground signal? FIGURE 010-15",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-104-A",
                "text": "Take-offs and landings are to be on a runway, but movement on the ground is not confined to pavements",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-104-B",
                "text": "Glider flying in progress",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-104-C",
                "text": "Aircraft movement is confined to paved, metaled or similar hardened surfaces",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-104-D",
                "text": "Light aircraft are permitted to take-off and land either on a runway or on the area designated",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-105",
            "text": "(Refer to figure 010-19): The basic holding position shown in the figure will be used? FIGURE 010-19",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-105-A",
                "text": "At each taxiway intersection",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-105-B",
                "text": "Where two or more taxi holding positions are provided at an intersection",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-105-C",
                "text": "At an intersection of a taxiway and a non-instrument, non-precision approach or take-off runway",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-105-D",
                "text": "When the red light stop bar is not available",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-106",
            "text": "(Refer to figure 010-13): The following sign is a:? FIGURE 010-13",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-106-A",
                "text": "Emergency sign",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-106-B",
                "text": "Mandatory sign",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-106-C",
                "text": "Information sign",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-106-D",
                "text": "Special sign",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-107",
            "text": "(Refer to figure 010-12): The following figure indicates: FIGURE 010-12",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-107-A",
                "text": "A taxiway intersection marking",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-107-B",
                "text": "A threshold marking",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-107-C",
                "text": "A runway intersection sign",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-107-D",
                "text": "A destination sign",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-108",
            "text": "(Refer to figure 010-02): Using the ground air visual signal code the letter similar to the symbol meaning REQUIRE MEDICAL ASSISTANCE is: FIGURE 010-02",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-108-A",
                "text": "4 1 2 3 4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-108-B",
                "text": "2",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-108-C",
                "text": "3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-108-D",
                "text": "1",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-109",
            "text": "(Refer to figure 010-03): What is the meaning of this symbol in the ground air visual signal code for use by survivors? FIGURE 010-03",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-109-A",
                "text": "Require assistance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-109-B",
                "text": "Require medical assistance",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-109-C",
                "text": "Landing here impossible",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-109-D",
                "text": "Drop emergency supplies at this point",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-110",
            "text": "(Refer to figure 010-06): What is the meaning of the following ground-air visual signal? FIGURE 010-06",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-110-A",
                "text": "Proceed in this direction",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-110-B",
                "text": "We are not able to continue and we will return to base",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-110-C",
                "text": "We have found all personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-110-D",
                "text": "Operation completed",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-111",
            "text": "(Refer to figure 010-04): What is the meaning of the following ground-air visual code illustrated means? FIGURE 010-04",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-111-A",
                "text": "Require medical assistance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-111-B",
                "text": "Proceeding in the direction shown",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-111-C",
                "text": "Please indicate direction",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-111-D",
                "text": "Require assistance",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-112",
            "text": "(Refer to figure 010-05): What is the meaning of this SAR visual signal when used by survivors on the ground FIGURE 010-05",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-112-A",
                "text": "Require food",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-112-B",
                "text": "Negative",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-112-C",
                "text": "Require medical assistance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-112-D",
                "text": "All is well",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-113",
            "text": "(Refer to figure 010-18): What is the meaning of the following visual ground signal? FIGURE 010-18",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-113-A",
                "text": "Aerodrome unfit for aircraft movements",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-113-B",
                "text": "Take-off and landing directions do not necessarily coincide",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-113-C",
                "text": "Aircraft movement on the ground is confined to paved, metaled or hardened surfaces",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-113-D",
                "text": "Glider flying in progress",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-114",
            "text": "(Refer to figure 010-11): What is the meaning of the following ground-air visual sign? FIGURE 010-11",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-114-A",
                "text": "We have found all personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-114-B",
                "text": "We are not able to continue and we will return to base",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-114-C",
                "text": "Operation completed",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-114-D",
                "text": "We have found some personnel",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-115",
            "text": "(Refer to figure 010-07): What is the meaning of the following ground-air visual sign? FIGURE 010-17",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-115-A",
                "text": "We have found all personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-115-B",
                "text": "Have divided into two groups, and each group is proceeding in the direction indicated",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-115-C",
                "text": "We have found some personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-115-D",
                "text": "We are not able to continue and we will return to base",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-116",
            "text": "(Refer to figure 010-09): What is the meaning of the following ground-air visual sign? FIGURE 010-09",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-116-A",
                "text": "We have found all personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-116-B",
                "text": "We are not able to continue and we will return to base",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-116-C",
                "text": "We have found some personnel",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-116-D",
                "text": "Operation completed",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-117",
            "text": "(Refer to figure 010-01): What is the meaning of the following ground-air visual signal number 1? FIGURE 010-01",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-117-A",
                "text": "We have found all personnel 1 2 3 4",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-117-B",
                "text": "We are not able to continue and we will return to base",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-117-C",
                "text": "We have found some personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-117-D",
                "text": "Operation completed",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-118",
            "text": "(Refer to figure 010-10): What is the meaning of the following ground-air visual signal? FIGURE 010-10",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-118-A",
                "text": "We have found nothing, but we will continue to search",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-118-B",
                "text": "We are not able to continue and we will return to base",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-118-C",
                "text": "We have found some personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-118-D",
                "text": "Operation completed",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-119",
            "text": "(Refer to figure 010-02): Using the ground-air visual code the letter(s) similar to thy symbol meaning REQUIRE ASSISTANCE is(are)? FIGURE 010-02",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-119-A",
                "text": "3 1 2 3 4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-119-B",
                "text": "4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-119-C",
                "text": "1",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-119-D",
                "text": "2",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-120",
            "text": "(Refer to figure 010-08): What is the meaning of the following ground-air visual signal: FIGURE 010-08",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-120-A",
                "text": "Operation completed",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-120-B",
                "text": "We are not able to continue and we will return to base",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-120-C",
                "text": "We have found all personnel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-120-D",
                "text": "2We have found some personnel",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-121",
            "text": "(Refer to figure 010-01): Using the ground-air visual code, the symbol meaning WE HAVE FOUND ALL PERSONNEL is:: FIGURE 010-01",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-121-A",
                "text": "4 1 2 3 4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-121-B",
                "text": "3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-121-C",
                "text": "1",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-121-D",
                "text": "2",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-122",
            "text": "VFR flights operating in Class E airspace are required:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-122-A",
                "text": "To carry an SSR transponder Mode C",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-122-B",
                "text": "To send position reports every half hour of flight",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-122-C",
                "text": "To send position reports every two hours of flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-122-D",
                "text": "To stay below 10 000 feet AMSL at all times",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-123",
            "text": "Class D airspace within UAE FIR:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-123-A",
                "text": "Starts from the surface up to 1 500 ft AMSL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-123-B",
                "text": "Has a varying lower limit above the ground but always ends at 24 500 ft AMSL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-123-C",
                "text": "Has a fixed lower limit above the ground but always ends at 24 500 ft AMSL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-123-D",
                "text": "Has a varying upper limit but always starts from the surface",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-124",
            "text": "Class G airspace lower and upper limits are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-124-A",
                "text": "Surface and FL 145 respectively",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-124-B",
                "text": "Surface and 4 500 feet respectively",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-124-C",
                "text": "Surface and 10 500 feet respectively",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-124-D",
                "text": "4 500 and FL 145 respectively",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-125",
            "text": "The lower and upper limits of the UAE upper information region are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-125-A",
                "text": "12 500 feet and FL 145 respectively",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-125-B",
                "text": "FL 145 and UNL respectively",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-125-C",
                "text": "10 500 feet and FL 145 respectively",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-125-D",
                "text": "Surface and UNL respectively",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-126",
            "text": "In class E airspace, the pilot of a VFR flight planning to fly a track heading towards the southwest should select an altitude of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-126-A",
                "text": "4 000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-126-B",
                "text": "5 000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-126-C",
                "text": "FL 45",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-126-D",
                "text": "4 500 feet",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-127",
            "text": "While the table of cruising levels applies to uncontrolled VFR flights,",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-127-A",
                "text": "VFR flights in controlled airspace may select any cruising level",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-127-B",
                "text": "Controlled VFR flights must follow the table of cruising levels any time they operate below 3 000 feet above the surface",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-127-C",
                "text": "VFR flights in controlled airspace may select any cruising altitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-127-D",
                "text": "ATC will normally assign IFR cruising altitudes to controlled VFR flights",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-128",
            "text": "The lowest class of airspace in the UAE requiring an ATC clearance to operate IFR flights:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-128-A",
                "text": "Class E",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-128-B",
                "text": "Class G",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-128-C",
                "text": "Class C",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-128-D",
                "text": "Class F",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-129",
            "text": "What will be in the action required when the limit values of cosmic radiation dose rate are exceeded",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-129-A",
                "text": "Descend as soon as possible",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-129-B",
                "text": "Continue the flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-129-C",
                "text": "Climb as soon as possible",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-129-D",
                "text": "Inform ATC",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-130",
            "text": "With respect to minimum flight altitude for IFR operations, which statement is correct?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-130-A",
                "text": "MOCA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-130-B",
                "text": "MTCA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-130-C",
                "text": "KSS Formula",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-130-D",
                "text": "MORA",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-131",
            "text": "The minimum altitude at which and aeroplane may be operated over any congested area of a city in UAE?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-131-A",
                "text": "500 ft over congested area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-131-B",
                "text": "2000 ft vertically and 2000 ft horizontally from any object",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-131-C",
                "text": "1000 ft vertically and 2000 ft horizontally from any object",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-131-D",
                "text": "Minimum height to enable land clear if engines fails",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-132",
            "text": "Minimum altitude anywhere",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-132-A",
                "text": "2000 ft vertically and 100 ft horizontally from an object",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-132-B",
                "text": "Minimum height to enable land clear if engines fails",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-132-C",
                "text": "2000 ft vertically and 2000 ft horizontally from any object",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-132-D",
                "text": "500 ft over congested area",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-133",
            "text": "Minimum safe altitudes",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-133-A",
                "text": "2000 ft vertically and 1000 ft horizontally from an object",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-133-B",
                "text": "Minimum height to enable land clear if engines fails",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-133-C",
                "text": "2000 ft vertically and 3000 ft horizontally from any object",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-133-D",
                "text": "1000 ft over congested area",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-134",
            "text": "UAE Aeronautical Information Publication is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-134-A",
                "text": "Regulatory",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-134-B",
                "text": "Not required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-134-C",
                "text": "Advisory",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-134-D",
                "text": "Mandatory",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-135",
            "text": "Information concerning notification of accidents and incidents involving airplane is provided in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-135-A",
                "text": "CAR Part VII",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-135-B",
                "text": "CAR Part IV",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-135-C",
                "text": "CAR Part II",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-135-D",
                "text": "CAR Part III",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-136",
            "text": "Where can once find information regarding flight crew licensing requirements:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-136-A",
                "text": "CAR Part IV",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-136-B",
                "text": "CAR Part III",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-136-C",
                "text": "CAR Part II",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-136-D",
                "text": "CAR Part VII",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-137",
            "text": "The rules which govern the licensing of all pilots and other flight crew are to be found in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-137-A",
                "text": "CAR Part II",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-137-B",
                "text": "CAR Part III",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-137-C",
                "text": "CAR Part X",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-137-D",
                "text": "CAR Part IV",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-138",
            "text": "Documents which must be carried on board each flight are listed in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-138-A",
                "text": "CAR Part IV",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-138-B",
                "text": "CAR Part III",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-138-C",
                "text": "CAR Part X",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-138-D",
                "text": "CAR Part II",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-139",
            "text": "Pilot shall not accept dangerous goods unless he received training in accordance to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-139-A",
                "text": "CAR Part X",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-139-B",
                "text": "CAR Part VI",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-139-C",
                "text": "CAR Part II",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-139-D",
                "text": "CAR Part III",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-140",
            "text": "A pilot should not accept dangerous goods unless:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-140-A",
                "text": "Unless he has been trained to do so",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-140-B",
                "text": "In accordance with CAR Part IV chapter 4",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-140-C",
                "text": "Any time",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-140-D",
                "text": "Never",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-141",
            "text": "Commencement and continuation of approach if the RVR is less than the applicable minima:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-141-A",
                "text": "Can commence the approach until the FAF or equivalent position, but the applicable RVR must be achieved before continuing to DA/MDA",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-141-B",
                "text": "Cannot commence the approach",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-141-C",
                "text": "Can commence the approach until reaching the FAF",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-141-D",
                "text": "Can commence the approach from the IAF and continue to MDA/DA",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-142",
            "text": "Under what circumstances may a pilot carry out CAT II approach?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-142-A",
                "text": "Never",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-142-B",
                "text": "Company Authorization",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-142-C",
                "text": "AOC Authorization",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-142-D",
                "text": "GCAA Authorization",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-143",
            "text": "The mass of an aeroplane at the start of take-off shall not exceed the maximum take-off mass mentioned in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-143-A",
                "text": "Performance data in the OMA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-143-B",
                "text": "Performance data in the AFM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-143-C",
                "text": "AFM for ambient temperature and pressure altitude at the take-off aerodrome",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-143-D",
                "text": "Aeroplane Flight Manual (AFM)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-144",
            "text": "What is the RVR limit for CAT I approach with full facilities and a DH of 200?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-144-A",
                "text": "125 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-144-B",
                "text": "550 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-144-C",
                "text": "75 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-144-D",
                "text": "200 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-145",
            "text": "Choose the correct statement regarding landing. In the event the commander decides to continue below DA/H or MDA/H of the CAT I or cat ii approaches:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-145-A",
                "text": "Visual reference can be maintained until landing",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-145-B",
                "text": "A Go Around has to be initiated",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-145-C",
                "text": "Landing must be assured",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-145-D",
                "text": "Autoland must be accomplished",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-146",
            "text": "In the event of a critical power unit failure at any point during take-off, the aeroplane shall be able to clear obstacles in the net take-off flight path by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-146-A",
                "text": "35 feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-146-B",
                "text": "50 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-146-C",
                "text": "60 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-146-D",
                "text": "100 feet",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-147",
            "text": "Before you obtain your PPL of all the ˝SOLO˝ flight time how much is credited as your pilot-in command time?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-147-A",
                "text": "50% of your solo time",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-147-B",
                "text": "10% of your solo time",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-147-C",
                "text": "none of your solo time",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-147-D",
                "text": "100% of your solo time",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-148",
            "text": "To compute local time in the UAE from UTC you must",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-148-A",
                "text": "UTC -3 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-148-B",
                "text": "UTC +3 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-148-C",
                "text": "UTC +4 hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-148-D",
                "text": "UTC -4 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-149",
            "text": "VFR flights operating in class E airspace are required",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-149-A",
                "text": "To carry an SSR transponder Mode C",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-149-B",
                "text": "To send position reports every half hour of flight",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-149-C",
                "text": "To stay below 10.000 feet AMSL at all times",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-149-D",
                "text": "To send position reports every 2 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-150",
            "text": "In order to reduce the possibility of being intercepted by the UAE air defence fighters in the absence of any ATC directions:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-150-A",
                "text": "Squawk 2000",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-150-B",
                "text": "Squawk ident then select mode A code 7500",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-150-C",
                "text": "Squawk 1200",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-150-D",
                "text": "Squawk 7700",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-151",
            "text": "You can find information about an aerodrome such as type of fuel available, threshold elevation and slopes, details of taxiways, ATC frequencies and administrative data:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-151-A",
                "text": "In the aerodrome section in the AIP",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-151-B",
                "text": "In the airport facility directory of the UAE",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-151-C",
                "text": "In the Operations Manual Section 8",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-151-D",
                "text": "Within the sectional and approach charts",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-152",
            "text": "In the event you experience and unlawful interference with your duties as a crew member of an aeroplane and experience what you believe to be hijacking, you should adjust your transponder code to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-152-A",
                "text": "7600",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-152-B",
                "text": "2000",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-152-C",
                "text": "7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-152-D",
                "text": "7500",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-153",
            "text": "To indicate communication failure, which squawk code is used?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-153-A",
                "text": "7600",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-153-B",
                "text": "2000",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-153-C",
                "text": "7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-153-D",
                "text": "7500",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-154",
            "text": "Position reports in class E airspace to be made:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-154-A",
                "text": "After the first 30 minutes the every hour",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-154-B",
                "text": "Every hour at night only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-154-C",
                "text": "Every hour at day only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-154-D",
                "text": "Every half an hour of flight",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-155",
            "text": "Radio transponder code when entering UAE FIR without assigned code is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-155-A",
                "text": "2000",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-155-B",
                "text": "7600",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-155-C",
                "text": "7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-155-D",
                "text": "1200",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-156",
            "text": "If the local time in UAE is 10:00. What will it be in UTC?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-156-A",
                "text": "06:00",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-156-B",
                "text": "14:00",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-156-C",
                "text": "17:00",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-156-D",
                "text": "18:00",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-157",
            "text": "An over water flights, for multiengine aeroplane, life rafts and survival ELTs are required to be carried on board, when the aeroplane operates greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-157-A",
                "text": "30 minutes at cruising speed or 100 nautical mile to an aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-157-B",
                "text": "30 minutes at cruising speed or 400 nautical mile to an aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-157-C",
                "text": "120 minutes at cruising speed or 100 nautical mile to an aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-157-D",
                "text": "120 minutes at cruising speed or 400 nautical mile to an aerodrome",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-158",
            "text": "Medical validity for a 36 year old ATP licensed pilot:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-158-A",
                "text": "24 months Class I",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-158-B",
                "text": "6 months Class I",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-158-C",
                "text": "12 months Class II",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-158-D",
                "text": "12 months Class I",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-159",
            "text": "What is the published maximum indicated airspeed in class C airspace:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-159-A",
                "text": "250 kts above 10.000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-159-B",
                "text": "250 kts below 10.000 feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-159-C",
                "text": "Not applicable",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-159-D",
                "text": "200 kts below 10.000 feet",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-160",
            "text": "In the event of interception of an aircraft during day light hours and no radio contacts are available:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-160-A",
                "text": "Lowering and raising landing gear",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-160-B",
                "text": "No action required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-160-C",
                "text": "Switching on and off all available lights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-160-D",
                "text": "Rocking aircrafts wings",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-161",
            "text": "UAE Pilot license is valid for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-161-A",
                "text": "Life long",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-161-B",
                "text": "Two years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-161-C",
                "text": "One year",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-161-D",
                "text": "Eight years",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-162",
            "text": "How many cabin crew members must be carried on a commercial flight with 163 passengers?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-162-A",
                "text": "Three",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-162-B",
                "text": "One for every 100 passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-162-C",
                "text": "One for every 25 passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-162-D",
                "text": "One for every 50 passengers",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-163",
            "text": "Which choice is most correct concerning mandatory drugs screening?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-163-A",
                "text": "Drug screening test is conducted by urine analysis",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-163-B",
                "text": "All of the above",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-163-C",
                "text": "Drug screening is mandatory",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-163-D",
                "text": "Drug screening is performed only for the initial assessments for all classes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-164",
            "text": "Intercepted aircraft should adjust the radio transponder code to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-164-A",
                "text": "7500",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-164-B",
                "text": "7700",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-164-C",
                "text": "7600",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-164-D",
                "text": "2000",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-165",
            "text": "Position of intercepting aircraft when requesting to be followed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-165-A",
                "text": "Below your aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-165-B",
                "text": "Behind your aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-165-C",
                "text": "Rapid departure to the left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-165-D",
                "text": "Ahead and to the left, waggling wings",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-166",
            "text": "Validity of a Commercial Pilot medical (25 years of age) which was issued on 12 April 1992",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-166-A",
                "text": "31st December 1993",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-166-B",
                "text": "30th of April 1993",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-166-C",
                "text": "One year from date of issue",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-166-D",
                "text": "31st of October 1992",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-167",
            "text": "Crediting of co-pilots time towards a higher grade of license: Unless otherwise determined in the regulation CAR2 FCL.035, the holder of a pilot licence, when acting as co-pilot of PICUS, is entitled to be credited with how many percent of the co=pilot time towards the total flight time required for a higher grade of pilot licence?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-167-A",
                "text": "50% of the flight time towards a higher grade of license.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-167-B",
                "text": "100% of the flight time.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-167-C",
                "text": "25% of the flight time towards a higher grade of license.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-167-D",
                "text": "25% of the flight time",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-168",
            "text": "IFR fuel requirements for alternate aerodrome:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-168-A",
                "text": "Not required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-168-B",
                "text": "60 minutes in still air conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-168-C",
                "text": "To complete an instrument approach and missed approach and fly for 45 minutes thereafter",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-168-D",
                "text": "45 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-169",
            "text": "Currency requirements for carrying passengers at night",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-169-A",
                "text": "3 take-offs and landings",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-169-B",
                "text": "3 take-offs and landings within previous 90 days in that category, class and type of aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-169-C",
                "text": "3 take-offs and landings between the hours of sunset and sunrise within previous 90 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-169-D",
                "text": "3 take-offs and landings between the hours of sunset and sunrise withing the previous 90 days in category 1 type 1 class",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-170",
            "text": "Transition level",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-170-A",
                "text": "14.000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-170-B",
                "text": "FL 150",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-170-C",
                "text": "12.000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-170-D",
                "text": "FL1 130",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-171",
            "text": "NDB holdings timing – when do you have to start timing?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-171-A",
                "text": "Abeam the NDB on the outbound leg",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-171-B",
                "text": "Over the NDB",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-171-C",
                "text": "Never",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-171-D",
                "text": "Abeam the NDB on the inbound leg",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-172",
            "text": "Prohibited areas - when are you allowed to fly in them?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-172-A",
                "text": "Never",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-172-B",
                "text": "With permission of the ICAO",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-172-C",
                "text": "Always",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-172-D",
                "text": "With permission of ATC",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-173",
            "text": "Restricted areas - when are you allowed to fly in them?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-173-A",
                "text": "Never",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-173-B",
                "text": "With permission of the ATC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-173-C",
                "text": "Always",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-173-D",
                "text": "Normally prohibited but sometimes permitted with ATC clearance",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-174",
            "text": "Maximum VFR flight level:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-174-A",
                "text": "FL 120",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-174-B",
                "text": "FL 160",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-174-C",
                "text": "FL 145",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-174-D",
                "text": "FL 100",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-175",
            "text": "What does CAVOK mean?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-175-A",
                "text": "10.000 feet horizontal and 1.000 feet vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-175-B",
                "text": "10.000 feet horizontal and 10.000 feet vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-175-C",
                "text": "10 km horizontal and 5.000 feet vertical",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-175-D",
                "text": "5.000 feet horizontal and 5.000 feet vertical",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-176",
            "text": "Validity of a UAE license?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-176-A",
                "text": "Two years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-176-B",
                "text": "Issued for a lifetime",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-176-C",
                "text": "Eight years",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-176-D",
                "text": "One year",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-177",
            "text": "Altimeter setting for take-off and landing",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-177-A",
                "text": "QNE/QFE",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-177-B",
                "text": "QNH or QFE",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-177-C",
                "text": "QDM or QDR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-177-D",
                "text": "QFE/QNE",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-178",
            "text": "Meaning of QNH:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-178-A",
                "text": "Standard condition",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-178-B",
                "text": "Pressure at mean sea level",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-178-C",
                "text": "29,92 inches",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-178-D",
                "text": "1013,2 millibars",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-179",
            "text": "We report ________ above the transition and ________ below.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-179-A",
                "text": "Elevation / Altitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-179-B",
                "text": "Altitude / Flight Level",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-179-C",
                "text": "Height / Altitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-179-D",
                "text": "Flight Level / Altitude",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-180",
            "text": "How many hours should be added to convert UTC to UAE time?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-180-A",
                "text": "Minus four",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-180-B",
                "text": "Plus five",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-180-C",
                "text": "Plus three",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-180-D",
                "text": "Plus four",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-181",
            "text": "Wake vortex – What is the dangerous area for a light aircraft following a heavy area?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-181-A",
                "text": "Below and behind the heavy aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-181-B",
                "text": "Upwind",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-181-C",
                "text": "Above",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-181-D",
                "text": "Downwind",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-182",
            "text": "What is the cabin altitude above which all flight crew members are required to use supplemental oxygen (O2) continuously?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-182-A",
                "text": "10.000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-182-B",
                "text": "15.000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-182-C",
                "text": "12.000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-182-D",
                "text": "13.000 feet",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-183",
            "text": "Airspace in which the flight of civil aircraft is not permitted at any time:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-183-A",
                "text": "Class G Airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-183-B",
                "text": "Prohibited Area",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-183-C",
                "text": "Danger Area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-183-D",
                "text": "Restricted Area",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-184",
            "text": "Requirement regarding commencement and continuation of precision instrument approaches if the RVR is less than the applicable minima:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-184-A",
                "text": "You can continue beyond the outer marker.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-184-B",
                "text": "You can continue to the minimum",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-184-C",
                "text": "You can continue to the middle marker",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-184-D",
                "text": "You cannot continue beyond the outer marker",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-185",
            "text": "An operator when operating abroad shall follow:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-185-A",
                "text": "ICAO regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-185-B",
                "text": "JARs",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-185-C",
                "text": "UAE CAR and other state regulations",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-185-D",
                "text": "Only EASA regulations",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-186",
            "text": "What is the squawk code to indicate hijack/ unlawful interference?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-186-A",
                "text": "2000",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-186-B",
                "text": "7500",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-186-C",
                "text": "7600",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-186-D",
                "text": "7700",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-187",
            "text": "Which aircraft has the right of way?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-187-A",
                "text": "The aircraft above you",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-187-B",
                "text": "The aircraft on your left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-187-C",
                "text": "The aircraft behind you",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-187-D",
                "text": "The aircraft on your right",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-188",
            "text": "During night flight you see a steady red light and a flashing red light ahead. The other aircraft is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-188-A",
                "text": "Approaching head on",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-188-B",
                "text": "Crossing from right to left",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-188-C",
                "text": "An emergency situation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-188-D",
                "text": "Crossing from left to right",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-189",
            "text": "During night flight you see a steady white light, steady green light and a flashing red light. The other aircraft is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-189-A",
                "text": "Passing from right to left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-189-B",
                "text": "Flying away from you and will cross left to right",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-189-C",
                "text": "Approaching from above",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-189-D",
                "text": "Approaching head on",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-190",
            "text": "Definition of night in the UAE:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-190-A",
                "text": "Hours between sunset and sunrise as maybe prescribed by the appropriate authority",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-190-B",
                "text": "Hours of darkness",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-190-C",
                "text": "Hours between sunset and sunrise",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-190-D",
                "text": "Hours between sunrise and sunset",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-191",
            "text": "Definition of VFR",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-191-A",
                "text": "Instrument Flight Conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-191-B",
                "text": "Visual Flight Rules",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-191-C",
                "text": "Visual Meteorological Conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-191-D",
                "text": "Visual Flight Conditions",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-192",
            "text": "The word ¨ROGER¨ means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-192-A",
                "text": "Message received and understood",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-192-B",
                "text": "With comply",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-192-C",
                "text": "Message received and not understood",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-192-D",
                "text": "That is correct",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-193",
            "text": "Monitor means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-193-A",
                "text": "Make a test transmission on the frequency stated",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-193-B",
                "text": "Set 2000 on your transponder",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-193-C",
                "text": "Listen out on the frequency stated",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-193-D",
                "text": "Change to the new frequency",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-194",
            "text": "A blind transmission is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-194-A",
                "text": "A broadcast procedure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-194-B",
                "text": "Transmission of information relating to air navigation that is not addressed to a specific navigation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-194-C",
                "text": "Transmission from one station to another station in circumstances where two-way communication cannot be established but when it is believed that the called station is able to receive the transmission",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-194-D",
                "text": "An all station call",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-195",
            "text": "A pilot is required to read back:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-195-A",
                "text": "Only traffic information and taxi instructions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-195-B",
                "text": "Altimeter setting, taxi instructions, traffic information",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-195-C",
                "text": "Only weather information",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-195-D",
                "text": "Only taxi instructions",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-196",
            "text": "An altitude of 10.000 feet will be transmitted as",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-196-A",
                "text": "Ten zero zero feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-196-B",
                "text": "Ten thousand feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-196-C",
                "text": "One zero thousand feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-196-D",
                "text": "Ten zero kilo feet",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-197",
            "text": "What are the fuel requirements for flight under VFR in an aeroplane in the UAE assuming normal cruising speed?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-197-A",
                "text": "Sufficient for an alternate aerodrome plus 30 minutes extra fuel",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-197-B",
                "text": "During day to the destination and to fly after that for at least 30 minutes or at night to fly at least 45 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-197-C",
                "text": "Sufficient for an alternate aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-197-D",
                "text": "During day and night to the destination and to fly after that for 30 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-198",
            "text": "Under which rules may aircraft operate under VFR conditions between the hours of sunset and sunrise?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-198-A",
                "text": "Special IFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-198-B",
                "text": "IFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-198-C",
                "text": "Night VFR",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-198-D",
                "text": "Special VFR",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-199",
            "text": "Which documents must be in your personal possession while operating as pilot – in – command of an aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-199-A",
                "text": "A pilot license with an endorsement showing accomplishment of PPL and a logbook showing recency of experience",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-199-B",
                "text": "Certificates showing accomplishments of a check-out in the aircraft and a current PPL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-199-C",
                "text": "An appropriate pilot license and an appropriate current medical certificate",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-199-D",
                "text": "A pilot license and a pilot logbook",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-200",
            "text": "The final responsibility for compliance with the rules of the air is",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-200-A",
                "text": "The pilot manipulating the controls",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-200-B",
                "text": "Pilot-in command",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-200-C",
                "text": "The senior first officer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-200-D",
                "text": "The controlling authority of the airspace in use",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-201",
            "text": "The privileges of a private pilot license aeroplane shall be to act as pilot-in-command or co-pilot carrying passengers",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-201-A",
                "text": "Not be paid in any manner for the operating expenses of the flight",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-201-B",
                "text": "Engaged in any commercial flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-201-C",
                "text": "Share the operating expenses of a flight with the passengers",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-201-D",
                "text": "Engaged in revenue flight",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-202",
            "text": "Entering UAE airspace without clearance, likely to be interrupted by fighters what would indicate that you have to follow:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-202-A",
                "text": "Ahead and to the left, rocking wings",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-202-B",
                "text": "Rapid departure to the left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-202-C",
                "text": "Flying below",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-202-D",
                "text": "Flying above",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-203",
            "text": "What is the cloud coverage is meteorological conditions state scattered (SCT)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-203-A",
                "text": "8/8 sky cover",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-203-B",
                "text": "1/8 sky cover",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-203-C",
                "text": "4/8 sky cover",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-203-D",
                "text": "2/8 sky cover",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-204",
            "text": "Minimum equipment required for operations under VFR",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-204-A",
                "text": "ELT, radio communication and navigation and SSR transponder",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-204-B",
                "text": "ELT and VHF communication (two way)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-204-C",
                "text": "ELT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-204-D",
                "text": "VHF and LRNS",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-205",
            "text": "The rest requirements of any flight crew members engaged in commercial flying should be",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-205-A",
                "text": "36 consecutive hour period of duty with in each 6 day period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-205-B",
                "text": "None of the above",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-205-C",
                "text": "48 consecutive hour period of duty with in each 6 day period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-205-D",
                "text": "24 consecutive hour period of duty with in each 7 day period",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-206",
            "text": "On multi-engine aircraft with propellers both turning clockwise, one engine failing is more critical than the other, why?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-206-A",
                "text": "Forces one wing leading to a higher stall speed for that wing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-206-B",
                "text": "Corkscrew vortex",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-206-C",
                "text": "The thrust produced by the descending propeller on the right engine has an arm farther away from centerline of the fuselage (P-factor)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-206-D",
                "text": "Due to induced drag",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-207",
            "text": "Automated Terminal Information Service (ATIS) is the continuous broadcast of recorded information concerning?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-207-A",
                "text": "Weather information for inbound traffic",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-207-B",
                "text": "Non-control information broadcast in heavy traffic area",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-207-C",
                "text": "Departure Information",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-207-D",
                "text": "Control information broadcast in heavy traffic area",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-208",
            "text": "If an aircraft is involved in an accident, which results in substantial damage to the aircraft notification to GCAA should be done:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-208-A",
                "text": "Within 10 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-208-B",
                "text": "Within 10 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-208-C",
                "text": "Within 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-208-D",
                "text": "Immediately",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-209",
            "text": "Aircraft accident report (written) is required within how many days after the accident?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-209-A",
                "text": "Within 10 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-209-B",
                "text": "Within 10 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-209-C",
                "text": "Within 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-209-D",
                "text": "Immediately",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-210",
            "text": "If an aircraft wreckage be moved prior to the time GCM take custody",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-210-A",
                "text": "Yes, but only to protect the wreckage from further damage",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-210-B",
                "text": "Yes but only if moved by GCM officials or local enforcement officer",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-210-C",
                "text": "Yes, but only within the first 10 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-210-D",
                "text": "Not to be moved under any circumstances",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-211",
            "text": "Special flight authorization for foreign aircraft operating in the UAE",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-211-A",
                "text": "Required a foreign pilot license only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-211-B",
                "text": "Can operate a foreign aircraft if the pilot is appropriately rated",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-211-C",
                "text": "Do not require any flight authorization",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-211-D",
                "text": "A specific flight authorization has to be issued for that operation by the GCAA to operate in UAE FIR only",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-212",
            "text": "A person may take-off a multi-engine civil aircraft with an operable instrument or equipment installed only if",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-212-A",
                "text": "An approved Master Minimum Equipment exists",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-212-B",
                "text": "Minimum equipment list is not required if the aircraft is in an airworthy condition",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-212-C",
                "text": "A GCAA approved minimum equipment list exists for that aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-212-D",
                "text": "If approved by the aircraft mechanic to fly",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-213",
            "text": "Useful time of consciousness without oxygen following pressurization failure at 20.000 feet, 25.000 feet and 30.000 feet",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-213-A",
                "text": "6 minutes, 4 minutes and 2 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-213-B",
                "text": "5 minutes, 2 minutes and 45 seconds",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-213-C",
                "text": "5 minutes, 2 minutes and 15 seconds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-213-D",
                "text": "10 minutes, 3 minutes and 1 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-214",
            "text": "Minimum airfield lighting requirements for night operations?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-214-A",
                "text": "Threshold lights only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-214-B",
                "text": "Runway edge and centerline lights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-214-C",
                "text": "Runway edge and approach lights with VASI",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-214-D",
                "text": "Runway edge light and displaced threshold lights or REIL",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-215",
            "text": "VOR Holding Timing – when do you have to start the timing?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-215-A",
                "text": "Over the VOR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-215-B",
                "text": "Beyond the VOR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-215-C",
                "text": "Abeam the VOR on the outbound leg",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-215-D",
                "text": "Abeam the VOR on the inbound leg",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-216",
            "text": "Requirements for an Aural Speed Warning Device is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-216-A",
                "text": "Required in transport category aeroplane",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-216-B",
                "text": "Required in all aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-216-C",
                "text": "Required only in non-commercial aircraft operation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-216-D",
                "text": "Not required in any type of aircraft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-217",
            "text": "Requirement of an Emergency Locator Transmitter (ELT) is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-217-A",
                "text": "Not required in any training area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-217-B",
                "text": "Not required on board of any aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-217-C",
                "text": "Required in all civil aircraft in the UAE",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-217-D",
                "text": "Required in transport category aeroplane",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-218",
            "text": "Requirement of an Emergency Locator Transmitter (ELT) is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-218-A",
                "text": "Not required in any training area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-218-B",
                "text": "Not required on board of any aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-218-C",
                "text": "Required in all civil aircraft in the UAE",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-218-D",
                "text": "Required in transport category aeroplane",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-219",
            "text": "Under which conditions, if any may a pilot allow a person who is obviously under the influence of intoxicating liquors or drugs to be carried aboard and aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-219-A",
                "text": "Only if the person does not have access to the cockpit",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-219-B",
                "text": "Under no conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-219-C",
                "text": "Only if the person is medical patient under proper care or an emergency",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-219-D",
                "text": "Only for short range flights less than 2 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-220",
            "text": "Pre-flight action, as required for all flight away from the vicinity of an airport shall include",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-220-A",
                "text": "No special pre-flight action is required to flights less than 1 hour",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-220-B",
                "text": "An alternate course of action if the flight cannot be completed as planned",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-220-C",
                "text": "The designation of an alternate airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-220-D",
                "text": "A study of arrival procedures at airport/heliports of intended use",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-221",
            "text": "In addition to other pre-flight actions for a VFR flight away from the vicinity of the departure airport, regulations specifically require the pilot in command to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-221-A",
                "text": "Review traffic control signal procedures",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-221-B",
                "text": "Mass and balance calculation and Navaid tuning",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-221-C",
                "text": "Determine runway lengths at airports at intended use and the aircraft take-off and landing distance data",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-221-D",
                "text": "Check the accuracy of the navigation equipment and the emergency locator transmitter (ELT)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-222",
            "text": "With certain exceptions, seatbelts are required to be secured on passengers during",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-222-A",
                "text": "All flight conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-222-B",
                "text": "Flight in turbulent air",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-222-C",
                "text": "When deemed necessary by the cabin crew members",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-222-D",
                "text": "Take-off and landing",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-223",
            "text": "The responsibility for ensuring that an aircraft is maintained in an airworthy condition is primarily that of the",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-223-A",
                "text": "Mechanic who performs the maintenance actions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-223-B",
                "text": "The state of registry",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-223-C",
                "text": "Pilot in command",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-223-D",
                "text": "Owner or operator",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-224",
            "text": "The operator of an aircraft that has been involved in an accident is required to file an accident report within how many days?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-224-A",
                "text": "20 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-224-B",
                "text": "10 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-224-C",
                "text": "7 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-224-D",
                "text": "5 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-225",
            "text": "The operator of an aircraft that has been involved in an incident is required to submit a report to GCAA",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-225-A",
                "text": "Within 24 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-225-B",
                "text": "Within 7 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-225-C",
                "text": "When requested to do so",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-225-D",
                "text": "Within 24 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-226",
            "text": "Requirements for a co-pilot under IFR:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-226-A",
                "text": "Needs only a commercial pilot license",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-226-B",
                "text": "Does not require an instrument rating if the pilot in command has an instrument rating",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-226-C",
                "text": "The co-pilot should have completed 6 hours of instrument flying and 6 approaches in the last 6 months in a category, class and type of aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-226-D",
                "text": "A co-pilot should have a proper authorization from GCAA which compromises of an instrument rating appropriate to the aircraft category on his license",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-227",
            "text": "Which document must a foreign pilot, who acts as a pilot of a UAE registered aircraft have in his possessions?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-227-A",
                "text": "Foreign license",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-227-B",
                "text": "License validation",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-227-C",
                "text": "No special action is required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-227-D",
                "text": "UAE pilot license",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-228",
            "text": "An active crew member found by the GCAA to be under the influence of psychoactive drugs or alcohol shall undergo:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-228-A",
                "text": "Drug screening",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-228-B",
                "text": "Blood test",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-228-C",
                "text": "Medical check",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-228-D",
                "text": "Urine test",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-229",
            "text": "To what matters does the JAR FCL-3 relate?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-229-A",
                "text": "Medical certificates",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-229-B",
                "text": "Aeroplane licenses",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-229-C",
                "text": "Operational procedures",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-229-D",
                "text": "Helicopter licenses",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-230",
            "text": "When does the holder of a medical certificate need to seek advice from an authorised medical examiner (AME)?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-230-A",
                "text": "Before the commencement of medical treatment",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-230-B",
                "text": "Pregnancy",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-230-C",
                "text": "Any sickness or injury that prevents the holder from exercising the privileges of the license to which the certificate is attached",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-230-D",
                "text": "Disablement due to sickness for more than 21 days",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-231",
            "text": "When should the holder of a medical certificate seek the advice of the authority or an AME?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-231-A",
                "text": "Being pregnant",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-231-B",
                "text": "Any surgical operation or invasive medical procedure",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-231-C",
                "text": "Illness of less than 21 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-231-D",
                "text": "Illness of 21 days or more preventing the holder from exercising the privileges of the license",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-232",
            "text": "How old do you have to be to have a PPL",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-232-A",
                "text": "16",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-232-B",
                "text": "17",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-232-C",
                "text": "21",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-232-D",
                "text": "18",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-233",
            "text": "Demonstration of skill to revalidate or renew ratings, and including such oral examination as the examiner may require is the definition for a:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-233-A",
                "text": "Proficiency check",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-233-B",
                "text": "Revalidation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-233-C",
                "text": "Conversion",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-233-D",
                "text": "Skill test",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-234",
            "text": "What is a danger area?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-234-A",
                "text": "A NOTAM activated airspace where the general flight rules are disregarded",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-234-B",
                "text": "An airspace of defined dimensions above the land areas or territorial waters of a State within which flight or aircraft is prohibited",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-234-C",
                "text": "An airspace of defined dimensions within which activities dangerous to the flight of aircraft may exist at specified times",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-234-D",
                "text": "An airspace of defined dimensions within which air traffic control service is provided to IFR flights and to VFR flights in accordance with the airspace classification",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-235",
            "text": "An aircraft is considered to overtake another if it approaches the other aircraft from the rear on a line forming an angle of less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-235-A",
                "text": "70 degrees with the plane of symmetry of the latter",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-235-B",
                "text": "60 degrees with the plane of symmetry of the later",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-235-C",
                "text": "80 degrees with the plane of symmetry of the later",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-235-D",
                "text": "50 degrees with the plane of symmetry of the later",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-236",
            "text": "What is a Special VFR?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-236-A",
                "text": "A flight in IMC for which the pilot and/or the aeroplane is unable to comply with the requirements of IFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-236-B",
                "text": "Any flights cleared by ATC to operate in conditions less than VMC in which the pilot is required to remain clear of cloud and in sight with surface",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-236-C",
                "text": "A VFR procedure to enable an aeroplane to transit a control zone or area in IMC without compliance IFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-236-D",
                "text": "A VFR flight cleared by ATC to operate within a CTR in meteorological conditions below VMC",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-237",
            "text": "In the case of a piloted flying machine, it shall be deemed to be in flight:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-237-A",
                "text": "From the time the main wheels lose contact with earth until they gain contact again on landing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-237-B",
                "text": "From the time the aircraft first moves under its own power until the moment it comes to rest after landing",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-237-C",
                "text": "From the time the aircraft moves into the maneuvering area until it leaves the maneuvering area after landing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-237-D",
                "text": "From the time the engines are started until they are shut down after landing",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-238",
            "text": "How is night generally defined?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-238-A",
                "text": "The hours between the end of evening civil twilight and the beginning of morning civil twilight",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-238-B",
                "text": "The hours of darkness",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-238-C",
                "text": "The hours when the sun is below the horizon",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-238-D",
                "text": "From 30 minutes after sunset until 30 minutes after sunrise",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-239",
            "text": "Which of the following defines flight visibility?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-239-A",
                "text": "Visibility determined in flight not obscured by cloud, dust haze or precipitation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-239-B",
                "text": "The forward distance at which objects can be discerned in the air with reference to atmospheric conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-239-C",
                "text": "The forward visibility from the cockpit of an aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-239-D",
                "text": "The ability to determine in the air the distance and identify of unlighted objects by night",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-240",
            "text": "An ETA for an IFR flight refers to the following",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-240-A",
                "text": "None of the above",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-240-B",
                "text": "IAF",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-240-C",
                "text": "Touch down",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-240-D",
                "text": "FAF/FAP",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-241",
            "text": "PANS are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-241-A",
                "text": "Procedures for Air Navigation Standards",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-241-B",
                "text": "Procedures for Air Navigation Services",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-241-C",
                "text": "Practices for Air Navigation Standards",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-241-D",
                "text": "Practices for Air Navigation Services",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-242",
            "text": "Who decided whether to fly under IFR or VFR in VMC?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-242-A",
                "text": "The operator",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-242-B",
                "text": "The PIC",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-242-C",
                "text": "Either A or B",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-242-D",
                "text": "The ATS authority",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-243",
            "text": "An aircraft Captain should transmit special aircraft observations when he encounters",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-243-A",
                "text": "Severe turbulence or icing",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-243-B",
                "text": "All of this",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-243-C",
                "text": "Moderate turbulence, hail or CB clouds during supersonic or",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-243-D",
                "text": "Other conditions that the captain considers may effect the safety of other aircraft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-244",
            "text": "RPLs are used for flights with which of the following properties:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-244-A",
                "text": "VFR flights operated regularly on the same day of consecutive weeks, on at least 10 occasions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-244-B",
                "text": "IFR flights operated regularly on the same day of consecutive weeks, on at least 10 occasions",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-244-C",
                "text": "All flights operated regularly on the same day of consecutive weeks, on at least 10 occasions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-244-D",
                "text": "IFR and SVFR flights operated regularly on the same day of consecutive weeks, on at least 10 occasions",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-245",
            "text": "An airborne flight plan must be submitted:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-245-A",
                "text": "60 minutes before the intended point of entry into a CTA or advisory area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-245-B",
                "text": "10 minutes before the intended point of entry into a CTA or advisory area",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-245-C",
                "text": "15 minutes before the intended point of entry into a CTA or advisory area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-245-D",
                "text": "30 minutes before the intended point of entry into a CTA or advisory area",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-246",
            "text": "Aircraft shall not be flown in formation except:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-246-A",
                "text": "By pre-arrangement among the PICs taking part",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-246-B",
                "text": "By pre-arrangement among the PICs taking part and if the flight is to be in CAS in accordance with the conditions laid out by ICAO Annex 2 and supplemented by the national procedures",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-246-C",
                "text": "By pre-arrangement among the PICs taking part and if the flight is to be in CAS in accordance with the conditions laid out by ICAO Annex 2",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-246-D",
                "text": "By pre-arrangement among the pilots taking part",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-247",
            "text": "What is the meaning of MEHT?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-247-A",
                "text": "Minimum eye height",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-247-B",
                "text": "Minimum elevation height",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-247-C",
                "text": "Mean height over the threshold",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-247-D",
                "text": "Minimum eye height",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-248",
            "text": "A ˝PRECISION APPROACH˝ is a direct instrument approach",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-248-A",
                "text": "Using bearing, elevation and distance information, providing the pilot uses a flight director or an autopilot certified to a height below 200 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-248-B",
                "text": "Using bearing, elevation and distance information",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-248-C",
                "text": "Using at least one source of bearing information and one source of elevation or distance information",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-248-D",
                "text": "Carried out by a crew of at least two pilots trained with a specific working method",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-249",
            "text": "Runway visual range is reported when it falls below:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-249-A",
                "text": "1500 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-249-B",
                "text": "1000 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-249-C",
                "text": "800 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-249-D",
                "text": "1200 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-250",
            "text": "Based on operational considerations, a margin may be added to OCA of a non-precision approach. The result is then called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-250-A",
                "text": "MDA",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-250-B",
                "text": "DA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-250-C",
                "text": "DH",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-250-D",
                "text": "MDH",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-251",
            "text": "A radial is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-251-A",
                "text": "A magnetic bearing to a VOR station",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-251-B",
                "text": "A magnetic bearing to or from a VOR station, depending on whether the A/C is inbound or outbound to or from the VOR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-251-C",
                "text": "A magnetic bearing extending from a VOR station",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-251-D",
                "text": "A QDM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-252",
            "text": "The document that specifies the recommendations for instrument procedures is called…..",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-252-A",
                "text": "The convention of Chicago",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-252-B",
                "text": "The Air Pilot",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-252-C",
                "text": "PANS OPS Doc 8168",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-252-D",
                "text": "The Air Navigation Bulletin",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-253",
            "text": "The approach categories of aircraft are based upon:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-253-A",
                "text": "1.3 times the stalling speed in the landing configuration at maximum certified landing mass",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-253-B",
                "text": "1.3 times the stalling speed in the landing configuration at minimum certified landing mass",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-253-C",
                "text": "1.3 times the stalling speed in clean configuration at maximum certified landing mass",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-253-D",
                "text": "1.3 times the stalling speed in clean configuration at maximum certified landing mass",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-254",
            "text": "NOZ is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-254-A",
                "text": "Airspace of defined dimensions extending to either side of an ILS localizer course and/or MLS final approach track center line",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-254-B",
                "text": "Airspace of defined dimensions extending to either side of an ILS glide path course and/or MLS initial approach track center line",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-254-C",
                "text": "Airspace of defined dimensions extending to either side of an ILS glide path course and/or MLS final approach track center line",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-254-D",
                "text": "Airspace of defined dimensions extending to either side of an ILS localizer course and/or MLS initial approach track center line",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-255",
            "text": "What is a low visibility take-off?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-255-A",
                "text": "A take-off on a runway where the RVR is less than 125m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-255-B",
                "text": "A take-off on a runway where the RVR is less than 400 m",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-255-C",
                "text": "A take-off on a runway where the RVR is less than 200 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-255-D",
                "text": "A take-off on a runway where the RVR is less than 500 m",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-256",
            "text": "In the event of a delay of 30 minutes in excess of the estimated EOBT for a controlled flight, which of the following actions is required?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-256-A",
                "text": "None, because ATC will automatically amend the current flight plan",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-256-B",
                "text": "The flight plan should be amended or a new flight plan should be submitted and the old flight plan cancelled, whichever is applicable",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-256-C",
                "text": "A new flight plan must be submitted if required by ATC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-256-D",
                "text": "No action required because the air traffic system accommodates delays of up to 60 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-257",
            "text": "If an instrument departure procedure the track to be followed by the aeroplane is published, the pilot is expected:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-257-A",
                "text": "To ignore the wind and proceed on an heading equal to the track",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-257-B",
                "text": "To request clearance from ATC for applying a wind correction",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-257-C",
                "text": "To request from ATC different heading for wind correction",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-257-D",
                "text": "To correct for known wind to remain within the protected airspace",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-258",
            "text": "A four-engine aeroplane is about to take-off from an airport where poor weather conditions are prevailing. The closest accessible aerodrome is three flying hours away. The take-off minima to be observed at departure airfield are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-258-A",
                "text": "VH (visibility horizontal) greater or equal to VH required for landing on the runway to be used",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-258-B",
                "text": "Ceiling greater or equal to DH/MDH, and VH (horizontal visibility) greater or equal to VH required for landing, with an available instrument approach procedure",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-258-C",
                "text": "VH (visibility horizontal) greater or equal to VH required for landing and ceiling greater or equal to ceiling required for landing, with an available instrument approach procedure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-258-D",
                "text": "Ceiling greater or equal to DH/MDH, and VH (horizontal visibility) greater or equal to VH required for landing, with an available instrument approach procedure to be envisaged with one engine out",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-259",
            "text": "Turning departures provide track guidance within:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-259-A",
                "text": "5 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-259-B",
                "text": "20 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-259-C",
                "text": "10 km",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-259-D",
                "text": "15 km",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-260",
            "text": "Which of the following factors is least likely to be considered in the design of an instrument Departure Procedure?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-260-A",
                "text": "ATC requirements",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-260-B",
                "text": "Terrain",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-260-C",
                "text": "Airspace restrictions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-260-D",
                "text": "The transition altitude",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-261",
            "text": "In an instrument departure procedure the minimum obstacle clearance at the departure end of runway equals:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-261-A",
                "text": "0 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-261-B",
                "text": "394 ft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-261-C",
                "text": "35 ft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-261-D",
                "text": "50 ft",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-262",
            "text": "When can the required noise abatement procedure procedure be disregarded?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-262-A",
                "text": "If the RVR is less than 1500 m",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-262-B",
                "text": "Never, it must always be complied with",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-262-C",
                "text": "If there is work in progress on the aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-262-D",
                "text": "At PICs discretion where safety is an issue",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-263",
            "text": "As a standard rule, while establishing the instrument departure procedures, the procedures assumes that the aeroplane has a climb gradient of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-263-A",
                "text": "5% with all engines operating and a climb gradient margin respectively of 0.8% 0.9%, 1% with two, three and four engines, taking into account one engine inoperative",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-263-B",
                "text": "2.4% with two engines, 2.7% with three engines and 3% with four engines",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-263-C",
                "text": "2.4% with all engines operating and 1.5% with one engine inoperative",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-263-D",
                "text": "3.3% with all engines operating",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-264",
            "text": "Who is responsible for the development of the contingency procedures required to cover the case of engine failure during an instrument departure, which occurs after V1?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-264-A",
                "text": "ATC will provide radar vector for obstacle clearance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-264-B",
                "text": "The operator of the aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-264-C",
                "text": "The pilot in close co-operation with ATC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-264-D",
                "text": "The designer of the procedure (normally the State)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-265",
            "text": "The procedure design gradient (PDG) consists of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-265-A",
                "text": "2.7% OIS (obstacle identification surface) and 0.6% increasing obstacle clearance margin",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-265-B",
                "text": "2.3% OIS (obstacle identification surface) and 1% increasing obstacle clearance margin",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-265-C",
                "text": "2.5% OIS (obstacle identification surface) and 0.8% increasing obstacle clearance margin",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-265-D",
                "text": "3% OIS (obstacle identification surface)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-266",
            "text": "For an instrument departure (SID) what is the procedure design gradient (PDG)?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-266-A",
                "text": "2.5%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-266-B",
                "text": "3.3%",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-266-C",
                "text": "5%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-266-D",
                "text": "3.5%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-267",
            "text": "We can distinguish two types of departure routes. During a straight departure the initial departure track is within",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-267-A",
                "text": "5˚ of the alignment of the runway center-line",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-267-B",
                "text": "25˚ of the alignment of the runway center-line",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-267-C",
                "text": "10˚ of the alignment of the runway center-line",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-267-D",
                "text": "15˚ of the alignment of the runway center-line",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-268",
            "text": "What is the action should be taken if contact is lost with the aerodrome on the downwind leg?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-268-A",
                "text": "Maintain your circling altitude and turn towards the aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-268-B",
                "text": "Request an amended clearance",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-268-C",
                "text": "Initiate a missed approach",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-268-D",
                "text": "Descend to OCL/ACH and in the hope that the visibility is better at lower altitude",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-269",
            "text": "The optimum descent gradient in the final approach should not exceed:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-269-A",
                "text": "6.5 percent",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-269-B",
                "text": "3 percent",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-269-C",
                "text": "5 percent",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-269-D",
                "text": "7.5 percent",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-270",
            "text": "Which of the following correctly defines the NOZ for parallel runway operations",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-270-A",
                "text": "The NOZ extends from runway threshold to the point where aircraft are normally established on the localizer",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-270-B",
                "text": "Both A and B are correct",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-270-C",
                "text": "The NOZ is the airspace in the vicinity of the control tower where ILS operations are conducted",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-270-D",
                "text": "The NOZ is the aerodrome area where movement of aircraft does not interfere with landing operations",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-271",
            "text": "For an ASR, within 40 nm of the radar, fix tolerance is assumed to be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-271-A",
                "text": "+- 1.5km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-271-B",
                "text": "+- 3.1km",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-271-C",
                "text": "+- 1.5nm",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-271-D",
                "text": "+- 3.1nm",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-272",
            "text": "When constructing a turning missed approach the pilot pilot reaction taken into account is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-272-A",
                "text": "0-3 seconds",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-272-B",
                "text": "3 seconds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-272-C",
                "text": "0-5 seconds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-272-D",
                "text": "3-5 seconds",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-273",
            "text": "The maximum angle of bank to be used in a holding pattern is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-273-A",
                "text": "15˚",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-273-B",
                "text": "25˚",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-273-C",
                "text": "30˚",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-273-D",
                "text": "35˚",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-274",
            "text": "What is the meaning of ATCRU?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-274-A",
                "text": "Air traffic control",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-274-B",
                "text": "Air traffic control rescue unit",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-274-C",
                "text": "Air traffic control radar unit",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-274-D",
                "text": "Air traffic control runway unit",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-275",
            "text": "The wake turbulence category - heavy – is applied to aircraft of MTOW:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-275-A",
                "text": "More than 136.000 lbs.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-275-B",
                "text": "126.000 lbs. or more",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-275-C",
                "text": "136.000 kg or more",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-275-D",
                "text": "40.000 lbs. or more",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-276",
            "text": "When ˝Secondary Radar˝ is used, an aircraft may be identified by one of the following procedures:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-276-A",
                "text": "To request pilot to switch from ON to STBY",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-276-B",
                "text": "Observation of compliance with an instruction to operate transponder from ON to STBT and back ON",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-276-C",
                "text": "To request pilot to set transponder on position OFF",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-276-D",
                "text": "To request pilot to set transponder on position ON",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-277",
            "text": "An Expected Approach Time (EAT) is given:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-277-A",
                "text": "For all flights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-277-B",
                "text": "On request",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-277-C",
                "text": "When an aircraft is instructed to hold",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-277-D",
                "text": "When the approach delay is longer than 20 minutes",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-278",
            "text": "The planned cruising speed for first leg or all of the cruising portion of the flight must be entered in the speed box of a light plan form. This speed is the",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-278-A",
                "text": "Indicated air speed (IAS)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-278-B",
                "text": "True airspeed (TAS)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-278-C",
                "text": "True airspeed at 65% power",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-278-D",
                "text": "Estimated Ground Speed (G/S)",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-279",
            "text": "In the event of a controlled flight inadvertently deviating from its flight plan. ATC must be informed when:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-279-A",
                "text": "ETA varies by +- 3%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-279-B",
                "text": "ETA varies by +-5 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-279-C",
                "text": "ETA varies by +-3 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-279-D",
                "text": "ETA varies by +- 5%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-280",
            "text": "A controlled flight is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-280-A",
                "text": "Any flight in C, D or E class airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-280-B",
                "text": "Any IFR flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-280-C",
                "text": "Any flight in controlled airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-280-D",
                "text": "Any flight which is subject to an ATC clearance",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-281",
            "text": "Whenever practicable, NOTAMs are distributed by:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-281-A",
                "text": "Printed brochure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-281-B",
                "text": "Fax",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-281-C",
                "text": "E-mail",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-281-D",
                "text": "AFTN",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-282",
            "text": "Geographical co-ordinates indicating latitude and longitude are expressed in terms of",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-282-A",
                "text": "GPS-84",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-282-B",
                "text": "WGS-94",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-282-C",
                "text": "GPS-94",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-282-D",
                "text": "WGS-84",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-283",
            "text": "Runway direction is indicated by two digits:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-283-A",
                "text": "The units are expressed in 10˚to the nearest 5˚of the true north",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-283-B",
                "text": "The units are expressed in 10˚to the nearest 10˚of the magnetic compass",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-283-C",
                "text": "The units are expressed in 10˚to the nearest 10˚of the true north",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-283-D",
                "text": "The units are expressed in 10˚to the nearest 5˚of the magnetic compass",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-284",
            "text": "The UAE Civil Aviation Regulations, Part II, Licensing Regulations establish Category Ratings for the following types of aircraft:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-284-A",
                "text": "Aeroplanes, helicopters and balloons",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-284-B",
                "text": "Aeroplanes only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-284-C",
                "text": "Military aircraft only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-284-D",
                "text": "Single and multiengine land aeroplane",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-285",
            "text": "You are a private pilot with a UAE license. Your date of birth is 1st April 1952 and you took class 2 medical on first day of April 1991. When does your medical expire?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-285-A",
                "text": "31st April 1991",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-285-B",
                "text": "1st April 1993",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-285-C",
                "text": "31st April 1992",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-285-D",
                "text": "30th April 1993",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-286",
            "text": "What is the specific fuel requirement for flight under VFR at night in ai airplane.",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-286-A",
                "text": "Enough to fly to the first point of intended landing and to fly after that for 30 minutes at normal cruising speed",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-286-B",
                "text": "Enough to complete the flight at normal cruising speed with adverse wind conditions",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-286-C",
                "text": "Enough to fly to the first point of intended landing and to fly after that for 60 minutes at normal cruising speed",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-286-D",
                "text": "Enough to fly to the first point of intended landing and to fly after that for 45 minutes at normal cruising speed",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-287",
            "text": "What does the anagram CAVOK denote in terms of visibility and cloud above aerodrome?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-287-A",
                "text": "5,000 feet horizontal and 5,000 feet vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-287-B",
                "text": "10 km horizontal and 5,000 feet vertical",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-287-C",
                "text": "10 km horizontal and 10,000 feet vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-287-D",
                "text": "50 km horizontal and 5,000 feet vertical",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-288",
            "text": "According to CAR PART IV a crew member shall not: (1) Commence a flight duty period with blood alcohol level in excess of 0-2 promille; (2) Consume alcohol during the flight duty period or whilst on standby and (3) Consume alcohol less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-288-A",
                "text": "10 hours prior to the specified reporting time for flight duty or the commencement of standby.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-288-B",
                "text": "8 hours prior to the specified reporting time for flight duty or the commencement of standby.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-288-C",
                "text": "4 hours prior to the specified reporting time for flight duty or the commencement of standby.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-288-D",
                "text": "12 hours prior to the specified reporting time for flight duty or the commencement of standby.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-289",
            "text": "Accident reports (written) must be submitted to the GCAA within:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-289-A",
                "text": "10 days after the accident",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-289-B",
                "text": "Immediately",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-289-C",
                "text": "7 days after the accident",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-289-D",
                "text": "3 days after the accident",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-290",
            "text": "With regard to the commencement and continuation of an instrument approach, the approach may be continued below DA/H or MDA/H and the landing may be completed provided that :",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-290-A",
                "text": "The aircraft is stable by 1.000 feet AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-290-B",
                "text": "The required visual reference is established at the DA/H or MDA/H and is maintained",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-290-C",
                "text": "The aircraft is stable by 200 feet agl",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-290-D",
                "text": "The captain is the pilot flying",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-291",
            "text": "No flight crew member may accept any assignment in excess of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-291-A",
                "text": "14 hours maximum duty time in any 48 hours consecutive hour period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-291-B",
                "text": "14 hours maximum duty time in any 24 consecutive hour period",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-291-C",
                "text": "12 hours maximum duty time in any 48 hours consecutive hour period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-291-D",
                "text": "12 hours maximum duty time in any 24 consecutive hour period",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-292",
            "text": "On takeoff, an aircraft with two or more engines that suffers an engine failure must be able to stop within the available accelerate stop distance (ASDA) or continue the takeoff and clear all obstacles along the net takeoff path by a vertical distance of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-292-A",
                "text": "35 feet",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-292-B",
                "text": "17 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-292-C",
                "text": "50 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-292-D",
                "text": "100 feet",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-293",
            "text": "After landing at a tower controlled airport when should pilot contact ground control?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-293-A",
                "text": "When advised by tower to do so",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-293-B",
                "text": "Without any delay",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-293-C",
                "text": "Prior turning off the runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-293-D",
                "text": "After reaching a taxiway that leads directly to the parking area",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-294",
            "text": "The commander or the pilot to whom conduct of the flight has been delegated may commence an instrument approach:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-294-A",
                "text": "Regardless of the reported RVR/Visibility but the approach shall not be continued beyond the Decision Altitude (DA) / Height (DH), if the reported RVR/Visibility is less than the applicable minima",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-294-B",
                "text": "Regardless of the reported RVR/Visibility but the approach shall not be continued beyond the inner marker or equivalent position if the reported RVR/Visibility is less than the applicable minima",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-294-C",
                "text": "Regardless of the reported RVR/Visibility but the approach shall not be continued beyond the outer marker or equivalent position if the reported RVR/Visibility is less than the applicable minima",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-294-D",
                "text": "Regardless of the reported RVR/Visibility but the approach shall not be continued beyond the initial approach fix, if the reported RVR/Visibility is less than the applicable minima",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-295",
            "text": "Flight time as a member of a one-or-two pilot crew if that crew members total time in all commercial flying should not exceed",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-295-A",
                "text": "200 hours in any period of 90 consecutive days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-295-B",
                "text": "100 hours in any period of 30 consecutive days or 1.000 hours in any calendar years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-295-C",
                "text": "300 hours in any period of 100 consecutive days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-295-D",
                "text": "100 hours in any period of 28 consecutive days or 900 hours in any calendar years",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-296",
            "text": "Flight time as a member of a one-or-two pilot crew if that crew members total time in all commercial flying should not exceed",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-296-A",
                "text": "300 hours in any period of 90 consecutive days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-296-B",
                "text": "1000 hours in any period of 30 consecutive days or 9000 hours in any calendar years",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-296-C",
                "text": "300 hours in any period of 100 consecutive days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-296-D",
                "text": "90 hours in any period of 30 consecutive days or 1000 hours in any calendar years",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-297",
            "text": "When on ground you see a flashing green light it indicates:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-297-A",
                "text": "Clear to taxi",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-297-B",
                "text": "Cleared to take off",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-297-C",
                "text": "Hold position",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-297-D",
                "text": "Clear to start engine",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-298",
            "text": "When would a pilot be required to submit a detailed report of an emergency which caused the pilot to deviate from an ATC clearance when requested?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-298-A",
                "text": "Within 7 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-298-B",
                "text": "Within 48 hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-298-C",
                "text": "When requested",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-298-D",
                "text": "immediately",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-299",
            "text": "The maximum cumulative duty hours for aircrew of an aeroplane shall not exceed",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-299-A",
                "text": "70 hours in one week, but may be increased to 80 hours, when rostered duty covering a series of duty periods, once commenced, is subject to unforeseen delays",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-299-B",
                "text": "55 hours in one week, but may be increased to 60 hours, when rostered duty covering a series of duty periods, once commenced, is subject to unforeseen delays",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-299-C",
                "text": "95 hours in any consecutive 4 weeks",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-299-D",
                "text": "95 hours in one week, but may be increased to 100 hours, when rostered duty covering a series of duty periods, once commenced, is subject to unforeseen delays",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-300",
            "text": "What does the anagram VFR stand for?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-300-A",
                "text": "Visual Flight Rules",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-300-B",
                "text": "Visual Flight Regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-300-C",
                "text": "Visual Flight Recommendations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-300-D",
                "text": "Visual Meteorological Conditions",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-301",
            "text": "Do you require an ATC clearance to enter a known danger are?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-301-A",
                "text": "A pilot can enter at his own discretion",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-301-B",
                "text": "Always at initial contact",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-301-C",
                "text": "Yes, but only when the danger area is active",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-301-D",
                "text": "Yes, all danger areas are within controlled airspace",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-302",
            "text": "The period of validity of an Operator Proficiency Check (OPC) shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-302-A",
                "text": "365 days until the remainder of the month",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-302-B",
                "text": "6 calendar months in addition to the remainder of the month of issue",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-302-C",
                "text": "6 calendar months to the day",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-302-D",
                "text": "12 calendar months in addition to the remainder of the month of issue",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-303",
            "text": "A crew member shall not commence a flight duty period with a blood alcohol level in excess of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-303-A",
                "text": "2.0 promille",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-303-B",
                "text": "0.12 promille",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-303-C",
                "text": "0.8 promille",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-303-D",
                "text": "0.2 promille",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-304",
            "text": "An operator will not conduct low visibility operations unless:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-304-A",
                "text": "The operations are approved by the Authority (GCAA)",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-304-B",
                "text": "The pilot in command has received a briefing on the conduct of low visibility operations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-304-C",
                "text": "The flight crew consists of at least one pilot qualified to conduct low visibility operations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-304-D",
                "text": "The operations are approved by the government",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-305",
            "text": "A pilot license issued by the GCAA shall not permit the holder of such license to act either as pilot-in-command or as co-pilot of an aeroplane, unless the holder has received a type rating in the applicable type of aeroplane. Type ratings shall be issued for:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-305-A",
                "text": "Any type of aircraft whenever considered necessary by the GCAA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-305-B",
                "text": "All of the above",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-305-C",
                "text": "Each type of aircraft certified for operation with a minimum crew of at least two pilots",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-305-D",
                "text": "All types of helicopters",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-306",
            "text": "No person shall act as an operating crew member of the flight crew of an aircraft if at the beginning of the flight the aggregate of all his previous flight time exceeds",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-306-A",
                "text": "100 hrs within 30 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-306-B",
                "text": "90 hrs per month / 300 hrs in a 3 month period",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-306-C",
                "text": "100 hrs within 28 days",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-306-D",
                "text": "30 hrs with one week",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-307",
            "text": "An operator shall ensure that special VFR flights are not commencement when the visibility is less than?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-307-A",
                "text": "500 meters ground visibility",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-307-B",
                "text": "3 km and not otherwise conducted when the visibility is less than 1.5 km",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-307-C",
                "text": "1500 meters ground visibility",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-307-D",
                "text": "5000 meters (5 km) flight visibility",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-308",
            "text": "No person may act as pilot-in-command of a multi-engine aircraft carrying passengers unless he has experience of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-308-A",
                "text": "30 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-308-B",
                "text": "Completed a proficiency check with a rated pilot",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-308-C",
                "text": "10 hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-308-D",
                "text": "50 hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-309",
            "text": "The UAE Aeronautical Information Publication (AIP) is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-309-A",
                "text": "Advisory in nature",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-309-B",
                "text": "Regulatory in nature",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-309-C",
                "text": "A recommendation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-309-D",
                "text": "Mandatory in nature",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-310",
            "text": "The requirement for an Emergency Locator Transmitters (ELT) to be installed in an aircraft relates to",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-310-A",
                "text": "Training aircraft only",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-310-B",
                "text": "Not required in any aircraft registered in the UAE",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-310-C",
                "text": "All civil aircraft in the UAE",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-310-D",
                "text": "Military aircraft only",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-311",
            "text": "In the event of interception of an aircraft the intercepting aircraft will position itself",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-311-A",
                "text": "To the left in front of the aircraft being intercepted",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-311-B",
                "text": "Immediately in front of the aircraft being intercepted",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-311-C",
                "text": "Behind the aircraft and blinking",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-311-D",
                "text": "To the right and in front of the aircraft being intercepted",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-312",
            "text": "When flying over the high seas, UAE registered aircraft will comply with the convention on international civil aviation rules annex:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-312-A",
                "text": "3",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-312-B",
                "text": "2",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-312-C",
                "text": "1",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-312-D",
                "text": "5",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-313",
            "text": "Except when necessary for take-off or landing, or when/as authorized by the GCAA, no person shall operate an aircraft under VFR below the following heights:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-313-A",
                "text": "A height allowing, if an engine fails, an emergency landing without hazard to persons or property on the surface 3000ft vertically and 1500 ft horizontally from an object",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-313-B",
                "text": "2000 ft over any congested area of a city, town or settlement",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-313-C",
                "text": "500 ft over any congested area of a city, town or settlement",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-313-D",
                "text": "1000 ft over any congested area of a city, town or settlement",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-314",
            "text": "If a pilot deviates from a rule or clearance in the interest of safety, the pilot shall?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-314-A",
                "text": "Regulation – Submit a written report to the GCAA within twenty-four (24) hours. Clearance – Upon the request of ATC or the GCAA, submit a detailed written report within forty-eight (48) hours to the GCAA",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-314-B",
                "text": "Regulation – Submit a written report to the GCAA within forty eight (48) hours. Clearance – Upon the request of ATC or the GCAA, submit a detailed written report within forty-eight (48) hours to the GCAA",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-314-C",
                "text": "No action is needed",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-314-D",
                "text": "Regulation – Submit a written report to the GCAA within forty eight (48) hours. Clearance – Upon the request of ATC or the GCAA, submit a detailed written report within twenty four (24) hours to the GCAA",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-315",
            "text": "What is the minimum required dual flight instrument instruction received in airplane from an authorized flight instructor to be eligible for a UAE instrument rating?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-315-A",
                "text": "Not less than six hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-315-B",
                "text": "Not less than twenty hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-315-C",
                "text": "Not less than twelve hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-315-D",
                "text": "Not less than ten hours",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-316",
            "text": "How many hours of instrument time is a pilot required to do before being eligible for a UAE instrument rating?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-316-A",
                "text": "Ten (10) hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-316-B",
                "text": "Twenty (20) hours",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-316-C",
                "text": "Forty (40) hours",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-316-D",
                "text": "Eighty (80) hours",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-317",
            "text": "What is the requirement for a pilot to operate a UAE registered aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-317-A",
                "text": "Needs a license which can be overdue up to 10 days",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-317-B",
                "text": "Needs only a foreign pilot license",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-317-C",
                "text": "A valid pilot license issued to him/her under these regulations or a validation of his/her foreign license",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-317-D",
                "text": "Need only a UAE pilot license",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-318",
            "text": "What class of medical must a holder of a UAE CPL have in his possession to perform duties of a pilot in commercial operations?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-318-A",
                "text": "Class 2 – issued in compliance with the provisions of these regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-318-B",
                "text": "Class 3 – issued in compliance with the provisions of these regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-318-C",
                "text": "Class 4 – issued in compliance with the provisions of these regulations",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-318-D",
                "text": "Class 1 - Issued in compliance with the provisions of these regulations",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-319",
            "text": "What is the total number of seats allowable before it is necessary to have a co-pilot?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-319-A",
                "text": "15",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-319-B",
                "text": "40",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-319-C",
                "text": "30",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-319-D",
                "text": "20",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-320",
            "text": "Under part IV to serve as a second in command, what are the minimum requirements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-320-A",
                "text": "PPL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-320-B",
                "text": "ATPL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-320-C",
                "text": "Only a valid medical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-320-D",
                "text": "CPL",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-321",
            "text": "Which of the following is true regarding overtaking aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-321-A",
                "text": "The overtaking aircraft shall keep out of the way of the way of the other aircraft by altering its heading to the left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-321-B",
                "text": "The overtaking aircraft shall keep in of the way of the way of the other aircraft by altering its heading to the left",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-321-C",
                "text": "The overtaking aircraft shall keep out of the way of the way of the other aircraft by altering its heading to the right",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-321-D",
                "text": "The overtaking aircraft shall keep in of the way of the way of the other aircraft by altering its heading to the right",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-322",
            "text": "Each person operating a civil aircraft on the UAE registry shall comply with the GCAA rules of the air except?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-322-A",
                "text": "……… there is no exception",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-322-B",
                "text": "…….. To the extend they do not conflict with the rules published by the state having jurisdiction over the territory over-flown",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-322-C",
                "text": "……… when the flight safety is in danger",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-322-D",
                "text": "……… to the extend they do not conflict with the rules published in the airports AOI",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-323",
            "text": "UAE registered aircraft will comply with the convention on international civil aviation rules Annex 2",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-323-A",
                "text": "Operating a civil aircraft of the United Arab Emirates over lakes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-323-B",
                "text": "Operating a civil aircraft of the United Arab Emirates over land",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-323-C",
                "text": "There is no annex 2",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-323-D",
                "text": "Operating a civil aircraft of the UAE over the high seas",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-324",
            "text": "What is the highest level VFR traffic can cruise at in UAE?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-324-A",
                "text": "Below 12,500 ft AMSL …….no aircraft shall plan to operate an aircraft under VFR at or above 12,500 ft AMSL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-324-B",
                "text": "Below 14,500 ft AMSL …….no aircraft shall plan to operate an aircraft under VFR at or above 14,500 ft AMSL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-324-C",
                "text": "Below 2,500 ft AMSL …….no aircraft shall plan to operate an aircraft under VFR at or above 2,500 ft AMSL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-324-D",
                "text": "Below 11,500 ft AMSL …….no aircraft shall plan to operate an aircraft under VFR at or above 11,500 ft AMSL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-325",
            "text": "Can a pilot be authorized to act as pilot in command in VFR night ops without an instrument rating?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-325-A",
                "text": "Yes – providing the pilot in command receives only clearance from ATC to operate in controlled airspace….",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-325-B",
                "text": "No",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-325-C",
                "text": "Yes – providing the pilot knows VFR rules Yes – providing the pilot in command receives only clearance from ATC to operate in controlled",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-325-D",
                "text": "airspace….; the operation involves a bona fide casualty evacuation and the flight crew is instrument rated and current; for night currency training conducted within controlled airspace or within a designated training area approved by the GCAA",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-326",
            "text": "Is the GCAA permitted to waive any rule of Part III – Rules of the Air?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-326-A",
                "text": "No",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-326-B",
                "text": "No, only rule of Part IV.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-326-C",
                "text": "Yes – without any restriction",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-326-D",
                "text": "Yes - …. The GCAA may issue a waiver authorizing deviations from any rules outlined herein if it finds that the proposed operation can be safety conducted under the terms of the waiver",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-327",
            "text": "If a multi engine civil aircraft is to takeoff with inoperative instruments which document must be carried on board?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-327-A",
                "text": "No specific documents are required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-327-B",
                "text": "GCAA Approved MEL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-327-C",
                "text": "Pilot logbook",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-327-D",
                "text": "Dispatch Deviation Guide",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-328",
            "text": "Who is responsible for keeping individual crew members operations manuals updates as changes and additions are furnished?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-328-A",
                "text": "The GCAA authorities",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-328-B",
                "text": "The state",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-328-C",
                "text": "No specific documents are required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-328-D",
                "text": "Each holder of an Operations Manual, or appropriate parts of it, shall keep it up to date with the amendments or revisions supplied by the Operator",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-329",
            "text": "What quantity of first aid oxygen is required on board an aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-329-A",
                "text": "…sufficient for the remainder of the flight after cabin depressurization when the cabin pressure altitude exceeds 8000 ft but does not exceed 12000 ft, for at least 2% of the passengers, but in no case less than one person",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-329-B",
                "text": "…sufficient for the remainder of the flight after cabin depressurization when the cabin pressure altitude exceeds 8000 ft but does not exceed 15000 ft, for at least 2% of the passengers, but in no case less than one person",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-329-C",
                "text": "…sufficient for the remainder of the flight after cabin depressurization when the cabin pressure altitude exceeds 6000 ft but does not exceed 15000 ft, for at least 2% of the passengers, but in no case less than one person",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-329-D",
                "text": "…sufficient for the remainder of the flight after cabin depressurization when the cabin pressure altitude exceeds 10000 ft but does not exceed 15000 ft, for at least 2% of the passengers, but in no case less than one person",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-330",
            "text": "If thunderstorms or potentially dangerous weather on a proposed route for a flight carrying passengers under Part IV regulations, what equipment must be carried on board?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-330-A",
                "text": "…. Predictive windshear system",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-330-B",
                "text": "…. Airborne weather radar equipment….",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-330-C",
                "text": "….. Two coupled autopilots",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-330-D",
                "text": "….. transponder",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-331",
            "text": "Under Part IV, what are the weather minimums required for an airport to be used as an alternate on an IFR flight plan?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-331-A",
                "text": "…. When the appropriate forecasts and reports indicate that during a period commencing 1.5 hours before and ending 1.5 hours after the ETA, the weather conditions will be at or above the applicable landing minima for that airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-331-B",
                "text": "…. When the appropriate forecasts and reports indicate that during a period commencing 2 hours before and ending 2 hours after the ETA, the weather conditions will be at or above the applicable landing minima for that airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-331-C",
                "text": "…. When the appropriate forecasts and reports indicate that during a period commencing 3 hours before and ending 3 hours after the ETA, the weather conditions will be at or above the applicable landing minima for that airport",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-331-D",
                "text": "…. When the appropriate forecasts and reports indicate that during a period commencing 1 hours before and ending 1 hours after the ETA, the weather conditions will be at or above the applicable landing minima for that airport",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-332",
            "text": "What are the maximum flight duty times for pilots?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-332-A",
                "text": "90 hours in 28 consecutive days; 900 hours in 12 months; Maximum in a 24 hours period: 2 crew: 14 hours duty – 10 hours flight, 1 crew: 11 hours duty – 8 hours flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-332-B",
                "text": "100 hours in 30 consecutive days; 900 hours in 12 months; Maximum in a 24 hours period: 2 crew: 14 hours duty – 10 hours flight, 1 crew: 11 hours duty – 8 hours flight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-332-C",
                "text": "100 hours in 28 consecutive days; 900 hours in 12 months; Maximum in a 24 hours period: 2 crew: 14 hours duty – 10 hours flight, 1 crew: 11 hours duty – 8 hours flight",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-332-D",
                "text": "85 hours in 28 consecutive days; 900 hours in 12 months; Maximum in a 24 hours period: 2 crew: 14 hours duty – 10 hours flight, 1 crew: 11 hours duty – 8 hours flight",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-333",
            "text": "Take-off weight shall not exceed?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-333-A",
                "text": "…. There is no limitation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-333-B",
                "text": "…. The maximum take-off mass specified in the Aeroplane Flight Manual for the pressure altitude and the ambient temperature at the aerodrome at which the take-off is to be made.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-333-C",
                "text": "…. The maximum zero-fuel mass specified in the Aeroplane Flight Manual for the pressure altitude and the ambient temperature at the aerodrome at which the take-off is to be made.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-333-D",
                "text": "…. The maximum landing mass specified in the Aeroplane Flight Manual for the pressure altitude and the ambient temperature at the aerodrome at which the take-off is to be made.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-334",
            "text": "Enroute with one engine inoperative the aeroplane must be able to?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-334-A",
                "text": "…. The net flight path must have a positive gradient of 800 ft above the aerodrome where the landing is assumed to be made after the engine failure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-334-B",
                "text": "…. The net flight path must have a positive gradient of 1500 ft above the aerodrome where the landing is assumed to be made after the engine failure",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-334-C",
                "text": "…. The net flight path must have a positive gradient of 1000 ft above the aerodrome where the landing is assumed to be made after the engine failure",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-334-D",
                "text": "…. The net flight path must have a positive gradient of 300 ft above the aerodrome where the landing is assumed to be made after the engine failure",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-335",
            "text": "A person may take-off a multi-engine civil aircraft with an operable instruments or equipment installed only if;",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-335-A",
                "text": "A GCAA approved minimum equipment list exists for the aircraft",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-335-B",
                "text": "There is no limitation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-335-C",
                "text": "Minimum equipment list not required if aircraft in airworthy condition",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-335-D",
                "text": "If approved by aircraft mechanic to fly",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-336",
            "text": "IFR and VFR in class G airspace-service available",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-336-A",
                "text": "Radar coverage",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-336-B",
                "text": "Flight information service for VFR advisory service for IFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-336-C",
                "text": "Flight information services",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-336-D",
                "text": "Full advisory service for IFR and none for VFR",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-337",
            "text": "Pilot-in-command cannot enter",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-337-A",
                "text": "Restricted area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-337-B",
                "text": "Danger area",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-337-C",
                "text": "High sea territory",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-337-D",
                "text": "Prohibited area",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-338",
            "text": "Entering UAE airspace without clearance, likely to be intercepted by fighter. How would it indicate that you are to follow:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-338-A",
                "text": "Ahead and to the left, rocking wings",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-338-B",
                "text": "Turning on the beacon",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-338-C",
                "text": "Below your aircraft",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-338-D",
                "text": "Rapid departure to the left",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-339",
            "text": "Flight visibility for VFR in class E airspace at or above 10 000 ft",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-339-A",
                "text": "8 km., 1500 meters horizontal, 300 meters vertical",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-339-B",
                "text": "8 km., 1500 meters horizontal, 600 meters vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-339-C",
                "text": "8 miles., 1500 meters horizontal, 300 meters vertical",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-339-D",
                "text": "5 km., 1500 meters horizontal, 300 meters vertical",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-340",
            "text": "No person may act as a pilot-in-command of a UAE registered aircraft unless he has in his personal possession",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-340-A",
                "text": "EASA License",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-340-B",
                "text": "U.S License",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-340-C",
                "text": "U.A.E. License",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-340-D",
                "text": "British License",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-341",
            "text": "Alcohol – How long must have elapsed since the last consumption of alcohol",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-341-A",
                "text": "4 hrs",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-341-B",
                "text": "8 hrs.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-341-C",
                "text": "12 hrs.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-341-D",
                "text": "10 hrs.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-342",
            "text": "Where can you find information regarding flight crew licensing requirements?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-342-A",
                "text": "Aeronautical Information Publication (AIP)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-342-B",
                "text": "Pilot Operating Handbook",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-342-C",
                "text": "Section III Aviation Regulation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-342-D",
                "text": "Section II Civil Aviation Regulation",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-343",
            "text": "What is the maximum permissible speed below 10,000 ft in UAE FIR?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-343-A",
                "text": "250 kts",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-343-B",
                "text": "230 kts",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-343-C",
                "text": "270 kts",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-343-D",
                "text": "250 mph",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-344",
            "text": "Commercial pilot maximum flying time allowed in 24 consecutive hours",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-344-A",
                "text": "6 hours for a flight crew consisting one pilot",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-344-B",
                "text": "8 hours for a flight crew consisting one pilot",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-344-C",
                "text": "10 hours for a flight crew consisting two pilot",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-344-D",
                "text": "All the above are correct",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-345",
            "text": "Are there provisions in place for the flexibility of an OPC?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-345-A",
                "text": "An OPC can be conducted three (3) months before or one month after its due date.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-345-B",
                "text": "An OPC can be conducted two (2) months before or one month after its due date.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-345-C",
                "text": "An OPC can be conducted four (4) months before or one month after its due date.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-345-D",
                "text": "An OPC can be conducted one (1) months before or one month after its due date.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-346",
            "text": "How often must a pilot perform an Instrument Proficiency Check (IPC)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-346-A",
                "text": "Every twenty-four months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-346-B",
                "text": "Every twelve months",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-346-C",
                "text": "Every ten months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-346-D",
                "text": "Every six months",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-347",
            "text": "How long does an instrument rating valid after completing an IPC with no further flights?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-347-A",
                "text": "18 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-347-B",
                "text": "12 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-347-C",
                "text": "24 months",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-347-D",
                "text": "6 months",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-348",
            "text": "Is it mandatory for an aircraft operated under Part IV to have an operable 4096 transponder?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-348-A",
                "text": "Yes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-348-B",
                "text": "No",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-348-C",
                "text": "Only at night",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-348-D",
                "text": "Only during daytime",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-349",
            "text": "What are the high seas?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-349-A",
                "text": "The open waters of a lake",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-349-B",
                "text": "The open waters close to land",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-349-C",
                "text": "The open waters of an ocean or a sea beyond the limits of the territorial jurisdiction of a country",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-349-D",
                "text": "The open waters of an ocean or a lake",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-350",
            "text": "Territory means?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-350-A",
                "text": "The land including the islands and internal and territorial waters over which a State party exercises sovereignty",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-350-B",
                "text": "The land including only islands",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-350-C",
                "text": "The land including territorial waters",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-350-D",
                "text": "The open waters of an ocean or a sea beyond the limits of the territorial jurisdiction of a country",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-OPS-351",
            "text": "A person who wants to take over control of an aircraft or committed unlawful actions on board an aircraft, what criminal charges will this person face?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-351-A",
                "text": "Air piracy, unlawful interference, high jacking",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-351-B",
                "text": "Air piracy",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-351-C",
                "text": "No charges will be faced",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-OPS-351-D",
                "text": "Only high jacking",
                "correct": false
              }
            }
          ]
        }
      ]
    },
    {
      "type": "Unit",
      "id": "f5d582b75f013331de84d3e540962039",
      "name": "Procedures for Air Navigation Services",
      "children": [
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-001",
            "text": "Light signals for aerodrome traffic A series of red flashes from aerodrome control directed towards an aircraft in flight means:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-001-A",
                "text": "Aerodrome temporarily closed, continue circling",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-001-B",
                "text": "Give way to other aircraft in emergency.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-001-C",
                "text": "Continue circling and wait for further instruction.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-001-D",
                "text": "Aerodrome unsafe, do not land.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-002",
            "text": "Approach Procedures -Arrival and Approach Segments The minimum obstacle clearance in the primary area of the initial approach segment for an instrument approach procedure is at least:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-002-A",
                "text": "300m (984 ft).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-002-B",
                "text": "600m (1968 ft).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-002-C",
                "text": "150m (492 ft).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-002-D",
                "text": "450m (1476 ft).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-003",
            "text": "Approach procedures - Arrival and Approach Segments? Intermediate approach segment What is the minimum obstacle clearance requirement at the end of the primary area of the intermediate approach segment in an instrument approach procedure?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-003-A",
                "text": "450m (1476 ft) reducing to 150 m (492 ft).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-003-B",
                "text": "300 m (984 ft) reducing to 0 m.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-003-C",
                "text": "300m (984 ft) reducing to 150 m (492 ft).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-003-D",
                "text": "150m (492 ft) reducing to 0 m.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-004",
            "text": "Approach procedures - Arrival and approach segments In an instrument approach procedure, the segment in which alignment and descent for landing are made is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-004-A",
                "text": "Initial approach segment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-004-B",
                "text": "Intermediate approach segment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-004-C",
                "text": "Arrival segment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-004-D",
                "text": "Final approach segment.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-005",
            "text": "Approach procedures - Final approach segment In a precision approach (ILS), the final approach segment begins at the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-005-A",
                "text": "MAP.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-005-B",
                "text": "IF.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-005-C",
                "text": "FAP.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-005-D",
                "text": "FAF.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-006",
            "text": "Approach procedures - final approach segment In a precision approach (ILS), generally glide path interception occurs at heights above runway elevation from:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-006-A",
                "text": "300m (984 ft) to 600m (1968 ft).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-006-B",
                "text": "150m (492 ft) to 300m (984 ft).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-006-C",
                "text": "300m (984 ft) to 900m (2955 ft).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-006-D",
                "text": "150m (492 ft) to 900m (2955 ft).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-007",
            "text": "Approach Procedures - Missed Approach - Phases A complete missed approach procedure consists of the following phases?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-007-A",
                "text": "Arrival, intermediate and final.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-007-B",
                "text": "Initial, intermediate and final.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-007-C",
                "text": "Arrival, initial, intermediate and final.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-007-D",
                "text": "Initial and final.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-008",
            "text": "Approach procedures - missed approach climb Normally the missed approach procedures are based on a nominal missed approach climb gradient of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-008-A",
                "text": "5%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-008-B",
                "text": "3,30%",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-008-C",
                "text": "2,50%",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-008-D",
                "text": "2%",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-009",
            "text": "Circling approach One of the conditions to descent below the MDA on a circling approach is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-009-A",
                "text": "The required visual references have been established and can be maintained",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-009-B",
                "text": "The landing runway and an alternative landing possibility (runway) are in sight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-009-C",
                "text": "The horizontal Visibility is at least 5 NM and the Ceiling is 1500 ft or higher.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-009-D",
                "text": "The Ceiling is 1500 ft or higher.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-010",
            "text": "Approach Procedures - Circling The term used to describe the visual phase of flight after completing an instrument approach, to bring an aircraft into position for landing on a runway which is not suitably located for straight-in approach, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-010-A",
                "text": "Contact approach.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-010-B",
                "text": "Aerodrome traffic pattern.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-010-C",
                "text": "Visual manoeuvring (circling).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-010-D",
                "text": "Visual approach.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-011",
            "text": "Approach Procedures - Circling It is permissible to eliminate from consideration a particular sector where a prominent obstacle exists in the visual manoeuvring (circling) area outside the final approach and missed approach area. When this option is exercised, the published procedure:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-011-A",
                "text": "Permits circling only in VMC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-011-B",
                "text": "Prohibits circling within the total sector in which the obstacle exists.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-011-C",
                "text": "Recommends not to perform circling within the total sector in which the obstacle exists",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-011-D",
                "text": "Prohibits the circling approach to the affected runway.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-012",
            "text": "Approach Procedures - Visual Flight Manoeuvre - Circling A circling approach is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-012-A",
                "text": "A visual flight manoeuvre to be performed when radar vectoring is available",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-012-B",
                "text": "A visual manoeuvre to be conducted only in IMC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-012-C",
                "text": "A visual flight manoeuvre keeping the runway environment in sight while at MDA/H",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-012-D",
                "text": "A visual flight manoeuvre that may be carried out as long as visual ground contact can be maintained.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-013",
            "text": "Approach procedures - Circling The visual contact with the runway is lost on the down-wind leg, while circling to land following an instrument approach. You have to initiate a go-around:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-013-A",
                "text": "Make an initial climbing turn towards the runway and initiate the missed approach.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-013-B",
                "text": "If you have other visual cues of the aerodrome environment, continue with visual ground contact.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-013-C",
                "text": "Make a turn of 90 degrees towards the runway and try to regain visual contact.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-013-D",
                "text": "Turn towards the runway, maintain altitude and request ATC instructions.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-014",
            "text": "Holding procedures If for any reasons a pilot is unable to conform to the procedures for normal conditions laid down for any particular holding pattern, he should:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-014-A",
                "text": "execute a non-standard holding pattern in accordance with the performance of his aeroplane",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-014-B",
                "text": "advise ATC as early as possible.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-014-C",
                "text": "follow the radio communication failure procedure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-014-D",
                "text": "remain within the protected area, but may deviate from the prescribed holding.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-015",
            "text": "Holding procedures (entry) The published procedure is: All turns to the right, 1 minute outbound, inbound Magnetic Track 052°. You are approaching the fix on Magnetic Track 232° (no wind). Select the appropriate entry procedure:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-015-A",
                "text": "direct only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-015-B",
                "text": "either offset or parallel",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-015-C",
                "text": "offset only.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-015-D",
                "text": "parallel or direct.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-016",
            "text": "Holding procedures (outbound time) The outbound time in a holding pattern at 14000 ft or below in still air conditions is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-016-A",
                "text": "1 minute.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-016-B",
                "text": "30 seconds.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-016-C",
                "text": "2 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-016-D",
                "text": "1,5 minutes.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-017",
            "text": "Holding procedures (outbound time) The outbound time in a holding pattern above 14000 ft in still air conditions is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-017-A",
                "text": "2 minutes 30 seconds.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-017-B",
                "text": "2 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-017-C",
                "text": "1 minute 30 seconds.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-017-D",
                "text": "1 minute.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-018",
            "text": "Holding procedures - Offset Entry Above 14000 ft in still air, the outbound time on a 30° offset track is limited to:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-018-A",
                "text": "3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-018-B",
                "text": "2 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-018-C",
                "text": "1 minute 30 seconds.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-018-D",
                "text": "1 minute.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-019",
            "text": "Holding Procedures - Entry Related to the three entry sectors in a holding pattern, there is a zone of flexibility on either side of the sectors boundaries of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-019-A",
                "text": "20°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-019-B",
                "text": "5°.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-019-C",
                "text": "15°.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-019-D",
                "text": "10°.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-020",
            "text": "Holding Procedures - Buffer Area How far beyond the boundary of the holding area extends the buffer area?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-020-A",
                "text": "3 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-020-B",
                "text": "3 km.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-020-C",
                "text": "5 NM.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-020-D",
                "text": "5 km.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-021",
            "text": "Altimeter setting procedures - Transition Altitude The transition altitude of an aerodrome shall be as low as possible but normally not less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-021-A",
                "text": "2500 ft AGL.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-021-B",
                "text": "1500 ft AGL.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-021-C",
                "text": "3000 ft AGL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-021-D",
                "text": "1000 ft AGL.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-022",
            "text": "Altimeter setting procedures - Transition Level The vertical position of an aircraft at or above the transition level with altimeter setting 1013.2 hPa has to be reported:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-022-A",
                "text": "as Height.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-022-B",
                "text": "as Flight Level.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-022-C",
                "text": "According to pilot's choice.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-022-D",
                "text": "as Altitude.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-023",
            "text": "Altimeter setting procedures - Definitions The transition level:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-023-A",
                "text": "shall be the highest available flight level below the transition altitude that has been established.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-023-B",
                "text": "is calculated and declared for an approach by the Pilot-in command.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-023-C",
                "text": "is published for the aerodrome in the Section ENR of the AIP.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-023-D",
                "text": "shall be the lowest flight level available for use above the transition altitude.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-024",
            "text": "Altimeter setting procedures - transition level The transition level:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-024-A",
                "text": "is calculated by the Pilot-in command",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-024-B",
                "text": "is published on the approach and landing chart for each aerodrome",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-024-C",
                "text": "is published and updated in the NOTAM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-024-D",
                "text": "will be passed to aircraft by ATS units",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-025",
            "text": "IFR cruising levels within controlled airspace shall be given as flight level (FL)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-025-A",
                "text": "only in airspace class A",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-025-B",
                "text": "if the obstacle clearance is more than 2000 feet",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-025-C",
                "text": "Above the transition altitude when applicable",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-025-D",
                "text": "When QNH is higher than the standard pressure 1013 hPa",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-026",
            "text": "Altimeter setting (change during climb) On flights in accordance with IFR, the change of the altimeter setting from QNH to Standard shall be made at the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-026-A",
                "text": "transition level.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-026-B",
                "text": "level specified by ATC.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-026-C",
                "text": "transition altitude.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-026-D",
                "text": "transition layer.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-027",
            "text": "Altimeter setting procedures - transition altitude / level In the vicinity of an aerodrome of intended landing or used for take-off, the vertical position of aircraft shall be expressed in term of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-027-A",
                "text": "flight level at or below the transition altitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-027-B",
                "text": "flight level at or below the transition level",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-027-C",
                "text": "altitude above mean sea level at or above the transition altitude",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-027-D",
                "text": "altitude above mean sea level at or below the transition altitude",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-028",
            "text": "Altimeter setting procedures - Transition Layer Unless instructed otherwise by an air traffic controller, when passing through the transition layer, a pilot shall report the vertical position of the aircraft as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-028-A",
                "text": "either altitude or flight level in a climb.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-028-B",
                "text": "altitude in a descent.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-028-C",
                "text": "altitude in a climb.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-028-D",
                "text": "flight level in a descent.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-029",
            "text": "SSR - Transponder When an aircraft carries a serviceable transponder, the pilot shall operate the transponder:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-029-A",
                "text": "Only when the aircraft is flying within airspace where SSR is used for ATS purposes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-029-B",
                "text": "At all times during flight, regardless of whether the aircraft is within or outside airspace where SSR is used for ATS purposes.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-029-C",
                "text": "Only when the aircraft is flying within controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-029-D",
                "text": "Only when directed by ATC.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-030",
            "text": "SSR special codes ATC has assigned you the transponder code 5320. In case of loosing two way radio communication, you have to squawk:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-030-A",
                "text": "Mode A Code 7500",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-030-B",
                "text": "Mode A Code 7700",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-030-C",
                "text": "Mode A Code 7600",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-030-D",
                "text": "Mode A Code 2320",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-031",
            "text": "Except in some special cases the establishment of change-over points should be limited to route segments of",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-031-A",
                "text": "100 NM or more",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-031-B",
                "text": "50 NM or more",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-031-C",
                "text": "75 NM or more",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-031-D",
                "text": "60 NM or more",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-032",
            "text": "Which condition is requested so that an aerodrome may be considered controlled?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-032-A",
                "text": "The aerodrome shall be provided with a Control Tower",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-032-B",
                "text": "The aerodrome shall be located within a controlled airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-032-C",
                "text": "The aerodrome shall be located within a Control Zone.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-032-D",
                "text": "The aerodrome shall be located within a Control Zone (CTR) and provided with a Control Tower.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-033",
            "text": "A controlled airspace extending upwards from a specified limit above the earth is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-033-A",
                "text": "Advisory airspace",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-033-B",
                "text": "Control zone.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-033-C",
                "text": "Control area.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-033-D",
                "text": "Flight Information Region.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-034",
            "text": "A controlled airspace extending upwards from the surface of the earth to a specified upper limit is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-034-A",
                "text": "Advisory airspace.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-034-B",
                "text": "Control zone.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-034-C",
                "text": "Control area.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-034-D",
                "text": "Air traffic zone",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-035",
            "text": "ATS airspace's where IFR and VFR flights are permitted, all flights are subject to air traffic control service and are separated from each other is classified as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-035-A",
                "text": "Class B.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-035-B",
                "text": "Class E.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-035-C",
                "text": "Class A.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-035-D",
                "text": "Class D.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-036",
            "text": "Control Area (CTA) is defined as follows:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-036-A",
                "text": "A controlled airspace extending upwards from a specified limit above the earth",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-036-B",
                "text": "A controlled airspace extending upwards from a height of 900 feet above the earth.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-036-C",
                "text": "A controlled airspace extending upwards from the surface of the earth to a specified limit.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-036-D",
                "text": "A controlled airspace extending upwards from a height of 1000 feet above the earth.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-037",
            "text": "CTR - Minimum lateral limits How many NM shall a Control Zone extend at least from a reference point of the aerodrome or aerodromes into the direction from which approaches may be made?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-037-A",
                "text": "5 NM.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-037-B",
                "text": "10 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-037-C",
                "text": "7.5 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-037-D",
                "text": "15 NM.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-038",
            "text": "A lower limit of a Control Area shall be established at a height above the ground level or water of not less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-038-A",
                "text": "200 metres.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-038-B",
                "text": "500 metres.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-038-C",
                "text": "150 metres.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-038-D",
                "text": "300 metres.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-039",
            "text": "Which provisions on a VFR-flight in Class E airspace are CORRECT?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-039-A",
                "text": "Service provided: Traffic Information as far as practical; ATC Clearance: required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-039-B",
                "text": "Service provided: Air Traffic Control Service; ATC Clearance: not required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-039-C",
                "text": "Service provided: Air Traffic Control Service; ATC Clearance: required",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-039-D",
                "text": "Service provided: Traffic Information as far as practical; ATC Clearance: not required",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-040",
            "text": "To perform a VFR flight in airspace classification E :",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-040-A",
                "text": "a clearance and/or two-way radio communication is required.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-040-B",
                "text": "a clearance is required.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-040-C",
                "text": "two way radio communication is not required.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-040-D",
                "text": "a clearance and two-way radio communication is required.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-041",
            "text": "Which statement is correct?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-041-A",
                "text": "The lower limit of a CTA shall be established at a height of at least 1500ft AGL",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-041-B",
                "text": "The lower limit of a TMA shall be established at a height of at least 700ft AGL",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-041-C",
                "text": "The lower limit of an UIR may coincide with an IFR cruising level",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-041-D",
                "text": "The upper limit of a CTR shall be established at a height of at least 3000ft AMSL",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-042",
            "text": "Which statement is correct ? During a \"Visual Approach\" in Controlled Airspace (Class C):",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-042-A",
                "text": "ATC will apply separation with other arriving traffic",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-042-B",
                "text": "ATC will apply separation with other traffic",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-042-C",
                "text": "the pilot to apply separation with other traffic",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-042-D",
                "text": "ATC will apply separation only with other IFR-traffic",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-043",
            "text": "What is the speed limit (IAS) in airspace class E?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-043-A",
                "text": "250 kt VFR and IFR, all levels",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-043-B",
                "text": "250 kt only for VFR up to FL 195",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-043-C",
                "text": "250 kt for IFR and VFR UP TO FL 100",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-043-D",
                "text": "250 kt only for IFR up to FL 100",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-044",
            "text": "The speed limitation for IFR flights inside ATS airspace classified as C, when flying below 3.050 m (10.000 ft) AMSL, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-044-A",
                "text": "250 KT TAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-044-B",
                "text": "240 KT IAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-044-C",
                "text": "Not applicable",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-044-D",
                "text": "250 KT IAS",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-045",
            "text": "The speed limitation for VFR flights inside ATS airspace classified as C, when flying below 3.050 m (10.000 ft) AMSL, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-045-A",
                "text": "250 KT TAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-045-B",
                "text": "240 KT IAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-045-C",
                "text": "Not applicable",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-045-D",
                "text": "250 KT IAS",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-046",
            "text": "The speed limitation for IFR flights inside ATS airspace classified as E, when flying below 3.050 m (10.000 ft) AMSL, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-046-A",
                "text": "250 KT TAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-046-B",
                "text": "250 KT IAS",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-046-C",
                "text": "Not applicable",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-046-D",
                "text": "260 KT IAS",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-047",
            "text": "The speed limitation for both IFR flights and VFR flights inside ATS airspace classified as B, when flying below 3.050 m (10.000 ft) AMLS, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-047-A",
                "text": "250 KT TAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-047-B",
                "text": "250 KT IAS",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-047-C",
                "text": "Not applicable",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-047-D",
                "text": "260 KT IAS",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-048",
            "text": "Where an upper flight information region (UIR) is established, the procedures applicable there in:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-048-A",
                "text": "need not to be identical with those applicable in the underlying flight information region",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-048-B",
                "text": "has to be the same as the underlying flight information region",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-048-C",
                "text": "have to be as indicated by ICAO council",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-048-D",
                "text": "have to be as agreed at the regional air navigation meetings",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-049",
            "text": "A VFR flight when flying inside an ATS airspace classified as C has to maintain the following minima of flight visibility and distance from clouds",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-049-A",
                "text": "8 km at or above 3050 m (10.000 ft) AMSL 1500 m horizontal and 300 m vertical from clouds",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-049-B",
                "text": "5 NM at or above 3050 m (10.000 ft) AMSL, 1500 m horizontal and 300 m vertical from clouds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-049-C",
                "text": "5km at or above 3050 m (10.000 ft) AMSL 1500 m horizontal and 300 m vertical from clouds",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-049-D",
                "text": "8 km at or above 3050 m (10.000 ft) AMSL, and clear of clouds",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-050",
            "text": "An ATS airspace where IFR and VFR flights are permitted, all flights are subject to air traffic control service and IFR flights are separated from other IFR flights and from VFR flights VFR flights are separated from IFR flights and receive traffic information in respect of other VFR flights, is classified as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-050-A",
                "text": "Airspace D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-050-B",
                "text": "Airspace C",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-050-C",
                "text": "Airspace E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-050-D",
                "text": "Airspace B",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-051",
            "text": "An ATS airspace where IFR and VFR flights are permitted, all flights are subject to air traffic control service and are separated from each other is classified as",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-051-A",
                "text": "Airspace D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-051-B",
                "text": "Airspace C",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-051-C",
                "text": "Airspace E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-051-D",
                "text": "Airspace B",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-052",
            "text": "An ATS airspace where IFR and VFR flights are permitted and all flights are subject to air traffic control service. IFR flights are separated from other IFR flights and receive traffic information in respect of VFR flights. VFR flights receive traffic information in respect of all other flights, is classified as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-052-A",
                "text": "Airspace D",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-052-B",
                "text": "Airspace A",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-052-C",
                "text": "Airspace E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-052-D",
                "text": "Airspace B",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-053",
            "text": "An ATS airspace where IFR and VFR are permitted IFR flights are subject to Air Traffic Control Service and are separated from other IFR flights. All flights receive traffic information as far as is practical, is classified as",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-053-A",
                "text": "Airspace D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-053-B",
                "text": "Airspace A",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-053-C",
                "text": "Airspace E",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-053-D",
                "text": "Airspace B",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-054",
            "text": "An ATS airspace where IFR and VFR flights are permitted, all participating IFR flights receive an air traffic advisory service and all flights receive flight information service if requested, is classified",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-054-A",
                "text": "Airspace D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-054-B",
                "text": "Airspace F",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-054-C",
                "text": "Airspace E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-054-D",
                "text": "Airspace G",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-055",
            "text": "An ATS airspace where IFR and VFR are permitted and receive flight information service if requested, is classified as",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-055-A",
                "text": "Airspace D",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-055-B",
                "text": "Airspace F",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-055-C",
                "text": "Airspace E",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-055-D",
                "text": "Airspace G",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-056",
            "text": "An aircraft is maintaining FL 150 within airspace class C. Another aircraft below at FL 140 is receiving a clearance to descend to FL 70. It is severe turbulence in the area. When is the earliest that a clearance to descend to FL 140 or below can be expected?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-056-A",
                "text": "When the other aircraft has reported that it has left FL 140",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-056-B",
                "text": "When the other aircraft has reported that it has reached FL 70",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-056-C",
                "text": "When the other aircraft has reported that it has left FL 120",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-056-D",
                "text": "When the other aircraft has reported that it has descended through FL 130",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-057",
            "text": "ATIS broadcast messages containing departure and arrival information should include cloud cover, when the clouds are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-057-A",
                "text": "below 1 500 m (5.000 ft) or below the highest minimum sector altitude, whichever is the greater.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-057-B",
                "text": "cumulonimbus.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-057-C",
                "text": "below 2 000 m (6.000 ft) or below the highest minimum sector altitude, whichever is the greater.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-057-D",
                "text": "below 900 m (3.000 ft) or below the highest minimum sector altitude, whichever is the greater.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-058",
            "text": "Concerning to RNP (Required Navigation Performance) types, the indication RNP 4, represents a navigation accuracy of",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-058-A",
                "text": "plus or minus 4 NM on a 90 per cent containment basis",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-058-B",
                "text": "plus or minus 4 miles on a 90 per cent containment basis",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-058-C",
                "text": "plus or minus 4 NM on a 98 per cent containment basis",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-058-D",
                "text": "plus or minus 4 NM on a 95 per cent containment basis",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-059",
            "text": "Required Navigation Performance (RNP) shall be prescribed",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-059-A",
                "text": "by regional air navigation agreements",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-059-B",
                "text": "by states on the basis of regional air navigation agreements",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-059-C",
                "text": "by ICAO on the basis of regional air navigation agreements",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-059-D",
                "text": "by states but not on the basis of regional air agreements",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-060",
            "text": "Separation in the vicinity of aerodromes - timed approaches A \"Timed Approach Procedure\" may be utilized as necessary in order to expedite the approaches of a number of arriving aircraft. This will be obtained by requesting aircraft to",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-060-A",
                "text": "maintain a specified airspeed during the approach procedure.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-060-B",
                "text": "pass a specified point inbound at the previously notified time",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-060-C",
                "text": "notify the time when passing a specified point.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-060-D",
                "text": "keep distance and time equal between aircraft in the approach.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-061",
            "text": "The primary duty provided by a radar unit is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-061-A",
                "text": "To provide radar separation.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-061-B",
                "text": "To assist aircraft due to failure of airborne equipment.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-061-C",
                "text": "To assist aircraft where navigation appears unsatisfactory.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-061-D",
                "text": "To assist aircraft on the location storms.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-062",
            "text": "Approach Control Service An Expected Approach Time / EAT will be transmitted by the most expeditious means to the aircraft when it is expected that it has to hold",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-062-A",
                "text": "for 15 minutes or more.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-062-B",
                "text": "for 30 minutes or more",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-062-C",
                "text": "for 10 minutes or more.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-062-D",
                "text": "for 20 minutes or more.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-063",
            "text": "The EAT has to be transmitted to the pilot as soon as possible, in case the expected delay is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-063-A",
                "text": "20 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-063-B",
                "text": "5 minutes or more.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-063-C",
                "text": "10 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-063-D",
                "text": "15 minutes or more",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-064",
            "text": "Except when prescribed in procedures or made possible by agreements, aircraft under radar-control shall not be vectored closer to the boundary of controlled airspace than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-064-A",
                "text": "5 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-064-B",
                "text": "3 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-064-C",
                "text": "2,5 NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-064-D",
                "text": "1,5 NM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-065",
            "text": "For controlled traffic that shall be separated in the vicinity of an airport, separation minima may be reduced:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-065-A",
                "text": "At the discretion of the air traffic controller",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-065-B",
                "text": "If the commander of the involved aircraft so requests",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-065-C",
                "text": "When the commander in the following aircraft has the preceding aircraft in sight and is able to maintain own separation",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-065-D",
                "text": "Only if the air traffic controller has the involved aircraft in sight",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-066",
            "text": "If the crew on an arriving aircraft approaching a controlled aerodrome will report 'field in sight', a clearance for 'visual approach' may be given under certain conditions",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-066-A",
                "text": "The meteorological visibility must not be less than 8 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-066-B",
                "text": "Continued approach will be according to VFR",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-066-C",
                "text": "The approach must be passing the FAF",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-066-D",
                "text": "The air traffic controller will provide separation to other controlled traffic",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-067",
            "text": "The surveillance radar approach shall be terminated at a distance of 2 NM from the touchdown except when as determined by the appropriate ATS authority, the accuracy of the radar equipment permits to be continued to a prescribed point less than 2 NM from the touchdown. In this case distance and level information shall be given at each",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-067-A",
                "text": "1 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-067-B",
                "text": "half NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-067-C",
                "text": "half mile",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-067-D",
                "text": "1.5 NM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-068",
            "text": "An aircraft making a radar approach should be directed to consider executing a missed approach if the aircraft is not visible on the radar display for any significant interval during the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-068-A",
                "text": "Last 3 NM of the approach",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-068-B",
                "text": "Last 2 NM of the approach",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-068-C",
                "text": "Last 5 NM of the approach",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-068-D",
                "text": "Last 4 NM of the approach",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-069",
            "text": "What light colours denotes taxiway center lights and perimeters",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-069-A",
                "text": "Green centerline lights and white perimeter lights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-069-B",
                "text": "White centerline lights and green perimeter lights",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-069-C",
                "text": "Green centerline lights and blue perimeter lights",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-069-D",
                "text": "Orange center line lights",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-070",
            "text": "The planned cruising speed for the first leg or all of the cruising portion of the flight must be entered in the speed box of a flight plan form. This speed is the:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-070-A",
                "text": "indicated air speed (IAS).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-070-B",
                "text": "true air speed (TAS).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-070-C",
                "text": "estimated ground speed (G/S).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-070-D",
                "text": "true air speed at 65% power.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-071",
            "text": "When a RADAR operator says the following to an aircraft: \"fly heading 030\", the pilot must fly heading:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-071-A",
                "text": "030° magnetic in still air conditions (thereby flying the magnetic track)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-071-B",
                "text": "030° magnetic",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-071-C",
                "text": "030° true, in still air conditions (thereby flying the true track)",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-071-D",
                "text": "030° true",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-072",
            "text": "Separation methods and minima - vertical separation The Vertical Separation Minimum (VSM) between flights operating in accordance with IFR, within controlled airspace, below FL 290 is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-072-A",
                "text": "2000 feet (600 m).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-072-B",
                "text": "2500 feet (750 m).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-072-C",
                "text": "500 feet (150 m).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-072-D",
                "text": "1000 feet (300 m).",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-073",
            "text": "Separation methods and minima - Vertical Separation Minima / VSM, ICAO DOC 4444 The Vertical Separation Minimum (VSM) between flights operating in accordance with IFR, within controlled airspace, above FL 290 is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-073-A",
                "text": "2000 feet (600 m).",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-073-B",
                "text": "4000 feet (1200 m).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-073-C",
                "text": "500 feet (150 m).",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-073-D",
                "text": "1000 feet (300 m).",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-074",
            "text": "Separation methods and minima - vertical separation Above flight level FL 290 the Vertical Separation Minimum (VSM) shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-074-A",
                "text": "2000 feet.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-074-B",
                "text": "4000 feet .",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-074-C",
                "text": "3000 feet.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-074-D",
                "text": "1500 feet.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-075",
            "text": "The longitudinal separation minima based on time between aircraft at same cruising level where navigation aids permit frequent determination of position and speed and the preceding aircraft is maintaining a true airspeed of 20 kt or more faster than the succeeding aircraft, is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-075-A",
                "text": "15 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-075-B",
                "text": "10 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-075-C",
                "text": "3 minutes.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-075-D",
                "text": "5 minutes.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-076",
            "text": "When an aircraft will pass through the level of another aircraft on the same track, the following minimum longitudinal separation shall be provided:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-076-A",
                "text": "20 minutes at the time the level is crossed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-076-B",
                "text": "5 minutes at the time the level is crossed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-076-C",
                "text": "10 minutes at the time the level is crossed.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-076-D",
                "text": "15 minutes at the time the level is crossed.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-077",
            "text": "Minimum Radar Separation on final approach The minimum radar separation provided between aircraft established on the same localizer course shall be: (plus additional longitudinal separation as required for wake turbulence)",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-077-A",
                "text": "3 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-077-B",
                "text": "2 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-077-C",
                "text": "2.5 NM.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-077-D",
                "text": "5 NM.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-078",
            "text": "Radar services - Radar Separation - Minima Unless otherwise prescribed by the appropriate ATS authority, the horizontal radar separation minimum shall be:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-078-A",
                "text": "3.0 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-078-B",
                "text": "5.0 NM.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-078-C",
                "text": "10.0 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-078-D",
                "text": "3.5 NM.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-079",
            "text": "Radar Services - Radar Separation Minima When radar capabilities at a given location so permit, the minimum radar separation of 5 NM may be reduced, but shall not be less than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-079-A",
                "text": "3.0 NM.",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-079-B",
                "text": "5.0 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-079-C",
                "text": "1.5 NM.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-079-D",
                "text": "2.0 NM.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-080",
            "text": "During an arrival procedure under an IFR flight plan in VMC conditions, traffic avoidance is the responsibility of:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-080-A",
                "text": "the pilot in command",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-080-B",
                "text": "the airport controller.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-080-C",
                "text": "the approach controller.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-080-D",
                "text": "the radar controller.",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-081",
            "text": "Separation - VMC and own separation The \"Clearance to fly maintaining own separation while in visual meteorological conditions\" may be given by the appropriate ATS authority. This has to be requested by the pilot of a controlled flight and has to be agreed by the pilot of the other aircraft. The conditions are:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-081-A",
                "text": "Airspace Class B. C, D and E, VMC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-081-B",
                "text": "Airspace Class C, VMC, hours of daylight",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-081-C",
                "text": "Airspace Class C, D, VMC",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-081-D",
                "text": "Airspace Class D and E, VMC, hours of daylight",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-082",
            "text": "Separation methods and minima - essential traffic A VFR flight constitutes essential traffic to other VFR flights, when operating in controlled airspace classified as:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-082-A",
                "text": "B and C.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-082-B",
                "text": "B, C and D.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-082-C",
                "text": "B, C, D and E.",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-082-D",
                "text": "B.",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-083",
            "text": "The separation method whereby the vertical and horizontal separation may be reduced till a maximum of half the standard criteria is called:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-083-A",
                "text": "Reduced separation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-083-B",
                "text": "Combined separation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-083-C",
                "text": "Essential separation",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-083-D",
                "text": "Composite separation",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-084",
            "text": "What is the shortest distance in a sequence for landing between a 'Heavy' aircraft preceding a 'Light' aircraft",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-084-A",
                "text": "3 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-084-B",
                "text": "2 km",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-084-C",
                "text": "6 NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-084-D",
                "text": "10 km",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-085",
            "text": "If an arriving aircraft is making a straight in approach a departing aircraft may take off in any direction",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-085-A",
                "text": "until three minutes before the arriving aircraft is estimated to be over the instrument runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-085-B",
                "text": "until two minutes before the arriving aircraft is estimated to be over the instrument runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-085-C",
                "text": "until ten minutes before the arriving aircraft is estimated to be over the instrument runway",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-085-D",
                "text": "until five minutes before the arriving aircraft is estimated to be over the instrument Runway",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-086",
            "text": "What is the minimum wake turbulence separation criteria when a light aircraft is taking off behind a medium aircraft and both are using the same runway?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-086-A",
                "text": "5 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-086-B",
                "text": "2 minutes",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-086-C",
                "text": "3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-086-D",
                "text": "1 minute",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-087",
            "text": "In order to meet wake turbulence criteria, for arriving aircraft and using timed approaches, what minima shall be applied to aircraft landing behind a heavy or a medium aircraft?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-087-A",
                "text": "medium aircraft behind heavy aircraft - 3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-087-B",
                "text": "medium aircraft other medium aircraft - 2 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-087-C",
                "text": "light aircraft behind medium aircraft -4 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-087-D",
                "text": "medium aircraft behind heavy aircraft - 2 minutes",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-088",
            "text": "A separation minimum shall be applied between a light or MEDIUM aircraft and a HEAVY aircraft and between a LIGHT aircraft and a MEDIUM aircraft when the heavier aircraft is making a low or missed approach and the lighter aircraft is utilizing an opposite direction runway for take off, this minimum is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-088-A",
                "text": "5 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-088-B",
                "text": "3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-088-C",
                "text": "1 minute",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-088-D",
                "text": "2 minutes",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-089",
            "text": "In order to meet the wake turbulence criteria, what minimum separation should be applied when a medium aircraft is taking off behind a heavy aircraft and both are using the same runway?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-089-A",
                "text": "4 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-089-B",
                "text": "3 minutes",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-089-C",
                "text": "1 minute",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-089-D",
                "text": "2 minutes",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-090",
            "text": "At the commencement of final approach, if the controller possesses wind information in the form of components, significant changes in the mean surface wind direction and speed shall be transmitted to aircraft. The mean cross- wind component significant change is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-090-A",
                "text": "10 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-090-B",
                "text": "3 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-090-C",
                "text": "8 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-090-D",
                "text": "5 KT",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-091",
            "text": "At the commencement of final approach, if the controller possesses wind information in the form of components, significant changes in the mean surface wind direction and speed shall be transmitted to aircraft. The mean tail- wind component significant change is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-091-A",
                "text": "4 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-091-B",
                "text": "3 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-091-C",
                "text": "2 KT",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-091-D",
                "text": "5 KT",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-092",
            "text": "At the commencement of final approach, if the controller possesses wind information in the form of components, significant changes in the mean surface wind direction and speed shall be transmitted to aircraft. The mean head- wind component significant change is:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-092-A",
                "text": "10 KT",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-092-B",
                "text": "8 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-092-C",
                "text": "4 KT",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-092-D",
                "text": "5 KT",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-093",
            "text": "A minimum radar separation shall be provided until aircraft are established inbound on the ILS localizer course and/or MLS final approach track. This minimum is, when independent parallel approaches are being conducted:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-093-A",
                "text": "1.0 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-093-B",
                "text": "2.0 NM",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-093-C",
                "text": "3.0 NM",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-093-D",
                "text": "5.0 NM",
                "correct": false
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-094",
            "text": "When independent parallel approaches are being conducted and vectoring to intercept the ILS localizer course or MLS final approach track, the final vector shall be such as to enable the aircraft to intercept the ILS localizer course or MLS final approach track at an angle not greater than:",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-094-A",
                "text": "20 degrees",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-094-B",
                "text": "25 degrees",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-094-C",
                "text": "15 degrees",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-094-D",
                "text": "30 degrees",
                "correct": true
              }
            }
          ]
        },
        {
          "type": "Question",
          "data": {
            "id": "Q-PNS-095",
            "text": "Which of the following is a valid colour scheme for signs on an aerodrome?",
            "type": "MultipleChoiceQuestion"
          },
          "children": [
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-095-A",
                "text": "Black on red",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-095-B",
                "text": "Orange",
                "correct": false
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-095-C",
                "text": "Yellow on black or black on yellow",
                "correct": true
              }
            },
            {
              "type": "QuestionAnswer",
              "data": {
                "id": "Q-PNS-095-D",
                "text": "Red on white",
                "correct": false
              }
            }
          ]
        }
      ]
    }
  ]
}
